(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredba1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredba1"] = parcelRequire;
}
parcelRequire.register("9AKcZ", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6fbb51e4195bbb20$export$ffb0004e005737fa; }, function (v) { return $6fbb51e4195bbb20$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $6fbb51e4195bbb20$export$34b9dba7ce09269b; }, function (v) { return $6fbb51e4195bbb20$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $6fbb51e4195bbb20$export$25062201e9e25d76; }, function (v) { return $6fbb51e4195bbb20$export$25062201e9e25d76 = v; });
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6fbb51e4195bbb20$export$ffb0004e005737fa;
var $6fbb51e4195bbb20$export$34b9dba7ce09269b;
var $6fbb51e4195bbb20$export$25062201e9e25d76;
"use strict";

var $hJwnw = parcelRequire("hJwnw");
var $6fbb51e4195bbb20$var$g = 60103;
$6fbb51e4195bbb20$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $6fbb51e4195bbb20$var$h = Symbol.for;
    $6fbb51e4195bbb20$var$g = $6fbb51e4195bbb20$var$h("react.element");
    $6fbb51e4195bbb20$export$ffb0004e005737fa = $6fbb51e4195bbb20$var$h("react.fragment");
}
var $6fbb51e4195bbb20$var$m = $hJwnw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $6fbb51e4195bbb20$var$n = Object.prototype.hasOwnProperty, $6fbb51e4195bbb20$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6fbb51e4195bbb20$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$6fbb51e4195bbb20$var$n.call(a, b) && !$6fbb51e4195bbb20$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $6fbb51e4195bbb20$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $6fbb51e4195bbb20$var$m.current
    };
}
$6fbb51e4195bbb20$export$34b9dba7ce09269b = $6fbb51e4195bbb20$var$q;
$6fbb51e4195bbb20$export$25062201e9e25d76 = $6fbb51e4195bbb20$var$q;

});
parcelRequire.register("hJwnw", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3oLo3"));

});
parcelRequire.register("3oLo3", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $27985f0e2f3220bc$export$dca3b0875bd9a954; }, function (v) { return $27985f0e2f3220bc$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $27985f0e2f3220bc$export$16fa2f45be04daa8; }, function (v) { return $27985f0e2f3220bc$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27985f0e2f3220bc$export$ffb0004e005737fa; }, function (v) { return $27985f0e2f3220bc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $27985f0e2f3220bc$export$e2c29f18771995cb; }, function (v) { return $27985f0e2f3220bc$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $27985f0e2f3220bc$export$221d75b3f55bb0bd; }, function (v) { return $27985f0e2f3220bc$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27985f0e2f3220bc$export$5f8d39834fd61797; }, function (v) { return $27985f0e2f3220bc$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27985f0e2f3220bc$export$74bf444e3cd11ea5; }, function (v) { return $27985f0e2f3220bc$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $27985f0e2f3220bc$export$ae55be85d98224ed; }, function (v) { return $27985f0e2f3220bc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $27985f0e2f3220bc$export$e530037191fcd5d7; }, function (v) { return $27985f0e2f3220bc$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $27985f0e2f3220bc$export$fd42f52fd3ae1109; }, function (v) { return $27985f0e2f3220bc$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $27985f0e2f3220bc$export$c8a8987d4410bf2d; }, function (v) { return $27985f0e2f3220bc$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $27985f0e2f3220bc$export$d38cd72104c1f0e9; }, function (v) { return $27985f0e2f3220bc$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $27985f0e2f3220bc$export$7d1e3a5e95ceca43; }, function (v) { return $27985f0e2f3220bc$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $27985f0e2f3220bc$export$257a8862b851cb5b; }, function (v) { return $27985f0e2f3220bc$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $27985f0e2f3220bc$export$a8257692ac88316c; }, function (v) { return $27985f0e2f3220bc$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $27985f0e2f3220bc$export$488013bae63b21da; }, function (v) { return $27985f0e2f3220bc$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $27985f0e2f3220bc$export$7c73462e0d25e514; }, function (v) { return $27985f0e2f3220bc$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $27985f0e2f3220bc$export$35808ee640e87ca7; }, function (v) { return $27985f0e2f3220bc$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $27985f0e2f3220bc$export$fae74005e78b1a27; }, function (v) { return $27985f0e2f3220bc$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $27985f0e2f3220bc$export$dc8fbce3eb94dc1e; }, function (v) { return $27985f0e2f3220bc$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $27985f0e2f3220bc$export$6d9c69b0de29b591; }, function (v) { return $27985f0e2f3220bc$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $27985f0e2f3220bc$export$d5a552a76deda3c2; }, function (v) { return $27985f0e2f3220bc$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $27985f0e2f3220bc$export$e5c5a5f917a5871c; }, function (v) { return $27985f0e2f3220bc$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $27985f0e2f3220bc$export$1538c33de8887b59; }, function (v) { return $27985f0e2f3220bc$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $27985f0e2f3220bc$export$13e3392192263954; }, function (v) { return $27985f0e2f3220bc$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $27985f0e2f3220bc$export$b8f5890fc79d6aca; }, function (v) { return $27985f0e2f3220bc$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $27985f0e2f3220bc$export$60241385465d0a34; }, function (v) { return $27985f0e2f3220bc$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $27985f0e2f3220bc$export$83d89fbfd8236492; }, function (v) { return $27985f0e2f3220bc$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27985f0e2f3220bc$export$dca3b0875bd9a954;
var $27985f0e2f3220bc$export$16fa2f45be04daa8;
var $27985f0e2f3220bc$export$ffb0004e005737fa;
var $27985f0e2f3220bc$export$e2c29f18771995cb;
var $27985f0e2f3220bc$export$221d75b3f55bb0bd;
var $27985f0e2f3220bc$export$5f8d39834fd61797;
var $27985f0e2f3220bc$export$74bf444e3cd11ea5;
var $27985f0e2f3220bc$export$ae55be85d98224ed;
var $27985f0e2f3220bc$export$e530037191fcd5d7;
var $27985f0e2f3220bc$export$fd42f52fd3ae1109;
var $27985f0e2f3220bc$export$c8a8987d4410bf2d;
var $27985f0e2f3220bc$export$d38cd72104c1f0e9;
var $27985f0e2f3220bc$export$7d1e3a5e95ceca43;
var $27985f0e2f3220bc$export$257a8862b851cb5b;
var $27985f0e2f3220bc$export$a8257692ac88316c;
var $27985f0e2f3220bc$export$488013bae63b21da;
var $27985f0e2f3220bc$export$7c73462e0d25e514;
var $27985f0e2f3220bc$export$35808ee640e87ca7;
var $27985f0e2f3220bc$export$fae74005e78b1a27;
var $27985f0e2f3220bc$export$dc8fbce3eb94dc1e;
var $27985f0e2f3220bc$export$6d9c69b0de29b591;
var $27985f0e2f3220bc$export$d5a552a76deda3c2;
var $27985f0e2f3220bc$export$e5c5a5f917a5871c;
var $27985f0e2f3220bc$export$1538c33de8887b59;
var $27985f0e2f3220bc$export$13e3392192263954;
var $27985f0e2f3220bc$export$b8f5890fc79d6aca;
var $27985f0e2f3220bc$export$60241385465d0a34;
var $27985f0e2f3220bc$export$83d89fbfd8236492;
"use strict";

var $70tqi = parcelRequire("70tqi");
var $27985f0e2f3220bc$var$n = "function" === typeof Symbol && Symbol.for, $27985f0e2f3220bc$var$p = $27985f0e2f3220bc$var$n ? Symbol.for("react.element") : 60103, $27985f0e2f3220bc$var$q = $27985f0e2f3220bc$var$n ? Symbol.for("react.portal") : 60106, $27985f0e2f3220bc$var$r = $27985f0e2f3220bc$var$n ? Symbol.for("react.fragment") : 60107, $27985f0e2f3220bc$var$t = $27985f0e2f3220bc$var$n ? Symbol.for("react.strict_mode") : 60108, $27985f0e2f3220bc$var$u = $27985f0e2f3220bc$var$n ? Symbol.for("react.profiler") : 60114, $27985f0e2f3220bc$var$v = $27985f0e2f3220bc$var$n ? Symbol.for("react.provider") : 60109, $27985f0e2f3220bc$var$w = $27985f0e2f3220bc$var$n ? Symbol.for("react.context") : 60110, $27985f0e2f3220bc$var$x = $27985f0e2f3220bc$var$n ? Symbol.for("react.forward_ref") : 60112, $27985f0e2f3220bc$var$y = $27985f0e2f3220bc$var$n ? Symbol.for("react.suspense") : 60113, $27985f0e2f3220bc$var$z = $27985f0e2f3220bc$var$n ? Symbol.for("react.memo") : 60115, $27985f0e2f3220bc$var$A = $27985f0e2f3220bc$var$n ? Symbol.for("react.lazy") : 60116, $27985f0e2f3220bc$var$B = "function" === typeof Symbol && Symbol.iterator;
function $27985f0e2f3220bc$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $27985f0e2f3220bc$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $27985f0e2f3220bc$var$E = {};
function $27985f0e2f3220bc$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $27985f0e2f3220bc$var$E;
    this.updater = c || $27985f0e2f3220bc$var$D;
}
$27985f0e2f3220bc$var$F.prototype.isReactComponent = {};
$27985f0e2f3220bc$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($27985f0e2f3220bc$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$27985f0e2f3220bc$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $27985f0e2f3220bc$var$G() {}
$27985f0e2f3220bc$var$G.prototype = $27985f0e2f3220bc$var$F.prototype;
function $27985f0e2f3220bc$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $27985f0e2f3220bc$var$E;
    this.updater = c || $27985f0e2f3220bc$var$D;
}
var $27985f0e2f3220bc$var$I = $27985f0e2f3220bc$var$H.prototype = new $27985f0e2f3220bc$var$G;
$27985f0e2f3220bc$var$I.constructor = $27985f0e2f3220bc$var$H;
$70tqi($27985f0e2f3220bc$var$I, $27985f0e2f3220bc$var$F.prototype);
$27985f0e2f3220bc$var$I.isPureReactComponent = !0;
var $27985f0e2f3220bc$var$J = {
    current: null
}, $27985f0e2f3220bc$var$K = Object.prototype.hasOwnProperty, $27985f0e2f3220bc$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $27985f0e2f3220bc$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$27985f0e2f3220bc$var$K.call(b, e) && !$27985f0e2f3220bc$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $27985f0e2f3220bc$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $27985f0e2f3220bc$var$J.current
    };
}
function $27985f0e2f3220bc$var$N(a, b) {
    return {
        $$typeof: $27985f0e2f3220bc$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $27985f0e2f3220bc$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27985f0e2f3220bc$var$p;
}
function $27985f0e2f3220bc$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $27985f0e2f3220bc$var$P = /\/+/g, $27985f0e2f3220bc$var$Q = [];
function $27985f0e2f3220bc$var$R(a, b, c, e) {
    if ($27985f0e2f3220bc$var$Q.length) {
        var d = $27985f0e2f3220bc$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $27985f0e2f3220bc$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $27985f0e2f3220bc$var$Q.length && $27985f0e2f3220bc$var$Q.push(a);
}
function $27985f0e2f3220bc$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $27985f0e2f3220bc$var$p:
                case $27985f0e2f3220bc$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $27985f0e2f3220bc$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $27985f0e2f3220bc$var$U(d, k);
        g += $27985f0e2f3220bc$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $27985f0e2f3220bc$var$B && a[$27985f0e2f3220bc$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $27985f0e2f3220bc$var$U(d, k++), g += $27985f0e2f3220bc$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($27985f0e2f3220bc$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $27985f0e2f3220bc$var$V(a, b, c) {
    return null == a ? 0 : $27985f0e2f3220bc$var$T(a, "", b, c);
}
function $27985f0e2f3220bc$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $27985f0e2f3220bc$var$escape(a.key) : b.toString(36);
}
function $27985f0e2f3220bc$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $27985f0e2f3220bc$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $27985f0e2f3220bc$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($27985f0e2f3220bc$var$O(a) && (a = $27985f0e2f3220bc$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($27985f0e2f3220bc$var$P, "$&/") + "/") + c)), e.push(a));
}
function $27985f0e2f3220bc$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($27985f0e2f3220bc$var$P, "$&/") + "/");
    b = $27985f0e2f3220bc$var$R(b, g, e, d);
    $27985f0e2f3220bc$var$V(a, $27985f0e2f3220bc$var$aa, b);
    $27985f0e2f3220bc$var$S(b);
}
var $27985f0e2f3220bc$var$Y = {
    current: null
};
function $27985f0e2f3220bc$var$Z() {
    var a = $27985f0e2f3220bc$var$Y.current;
    if (null === a) throw Error($27985f0e2f3220bc$var$C(321));
    return a;
}
var $27985f0e2f3220bc$var$ba = {
    ReactCurrentDispatcher: $27985f0e2f3220bc$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $27985f0e2f3220bc$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $70tqi
};
$27985f0e2f3220bc$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $27985f0e2f3220bc$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $27985f0e2f3220bc$var$R(null, null, b, c);
        $27985f0e2f3220bc$var$V(a, $27985f0e2f3220bc$var$W, b);
        $27985f0e2f3220bc$var$S(b);
    },
    count: function(a) {
        return $27985f0e2f3220bc$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $27985f0e2f3220bc$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$27985f0e2f3220bc$var$O(a)) throw Error($27985f0e2f3220bc$var$C(143));
        return a;
    }
};
$27985f0e2f3220bc$export$16fa2f45be04daa8 = $27985f0e2f3220bc$var$F;
$27985f0e2f3220bc$export$ffb0004e005737fa = $27985f0e2f3220bc$var$r;
$27985f0e2f3220bc$export$e2c29f18771995cb = $27985f0e2f3220bc$var$u;
$27985f0e2f3220bc$export$221d75b3f55bb0bd = $27985f0e2f3220bc$var$H;
$27985f0e2f3220bc$export$5f8d39834fd61797 = $27985f0e2f3220bc$var$t;
$27985f0e2f3220bc$export$74bf444e3cd11ea5 = $27985f0e2f3220bc$var$y;
$27985f0e2f3220bc$export$ae55be85d98224ed = $27985f0e2f3220bc$var$ba;
$27985f0e2f3220bc$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($27985f0e2f3220bc$var$C(267, a));
    var e = $70tqi({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $27985f0e2f3220bc$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$27985f0e2f3220bc$var$K.call(b, h) && !$27985f0e2f3220bc$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $27985f0e2f3220bc$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$27985f0e2f3220bc$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $27985f0e2f3220bc$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $27985f0e2f3220bc$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$27985f0e2f3220bc$export$c8a8987d4410bf2d = $27985f0e2f3220bc$var$M;
$27985f0e2f3220bc$export$d38cd72104c1f0e9 = function(a) {
    var b = $27985f0e2f3220bc$var$M.bind(null, a);
    b.type = a;
    return b;
};
$27985f0e2f3220bc$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$27985f0e2f3220bc$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $27985f0e2f3220bc$var$x,
        render: a
    };
};
$27985f0e2f3220bc$export$a8257692ac88316c = $27985f0e2f3220bc$var$O;
$27985f0e2f3220bc$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $27985f0e2f3220bc$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$27985f0e2f3220bc$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $27985f0e2f3220bc$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$27985f0e2f3220bc$export$35808ee640e87ca7 = function(a, b) {
    return $27985f0e2f3220bc$var$Z().useCallback(a, b);
};
$27985f0e2f3220bc$export$fae74005e78b1a27 = function(a, b) {
    return $27985f0e2f3220bc$var$Z().useContext(a, b);
};
$27985f0e2f3220bc$export$dc8fbce3eb94dc1e = function() {};
$27985f0e2f3220bc$export$6d9c69b0de29b591 = function(a, b) {
    return $27985f0e2f3220bc$var$Z().useEffect(a, b);
};
$27985f0e2f3220bc$export$d5a552a76deda3c2 = function(a, b, c) {
    return $27985f0e2f3220bc$var$Z().useImperativeHandle(a, b, c);
};
$27985f0e2f3220bc$export$e5c5a5f917a5871c = function(a, b) {
    return $27985f0e2f3220bc$var$Z().useLayoutEffect(a, b);
};
$27985f0e2f3220bc$export$1538c33de8887b59 = function(a, b) {
    return $27985f0e2f3220bc$var$Z().useMemo(a, b);
};
$27985f0e2f3220bc$export$13e3392192263954 = function(a, b, c) {
    return $27985f0e2f3220bc$var$Z().useReducer(a, b, c);
};
$27985f0e2f3220bc$export$b8f5890fc79d6aca = function(a) {
    return $27985f0e2f3220bc$var$Z().useRef(a);
};
$27985f0e2f3220bc$export$60241385465d0a34 = function(a) {
    return $27985f0e2f3220bc$var$Z().useState(a);
};
$27985f0e2f3220bc$export$83d89fbfd8236492 = "16.14.0";

});
parcelRequire.register("70tqi", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $519f5b540dd3ab43$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $519f5b540dd3ab43$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $519f5b540dd3ab43$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $519f5b540dd3ab43$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $519f5b540dd3ab43$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $519f5b540dd3ab43$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $519f5b540dd3ab43$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($519f5b540dd3ab43$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($519f5b540dd3ab43$var$getOwnPropertySymbols) {
            symbols = $519f5b540dd3ab43$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($519f5b540dd3ab43$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});




parcelRequire.register("gEPfk", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c208222f2bd70452$export$ae55be85d98224ed; }, function (v) { return $c208222f2bd70452$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c208222f2bd70452$export$d39a5bbd09211389; }, function (v) { return $c208222f2bd70452$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c208222f2bd70452$export$466bfc07425424d5; }, function (v) { return $c208222f2bd70452$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c208222f2bd70452$export$cd75ccfd720a3cd4; }, function (v) { return $c208222f2bd70452$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c208222f2bd70452$export$fa8d919ba61d84db; }, function (v) { return $c208222f2bd70452$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "render", function () { return $c208222f2bd70452$export$b3890eb0ae9dca99; }, function (v) { return $c208222f2bd70452$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c208222f2bd70452$export$502457920280e6be; }, function (v) { return $c208222f2bd70452$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c208222f2bd70452$export$c78a37762a8d58e1; }, function (v) { return $c208222f2bd70452$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_createPortal", function () { return $c208222f2bd70452$export$2577ef5d2565d52f; }, function (v) { return $c208222f2bd70452$export$2577ef5d2565d52f = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c208222f2bd70452$export$dc54d992c10e8a18; }, function (v) { return $c208222f2bd70452$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c208222f2bd70452$export$83d89fbfd8236492; }, function (v) { return $c208222f2bd70452$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c208222f2bd70452$export$ae55be85d98224ed;
var $c208222f2bd70452$export$d39a5bbd09211389;
var $c208222f2bd70452$export$466bfc07425424d5;
var $c208222f2bd70452$export$cd75ccfd720a3cd4;
var $c208222f2bd70452$export$fa8d919ba61d84db;
var $c208222f2bd70452$export$b3890eb0ae9dca99;
var $c208222f2bd70452$export$502457920280e6be;
var $c208222f2bd70452$export$c78a37762a8d58e1;
var $c208222f2bd70452$export$2577ef5d2565d52f;
var $c208222f2bd70452$export$dc54d992c10e8a18;
var $c208222f2bd70452$export$83d89fbfd8236492;
"use strict";

var $hJwnw = parcelRequire("hJwnw");

var $70tqi = parcelRequire("70tqi");

var $ezKtH = parcelRequire("ezKtH");
function $c208222f2bd70452$var$u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$hJwnw) throw Error($c208222f2bd70452$var$u(227));
function $c208222f2bd70452$var$ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c208222f2bd70452$var$da = !1, $c208222f2bd70452$var$ea = null, $c208222f2bd70452$var$fa = !1, $c208222f2bd70452$var$ha = null, $c208222f2bd70452$var$ia = {
    onError: function(a) {
        $c208222f2bd70452$var$da = !0;
        $c208222f2bd70452$var$ea = a;
    }
};
function $c208222f2bd70452$var$ja(a, b, c, d, e, f, g, h, k) {
    $c208222f2bd70452$var$da = !1;
    $c208222f2bd70452$var$ea = null;
    $c208222f2bd70452$var$ba.apply($c208222f2bd70452$var$ia, arguments);
}
function $c208222f2bd70452$var$ka(a, b, c, d, e, f, g, h, k) {
    $c208222f2bd70452$var$ja.apply(this, arguments);
    if ($c208222f2bd70452$var$da) {
        if ($c208222f2bd70452$var$da) {
            var l = $c208222f2bd70452$var$ea;
            $c208222f2bd70452$var$da = !1;
            $c208222f2bd70452$var$ea = null;
        } else throw Error($c208222f2bd70452$var$u(198));
        $c208222f2bd70452$var$fa || ($c208222f2bd70452$var$fa = !0, $c208222f2bd70452$var$ha = l);
    }
}
var $c208222f2bd70452$var$la = null, $c208222f2bd70452$var$ma = null, $c208222f2bd70452$var$na = null;
function $c208222f2bd70452$var$oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = $c208222f2bd70452$var$na(c);
    $c208222f2bd70452$var$ka(d, b, void 0, a);
    a.currentTarget = null;
}
var $c208222f2bd70452$var$pa = null, $c208222f2bd70452$var$qa = {};
function $c208222f2bd70452$var$ra() {
    if ($c208222f2bd70452$var$pa) for(var a in $c208222f2bd70452$var$qa){
        var b = $c208222f2bd70452$var$qa[a], c = $c208222f2bd70452$var$pa.indexOf(a);
        if (!(-1 < c)) throw Error($c208222f2bd70452$var$u(96, a));
        if (!$c208222f2bd70452$var$sa[c]) {
            if (!b.extractEvents) throw Error($c208222f2bd70452$var$u(97, a));
            $c208222f2bd70452$var$sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if ($c208222f2bd70452$var$ta.hasOwnProperty(h)) throw Error($c208222f2bd70452$var$u(99, h));
                $c208222f2bd70452$var$ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && $c208222f2bd70452$var$ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? ($c208222f2bd70452$var$ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error($c208222f2bd70452$var$u(98, d, a));
            }
        }
    }
}
function $c208222f2bd70452$var$ua(a, b, c) {
    if ($c208222f2bd70452$var$va[a]) throw Error($c208222f2bd70452$var$u(100, a));
    $c208222f2bd70452$var$va[a] = b;
    $c208222f2bd70452$var$wa[a] = b.eventTypes[c].dependencies;
}
var $c208222f2bd70452$var$sa = [], $c208222f2bd70452$var$ta = {}, $c208222f2bd70452$var$va = {}, $c208222f2bd70452$var$wa = {};
function $c208222f2bd70452$var$xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!$c208222f2bd70452$var$qa.hasOwnProperty(c) || $c208222f2bd70452$var$qa[c] !== d) {
            if ($c208222f2bd70452$var$qa[c]) throw Error($c208222f2bd70452$var$u(102, c));
            $c208222f2bd70452$var$qa[c] = d;
            b = !0;
        }
    }
    b && $c208222f2bd70452$var$ra();
}
var $c208222f2bd70452$var$ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c208222f2bd70452$var$za = null, $c208222f2bd70452$var$Aa = null, $c208222f2bd70452$var$Ba = null;
function $c208222f2bd70452$var$Ca(a) {
    if (a = $c208222f2bd70452$var$ma(a)) {
        if ("function" !== typeof $c208222f2bd70452$var$za) throw Error($c208222f2bd70452$var$u(280));
        var b = a.stateNode;
        b && (b = $c208222f2bd70452$var$la(b), $c208222f2bd70452$var$za(a.stateNode, a.type, b));
    }
}
function $c208222f2bd70452$var$Da(a) {
    $c208222f2bd70452$var$Aa ? $c208222f2bd70452$var$Ba ? $c208222f2bd70452$var$Ba.push(a) : $c208222f2bd70452$var$Ba = [
        a
    ] : $c208222f2bd70452$var$Aa = a;
}
function $c208222f2bd70452$var$Ea() {
    if ($c208222f2bd70452$var$Aa) {
        var a = $c208222f2bd70452$var$Aa, b = $c208222f2bd70452$var$Ba;
        $c208222f2bd70452$var$Ba = $c208222f2bd70452$var$Aa = null;
        $c208222f2bd70452$var$Ca(a);
        if (b) for(a = 0; a < b.length; a++)$c208222f2bd70452$var$Ca(b[a]);
    }
}
function $c208222f2bd70452$var$Fa(a, b) {
    return a(b);
}
function $c208222f2bd70452$var$Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $c208222f2bd70452$var$Ha() {}
var $c208222f2bd70452$var$Ia = $c208222f2bd70452$var$Fa, $c208222f2bd70452$var$Ja = !1, $c208222f2bd70452$var$Ka = !1;
function $c208222f2bd70452$var$La() {
    if (null !== $c208222f2bd70452$var$Aa || null !== $c208222f2bd70452$var$Ba) $c208222f2bd70452$var$Ha(), $c208222f2bd70452$var$Ea();
}
function $c208222f2bd70452$var$Ma(a, b, c) {
    if ($c208222f2bd70452$var$Ka) return a(b, c);
    $c208222f2bd70452$var$Ka = !0;
    try {
        return $c208222f2bd70452$var$Ia(a, b, c);
    } finally{
        $c208222f2bd70452$var$Ka = !1, $c208222f2bd70452$var$La();
    }
}
var $c208222f2bd70452$var$Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c208222f2bd70452$var$Oa = Object.prototype.hasOwnProperty, $c208222f2bd70452$var$Pa = {}, $c208222f2bd70452$var$Qa = {};
function $c208222f2bd70452$var$Ra(a) {
    if ($c208222f2bd70452$var$Oa.call($c208222f2bd70452$var$Qa, a)) return !0;
    if ($c208222f2bd70452$var$Oa.call($c208222f2bd70452$var$Pa, a)) return !1;
    if ($c208222f2bd70452$var$Na.test(a)) return $c208222f2bd70452$var$Qa[a] = !0;
    $c208222f2bd70452$var$Pa[a] = !0;
    return !1;
}
function $c208222f2bd70452$var$Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c208222f2bd70452$var$Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c208222f2bd70452$var$Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c208222f2bd70452$var$v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var $c208222f2bd70452$var$C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c208222f2bd70452$var$C[a] = new $c208222f2bd70452$var$v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c208222f2bd70452$var$C[b] = new $c208222f2bd70452$var$v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c208222f2bd70452$var$C[a] = new $c208222f2bd70452$var$v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c208222f2bd70452$var$C[a] = new $c208222f2bd70452$var$v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c208222f2bd70452$var$C[a] = new $c208222f2bd70452$var$v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c208222f2bd70452$var$C[a] = new $c208222f2bd70452$var$v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c208222f2bd70452$var$C[a] = new $c208222f2bd70452$var$v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c208222f2bd70452$var$C[a] = new $c208222f2bd70452$var$v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c208222f2bd70452$var$C[a] = new $c208222f2bd70452$var$v(a, 5, !1, a.toLowerCase(), null, !1);
});
var $c208222f2bd70452$var$Ua = /[\-:]([a-z])/g;
function $c208222f2bd70452$var$Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c208222f2bd70452$var$Ua, $c208222f2bd70452$var$Va);
    $c208222f2bd70452$var$C[b] = new $c208222f2bd70452$var$v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c208222f2bd70452$var$Ua, $c208222f2bd70452$var$Va);
    $c208222f2bd70452$var$C[b] = new $c208222f2bd70452$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c208222f2bd70452$var$Ua, $c208222f2bd70452$var$Va);
    $c208222f2bd70452$var$C[b] = new $c208222f2bd70452$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c208222f2bd70452$var$C[a] = new $c208222f2bd70452$var$v(a, 1, !1, a.toLowerCase(), null, !1);
});
$c208222f2bd70452$var$C.xlinkHref = new $c208222f2bd70452$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c208222f2bd70452$var$C[a] = new $c208222f2bd70452$var$v(a, 1, !1, a.toLowerCase(), null, !0);
});
var $c208222f2bd70452$var$Wa = $hJwnw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$c208222f2bd70452$var$Wa.hasOwnProperty("ReactCurrentDispatcher") || ($c208222f2bd70452$var$Wa.ReactCurrentDispatcher = {
    current: null
});
$c208222f2bd70452$var$Wa.hasOwnProperty("ReactCurrentBatchConfig") || ($c208222f2bd70452$var$Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function $c208222f2bd70452$var$Xa(a, b, c, d) {
    var e = $c208222f2bd70452$var$C.hasOwnProperty(b) ? $c208222f2bd70452$var$C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($c208222f2bd70452$var$Ta(b, c, e, d) && (c = null), d || null === e ? $c208222f2bd70452$var$Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $c208222f2bd70452$var$Ya = /^(.*)[\\\/]/, $c208222f2bd70452$var$E = "function" === typeof Symbol && Symbol.for, $c208222f2bd70452$var$Za = $c208222f2bd70452$var$E ? Symbol.for("react.element") : 60103, $c208222f2bd70452$var$$a = $c208222f2bd70452$var$E ? Symbol.for("react.portal") : 60106, $c208222f2bd70452$var$ab = $c208222f2bd70452$var$E ? Symbol.for("react.fragment") : 60107, $c208222f2bd70452$var$bb = $c208222f2bd70452$var$E ? Symbol.for("react.strict_mode") : 60108, $c208222f2bd70452$var$cb = $c208222f2bd70452$var$E ? Symbol.for("react.profiler") : 60114, $c208222f2bd70452$var$db = $c208222f2bd70452$var$E ? Symbol.for("react.provider") : 60109, $c208222f2bd70452$var$eb = $c208222f2bd70452$var$E ? Symbol.for("react.context") : 60110, $c208222f2bd70452$var$fb = $c208222f2bd70452$var$E ? Symbol.for("react.concurrent_mode") : 60111, $c208222f2bd70452$var$gb = $c208222f2bd70452$var$E ? Symbol.for("react.forward_ref") : 60112, $c208222f2bd70452$var$hb = $c208222f2bd70452$var$E ? Symbol.for("react.suspense") : 60113, $c208222f2bd70452$var$ib = $c208222f2bd70452$var$E ? Symbol.for("react.suspense_list") : 60120, $c208222f2bd70452$var$jb = $c208222f2bd70452$var$E ? Symbol.for("react.memo") : 60115, $c208222f2bd70452$var$kb = $c208222f2bd70452$var$E ? Symbol.for("react.lazy") : 60116, $c208222f2bd70452$var$lb = $c208222f2bd70452$var$E ? Symbol.for("react.block") : 60121, $c208222f2bd70452$var$mb = "function" === typeof Symbol && Symbol.iterator;
function $c208222f2bd70452$var$nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c208222f2bd70452$var$mb && a[$c208222f2bd70452$var$mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $c208222f2bd70452$var$ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function $c208222f2bd70452$var$pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c208222f2bd70452$var$ab:
            return "Fragment";
        case $c208222f2bd70452$var$$a:
            return "Portal";
        case $c208222f2bd70452$var$cb:
            return "Profiler";
        case $c208222f2bd70452$var$bb:
            return "StrictMode";
        case $c208222f2bd70452$var$hb:
            return "Suspense";
        case $c208222f2bd70452$var$ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c208222f2bd70452$var$eb:
            return "Context.Consumer";
        case $c208222f2bd70452$var$db:
            return "Context.Provider";
        case $c208222f2bd70452$var$gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $c208222f2bd70452$var$jb:
            return $c208222f2bd70452$var$pb(a.type);
        case $c208222f2bd70452$var$lb:
            return $c208222f2bd70452$var$pb(a.render);
        case $c208222f2bd70452$var$kb:
            if (a = 1 === a._status ? a._result : null) return $c208222f2bd70452$var$pb(a);
    }
    return null;
}
function $c208222f2bd70452$var$qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = $c208222f2bd70452$var$pb(a.type);
                c = null;
                d && (c = $c208222f2bd70452$var$pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace($c208222f2bd70452$var$Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function $c208222f2bd70452$var$rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $c208222f2bd70452$var$sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c208222f2bd70452$var$tb(a) {
    var b = $c208222f2bd70452$var$sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c208222f2bd70452$var$xb(a) {
    a._valueTracker || (a._valueTracker = $c208222f2bd70452$var$tb(a));
}
function $c208222f2bd70452$var$yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c208222f2bd70452$var$sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c208222f2bd70452$var$zb(a, b) {
    var c = b.checked;
    return $70tqi({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c208222f2bd70452$var$Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c208222f2bd70452$var$rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c208222f2bd70452$var$Bb(a, b) {
    b = b.checked;
    null != b && $c208222f2bd70452$var$Xa(a, "checked", b, !1);
}
function $c208222f2bd70452$var$Cb(a, b) {
    $c208222f2bd70452$var$Bb(a, b);
    var c = $c208222f2bd70452$var$rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c208222f2bd70452$var$Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c208222f2bd70452$var$Db(a, b.type, $c208222f2bd70452$var$rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c208222f2bd70452$var$Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c208222f2bd70452$var$Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $c208222f2bd70452$var$Fb(a) {
    var b = "";
    $hJwnw.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $c208222f2bd70452$var$Gb(a, b) {
    a = $70tqi({
        children: void 0
    }, b);
    if (b = $c208222f2bd70452$var$Fb(b.children)) a.children = b;
    return a;
}
function $c208222f2bd70452$var$Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c208222f2bd70452$var$rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c208222f2bd70452$var$Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c208222f2bd70452$var$u(91));
    return $70tqi({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c208222f2bd70452$var$Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c208222f2bd70452$var$u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($c208222f2bd70452$var$u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c208222f2bd70452$var$rb(c)
    };
}
function $c208222f2bd70452$var$Kb(a, b) {
    var c = $c208222f2bd70452$var$rb(b.value), d = $c208222f2bd70452$var$rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c208222f2bd70452$var$Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $c208222f2bd70452$var$Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $c208222f2bd70452$var$Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c208222f2bd70452$var$Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c208222f2bd70452$var$Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c208222f2bd70452$var$Pb, $c208222f2bd70452$var$Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $c208222f2bd70452$var$Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $c208222f2bd70452$var$Pb = $c208222f2bd70452$var$Pb || document.createElement("div");
        $c208222f2bd70452$var$Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c208222f2bd70452$var$Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c208222f2bd70452$var$Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function $c208222f2bd70452$var$Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c208222f2bd70452$var$Tb = {
    animationend: $c208222f2bd70452$var$Sb("Animation", "AnimationEnd"),
    animationiteration: $c208222f2bd70452$var$Sb("Animation", "AnimationIteration"),
    animationstart: $c208222f2bd70452$var$Sb("Animation", "AnimationStart"),
    transitionend: $c208222f2bd70452$var$Sb("Transition", "TransitionEnd")
}, $c208222f2bd70452$var$Ub = {}, $c208222f2bd70452$var$Vb = {};
$c208222f2bd70452$var$ya && ($c208222f2bd70452$var$Vb = document.createElement("div").style, "AnimationEvent" in window || (delete $c208222f2bd70452$var$Tb.animationend.animation, delete $c208222f2bd70452$var$Tb.animationiteration.animation, delete $c208222f2bd70452$var$Tb.animationstart.animation), "TransitionEvent" in window || delete $c208222f2bd70452$var$Tb.transitionend.transition);
function $c208222f2bd70452$var$Wb(a) {
    if ($c208222f2bd70452$var$Ub[a]) return $c208222f2bd70452$var$Ub[a];
    if (!$c208222f2bd70452$var$Tb[a]) return a;
    var b = $c208222f2bd70452$var$Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c208222f2bd70452$var$Vb) return $c208222f2bd70452$var$Ub[a] = b[c];
    return a;
}
var $c208222f2bd70452$var$Xb = $c208222f2bd70452$var$Wb("animationend"), $c208222f2bd70452$var$Yb = $c208222f2bd70452$var$Wb("animationiteration"), $c208222f2bd70452$var$Zb = $c208222f2bd70452$var$Wb("animationstart"), $c208222f2bd70452$var$$b = $c208222f2bd70452$var$Wb("transitionend"), $c208222f2bd70452$var$ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c208222f2bd70452$var$bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function $c208222f2bd70452$var$cc(a) {
    var b = $c208222f2bd70452$var$bc.get(a);
    void 0 === b && (b = new Map, $c208222f2bd70452$var$bc.set(a, b));
    return b;
}
function $c208222f2bd70452$var$dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c208222f2bd70452$var$ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c208222f2bd70452$var$fc(a) {
    if ($c208222f2bd70452$var$dc(a) !== a) throw Error($c208222f2bd70452$var$u(188));
}
function $c208222f2bd70452$var$gc(a) {
    var b = a.alternate;
    if (!b) {
        b = $c208222f2bd70452$var$dc(a);
        if (null === b) throw Error($c208222f2bd70452$var$u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c208222f2bd70452$var$fc(e), a;
                if (f === d) return $c208222f2bd70452$var$fc(e), b;
                f = f.sibling;
            }
            throw Error($c208222f2bd70452$var$u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c208222f2bd70452$var$u(189));
            }
        }
        if (c.alternate !== d) throw Error($c208222f2bd70452$var$u(190));
    }
    if (3 !== c.tag) throw Error($c208222f2bd70452$var$u(188));
    return c.stateNode.current === c ? a : b;
}
function $c208222f2bd70452$var$hc(a) {
    a = $c208222f2bd70452$var$gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $c208222f2bd70452$var$ic(a, b) {
    if (null == b) throw Error($c208222f2bd70452$var$u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function $c208222f2bd70452$var$jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var $c208222f2bd70452$var$kc = null;
function $c208222f2bd70452$var$lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)$c208222f2bd70452$var$oa(a, b[d], c[d]);
        else b && $c208222f2bd70452$var$oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function $c208222f2bd70452$var$mc(a) {
    null !== a && ($c208222f2bd70452$var$kc = $c208222f2bd70452$var$ic($c208222f2bd70452$var$kc, a));
    a = $c208222f2bd70452$var$kc;
    $c208222f2bd70452$var$kc = null;
    if (a) {
        $c208222f2bd70452$var$jc(a, $c208222f2bd70452$var$lc);
        if ($c208222f2bd70452$var$kc) throw Error($c208222f2bd70452$var$u(95));
        if ($c208222f2bd70452$var$fa) throw a = $c208222f2bd70452$var$ha, $c208222f2bd70452$var$fa = !1, $c208222f2bd70452$var$ha = null, a;
    }
}
function $c208222f2bd70452$var$nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function $c208222f2bd70452$var$oc(a) {
    if (!$c208222f2bd70452$var$ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var $c208222f2bd70452$var$pc = [];
function $c208222f2bd70452$var$qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > $c208222f2bd70452$var$pc.length && $c208222f2bd70452$var$pc.push(a);
}
function $c208222f2bd70452$var$rc(a, b, c, d) {
    if ($c208222f2bd70452$var$pc.length) {
        var e = $c208222f2bd70452$var$pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function $c208222f2bd70452$var$sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = $c208222f2bd70452$var$tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = $c208222f2bd70452$var$nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < $c208222f2bd70452$var$sa.length; k++){
            var l = $c208222f2bd70452$var$sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = $c208222f2bd70452$var$ic(h, l));
        }
        $c208222f2bd70452$var$mc(h);
    }
}
function $c208222f2bd70452$var$uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                $c208222f2bd70452$var$vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                $c208222f2bd70452$var$vc(b, "focus", !0);
                $c208222f2bd70452$var$vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                $c208222f2bd70452$var$oc(a) && $c208222f2bd70452$var$vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === $c208222f2bd70452$var$ac.indexOf(a) && $c208222f2bd70452$var$F(a, b);
        }
        c.set(a, null);
    }
}
var $c208222f2bd70452$var$wc, $c208222f2bd70452$var$xc, $c208222f2bd70452$var$yc, $c208222f2bd70452$var$zc = !1, $c208222f2bd70452$var$Ac = [], $c208222f2bd70452$var$Bc = null, $c208222f2bd70452$var$Cc = null, $c208222f2bd70452$var$Dc = null, $c208222f2bd70452$var$Ec = new Map, $c208222f2bd70452$var$Fc = new Map, $c208222f2bd70452$var$Gc = [], $c208222f2bd70452$var$Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), $c208222f2bd70452$var$Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function $c208222f2bd70452$var$Jc(a, b) {
    var c = $c208222f2bd70452$var$cc(b);
    $c208222f2bd70452$var$Hc.forEach(function(a) {
        $c208222f2bd70452$var$uc(a, b, c);
    });
    $c208222f2bd70452$var$Ic.forEach(function(a) {
        $c208222f2bd70452$var$uc(a, b, c);
    });
}
function $c208222f2bd70452$var$Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function $c208222f2bd70452$var$Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            $c208222f2bd70452$var$Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c208222f2bd70452$var$Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c208222f2bd70452$var$Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c208222f2bd70452$var$Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c208222f2bd70452$var$Fc.delete(b.pointerId);
    }
}
function $c208222f2bd70452$var$Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $c208222f2bd70452$var$Kc(b, c, d, e, f), null !== b && (b = $c208222f2bd70452$var$Nc(b), null !== b && $c208222f2bd70452$var$xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function $c208222f2bd70452$var$Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return $c208222f2bd70452$var$Bc = $c208222f2bd70452$var$Mc($c208222f2bd70452$var$Bc, a, b, c, d, e), !0;
        case "dragenter":
            return $c208222f2bd70452$var$Cc = $c208222f2bd70452$var$Mc($c208222f2bd70452$var$Cc, a, b, c, d, e), !0;
        case "mouseover":
            return $c208222f2bd70452$var$Dc = $c208222f2bd70452$var$Mc($c208222f2bd70452$var$Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c208222f2bd70452$var$Ec.set(f, $c208222f2bd70452$var$Mc($c208222f2bd70452$var$Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c208222f2bd70452$var$Fc.set(f, $c208222f2bd70452$var$Mc($c208222f2bd70452$var$Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c208222f2bd70452$var$Pc(a) {
    var b = $c208222f2bd70452$var$tc(a.target);
    if (null !== b) {
        var c = $c208222f2bd70452$var$dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c208222f2bd70452$var$ec(c), null !== b) {
                    a.blockedOn = b;
                    $ezKtH.unstable_runWithPriority(a.priority, function() {
                        $c208222f2bd70452$var$yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c208222f2bd70452$var$Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = $c208222f2bd70452$var$Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = $c208222f2bd70452$var$Nc(b);
        null !== c && $c208222f2bd70452$var$xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function $c208222f2bd70452$var$Sc(a, b, c) {
    $c208222f2bd70452$var$Qc(a) && c.delete(b);
}
function $c208222f2bd70452$var$Tc() {
    for($c208222f2bd70452$var$zc = !1; 0 < $c208222f2bd70452$var$Ac.length;){
        var a = $c208222f2bd70452$var$Ac[0];
        if (null !== a.blockedOn) {
            a = $c208222f2bd70452$var$Nc(a.blockedOn);
            null !== a && $c208222f2bd70452$var$wc(a);
            break;
        }
        var b = $c208222f2bd70452$var$Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : $c208222f2bd70452$var$Ac.shift();
    }
    null !== $c208222f2bd70452$var$Bc && $c208222f2bd70452$var$Qc($c208222f2bd70452$var$Bc) && ($c208222f2bd70452$var$Bc = null);
    null !== $c208222f2bd70452$var$Cc && $c208222f2bd70452$var$Qc($c208222f2bd70452$var$Cc) && ($c208222f2bd70452$var$Cc = null);
    null !== $c208222f2bd70452$var$Dc && $c208222f2bd70452$var$Qc($c208222f2bd70452$var$Dc) && ($c208222f2bd70452$var$Dc = null);
    $c208222f2bd70452$var$Ec.forEach($c208222f2bd70452$var$Sc);
    $c208222f2bd70452$var$Fc.forEach($c208222f2bd70452$var$Sc);
}
function $c208222f2bd70452$var$Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c208222f2bd70452$var$zc || ($c208222f2bd70452$var$zc = !0, $ezKtH.unstable_scheduleCallback($ezKtH.unstable_NormalPriority, $c208222f2bd70452$var$Tc)));
}
function $c208222f2bd70452$var$Vc(a) {
    function b(b) {
        return $c208222f2bd70452$var$Uc(b, a);
    }
    if (0 < $c208222f2bd70452$var$Ac.length) {
        $c208222f2bd70452$var$Uc($c208222f2bd70452$var$Ac[0], a);
        for(var c = 1; c < $c208222f2bd70452$var$Ac.length; c++){
            var d = $c208222f2bd70452$var$Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c208222f2bd70452$var$Bc && $c208222f2bd70452$var$Uc($c208222f2bd70452$var$Bc, a);
    null !== $c208222f2bd70452$var$Cc && $c208222f2bd70452$var$Uc($c208222f2bd70452$var$Cc, a);
    null !== $c208222f2bd70452$var$Dc && $c208222f2bd70452$var$Uc($c208222f2bd70452$var$Dc, a);
    $c208222f2bd70452$var$Ec.forEach(b);
    $c208222f2bd70452$var$Fc.forEach(b);
    for(c = 0; c < $c208222f2bd70452$var$Gc.length; c++)d = $c208222f2bd70452$var$Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c208222f2bd70452$var$Gc.length && (c = $c208222f2bd70452$var$Gc[0], null === c.blockedOn);)$c208222f2bd70452$var$Pc(c), null === c.blockedOn && $c208222f2bd70452$var$Gc.shift();
}
var $c208222f2bd70452$var$Wc = {}, $c208222f2bd70452$var$Yc = new Map, $c208222f2bd70452$var$Zc = new Map, $c208222f2bd70452$var$$c = [
    "abort",
    "abort",
    $c208222f2bd70452$var$Xb,
    "animationEnd",
    $c208222f2bd70452$var$Yb,
    "animationIteration",
    $c208222f2bd70452$var$Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $c208222f2bd70452$var$$b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $c208222f2bd70452$var$ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        $c208222f2bd70452$var$Zc.set(d, b);
        $c208222f2bd70452$var$Yc.set(d, f);
        $c208222f2bd70452$var$Wc[e] = f;
    }
}
$c208222f2bd70452$var$ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$c208222f2bd70452$var$ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$c208222f2bd70452$var$ad($c208222f2bd70452$var$$c, 2);
for(var $c208222f2bd70452$var$bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $c208222f2bd70452$var$cd = 0; $c208222f2bd70452$var$cd < $c208222f2bd70452$var$bd.length; $c208222f2bd70452$var$cd++)$c208222f2bd70452$var$Zc.set($c208222f2bd70452$var$bd[$c208222f2bd70452$var$cd], 0);
var $c208222f2bd70452$var$dd = $ezKtH.unstable_UserBlockingPriority, $c208222f2bd70452$var$ed = $ezKtH.unstable_runWithPriority, $c208222f2bd70452$var$fd = !0;
function $c208222f2bd70452$var$F(a, b) {
    $c208222f2bd70452$var$vc(b, a, !1);
}
function $c208222f2bd70452$var$vc(a, b, c) {
    var d = $c208222f2bd70452$var$Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = $c208222f2bd70452$var$gd.bind(null, b, 1, a);
            break;
        case 1:
            d = $c208222f2bd70452$var$hd.bind(null, b, 1, a);
            break;
        default:
            d = $c208222f2bd70452$var$id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function $c208222f2bd70452$var$gd(a, b, c, d) {
    $c208222f2bd70452$var$Ja || $c208222f2bd70452$var$Ha();
    var e = $c208222f2bd70452$var$id, f = $c208222f2bd70452$var$Ja;
    $c208222f2bd70452$var$Ja = !0;
    try {
        $c208222f2bd70452$var$Ga(e, a, b, c, d);
    } finally{
        ($c208222f2bd70452$var$Ja = f) || $c208222f2bd70452$var$La();
    }
}
function $c208222f2bd70452$var$hd(a, b, c, d) {
    $c208222f2bd70452$var$ed($c208222f2bd70452$var$dd, $c208222f2bd70452$var$id.bind(null, a, b, c, d));
}
function $c208222f2bd70452$var$id(a, b, c, d) {
    if ($c208222f2bd70452$var$fd) {
        if (0 < $c208222f2bd70452$var$Ac.length && -1 < $c208222f2bd70452$var$Hc.indexOf(a)) a = $c208222f2bd70452$var$Kc(null, a, b, c, d), $c208222f2bd70452$var$Ac.push(a);
        else {
            var e = $c208222f2bd70452$var$Rc(a, b, c, d);
            if (null === e) $c208222f2bd70452$var$Lc(a, d);
            else if (-1 < $c208222f2bd70452$var$Hc.indexOf(a)) a = $c208222f2bd70452$var$Kc(e, a, b, c, d), $c208222f2bd70452$var$Ac.push(a);
            else if (!$c208222f2bd70452$var$Oc(e, a, b, c, d)) {
                $c208222f2bd70452$var$Lc(a, d);
                a = $c208222f2bd70452$var$rc(a, d, null, b);
                try {
                    $c208222f2bd70452$var$Ma($c208222f2bd70452$var$sc, a);
                } finally{
                    $c208222f2bd70452$var$qc(a);
                }
            }
        }
    }
}
function $c208222f2bd70452$var$Rc(a, b, c, d) {
    c = $c208222f2bd70452$var$nc(d);
    c = $c208222f2bd70452$var$tc(c);
    if (null !== c) {
        var e = $c208222f2bd70452$var$dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = $c208222f2bd70452$var$ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = $c208222f2bd70452$var$rc(a, d, c, b);
    try {
        $c208222f2bd70452$var$Ma($c208222f2bd70452$var$sc, a);
    } finally{
        $c208222f2bd70452$var$qc(a);
    }
    return null;
}
var $c208222f2bd70452$var$jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c208222f2bd70452$var$kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c208222f2bd70452$var$jd).forEach(function(a) {
    $c208222f2bd70452$var$kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c208222f2bd70452$var$jd[b] = $c208222f2bd70452$var$jd[a];
    });
});
function $c208222f2bd70452$var$ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c208222f2bd70452$var$jd.hasOwnProperty(a) && $c208222f2bd70452$var$jd[a] ? ("" + b).trim() : b + "px";
}
function $c208222f2bd70452$var$md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c208222f2bd70452$var$ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c208222f2bd70452$var$nd = $70tqi({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c208222f2bd70452$var$od(a, b) {
    if (b) {
        if ($c208222f2bd70452$var$nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c208222f2bd70452$var$u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c208222f2bd70452$var$u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($c208222f2bd70452$var$u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c208222f2bd70452$var$u(62, ""));
    }
}
function $c208222f2bd70452$var$pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c208222f2bd70452$var$qd = $c208222f2bd70452$var$Mb.html;
function $c208222f2bd70452$var$rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = $c208222f2bd70452$var$cc(a);
    b = $c208222f2bd70452$var$wa[b];
    for(var d = 0; d < b.length; d++)$c208222f2bd70452$var$uc(b[d], a, c);
}
function $c208222f2bd70452$var$sd() {}
function $c208222f2bd70452$var$td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c208222f2bd70452$var$ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c208222f2bd70452$var$vd(a, b) {
    var c = $c208222f2bd70452$var$ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c208222f2bd70452$var$ud(c);
    }
}
function $c208222f2bd70452$var$wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c208222f2bd70452$var$wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c208222f2bd70452$var$xd() {
    for(var a = window, b = $c208222f2bd70452$var$td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c208222f2bd70452$var$td(a.document);
    }
    return b;
}
function $c208222f2bd70452$var$yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $c208222f2bd70452$var$zd = "$", $c208222f2bd70452$var$Ad = "/$", $c208222f2bd70452$var$Bd = "$?", $c208222f2bd70452$var$Cd = "$!", $c208222f2bd70452$var$Dd = null, $c208222f2bd70452$var$Ed = null;
function $c208222f2bd70452$var$Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $c208222f2bd70452$var$Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c208222f2bd70452$var$Hd = "function" === typeof setTimeout ? setTimeout : void 0, $c208222f2bd70452$var$Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $c208222f2bd70452$var$Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $c208222f2bd70452$var$Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === $c208222f2bd70452$var$zd || c === $c208222f2bd70452$var$Cd || c === $c208222f2bd70452$var$Bd) {
                if (0 === b) return a;
                b--;
            } else c === $c208222f2bd70452$var$Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c208222f2bd70452$var$Ld = Math.random().toString(36).slice(2), $c208222f2bd70452$var$Md = "__reactInternalInstance$" + $c208222f2bd70452$var$Ld, $c208222f2bd70452$var$Nd = "__reactEventHandlers$" + $c208222f2bd70452$var$Ld, $c208222f2bd70452$var$Od = "__reactContainere$" + $c208222f2bd70452$var$Ld;
function $c208222f2bd70452$var$tc(a) {
    var b = a[$c208222f2bd70452$var$Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c208222f2bd70452$var$Od] || c[$c208222f2bd70452$var$Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c208222f2bd70452$var$Kd(a); null !== a;){
                if (c = a[$c208222f2bd70452$var$Md]) return c;
                a = $c208222f2bd70452$var$Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c208222f2bd70452$var$Nc(a) {
    a = a[$c208222f2bd70452$var$Md] || a[$c208222f2bd70452$var$Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c208222f2bd70452$var$Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c208222f2bd70452$var$u(33));
}
function $c208222f2bd70452$var$Qd(a) {
    return a[$c208222f2bd70452$var$Nd] || null;
}
function $c208222f2bd70452$var$Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c208222f2bd70452$var$Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = $c208222f2bd70452$var$la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c208222f2bd70452$var$u(231, b, typeof c));
    return c;
}
function $c208222f2bd70452$var$Td(a, b, c) {
    if (b = $c208222f2bd70452$var$Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = $c208222f2bd70452$var$ic(c._dispatchListeners, b), c._dispatchInstances = $c208222f2bd70452$var$ic(c._dispatchInstances, a);
}
function $c208222f2bd70452$var$Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = $c208222f2bd70452$var$Rd(b);
        for(b = c.length; 0 < b--;)$c208222f2bd70452$var$Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)$c208222f2bd70452$var$Td(c[b], "bubbled", a);
    }
}
function $c208222f2bd70452$var$Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = $c208222f2bd70452$var$Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = $c208222f2bd70452$var$ic(c._dispatchListeners, b), c._dispatchInstances = $c208222f2bd70452$var$ic(c._dispatchInstances, a));
}
function $c208222f2bd70452$var$Wd(a) {
    a && a.dispatchConfig.registrationName && $c208222f2bd70452$var$Vd(a._targetInst, null, a);
}
function $c208222f2bd70452$var$Xd(a) {
    $c208222f2bd70452$var$jc(a, $c208222f2bd70452$var$Ud);
}
var $c208222f2bd70452$var$Yd = null, $c208222f2bd70452$var$Zd = null, $c208222f2bd70452$var$$d = null;
function $c208222f2bd70452$var$ae() {
    if ($c208222f2bd70452$var$$d) return $c208222f2bd70452$var$$d;
    var a, b = $c208222f2bd70452$var$Zd, c = b.length, d, e = "value" in $c208222f2bd70452$var$Yd ? $c208222f2bd70452$var$Yd.value : $c208222f2bd70452$var$Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c208222f2bd70452$var$$d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c208222f2bd70452$var$be() {
    return !0;
}
function $c208222f2bd70452$var$ce() {
    return !1;
}
function $c208222f2bd70452$var$G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? $c208222f2bd70452$var$be : $c208222f2bd70452$var$ce;
    this.isPropagationStopped = $c208222f2bd70452$var$ce;
    return this;
}
$70tqi($c208222f2bd70452$var$G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c208222f2bd70452$var$be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c208222f2bd70452$var$be);
    },
    persist: function() {
        this.isPersistent = $c208222f2bd70452$var$be;
    },
    isPersistent: $c208222f2bd70452$var$ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = $c208222f2bd70452$var$ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
$c208222f2bd70452$var$G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
$c208222f2bd70452$var$G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $70tqi(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $70tqi({}, d.Interface, a);
    c.extend = d.extend;
    $c208222f2bd70452$var$de(c);
    return c;
};
$c208222f2bd70452$var$de($c208222f2bd70452$var$G);
function $c208222f2bd70452$var$ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function $c208222f2bd70452$var$fe(a) {
    if (!(a instanceof this)) throw Error($c208222f2bd70452$var$u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function $c208222f2bd70452$var$de(a) {
    a.eventPool = [];
    a.getPooled = $c208222f2bd70452$var$ee;
    a.release = $c208222f2bd70452$var$fe;
}
var $c208222f2bd70452$var$ge = $c208222f2bd70452$var$G.extend({
    data: null
}), $c208222f2bd70452$var$he = $c208222f2bd70452$var$G.extend({
    data: null
}), $c208222f2bd70452$var$ie = [
    9,
    13,
    27,
    32
], $c208222f2bd70452$var$je = $c208222f2bd70452$var$ya && "CompositionEvent" in window, $c208222f2bd70452$var$ke = null;
$c208222f2bd70452$var$ya && "documentMode" in document && ($c208222f2bd70452$var$ke = document.documentMode);
var $c208222f2bd70452$var$le = $c208222f2bd70452$var$ya && "TextEvent" in window && !$c208222f2bd70452$var$ke, $c208222f2bd70452$var$me = $c208222f2bd70452$var$ya && (!$c208222f2bd70452$var$je || $c208222f2bd70452$var$ke && 8 < $c208222f2bd70452$var$ke && 11 >= $c208222f2bd70452$var$ke), $c208222f2bd70452$var$ne = String.fromCharCode(32), $c208222f2bd70452$var$oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, $c208222f2bd70452$var$pe = !1;
function $c208222f2bd70452$var$qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c208222f2bd70452$var$ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function $c208222f2bd70452$var$re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c208222f2bd70452$var$se = !1;
function $c208222f2bd70452$var$te(a, b) {
    switch(a){
        case "compositionend":
            return $c208222f2bd70452$var$re(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c208222f2bd70452$var$pe = !0;
            return $c208222f2bd70452$var$ne;
        case "textInput":
            return a = b.data, a === $c208222f2bd70452$var$ne && $c208222f2bd70452$var$pe ? null : a;
        default:
            return null;
    }
}
function $c208222f2bd70452$var$ue(a, b) {
    if ($c208222f2bd70452$var$se) return "compositionend" === a || !$c208222f2bd70452$var$je && $c208222f2bd70452$var$qe(a, b) ? (a = $c208222f2bd70452$var$ae(), $c208222f2bd70452$var$$d = $c208222f2bd70452$var$Zd = $c208222f2bd70452$var$Yd = null, $c208222f2bd70452$var$se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c208222f2bd70452$var$me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c208222f2bd70452$var$ve = {
    eventTypes: $c208222f2bd70452$var$oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if ($c208222f2bd70452$var$je) b: {
            switch(a){
                case "compositionstart":
                    var f = $c208222f2bd70452$var$oe.compositionStart;
                    break b;
                case "compositionend":
                    f = $c208222f2bd70452$var$oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = $c208222f2bd70452$var$oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else $c208222f2bd70452$var$se ? $c208222f2bd70452$var$qe(a, c) && (f = $c208222f2bd70452$var$oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = $c208222f2bd70452$var$oe.compositionStart);
        f ? ($c208222f2bd70452$var$me && "ko" !== c.locale && ($c208222f2bd70452$var$se || f !== $c208222f2bd70452$var$oe.compositionStart ? f === $c208222f2bd70452$var$oe.compositionEnd && $c208222f2bd70452$var$se && (e = $c208222f2bd70452$var$ae()) : ($c208222f2bd70452$var$Yd = d, $c208222f2bd70452$var$Zd = "value" in $c208222f2bd70452$var$Yd ? $c208222f2bd70452$var$Yd.value : $c208222f2bd70452$var$Yd.textContent, $c208222f2bd70452$var$se = !0)), f = $c208222f2bd70452$var$ge.getPooled(f, b, c, d), e ? f.data = e : (e = $c208222f2bd70452$var$re(c), null !== e && (f.data = e)), $c208222f2bd70452$var$Xd(f), e = f) : e = null;
        (a = $c208222f2bd70452$var$le ? $c208222f2bd70452$var$te(a, c) : $c208222f2bd70452$var$ue(a, c)) ? (b = $c208222f2bd70452$var$he.getPooled($c208222f2bd70452$var$oe.beforeInput, b, c, d), b.data = a, $c208222f2bd70452$var$Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, $c208222f2bd70452$var$we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c208222f2bd70452$var$xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c208222f2bd70452$var$we[a.type] : "textarea" === b ? !0 : !1;
}
var $c208222f2bd70452$var$ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function $c208222f2bd70452$var$ze(a, b, c) {
    a = $c208222f2bd70452$var$G.getPooled($c208222f2bd70452$var$ye.change, a, b, c);
    a.type = "change";
    $c208222f2bd70452$var$Da(c);
    $c208222f2bd70452$var$Xd(a);
    return a;
}
var $c208222f2bd70452$var$Ae = null, $c208222f2bd70452$var$Be = null;
function $c208222f2bd70452$var$Ce(a) {
    $c208222f2bd70452$var$mc(a);
}
function $c208222f2bd70452$var$De(a) {
    var b = $c208222f2bd70452$var$Pd(a);
    if ($c208222f2bd70452$var$yb(b)) return a;
}
function $c208222f2bd70452$var$Ee(a, b) {
    if ("change" === a) return b;
}
var $c208222f2bd70452$var$Fe = !1;
$c208222f2bd70452$var$ya && ($c208222f2bd70452$var$Fe = $c208222f2bd70452$var$oc("input") && (!document.documentMode || 9 < document.documentMode));
function $c208222f2bd70452$var$Ge() {
    $c208222f2bd70452$var$Ae && ($c208222f2bd70452$var$Ae.detachEvent("onpropertychange", $c208222f2bd70452$var$He), $c208222f2bd70452$var$Be = $c208222f2bd70452$var$Ae = null);
}
function $c208222f2bd70452$var$He(a) {
    if ("value" === a.propertyName && $c208222f2bd70452$var$De($c208222f2bd70452$var$Be)) {
        if (a = $c208222f2bd70452$var$ze($c208222f2bd70452$var$Be, a, $c208222f2bd70452$var$nc(a)), $c208222f2bd70452$var$Ja) $c208222f2bd70452$var$mc(a);
        else {
            $c208222f2bd70452$var$Ja = !0;
            try {
                $c208222f2bd70452$var$Fa($c208222f2bd70452$var$Ce, a);
            } finally{
                $c208222f2bd70452$var$Ja = !1, $c208222f2bd70452$var$La();
            }
        }
    }
}
function $c208222f2bd70452$var$Ie(a, b, c) {
    "focus" === a ? ($c208222f2bd70452$var$Ge(), $c208222f2bd70452$var$Ae = b, $c208222f2bd70452$var$Be = c, $c208222f2bd70452$var$Ae.attachEvent("onpropertychange", $c208222f2bd70452$var$He)) : "blur" === a && $c208222f2bd70452$var$Ge();
}
function $c208222f2bd70452$var$Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c208222f2bd70452$var$De($c208222f2bd70452$var$Be);
}
function $c208222f2bd70452$var$Ke(a, b) {
    if ("click" === a) return $c208222f2bd70452$var$De(b);
}
function $c208222f2bd70452$var$Le(a, b) {
    if ("input" === a || "change" === a) return $c208222f2bd70452$var$De(b);
}
var $c208222f2bd70452$var$Me = {
    eventTypes: $c208222f2bd70452$var$ye,
    _isInputEventSupported: $c208222f2bd70452$var$Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? $c208222f2bd70452$var$Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = $c208222f2bd70452$var$Ee;
        else if ($c208222f2bd70452$var$xe(e)) {
            if ($c208222f2bd70452$var$Fe) g = $c208222f2bd70452$var$Le;
            else {
                g = $c208222f2bd70452$var$Je;
                var h = $c208222f2bd70452$var$Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = $c208222f2bd70452$var$Ke);
        if (g && (g = g(a, b))) return $c208222f2bd70452$var$ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && $c208222f2bd70452$var$Db(e, "number", e.value);
    }
}, $c208222f2bd70452$var$Ne = $c208222f2bd70452$var$G.extend({
    view: null,
    detail: null
}), $c208222f2bd70452$var$Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c208222f2bd70452$var$Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c208222f2bd70452$var$Oe[a]) ? !!b[a] : !1;
}
function $c208222f2bd70452$var$Qe() {
    return $c208222f2bd70452$var$Pe;
}
var $c208222f2bd70452$var$Re = 0, $c208222f2bd70452$var$Se = 0, $c208222f2bd70452$var$Te = !1, $c208222f2bd70452$var$Ue = !1, $c208222f2bd70452$var$Ve = $c208222f2bd70452$var$Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: $c208222f2bd70452$var$Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = $c208222f2bd70452$var$Re;
        $c208222f2bd70452$var$Re = a.screenX;
        return $c208222f2bd70452$var$Te ? "mousemove" === a.type ? a.screenX - b : 0 : ($c208222f2bd70452$var$Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = $c208222f2bd70452$var$Se;
        $c208222f2bd70452$var$Se = a.screenY;
        return $c208222f2bd70452$var$Ue ? "mousemove" === a.type ? a.screenY - b : 0 : ($c208222f2bd70452$var$Ue = !0, 0);
    }
}), $c208222f2bd70452$var$We = $c208222f2bd70452$var$Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), $c208222f2bd70452$var$Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, $c208222f2bd70452$var$Ye = {
    eventTypes: $c208222f2bd70452$var$Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? $c208222f2bd70452$var$tc(b) : null, null !== b) {
                var h = $c208222f2bd70452$var$dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = $c208222f2bd70452$var$Ve;
            var l = $c208222f2bd70452$var$Xe.mouseLeave;
            var m = $c208222f2bd70452$var$Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = $c208222f2bd70452$var$We, l = $c208222f2bd70452$var$Xe.pointerLeave, m = $c208222f2bd70452$var$Xe.pointerEnter, p = "pointer";
        a = null == g ? f : $c208222f2bd70452$var$Pd(g);
        f = null == b ? f : $c208222f2bd70452$var$Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = $c208222f2bd70452$var$Rd(a))g++;
            a = 0;
            for(b = m; b; b = $c208222f2bd70452$var$Rd(b))a++;
            for(; 0 < g - a;)k = $c208222f2bd70452$var$Rd(k), g--;
            for(; 0 < a - g;)m = $c208222f2bd70452$var$Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = $c208222f2bd70452$var$Rd(k);
                m = $c208222f2bd70452$var$Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = $c208222f2bd70452$var$Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = $c208222f2bd70452$var$Rd(p);
        }
        for(p = 0; p < k.length; p++)$c208222f2bd70452$var$Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)$c208222f2bd70452$var$Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function $c208222f2bd70452$var$Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c208222f2bd70452$var$$e = "function" === typeof Object.is ? Object.is : $c208222f2bd70452$var$Ze, $c208222f2bd70452$var$af = Object.prototype.hasOwnProperty;
function $c208222f2bd70452$var$bf(a, b) {
    if ($c208222f2bd70452$var$$e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$c208222f2bd70452$var$af.call(b, c[d]) || !$c208222f2bd70452$var$$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var $c208222f2bd70452$var$cf = $c208222f2bd70452$var$ya && "documentMode" in document && 11 >= document.documentMode, $c208222f2bd70452$var$df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, $c208222f2bd70452$var$ef = null, $c208222f2bd70452$var$ff = null, $c208222f2bd70452$var$gf = null, $c208222f2bd70452$var$hf = !1;
function $c208222f2bd70452$var$jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if ($c208222f2bd70452$var$hf || null == $c208222f2bd70452$var$ef || $c208222f2bd70452$var$ef !== $c208222f2bd70452$var$td(c)) return null;
    c = $c208222f2bd70452$var$ef;
    "selectionStart" in c && $c208222f2bd70452$var$yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return $c208222f2bd70452$var$gf && $c208222f2bd70452$var$bf($c208222f2bd70452$var$gf, c) ? null : ($c208222f2bd70452$var$gf = c, a = $c208222f2bd70452$var$G.getPooled($c208222f2bd70452$var$df.select, $c208222f2bd70452$var$ff, a, b), a.type = "select", a.target = $c208222f2bd70452$var$ef, $c208222f2bd70452$var$Xd(a), a);
}
var $c208222f2bd70452$var$kf = {
    eventTypes: $c208222f2bd70452$var$df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = $c208222f2bd70452$var$cc(e);
                f = $c208222f2bd70452$var$wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? $c208222f2bd70452$var$Pd(b) : window;
        switch(a){
            case "focus":
                if ($c208222f2bd70452$var$xe(e) || "true" === e.contentEditable) $c208222f2bd70452$var$ef = e, $c208222f2bd70452$var$ff = b, $c208222f2bd70452$var$gf = null;
                break;
            case "blur":
                $c208222f2bd70452$var$gf = $c208222f2bd70452$var$ff = $c208222f2bd70452$var$ef = null;
                break;
            case "mousedown":
                $c208222f2bd70452$var$hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return $c208222f2bd70452$var$hf = !1, $c208222f2bd70452$var$jf(c, d);
            case "selectionchange":
                if ($c208222f2bd70452$var$cf) break;
            case "keydown":
            case "keyup":
                return $c208222f2bd70452$var$jf(c, d);
        }
        return null;
    }
}, $c208222f2bd70452$var$lf = $c208222f2bd70452$var$G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), $c208222f2bd70452$var$mf = $c208222f2bd70452$var$G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c208222f2bd70452$var$nf = $c208222f2bd70452$var$Ne.extend({
    relatedTarget: null
});
function $c208222f2bd70452$var$of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var $c208222f2bd70452$var$pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c208222f2bd70452$var$qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c208222f2bd70452$var$rf = $c208222f2bd70452$var$Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = $c208222f2bd70452$var$pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c208222f2bd70452$var$of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c208222f2bd70452$var$qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: $c208222f2bd70452$var$Qe,
    charCode: function(a) {
        return "keypress" === a.type ? $c208222f2bd70452$var$of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c208222f2bd70452$var$of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c208222f2bd70452$var$sf = $c208222f2bd70452$var$Ve.extend({
    dataTransfer: null
}), $c208222f2bd70452$var$tf = $c208222f2bd70452$var$Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: $c208222f2bd70452$var$Qe
}), $c208222f2bd70452$var$uf = $c208222f2bd70452$var$G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), $c208222f2bd70452$var$vf = $c208222f2bd70452$var$Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), $c208222f2bd70452$var$wf = {
    eventTypes: $c208222f2bd70452$var$Wc,
    extractEvents: function(a, b, c, d) {
        var e = $c208222f2bd70452$var$Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === $c208222f2bd70452$var$of(c)) return null;
            case "keydown":
            case "keyup":
                a = $c208222f2bd70452$var$rf;
                break;
            case "blur":
            case "focus":
                a = $c208222f2bd70452$var$nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = $c208222f2bd70452$var$Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = $c208222f2bd70452$var$sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = $c208222f2bd70452$var$tf;
                break;
            case $c208222f2bd70452$var$Xb:
            case $c208222f2bd70452$var$Yb:
            case $c208222f2bd70452$var$Zb:
                a = $c208222f2bd70452$var$lf;
                break;
            case $c208222f2bd70452$var$$b:
                a = $c208222f2bd70452$var$uf;
                break;
            case "scroll":
                a = $c208222f2bd70452$var$Ne;
                break;
            case "wheel":
                a = $c208222f2bd70452$var$vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = $c208222f2bd70452$var$mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = $c208222f2bd70452$var$We;
                break;
            default:
                a = $c208222f2bd70452$var$G;
        }
        b = a.getPooled(e, b, c, d);
        $c208222f2bd70452$var$Xd(b);
        return b;
    }
};
if ($c208222f2bd70452$var$pa) throw Error($c208222f2bd70452$var$u(101));
$c208222f2bd70452$var$pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
$c208222f2bd70452$var$ra();
var $c208222f2bd70452$var$xf = $c208222f2bd70452$var$Nc;
$c208222f2bd70452$var$la = $c208222f2bd70452$var$Qd;
$c208222f2bd70452$var$ma = $c208222f2bd70452$var$xf;
$c208222f2bd70452$var$na = $c208222f2bd70452$var$Pd;
$c208222f2bd70452$var$xa({
    SimpleEventPlugin: $c208222f2bd70452$var$wf,
    EnterLeaveEventPlugin: $c208222f2bd70452$var$Ye,
    ChangeEventPlugin: $c208222f2bd70452$var$Me,
    SelectEventPlugin: $c208222f2bd70452$var$kf,
    BeforeInputEventPlugin: $c208222f2bd70452$var$ve
});
var $c208222f2bd70452$var$yf = [], $c208222f2bd70452$var$zf = -1;
function $c208222f2bd70452$var$H(a) {
    0 > $c208222f2bd70452$var$zf || (a.current = $c208222f2bd70452$var$yf[$c208222f2bd70452$var$zf], $c208222f2bd70452$var$yf[$c208222f2bd70452$var$zf] = null, $c208222f2bd70452$var$zf--);
}
function $c208222f2bd70452$var$I(a, b) {
    $c208222f2bd70452$var$zf++;
    $c208222f2bd70452$var$yf[$c208222f2bd70452$var$zf] = a.current;
    a.current = b;
}
var $c208222f2bd70452$var$Af = {}, $c208222f2bd70452$var$J = {
    current: $c208222f2bd70452$var$Af
}, $c208222f2bd70452$var$K = {
    current: !1
}, $c208222f2bd70452$var$Bf = $c208222f2bd70452$var$Af;
function $c208222f2bd70452$var$Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c208222f2bd70452$var$Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c208222f2bd70452$var$L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c208222f2bd70452$var$Df() {
    $c208222f2bd70452$var$H($c208222f2bd70452$var$K);
    $c208222f2bd70452$var$H($c208222f2bd70452$var$J);
}
function $c208222f2bd70452$var$Ef(a, b, c) {
    if ($c208222f2bd70452$var$J.current !== $c208222f2bd70452$var$Af) throw Error($c208222f2bd70452$var$u(168));
    $c208222f2bd70452$var$I($c208222f2bd70452$var$J, b);
    $c208222f2bd70452$var$I($c208222f2bd70452$var$K, c);
}
function $c208222f2bd70452$var$Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($c208222f2bd70452$var$u(108, $c208222f2bd70452$var$pb(b) || "Unknown", e));
    return $70tqi({}, c, {}, d);
}
function $c208222f2bd70452$var$Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c208222f2bd70452$var$Af;
    $c208222f2bd70452$var$Bf = $c208222f2bd70452$var$J.current;
    $c208222f2bd70452$var$I($c208222f2bd70452$var$J, a);
    $c208222f2bd70452$var$I($c208222f2bd70452$var$K, $c208222f2bd70452$var$K.current);
    return !0;
}
function $c208222f2bd70452$var$Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c208222f2bd70452$var$u(169));
    c ? (a = $c208222f2bd70452$var$Ff(a, b, $c208222f2bd70452$var$Bf), d.__reactInternalMemoizedMergedChildContext = a, $c208222f2bd70452$var$H($c208222f2bd70452$var$K), $c208222f2bd70452$var$H($c208222f2bd70452$var$J), $c208222f2bd70452$var$I($c208222f2bd70452$var$J, a)) : $c208222f2bd70452$var$H($c208222f2bd70452$var$K);
    $c208222f2bd70452$var$I($c208222f2bd70452$var$K, c);
}
var $c208222f2bd70452$var$If = $ezKtH.unstable_runWithPriority, $c208222f2bd70452$var$Jf = $ezKtH.unstable_scheduleCallback, $c208222f2bd70452$var$Kf = $ezKtH.unstable_cancelCallback, $c208222f2bd70452$var$Lf = $ezKtH.unstable_requestPaint, $c208222f2bd70452$var$Mf = $ezKtH.unstable_now, $c208222f2bd70452$var$Nf = $ezKtH.unstable_getCurrentPriorityLevel, $c208222f2bd70452$var$Of = $ezKtH.unstable_ImmediatePriority, $c208222f2bd70452$var$Pf = $ezKtH.unstable_UserBlockingPriority, $c208222f2bd70452$var$Qf = $ezKtH.unstable_NormalPriority, $c208222f2bd70452$var$Rf = $ezKtH.unstable_LowPriority, $c208222f2bd70452$var$Sf = $ezKtH.unstable_IdlePriority, $c208222f2bd70452$var$Tf = {}, $c208222f2bd70452$var$Uf = $ezKtH.unstable_shouldYield, $c208222f2bd70452$var$Vf = void 0 !== $c208222f2bd70452$var$Lf ? $c208222f2bd70452$var$Lf : function() {}, $c208222f2bd70452$var$Wf = null, $c208222f2bd70452$var$Xf = null, $c208222f2bd70452$var$Yf = !1, $c208222f2bd70452$var$Zf = $c208222f2bd70452$var$Mf(), $c208222f2bd70452$var$$f = 1E4 > $c208222f2bd70452$var$Zf ? $c208222f2bd70452$var$Mf : function() {
    return $c208222f2bd70452$var$Mf() - $c208222f2bd70452$var$Zf;
};
function $c208222f2bd70452$var$ag() {
    switch($c208222f2bd70452$var$Nf()){
        case $c208222f2bd70452$var$Of:
            return 99;
        case $c208222f2bd70452$var$Pf:
            return 98;
        case $c208222f2bd70452$var$Qf:
            return 97;
        case $c208222f2bd70452$var$Rf:
            return 96;
        case $c208222f2bd70452$var$Sf:
            return 95;
        default:
            throw Error($c208222f2bd70452$var$u(332));
    }
}
function $c208222f2bd70452$var$bg(a) {
    switch(a){
        case 99:
            return $c208222f2bd70452$var$Of;
        case 98:
            return $c208222f2bd70452$var$Pf;
        case 97:
            return $c208222f2bd70452$var$Qf;
        case 96:
            return $c208222f2bd70452$var$Rf;
        case 95:
            return $c208222f2bd70452$var$Sf;
        default:
            throw Error($c208222f2bd70452$var$u(332));
    }
}
function $c208222f2bd70452$var$cg(a, b) {
    a = $c208222f2bd70452$var$bg(a);
    return $c208222f2bd70452$var$If(a, b);
}
function $c208222f2bd70452$var$dg(a, b, c) {
    a = $c208222f2bd70452$var$bg(a);
    return $c208222f2bd70452$var$Jf(a, b, c);
}
function $c208222f2bd70452$var$eg(a) {
    null === $c208222f2bd70452$var$Wf ? ($c208222f2bd70452$var$Wf = [
        a
    ], $c208222f2bd70452$var$Xf = $c208222f2bd70452$var$Jf($c208222f2bd70452$var$Of, $c208222f2bd70452$var$fg)) : $c208222f2bd70452$var$Wf.push(a);
    return $c208222f2bd70452$var$Tf;
}
function $c208222f2bd70452$var$gg() {
    if (null !== $c208222f2bd70452$var$Xf) {
        var a = $c208222f2bd70452$var$Xf;
        $c208222f2bd70452$var$Xf = null;
        $c208222f2bd70452$var$Kf(a);
    }
    $c208222f2bd70452$var$fg();
}
function $c208222f2bd70452$var$fg() {
    if (!$c208222f2bd70452$var$Yf && null !== $c208222f2bd70452$var$Wf) {
        $c208222f2bd70452$var$Yf = !0;
        var a = 0;
        try {
            var b = $c208222f2bd70452$var$Wf;
            $c208222f2bd70452$var$cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $c208222f2bd70452$var$Wf = null;
        } catch (c) {
            throw null !== $c208222f2bd70452$var$Wf && ($c208222f2bd70452$var$Wf = $c208222f2bd70452$var$Wf.slice(a + 1)), $c208222f2bd70452$var$Jf($c208222f2bd70452$var$Of, $c208222f2bd70452$var$gg), c;
        } finally{
            $c208222f2bd70452$var$Yf = !1;
        }
    }
}
function $c208222f2bd70452$var$hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function $c208222f2bd70452$var$ig(a, b) {
    if (a && a.defaultProps) {
        b = $70tqi({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var $c208222f2bd70452$var$jg = {
    current: null
}, $c208222f2bd70452$var$kg = null, $c208222f2bd70452$var$lg = null, $c208222f2bd70452$var$mg = null;
function $c208222f2bd70452$var$ng() {
    $c208222f2bd70452$var$mg = $c208222f2bd70452$var$lg = $c208222f2bd70452$var$kg = null;
}
function $c208222f2bd70452$var$og(a) {
    var b = $c208222f2bd70452$var$jg.current;
    $c208222f2bd70452$var$H($c208222f2bd70452$var$jg);
    a.type._context._currentValue = b;
}
function $c208222f2bd70452$var$pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function $c208222f2bd70452$var$qg(a, b) {
    $c208222f2bd70452$var$kg = a;
    $c208222f2bd70452$var$mg = $c208222f2bd70452$var$lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && ($c208222f2bd70452$var$rg = !0), a.firstContext = null);
}
function $c208222f2bd70452$var$sg(a, b) {
    if ($c208222f2bd70452$var$mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $c208222f2bd70452$var$mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $c208222f2bd70452$var$lg) {
            if (null === $c208222f2bd70452$var$kg) throw Error($c208222f2bd70452$var$u(308));
            $c208222f2bd70452$var$lg = b;
            $c208222f2bd70452$var$kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else $c208222f2bd70452$var$lg = $c208222f2bd70452$var$lg.next = b;
    }
    return a._currentValue;
}
var $c208222f2bd70452$var$tg = !1;
function $c208222f2bd70452$var$ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $c208222f2bd70452$var$vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function $c208222f2bd70452$var$wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function $c208222f2bd70452$var$xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $c208222f2bd70452$var$yg(a, b) {
    var c = a.alternate;
    null !== c && $c208222f2bd70452$var$vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function $c208222f2bd70452$var$zg(a, b, c, d) {
    var e = a.updateQueue;
    $c208222f2bd70452$var$tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    $c208222f2bd70452$var$Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $70tqi({}, k, g);
                                break a;
                            case 2:
                                $c208222f2bd70452$var$tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        $c208222f2bd70452$var$Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function $c208222f2bd70452$var$Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error($c208222f2bd70452$var$u(191, d));
            d.call(e);
        }
    }
}
var $c208222f2bd70452$var$Dg = $c208222f2bd70452$var$Wa.ReactCurrentBatchConfig, $c208222f2bd70452$var$Eg = (new $hJwnw.Component).refs;
function $c208222f2bd70452$var$Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $70tqi({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var $c208222f2bd70452$var$Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? $c208222f2bd70452$var$dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $c208222f2bd70452$var$Gg(), e = $c208222f2bd70452$var$Dg.suspense;
        d = $c208222f2bd70452$var$Hg(d, a, e);
        e = $c208222f2bd70452$var$wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $c208222f2bd70452$var$xg(a, e);
        $c208222f2bd70452$var$Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $c208222f2bd70452$var$Gg(), e = $c208222f2bd70452$var$Dg.suspense;
        d = $c208222f2bd70452$var$Hg(d, a, e);
        e = $c208222f2bd70452$var$wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $c208222f2bd70452$var$xg(a, e);
        $c208222f2bd70452$var$Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = $c208222f2bd70452$var$Gg(), d = $c208222f2bd70452$var$Dg.suspense;
        c = $c208222f2bd70452$var$Hg(c, a, d);
        d = $c208222f2bd70452$var$wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        $c208222f2bd70452$var$xg(a, d);
        $c208222f2bd70452$var$Ig(a, c);
    }
};
function $c208222f2bd70452$var$Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c208222f2bd70452$var$bf(c, d) || !$c208222f2bd70452$var$bf(e, f) : !0;
}
function $c208222f2bd70452$var$Lg(a, b, c) {
    var d = !1, e = $c208222f2bd70452$var$Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c208222f2bd70452$var$sg(f) : (e = $c208222f2bd70452$var$L(b) ? $c208222f2bd70452$var$Bf : $c208222f2bd70452$var$J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c208222f2bd70452$var$Cf(a, e) : $c208222f2bd70452$var$Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c208222f2bd70452$var$Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c208222f2bd70452$var$Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c208222f2bd70452$var$Jg.enqueueReplaceState(b, b.state, null);
}
function $c208222f2bd70452$var$Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c208222f2bd70452$var$Eg;
    $c208222f2bd70452$var$ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c208222f2bd70452$var$sg(f) : (f = $c208222f2bd70452$var$L(b) ? $c208222f2bd70452$var$Bf : $c208222f2bd70452$var$J.current, e.context = $c208222f2bd70452$var$Cf(a, f));
    $c208222f2bd70452$var$zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c208222f2bd70452$var$Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c208222f2bd70452$var$Jg.enqueueReplaceState(e, e.state, null), $c208222f2bd70452$var$zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var $c208222f2bd70452$var$Og = Array.isArray;
function $c208222f2bd70452$var$Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c208222f2bd70452$var$u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c208222f2bd70452$var$u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $c208222f2bd70452$var$Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($c208222f2bd70452$var$u(284));
        if (!c._owner) throw Error($c208222f2bd70452$var$u(290, a));
    }
    return a;
}
function $c208222f2bd70452$var$Qg(a, b) {
    if ("textarea" !== a.type) throw Error($c208222f2bd70452$var$u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function $c208222f2bd70452$var$Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c208222f2bd70452$var$Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c208222f2bd70452$var$Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $c208222f2bd70452$var$Pg(a, b, c), d.return = a, d;
        d = $c208222f2bd70452$var$Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c208222f2bd70452$var$Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c208222f2bd70452$var$Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c208222f2bd70452$var$Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $c208222f2bd70452$var$Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c208222f2bd70452$var$Za:
                    return c = $c208222f2bd70452$var$Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = $c208222f2bd70452$var$Pg(a, null, b), c.return = a, c;
                case $c208222f2bd70452$var$$a:
                    return b = $c208222f2bd70452$var$Vg(b, a.mode, c), b.return = a, b;
            }
            if ($c208222f2bd70452$var$Og(b) || $c208222f2bd70452$var$nb(b)) return b = $c208222f2bd70452$var$Wg(b, a.mode, c, null), b.return = a, b;
            $c208222f2bd70452$var$Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c208222f2bd70452$var$Za:
                    return c.key === e ? c.type === $c208222f2bd70452$var$ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $c208222f2bd70452$var$$a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($c208222f2bd70452$var$Og(c) || $c208222f2bd70452$var$nb(c)) return null !== e ? null : m(a, b, c, d, null);
            $c208222f2bd70452$var$Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c208222f2bd70452$var$Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $c208222f2bd70452$var$ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $c208222f2bd70452$var$$a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($c208222f2bd70452$var$Og(d) || $c208222f2bd70452$var$nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c208222f2bd70452$var$Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = $c208222f2bd70452$var$nb(h);
        if ("function" !== typeof k) throw Error($c208222f2bd70452$var$u(150));
        h = k.call(h);
        if (null == h) throw Error($c208222f2bd70452$var$u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $c208222f2bd70452$var$ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $c208222f2bd70452$var$Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $c208222f2bd70452$var$ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $c208222f2bd70452$var$Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $c208222f2bd70452$var$ab ? (d = $c208222f2bd70452$var$Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c208222f2bd70452$var$Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = $c208222f2bd70452$var$Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $c208222f2bd70452$var$$a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $c208222f2bd70452$var$Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c208222f2bd70452$var$Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if ($c208222f2bd70452$var$Og(f)) return ca(a, d, f, h);
        if ($c208222f2bd70452$var$nb(f)) return D(a, d, f, h);
        l && $c208222f2bd70452$var$Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error($c208222f2bd70452$var$u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var $c208222f2bd70452$var$Xg = $c208222f2bd70452$var$Rg(!0), $c208222f2bd70452$var$Yg = $c208222f2bd70452$var$Rg(!1), $c208222f2bd70452$var$Zg = {}, $c208222f2bd70452$var$$g = {
    current: $c208222f2bd70452$var$Zg
}, $c208222f2bd70452$var$ah = {
    current: $c208222f2bd70452$var$Zg
}, $c208222f2bd70452$var$bh = {
    current: $c208222f2bd70452$var$Zg
};
function $c208222f2bd70452$var$ch(a) {
    if (a === $c208222f2bd70452$var$Zg) throw Error($c208222f2bd70452$var$u(174));
    return a;
}
function $c208222f2bd70452$var$dh(a, b) {
    $c208222f2bd70452$var$I($c208222f2bd70452$var$bh, b);
    $c208222f2bd70452$var$I($c208222f2bd70452$var$ah, a);
    $c208222f2bd70452$var$I($c208222f2bd70452$var$$g, $c208222f2bd70452$var$Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c208222f2bd70452$var$Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c208222f2bd70452$var$Ob(b, a);
    }
    $c208222f2bd70452$var$H($c208222f2bd70452$var$$g);
    $c208222f2bd70452$var$I($c208222f2bd70452$var$$g, b);
}
function $c208222f2bd70452$var$eh() {
    $c208222f2bd70452$var$H($c208222f2bd70452$var$$g);
    $c208222f2bd70452$var$H($c208222f2bd70452$var$ah);
    $c208222f2bd70452$var$H($c208222f2bd70452$var$bh);
}
function $c208222f2bd70452$var$fh(a) {
    $c208222f2bd70452$var$ch($c208222f2bd70452$var$bh.current);
    var b = $c208222f2bd70452$var$ch($c208222f2bd70452$var$$g.current);
    var c = $c208222f2bd70452$var$Ob(b, a.type);
    b !== c && ($c208222f2bd70452$var$I($c208222f2bd70452$var$ah, a), $c208222f2bd70452$var$I($c208222f2bd70452$var$$g, c));
}
function $c208222f2bd70452$var$gh(a) {
    $c208222f2bd70452$var$ah.current === a && ($c208222f2bd70452$var$H($c208222f2bd70452$var$$g), $c208222f2bd70452$var$H($c208222f2bd70452$var$ah));
}
var $c208222f2bd70452$var$M = {
    current: 0
};
function $c208222f2bd70452$var$hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === $c208222f2bd70452$var$Bd || c.data === $c208222f2bd70452$var$Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function $c208222f2bd70452$var$ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var $c208222f2bd70452$var$jh = $c208222f2bd70452$var$Wa.ReactCurrentDispatcher, $c208222f2bd70452$var$kh = $c208222f2bd70452$var$Wa.ReactCurrentBatchConfig, $c208222f2bd70452$var$lh = 0, $c208222f2bd70452$var$N = null, $c208222f2bd70452$var$O = null, $c208222f2bd70452$var$P = null, $c208222f2bd70452$var$mh = !1;
function $c208222f2bd70452$var$Q() {
    throw Error($c208222f2bd70452$var$u(321));
}
function $c208222f2bd70452$var$nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c208222f2bd70452$var$$e(a[c], b[c])) return !1;
    return !0;
}
function $c208222f2bd70452$var$oh(a, b, c, d, e, f) {
    $c208222f2bd70452$var$lh = f;
    $c208222f2bd70452$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    $c208222f2bd70452$var$jh.current = null === a || null === a.memoizedState ? $c208222f2bd70452$var$ph : $c208222f2bd70452$var$qh;
    a = c(d, e);
    if (b.expirationTime === $c208222f2bd70452$var$lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error($c208222f2bd70452$var$u(301));
            f += 1;
            $c208222f2bd70452$var$P = $c208222f2bd70452$var$O = null;
            b.updateQueue = null;
            $c208222f2bd70452$var$jh.current = $c208222f2bd70452$var$rh;
            a = c(d, e);
        }while (b.expirationTime === $c208222f2bd70452$var$lh);
    }
    $c208222f2bd70452$var$jh.current = $c208222f2bd70452$var$sh;
    b = null !== $c208222f2bd70452$var$O && null !== $c208222f2bd70452$var$O.next;
    $c208222f2bd70452$var$lh = 0;
    $c208222f2bd70452$var$P = $c208222f2bd70452$var$O = $c208222f2bd70452$var$N = null;
    $c208222f2bd70452$var$mh = !1;
    if (b) throw Error($c208222f2bd70452$var$u(300));
    return a;
}
function $c208222f2bd70452$var$th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c208222f2bd70452$var$P ? $c208222f2bd70452$var$N.memoizedState = $c208222f2bd70452$var$P = a : $c208222f2bd70452$var$P = $c208222f2bd70452$var$P.next = a;
    return $c208222f2bd70452$var$P;
}
function $c208222f2bd70452$var$uh() {
    if (null === $c208222f2bd70452$var$O) {
        var a = $c208222f2bd70452$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c208222f2bd70452$var$O.next;
    var b = null === $c208222f2bd70452$var$P ? $c208222f2bd70452$var$N.memoizedState : $c208222f2bd70452$var$P.next;
    if (null !== b) $c208222f2bd70452$var$P = b, $c208222f2bd70452$var$O = a;
    else {
        if (null === a) throw Error($c208222f2bd70452$var$u(310));
        $c208222f2bd70452$var$O = a;
        a = {
            memoizedState: $c208222f2bd70452$var$O.memoizedState,
            baseState: $c208222f2bd70452$var$O.baseState,
            baseQueue: $c208222f2bd70452$var$O.baseQueue,
            queue: $c208222f2bd70452$var$O.queue,
            next: null
        };
        null === $c208222f2bd70452$var$P ? $c208222f2bd70452$var$N.memoizedState = $c208222f2bd70452$var$P = a : $c208222f2bd70452$var$P = $c208222f2bd70452$var$P.next = a;
    }
    return $c208222f2bd70452$var$P;
}
function $c208222f2bd70452$var$vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c208222f2bd70452$var$wh(a) {
    var b = $c208222f2bd70452$var$uh(), c = b.queue;
    if (null === c) throw Error($c208222f2bd70452$var$u(311));
    c.lastRenderedReducer = a;
    var d = $c208222f2bd70452$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < $c208222f2bd70452$var$lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > $c208222f2bd70452$var$N.expirationTime && ($c208222f2bd70452$var$N.expirationTime = l, $c208222f2bd70452$var$Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), $c208222f2bd70452$var$Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $c208222f2bd70452$var$$e(d, b.memoizedState) || ($c208222f2bd70452$var$rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c208222f2bd70452$var$xh(a) {
    var b = $c208222f2bd70452$var$uh(), c = b.queue;
    if (null === c) throw Error($c208222f2bd70452$var$u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c208222f2bd70452$var$$e(f, b.memoizedState) || ($c208222f2bd70452$var$rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c208222f2bd70452$var$yh(a) {
    var b = $c208222f2bd70452$var$th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $c208222f2bd70452$var$vh,
        lastRenderedState: a
    };
    a = a.dispatch = $c208222f2bd70452$var$zh.bind(null, $c208222f2bd70452$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c208222f2bd70452$var$Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c208222f2bd70452$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $c208222f2bd70452$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c208222f2bd70452$var$Bh() {
    return $c208222f2bd70452$var$uh().memoizedState;
}
function $c208222f2bd70452$var$Ch(a, b, c, d) {
    var e = $c208222f2bd70452$var$th();
    $c208222f2bd70452$var$N.effectTag |= a;
    e.memoizedState = $c208222f2bd70452$var$Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c208222f2bd70452$var$Dh(a, b, c, d) {
    var e = $c208222f2bd70452$var$uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c208222f2bd70452$var$O) {
        var g = $c208222f2bd70452$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c208222f2bd70452$var$nh(d, g.deps)) {
            $c208222f2bd70452$var$Ah(b, c, f, d);
            return;
        }
    }
    $c208222f2bd70452$var$N.effectTag |= a;
    e.memoizedState = $c208222f2bd70452$var$Ah(1 | b, c, f, d);
}
function $c208222f2bd70452$var$Eh(a, b) {
    return $c208222f2bd70452$var$Ch(516, 4, a, b);
}
function $c208222f2bd70452$var$Fh(a, b) {
    return $c208222f2bd70452$var$Dh(516, 4, a, b);
}
function $c208222f2bd70452$var$Gh(a, b) {
    return $c208222f2bd70452$var$Dh(4, 2, a, b);
}
function $c208222f2bd70452$var$Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c208222f2bd70452$var$Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c208222f2bd70452$var$Dh(4, 2, $c208222f2bd70452$var$Hh.bind(null, b, a), c);
}
function $c208222f2bd70452$var$Jh() {}
function $c208222f2bd70452$var$Kh(a, b) {
    $c208222f2bd70452$var$th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function $c208222f2bd70452$var$Lh(a, b) {
    var c = $c208222f2bd70452$var$uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c208222f2bd70452$var$nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c208222f2bd70452$var$Mh(a, b) {
    var c = $c208222f2bd70452$var$uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c208222f2bd70452$var$nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c208222f2bd70452$var$Nh(a, b, c) {
    var d = $c208222f2bd70452$var$ag();
    $c208222f2bd70452$var$cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    $c208222f2bd70452$var$cg(97 < d ? 97 : d, function() {
        var d = $c208222f2bd70452$var$kh.suspense;
        $c208222f2bd70452$var$kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            $c208222f2bd70452$var$kh.suspense = d;
        }
    });
}
function $c208222f2bd70452$var$zh(a, b, c) {
    var d = $c208222f2bd70452$var$Gg(), e = $c208222f2bd70452$var$Dg.suspense;
    d = $c208222f2bd70452$var$Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === $c208222f2bd70452$var$N || null !== f && f === $c208222f2bd70452$var$N) $c208222f2bd70452$var$mh = !0, e.expirationTime = $c208222f2bd70452$var$lh, $c208222f2bd70452$var$N.expirationTime = $c208222f2bd70452$var$lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($c208222f2bd70452$var$$e(h, g)) return;
        } catch (k) {} finally{}
        $c208222f2bd70452$var$Ig(a, d);
    }
}
var $c208222f2bd70452$var$sh = {
    readContext: $c208222f2bd70452$var$sg,
    useCallback: $c208222f2bd70452$var$Q,
    useContext: $c208222f2bd70452$var$Q,
    useEffect: $c208222f2bd70452$var$Q,
    useImperativeHandle: $c208222f2bd70452$var$Q,
    useLayoutEffect: $c208222f2bd70452$var$Q,
    useMemo: $c208222f2bd70452$var$Q,
    useReducer: $c208222f2bd70452$var$Q,
    useRef: $c208222f2bd70452$var$Q,
    useState: $c208222f2bd70452$var$Q,
    useDebugValue: $c208222f2bd70452$var$Q,
    useResponder: $c208222f2bd70452$var$Q,
    useDeferredValue: $c208222f2bd70452$var$Q,
    useTransition: $c208222f2bd70452$var$Q
}, $c208222f2bd70452$var$ph = {
    readContext: $c208222f2bd70452$var$sg,
    useCallback: $c208222f2bd70452$var$Kh,
    useContext: $c208222f2bd70452$var$sg,
    useEffect: $c208222f2bd70452$var$Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c208222f2bd70452$var$Ch(4, 2, $c208222f2bd70452$var$Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c208222f2bd70452$var$Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c208222f2bd70452$var$th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c208222f2bd70452$var$th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $c208222f2bd70452$var$zh.bind(null, $c208222f2bd70452$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c208222f2bd70452$var$th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c208222f2bd70452$var$yh,
    useDebugValue: $c208222f2bd70452$var$Jh,
    useResponder: $c208222f2bd70452$var$ih,
    useDeferredValue: function(a, b) {
        var c = $c208222f2bd70452$var$yh(a), d = c[0], e = c[1];
        $c208222f2bd70452$var$Eh(function() {
            var c = $c208222f2bd70452$var$kh.suspense;
            $c208222f2bd70452$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $c208222f2bd70452$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $c208222f2bd70452$var$yh(!1), c = b[0];
        b = b[1];
        return [
            $c208222f2bd70452$var$Kh($c208222f2bd70452$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $c208222f2bd70452$var$qh = {
    readContext: $c208222f2bd70452$var$sg,
    useCallback: $c208222f2bd70452$var$Lh,
    useContext: $c208222f2bd70452$var$sg,
    useEffect: $c208222f2bd70452$var$Fh,
    useImperativeHandle: $c208222f2bd70452$var$Ih,
    useLayoutEffect: $c208222f2bd70452$var$Gh,
    useMemo: $c208222f2bd70452$var$Mh,
    useReducer: $c208222f2bd70452$var$wh,
    useRef: $c208222f2bd70452$var$Bh,
    useState: function() {
        return $c208222f2bd70452$var$wh($c208222f2bd70452$var$vh);
    },
    useDebugValue: $c208222f2bd70452$var$Jh,
    useResponder: $c208222f2bd70452$var$ih,
    useDeferredValue: function(a, b) {
        var c = $c208222f2bd70452$var$wh($c208222f2bd70452$var$vh), d = c[0], e = c[1];
        $c208222f2bd70452$var$Fh(function() {
            var c = $c208222f2bd70452$var$kh.suspense;
            $c208222f2bd70452$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $c208222f2bd70452$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $c208222f2bd70452$var$wh($c208222f2bd70452$var$vh), c = b[0];
        b = b[1];
        return [
            $c208222f2bd70452$var$Lh($c208222f2bd70452$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $c208222f2bd70452$var$rh = {
    readContext: $c208222f2bd70452$var$sg,
    useCallback: $c208222f2bd70452$var$Lh,
    useContext: $c208222f2bd70452$var$sg,
    useEffect: $c208222f2bd70452$var$Fh,
    useImperativeHandle: $c208222f2bd70452$var$Ih,
    useLayoutEffect: $c208222f2bd70452$var$Gh,
    useMemo: $c208222f2bd70452$var$Mh,
    useReducer: $c208222f2bd70452$var$xh,
    useRef: $c208222f2bd70452$var$Bh,
    useState: function() {
        return $c208222f2bd70452$var$xh($c208222f2bd70452$var$vh);
    },
    useDebugValue: $c208222f2bd70452$var$Jh,
    useResponder: $c208222f2bd70452$var$ih,
    useDeferredValue: function(a, b) {
        var c = $c208222f2bd70452$var$xh($c208222f2bd70452$var$vh), d = c[0], e = c[1];
        $c208222f2bd70452$var$Fh(function() {
            var c = $c208222f2bd70452$var$kh.suspense;
            $c208222f2bd70452$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $c208222f2bd70452$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $c208222f2bd70452$var$xh($c208222f2bd70452$var$vh), c = b[0];
        b = b[1];
        return [
            $c208222f2bd70452$var$Lh($c208222f2bd70452$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $c208222f2bd70452$var$Oh = null, $c208222f2bd70452$var$Ph = null, $c208222f2bd70452$var$Qh = !1;
function $c208222f2bd70452$var$Rh(a, b) {
    var c = $c208222f2bd70452$var$Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $c208222f2bd70452$var$Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $c208222f2bd70452$var$Uh(a) {
    if ($c208222f2bd70452$var$Qh) {
        var b = $c208222f2bd70452$var$Ph;
        if (b) {
            var c = b;
            if (!$c208222f2bd70452$var$Th(a, b)) {
                b = $c208222f2bd70452$var$Jd(c.nextSibling);
                if (!b || !$c208222f2bd70452$var$Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    $c208222f2bd70452$var$Qh = !1;
                    $c208222f2bd70452$var$Oh = a;
                    return;
                }
                $c208222f2bd70452$var$Rh($c208222f2bd70452$var$Oh, c);
            }
            $c208222f2bd70452$var$Oh = a;
            $c208222f2bd70452$var$Ph = $c208222f2bd70452$var$Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, $c208222f2bd70452$var$Qh = !1, $c208222f2bd70452$var$Oh = a;
    }
}
function $c208222f2bd70452$var$Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c208222f2bd70452$var$Oh = a;
}
function $c208222f2bd70452$var$Wh(a) {
    if (a !== $c208222f2bd70452$var$Oh) return !1;
    if (!$c208222f2bd70452$var$Qh) return $c208222f2bd70452$var$Vh(a), $c208222f2bd70452$var$Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$c208222f2bd70452$var$Gd(b, a.memoizedProps)) for(b = $c208222f2bd70452$var$Ph; b;)$c208222f2bd70452$var$Rh(a, b), b = $c208222f2bd70452$var$Jd(b.nextSibling);
    $c208222f2bd70452$var$Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c208222f2bd70452$var$u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === $c208222f2bd70452$var$Ad) {
                        if (0 === b) {
                            $c208222f2bd70452$var$Ph = $c208222f2bd70452$var$Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== $c208222f2bd70452$var$zd && c !== $c208222f2bd70452$var$Cd && c !== $c208222f2bd70452$var$Bd || b++;
                }
                a = a.nextSibling;
            }
            $c208222f2bd70452$var$Ph = null;
        }
    } else $c208222f2bd70452$var$Ph = $c208222f2bd70452$var$Oh ? $c208222f2bd70452$var$Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function $c208222f2bd70452$var$Xh() {
    $c208222f2bd70452$var$Ph = $c208222f2bd70452$var$Oh = null;
    $c208222f2bd70452$var$Qh = !1;
}
var $c208222f2bd70452$var$Yh = $c208222f2bd70452$var$Wa.ReactCurrentOwner, $c208222f2bd70452$var$rg = !1;
function $c208222f2bd70452$var$R(a, b, c, d) {
    b.child = null === a ? $c208222f2bd70452$var$Yg(b, null, c, d) : $c208222f2bd70452$var$Xg(b, a.child, c, d);
}
function $c208222f2bd70452$var$Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c208222f2bd70452$var$qg(b, e);
    d = $c208222f2bd70452$var$oh(a, b, c, d, f, e);
    if (null !== a && !$c208222f2bd70452$var$rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $c208222f2bd70452$var$$h(a, b, e);
    b.effectTag |= 1;
    $c208222f2bd70452$var$R(a, b, d, e);
    return b.child;
}
function $c208222f2bd70452$var$ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$c208222f2bd70452$var$bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $c208222f2bd70452$var$ci(a, b, g, d, e, f);
        a = $c208222f2bd70452$var$Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $c208222f2bd70452$var$bf, c(e, d) && a.ref === b.ref)) return $c208222f2bd70452$var$$h(a, b, f);
    b.effectTag |= 1;
    a = $c208222f2bd70452$var$Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c208222f2bd70452$var$ci(a, b, c, d, e, f) {
    return null !== a && $c208222f2bd70452$var$bf(a.memoizedProps, d) && a.ref === b.ref && ($c208222f2bd70452$var$rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $c208222f2bd70452$var$$h(a, b, f)) : $c208222f2bd70452$var$di(a, b, c, d, f);
}
function $c208222f2bd70452$var$ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function $c208222f2bd70452$var$di(a, b, c, d, e) {
    var f = $c208222f2bd70452$var$L(c) ? $c208222f2bd70452$var$Bf : $c208222f2bd70452$var$J.current;
    f = $c208222f2bd70452$var$Cf(b, f);
    $c208222f2bd70452$var$qg(b, e);
    c = $c208222f2bd70452$var$oh(a, b, c, d, f, e);
    if (null !== a && !$c208222f2bd70452$var$rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $c208222f2bd70452$var$$h(a, b, e);
    b.effectTag |= 1;
    $c208222f2bd70452$var$R(a, b, c, e);
    return b.child;
}
function $c208222f2bd70452$var$fi(a, b, c, d, e) {
    if ($c208222f2bd70452$var$L(c)) {
        var f = !0;
        $c208222f2bd70452$var$Gf(b);
    } else f = !1;
    $c208222f2bd70452$var$qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), $c208222f2bd70452$var$Lg(b, c, d), $c208222f2bd70452$var$Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c208222f2bd70452$var$sg(l) : (l = $c208222f2bd70452$var$L(c) ? $c208222f2bd70452$var$Bf : $c208222f2bd70452$var$J.current, l = $c208222f2bd70452$var$Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c208222f2bd70452$var$Mg(b, g, d, l);
        $c208222f2bd70452$var$tg = !1;
        var x = b.memoizedState;
        g.state = x;
        $c208222f2bd70452$var$zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || $c208222f2bd70452$var$K.current || $c208222f2bd70452$var$tg ? ("function" === typeof m && ($c208222f2bd70452$var$Fg(b, c, m, d), k = b.memoizedState), (h = $c208222f2bd70452$var$tg || $c208222f2bd70452$var$Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, $c208222f2bd70452$var$vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : $c208222f2bd70452$var$ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = $c208222f2bd70452$var$sg(l) : (l = $c208222f2bd70452$var$L(c) ? $c208222f2bd70452$var$Bf : $c208222f2bd70452$var$J.current, l = $c208222f2bd70452$var$Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c208222f2bd70452$var$Mg(b, g, d, l), $c208222f2bd70452$var$tg = !1, k = b.memoizedState, g.state = k, $c208222f2bd70452$var$zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || $c208222f2bd70452$var$K.current || $c208222f2bd70452$var$tg ? ("function" === typeof m && ($c208222f2bd70452$var$Fg(b, c, m, d), x = b.memoizedState), (m = $c208222f2bd70452$var$tg || $c208222f2bd70452$var$Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return $c208222f2bd70452$var$gi(a, b, c, d, f, e);
}
function $c208222f2bd70452$var$gi(a, b, c, d, e, f) {
    $c208222f2bd70452$var$ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && $c208222f2bd70452$var$Hf(b, c, !1), $c208222f2bd70452$var$$h(a, b, f);
    d = b.stateNode;
    $c208222f2bd70452$var$Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = $c208222f2bd70452$var$Xg(b, a.child, null, f), b.child = $c208222f2bd70452$var$Xg(b, null, h, f)) : $c208222f2bd70452$var$R(a, b, h, f);
    b.memoizedState = d.state;
    e && $c208222f2bd70452$var$Hf(b, c, !0);
    return b.child;
}
function $c208222f2bd70452$var$hi(a) {
    var b = a.stateNode;
    b.pendingContext ? $c208222f2bd70452$var$Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c208222f2bd70452$var$Ef(a, b.context, !1);
    $c208222f2bd70452$var$dh(a, b.containerInfo);
}
var $c208222f2bd70452$var$ii = {
    dehydrated: null,
    retryTime: 0
};
function $c208222f2bd70452$var$ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = $c208222f2bd70452$var$M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    $c208222f2bd70452$var$I($c208222f2bd70452$var$M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && $c208222f2bd70452$var$Uh(b);
        if (g) {
            g = e.fallback;
            e = $c208222f2bd70452$var$Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = $c208222f2bd70452$var$Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = $c208222f2bd70452$var$ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = $c208222f2bd70452$var$Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = $c208222f2bd70452$var$Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = $c208222f2bd70452$var$Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = $c208222f2bd70452$var$ii;
            b.child = c;
            return d;
        }
        c = $c208222f2bd70452$var$Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = $c208222f2bd70452$var$Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = $c208222f2bd70452$var$Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = $c208222f2bd70452$var$ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = $c208222f2bd70452$var$Xg(b, a, e.children, c);
}
function $c208222f2bd70452$var$ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    $c208222f2bd70452$var$pg(a.return, b);
}
function $c208222f2bd70452$var$li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function $c208222f2bd70452$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c208222f2bd70452$var$R(a, b, d.children, c);
    d = $c208222f2bd70452$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c208222f2bd70452$var$ki(a, c);
            else if (19 === a.tag) $c208222f2bd70452$var$ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c208222f2bd70452$var$I($c208222f2bd70452$var$M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c208222f2bd70452$var$hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c208222f2bd70452$var$li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c208222f2bd70452$var$hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c208222f2bd70452$var$li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $c208222f2bd70452$var$li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c208222f2bd70452$var$$h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && $c208222f2bd70452$var$Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error($c208222f2bd70452$var$u(153));
    if (null !== b.child) {
        a = b.child;
        c = $c208222f2bd70452$var$Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c208222f2bd70452$var$Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var $c208222f2bd70452$var$ni, $c208222f2bd70452$var$oi, $c208222f2bd70452$var$pi, $c208222f2bd70452$var$qi;
$c208222f2bd70452$var$ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c208222f2bd70452$var$oi = function() {};
$c208222f2bd70452$var$pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        $c208222f2bd70452$var$ch($c208222f2bd70452$var$$g.current);
        a = null;
        switch(c){
            case "input":
                f = $c208222f2bd70452$var$zb(g, f);
                d = $c208222f2bd70452$var$zb(g, d);
                a = [];
                break;
            case "option":
                f = $c208222f2bd70452$var$Gb(g, f);
                d = $c208222f2bd70452$var$Gb(g, d);
                a = [];
                break;
            case "select":
                f = $70tqi({}, f, {
                    value: void 0
                });
                d = $70tqi({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = $c208222f2bd70452$var$Ib(g, f);
                d = $c208222f2bd70452$var$Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = $c208222f2bd70452$var$sd);
        }
        $c208222f2bd70452$var$od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && ($c208222f2bd70452$var$va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && ($c208222f2bd70452$var$va.hasOwnProperty(h) ? (null != l && $c208222f2bd70452$var$rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
$c208222f2bd70452$var$qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function $c208222f2bd70452$var$ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c208222f2bd70452$var$si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $c208222f2bd70452$var$L(b.type) && $c208222f2bd70452$var$Df(), null;
        case 3:
            return $c208222f2bd70452$var$eh(), $c208222f2bd70452$var$H($c208222f2bd70452$var$K), $c208222f2bd70452$var$H($c208222f2bd70452$var$J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !$c208222f2bd70452$var$Wh(b) || (b.effectTag |= 4), $c208222f2bd70452$var$oi(b), null;
        case 5:
            $c208222f2bd70452$var$gh(b);
            c = $c208222f2bd70452$var$ch($c208222f2bd70452$var$bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) $c208222f2bd70452$var$pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c208222f2bd70452$var$u(166));
                    return null;
                }
                a = $c208222f2bd70452$var$ch($c208222f2bd70452$var$$g.current);
                if ($c208222f2bd70452$var$Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[$c208222f2bd70452$var$Md] = b;
                    d[$c208222f2bd70452$var$Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            $c208222f2bd70452$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $c208222f2bd70452$var$ac.length; a++)$c208222f2bd70452$var$F($c208222f2bd70452$var$ac[a], d);
                            break;
                        case "source":
                            $c208222f2bd70452$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c208222f2bd70452$var$F("error", d);
                            $c208222f2bd70452$var$F("load", d);
                            break;
                        case "form":
                            $c208222f2bd70452$var$F("reset", d);
                            $c208222f2bd70452$var$F("submit", d);
                            break;
                        case "details":
                            $c208222f2bd70452$var$F("toggle", d);
                            break;
                        case "input":
                            $c208222f2bd70452$var$Ab(d, f);
                            $c208222f2bd70452$var$F("invalid", d);
                            $c208222f2bd70452$var$rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c208222f2bd70452$var$F("invalid", d);
                            $c208222f2bd70452$var$rd(c, "onChange");
                            break;
                        case "textarea":
                            $c208222f2bd70452$var$Jb(d, f), $c208222f2bd70452$var$F("invalid", d), $c208222f2bd70452$var$rd(c, "onChange");
                    }
                    $c208222f2bd70452$var$od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : $c208222f2bd70452$var$va.hasOwnProperty(g) && null != h && $c208222f2bd70452$var$rd(c, g);
                    }
                    switch(e){
                        case "input":
                            $c208222f2bd70452$var$xb(d);
                            $c208222f2bd70452$var$Eb(d, f, !0);
                            break;
                        case "textarea":
                            $c208222f2bd70452$var$xb(d);
                            $c208222f2bd70452$var$Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c208222f2bd70452$var$sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === $c208222f2bd70452$var$qd && (a = $c208222f2bd70452$var$Nb(e));
                    a === $c208222f2bd70452$var$qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[$c208222f2bd70452$var$Md] = b;
                    a[$c208222f2bd70452$var$Nd] = d;
                    $c208222f2bd70452$var$ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = $c208222f2bd70452$var$pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            $c208222f2bd70452$var$F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < $c208222f2bd70452$var$ac.length; h++)$c208222f2bd70452$var$F($c208222f2bd70452$var$ac[h], a);
                            h = d;
                            break;
                        case "source":
                            $c208222f2bd70452$var$F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c208222f2bd70452$var$F("error", a);
                            $c208222f2bd70452$var$F("load", a);
                            h = d;
                            break;
                        case "form":
                            $c208222f2bd70452$var$F("reset", a);
                            $c208222f2bd70452$var$F("submit", a);
                            h = d;
                            break;
                        case "details":
                            $c208222f2bd70452$var$F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            $c208222f2bd70452$var$Ab(a, d);
                            h = $c208222f2bd70452$var$zb(a, d);
                            $c208222f2bd70452$var$F("invalid", a);
                            $c208222f2bd70452$var$rd(c, "onChange");
                            break;
                        case "option":
                            h = $c208222f2bd70452$var$Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $70tqi({}, d, {
                                value: void 0
                            });
                            $c208222f2bd70452$var$F("invalid", a);
                            $c208222f2bd70452$var$rd(c, "onChange");
                            break;
                        case "textarea":
                            $c208222f2bd70452$var$Jb(a, d);
                            h = $c208222f2bd70452$var$Ib(a, d);
                            $c208222f2bd70452$var$F("invalid", a);
                            $c208222f2bd70452$var$rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    $c208222f2bd70452$var$od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? $c208222f2bd70452$var$md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && $c208222f2bd70452$var$Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && $c208222f2bd70452$var$Rb(a, l) : "number" === typeof l && $c208222f2bd70452$var$Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c208222f2bd70452$var$va.hasOwnProperty(f) ? null != l && $c208222f2bd70452$var$rd(c, f) : null != l && $c208222f2bd70452$var$Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            $c208222f2bd70452$var$xb(a);
                            $c208222f2bd70452$var$Eb(a, d, !1);
                            break;
                        case "textarea":
                            $c208222f2bd70452$var$xb(a);
                            $c208222f2bd70452$var$Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $c208222f2bd70452$var$rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? $c208222f2bd70452$var$Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && $c208222f2bd70452$var$Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = $c208222f2bd70452$var$sd);
                    }
                    $c208222f2bd70452$var$Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $c208222f2bd70452$var$qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c208222f2bd70452$var$u(166));
                c = $c208222f2bd70452$var$ch($c208222f2bd70452$var$bh.current);
                $c208222f2bd70452$var$ch($c208222f2bd70452$var$$g.current);
                $c208222f2bd70452$var$Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[$c208222f2bd70452$var$Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[$c208222f2bd70452$var$Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            $c208222f2bd70452$var$H($c208222f2bd70452$var$M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $c208222f2bd70452$var$Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($c208222f2bd70452$var$M.current & 1)) $c208222f2bd70452$var$S === $c208222f2bd70452$var$ti && ($c208222f2bd70452$var$S = $c208222f2bd70452$var$ui);
                else {
                    if ($c208222f2bd70452$var$S === $c208222f2bd70452$var$ti || $c208222f2bd70452$var$S === $c208222f2bd70452$var$ui) $c208222f2bd70452$var$S = $c208222f2bd70452$var$vi;
                    0 !== $c208222f2bd70452$var$wi && null !== $c208222f2bd70452$var$T && ($c208222f2bd70452$var$xi($c208222f2bd70452$var$T, $c208222f2bd70452$var$U), $c208222f2bd70452$var$yi($c208222f2bd70452$var$T, $c208222f2bd70452$var$wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return $c208222f2bd70452$var$eh(), $c208222f2bd70452$var$oi(b), null;
        case 10:
            return $c208222f2bd70452$var$og(b), null;
        case 17:
            return $c208222f2bd70452$var$L(b.type) && $c208222f2bd70452$var$Df(), null;
        case 19:
            $c208222f2bd70452$var$H($c208222f2bd70452$var$M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) $c208222f2bd70452$var$ri(d, !1);
                else {
                    if ($c208222f2bd70452$var$S !== $c208222f2bd70452$var$ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = $c208222f2bd70452$var$hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            $c208222f2bd70452$var$ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            $c208222f2bd70452$var$I($c208222f2bd70452$var$M, $c208222f2bd70452$var$M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = $c208222f2bd70452$var$hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), $c208222f2bd70452$var$ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $c208222f2bd70452$var$$f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, $c208222f2bd70452$var$ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $c208222f2bd70452$var$$f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $c208222f2bd70452$var$$f(), c.sibling = null, b = $c208222f2bd70452$var$M.current, $c208222f2bd70452$var$I($c208222f2bd70452$var$M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error($c208222f2bd70452$var$u(156, b.tag));
}
function $c208222f2bd70452$var$zi(a) {
    switch(a.tag){
        case 1:
            $c208222f2bd70452$var$L(a.type) && $c208222f2bd70452$var$Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            $c208222f2bd70452$var$eh();
            $c208222f2bd70452$var$H($c208222f2bd70452$var$K);
            $c208222f2bd70452$var$H($c208222f2bd70452$var$J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error($c208222f2bd70452$var$u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return $c208222f2bd70452$var$gh(a), null;
        case 13:
            return $c208222f2bd70452$var$H($c208222f2bd70452$var$M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return $c208222f2bd70452$var$H($c208222f2bd70452$var$M), null;
        case 4:
            return $c208222f2bd70452$var$eh(), null;
        case 10:
            return $c208222f2bd70452$var$og(a), null;
        default:
            return null;
    }
}
function $c208222f2bd70452$var$Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: $c208222f2bd70452$var$qb(b)
    };
}
var $c208222f2bd70452$var$Bi = "function" === typeof WeakSet ? WeakSet : Set;
function $c208222f2bd70452$var$Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = $c208222f2bd70452$var$qb(c));
    null !== c && $c208222f2bd70452$var$pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && $c208222f2bd70452$var$pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function $c208222f2bd70452$var$Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        $c208222f2bd70452$var$Ei(a, c);
    }
}
function $c208222f2bd70452$var$Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $c208222f2bd70452$var$Ei(a, c);
        }
        else b.current = null;
    }
}
function $c208222f2bd70452$var$Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $c208222f2bd70452$var$ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($c208222f2bd70452$var$u(163));
}
function $c208222f2bd70452$var$Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c208222f2bd70452$var$Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c208222f2bd70452$var$Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            $c208222f2bd70452$var$Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : $c208222f2bd70452$var$ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && $c208222f2bd70452$var$Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $c208222f2bd70452$var$Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && $c208222f2bd70452$var$Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $c208222f2bd70452$var$Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error($c208222f2bd70452$var$u(163));
}
function $c208222f2bd70452$var$Ki(a, b, c) {
    "function" === typeof $c208222f2bd70452$var$Li && $c208222f2bd70452$var$Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                $c208222f2bd70452$var$cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                $c208222f2bd70452$var$Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            $c208222f2bd70452$var$Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && $c208222f2bd70452$var$Di(b, c);
            break;
        case 5:
            $c208222f2bd70452$var$Fi(b);
            break;
        case 4:
            $c208222f2bd70452$var$Mi(a, b, c);
    }
}
function $c208222f2bd70452$var$Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && $c208222f2bd70452$var$Ni(b);
}
function $c208222f2bd70452$var$Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c208222f2bd70452$var$Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($c208222f2bd70452$var$Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error($c208222f2bd70452$var$u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($c208222f2bd70452$var$u(161));
    }
    c.effectTag & 16 && ($c208222f2bd70452$var$Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $c208222f2bd70452$var$Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $c208222f2bd70452$var$Qi(a, c, b) : $c208222f2bd70452$var$Ri(a, c, b);
}
function $c208222f2bd70452$var$Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c208222f2bd70452$var$sd));
    else if (4 !== d && (a = a.child, null !== a)) for($c208222f2bd70452$var$Qi(a, b, c), a = a.sibling; null !== a;)$c208222f2bd70452$var$Qi(a, b, c), a = a.sibling;
}
function $c208222f2bd70452$var$Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c208222f2bd70452$var$Ri(a, b, c), a = a.sibling; null !== a;)$c208222f2bd70452$var$Ri(a, b, c), a = a.sibling;
}
function $c208222f2bd70452$var$Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error($c208222f2bd70452$var$u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if ($c208222f2bd70452$var$Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if ($c208222f2bd70452$var$Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function $c208222f2bd70452$var$Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            $c208222f2bd70452$var$Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$c208222f2bd70452$var$Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && $c208222f2bd70452$var$Bb(c, d);
                    $c208222f2bd70452$var$pd(a, e);
                    b = $c208222f2bd70452$var$pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $c208222f2bd70452$var$md(c, h) : "dangerouslySetInnerHTML" === g ? $c208222f2bd70452$var$Qb(c, h) : "children" === g ? $c208222f2bd70452$var$Rb(c, h) : $c208222f2bd70452$var$Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $c208222f2bd70452$var$Cb(c, d);
                            break;
                        case "textarea":
                            $c208222f2bd70452$var$Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? $c208222f2bd70452$var$Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? $c208222f2bd70452$var$Hb(c, !!d.multiple, d.defaultValue, !0) : $c208222f2bd70452$var$Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($c208222f2bd70452$var$u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, $c208222f2bd70452$var$Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, $c208222f2bd70452$var$Ti = $c208222f2bd70452$var$$f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = $c208222f2bd70452$var$ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            $c208222f2bd70452$var$Ui(b);
            return;
        case 19:
            $c208222f2bd70452$var$Ui(b);
            return;
        case 17:
            return;
    }
    throw Error($c208222f2bd70452$var$u(163));
}
function $c208222f2bd70452$var$Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c208222f2bd70452$var$Bi);
        b.forEach(function(b) {
            var d = $c208222f2bd70452$var$Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var $c208222f2bd70452$var$Wi = "function" === typeof WeakMap ? WeakMap : Map;
function $c208222f2bd70452$var$Xi(a, b, c) {
    c = $c208222f2bd70452$var$wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c208222f2bd70452$var$Yi || ($c208222f2bd70452$var$Yi = !0, $c208222f2bd70452$var$Zi = d);
        $c208222f2bd70452$var$Ci(a, b);
    };
    return c;
}
function $c208222f2bd70452$var$$i(a, b, c) {
    c = $c208222f2bd70452$var$wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $c208222f2bd70452$var$Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $c208222f2bd70452$var$aj ? $c208222f2bd70452$var$aj = new Set([
            this
        ]) : $c208222f2bd70452$var$aj.add(this), $c208222f2bd70452$var$Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $c208222f2bd70452$var$bj = Math.ceil, $c208222f2bd70452$var$cj = $c208222f2bd70452$var$Wa.ReactCurrentDispatcher, $c208222f2bd70452$var$dj = $c208222f2bd70452$var$Wa.ReactCurrentOwner, $c208222f2bd70452$var$V = 0, $c208222f2bd70452$var$ej = 8, $c208222f2bd70452$var$fj = 16, $c208222f2bd70452$var$gj = 32, $c208222f2bd70452$var$ti = 0, $c208222f2bd70452$var$hj = 1, $c208222f2bd70452$var$ij = 2, $c208222f2bd70452$var$ui = 3, $c208222f2bd70452$var$vi = 4, $c208222f2bd70452$var$jj = 5, $c208222f2bd70452$var$W = $c208222f2bd70452$var$V, $c208222f2bd70452$var$T = null, $c208222f2bd70452$var$X = null, $c208222f2bd70452$var$U = 0, $c208222f2bd70452$var$S = $c208222f2bd70452$var$ti, $c208222f2bd70452$var$kj = null, $c208222f2bd70452$var$lj = 1073741823, $c208222f2bd70452$var$mj = 1073741823, $c208222f2bd70452$var$nj = null, $c208222f2bd70452$var$wi = 0, $c208222f2bd70452$var$oj = !1, $c208222f2bd70452$var$Ti = 0, $c208222f2bd70452$var$pj = 500, $c208222f2bd70452$var$Y = null, $c208222f2bd70452$var$Yi = !1, $c208222f2bd70452$var$Zi = null, $c208222f2bd70452$var$aj = null, $c208222f2bd70452$var$qj = !1, $c208222f2bd70452$var$rj = null, $c208222f2bd70452$var$sj = 90, $c208222f2bd70452$var$tj = null, $c208222f2bd70452$var$uj = 0, $c208222f2bd70452$var$vj = null, $c208222f2bd70452$var$wj = 0;
function $c208222f2bd70452$var$Gg() {
    return ($c208222f2bd70452$var$W & ($c208222f2bd70452$var$fj | $c208222f2bd70452$var$gj)) !== $c208222f2bd70452$var$V ? 1073741821 - ($c208222f2bd70452$var$$f() / 10 | 0) : 0 !== $c208222f2bd70452$var$wj ? $c208222f2bd70452$var$wj : $c208222f2bd70452$var$wj = 1073741821 - ($c208222f2bd70452$var$$f() / 10 | 0);
}
function $c208222f2bd70452$var$Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = $c208222f2bd70452$var$ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if (($c208222f2bd70452$var$W & $c208222f2bd70452$var$fj) !== $c208222f2bd70452$var$V) return $c208222f2bd70452$var$U;
    if (null !== c) a = $c208222f2bd70452$var$hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = $c208222f2bd70452$var$hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = $c208222f2bd70452$var$hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error($c208222f2bd70452$var$u(326));
    }
    null !== $c208222f2bd70452$var$T && a === $c208222f2bd70452$var$U && --a;
    return a;
}
function $c208222f2bd70452$var$Ig(a, b) {
    if (50 < $c208222f2bd70452$var$uj) throw $c208222f2bd70452$var$uj = 0, $c208222f2bd70452$var$vj = null, Error($c208222f2bd70452$var$u(185));
    a = $c208222f2bd70452$var$xj(a, b);
    if (null !== a) {
        var c = $c208222f2bd70452$var$ag();
        1073741823 === b ? ($c208222f2bd70452$var$W & $c208222f2bd70452$var$ej) !== $c208222f2bd70452$var$V && ($c208222f2bd70452$var$W & ($c208222f2bd70452$var$fj | $c208222f2bd70452$var$gj)) === $c208222f2bd70452$var$V ? $c208222f2bd70452$var$yj(a) : ($c208222f2bd70452$var$Z(a), $c208222f2bd70452$var$W === $c208222f2bd70452$var$V && $c208222f2bd70452$var$gg()) : $c208222f2bd70452$var$Z(a);
        ($c208222f2bd70452$var$W & 4) === $c208222f2bd70452$var$V || 98 !== c && 99 !== c || (null === $c208222f2bd70452$var$tj ? $c208222f2bd70452$var$tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = $c208222f2bd70452$var$tj.get(a), (void 0 === c || c > b) && $c208222f2bd70452$var$tj.set(a, b)));
    }
}
function $c208222f2bd70452$var$xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && ($c208222f2bd70452$var$T === e && ($c208222f2bd70452$var$Bg(b), $c208222f2bd70452$var$S === $c208222f2bd70452$var$vi && $c208222f2bd70452$var$xi(e, $c208222f2bd70452$var$U)), $c208222f2bd70452$var$yi(e, b));
    return e;
}
function $c208222f2bd70452$var$zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!$c208222f2bd70452$var$Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function $c208222f2bd70452$var$Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = $c208222f2bd70452$var$eg($c208222f2bd70452$var$yj.bind(null, a));
    else {
        var b = $c208222f2bd70452$var$zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = $c208222f2bd70452$var$Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== $c208222f2bd70452$var$Tf && $c208222f2bd70452$var$Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? $c208222f2bd70452$var$eg($c208222f2bd70452$var$yj.bind(null, a)) : $c208222f2bd70452$var$dg(d, $c208222f2bd70452$var$Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $c208222f2bd70452$var$$f()
            });
            a.callbackNode = b;
        }
    }
}
function $c208222f2bd70452$var$Bj(a, b) {
    $c208222f2bd70452$var$wj = 0;
    if (b) return b = $c208222f2bd70452$var$Gg(), $c208222f2bd70452$var$Cj(a, b), $c208222f2bd70452$var$Z(a), null;
    var c = $c208222f2bd70452$var$zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if (($c208222f2bd70452$var$W & ($c208222f2bd70452$var$fj | $c208222f2bd70452$var$gj)) !== $c208222f2bd70452$var$V) throw Error($c208222f2bd70452$var$u(327));
        $c208222f2bd70452$var$Dj();
        a === $c208222f2bd70452$var$T && c === $c208222f2bd70452$var$U || $c208222f2bd70452$var$Ej(a, c);
        if (null !== $c208222f2bd70452$var$X) {
            var d = $c208222f2bd70452$var$W;
            $c208222f2bd70452$var$W |= $c208222f2bd70452$var$fj;
            var e = $c208222f2bd70452$var$Fj();
            for(;;)try {
                $c208222f2bd70452$var$Gj();
                break;
            } catch (h) {
                $c208222f2bd70452$var$Hj(a, h);
            }
            $c208222f2bd70452$var$ng();
            $c208222f2bd70452$var$W = d;
            $c208222f2bd70452$var$cj.current = e;
            if ($c208222f2bd70452$var$S === $c208222f2bd70452$var$hj) throw b = $c208222f2bd70452$var$kj, $c208222f2bd70452$var$Ej(a, c), $c208222f2bd70452$var$xi(a, c), $c208222f2bd70452$var$Z(a), b;
            if (null === $c208222f2bd70452$var$X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = $c208222f2bd70452$var$S, $c208222f2bd70452$var$T = null, d){
                case $c208222f2bd70452$var$ti:
                case $c208222f2bd70452$var$hj:
                    throw Error($c208222f2bd70452$var$u(345));
                case $c208222f2bd70452$var$ij:
                    $c208222f2bd70452$var$Cj(a, 2 < c ? 2 : c);
                    break;
                case $c208222f2bd70452$var$ui:
                    $c208222f2bd70452$var$xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = $c208222f2bd70452$var$Ij(e));
                    if (1073741823 === $c208222f2bd70452$var$lj && (e = $c208222f2bd70452$var$Ti + $c208222f2bd70452$var$pj - $c208222f2bd70452$var$$f(), 10 < e)) {
                        if ($c208222f2bd70452$var$oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                $c208222f2bd70452$var$Ej(a, c);
                                break;
                            }
                        }
                        f = $c208222f2bd70452$var$zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = $c208222f2bd70452$var$Hd($c208222f2bd70452$var$Jj.bind(null, a), e);
                        break;
                    }
                    $c208222f2bd70452$var$Jj(a);
                    break;
                case $c208222f2bd70452$var$vi:
                    $c208222f2bd70452$var$xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = $c208222f2bd70452$var$Ij(e));
                    if ($c208222f2bd70452$var$oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        $c208222f2bd70452$var$Ej(a, c);
                        break;
                    }
                    e = $c208222f2bd70452$var$zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== $c208222f2bd70452$var$mj ? d = 10 * (1073741821 - $c208222f2bd70452$var$mj) - $c208222f2bd70452$var$$f() : 1073741823 === $c208222f2bd70452$var$lj ? d = 0 : (d = 10 * (1073741821 - $c208222f2bd70452$var$lj) - 5E3, e = $c208222f2bd70452$var$$f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c208222f2bd70452$var$bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = $c208222f2bd70452$var$Hd($c208222f2bd70452$var$Jj.bind(null, a), d);
                        break;
                    }
                    $c208222f2bd70452$var$Jj(a);
                    break;
                case $c208222f2bd70452$var$jj:
                    if (1073741823 !== $c208222f2bd70452$var$lj && null !== $c208222f2bd70452$var$nj) {
                        f = $c208222f2bd70452$var$lj;
                        var g = $c208222f2bd70452$var$nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $c208222f2bd70452$var$$f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            $c208222f2bd70452$var$xi(a, c);
                            a.timeoutHandle = $c208222f2bd70452$var$Hd($c208222f2bd70452$var$Jj.bind(null, a), d);
                            break;
                        }
                    }
                    $c208222f2bd70452$var$Jj(a);
                    break;
                default:
                    throw Error($c208222f2bd70452$var$u(329));
            }
            $c208222f2bd70452$var$Z(a);
            if (a.callbackNode === b) return $c208222f2bd70452$var$Bj.bind(null, a);
        }
    }
    return null;
}
function $c208222f2bd70452$var$yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if (($c208222f2bd70452$var$W & ($c208222f2bd70452$var$fj | $c208222f2bd70452$var$gj)) !== $c208222f2bd70452$var$V) throw Error($c208222f2bd70452$var$u(327));
    $c208222f2bd70452$var$Dj();
    a === $c208222f2bd70452$var$T && b === $c208222f2bd70452$var$U || $c208222f2bd70452$var$Ej(a, b);
    if (null !== $c208222f2bd70452$var$X) {
        var c = $c208222f2bd70452$var$W;
        $c208222f2bd70452$var$W |= $c208222f2bd70452$var$fj;
        var d = $c208222f2bd70452$var$Fj();
        for(;;)try {
            $c208222f2bd70452$var$Kj();
            break;
        } catch (e) {
            $c208222f2bd70452$var$Hj(a, e);
        }
        $c208222f2bd70452$var$ng();
        $c208222f2bd70452$var$W = c;
        $c208222f2bd70452$var$cj.current = d;
        if ($c208222f2bd70452$var$S === $c208222f2bd70452$var$hj) throw c = $c208222f2bd70452$var$kj, $c208222f2bd70452$var$Ej(a, b), $c208222f2bd70452$var$xi(a, b), $c208222f2bd70452$var$Z(a), c;
        if (null !== $c208222f2bd70452$var$X) throw Error($c208222f2bd70452$var$u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        $c208222f2bd70452$var$T = null;
        $c208222f2bd70452$var$Jj(a);
        $c208222f2bd70452$var$Z(a);
    }
    return null;
}
function $c208222f2bd70452$var$Lj() {
    if (null !== $c208222f2bd70452$var$tj) {
        var a = $c208222f2bd70452$var$tj;
        $c208222f2bd70452$var$tj = null;
        a.forEach(function(a, c) {
            $c208222f2bd70452$var$Cj(c, a);
            $c208222f2bd70452$var$Z(c);
        });
        $c208222f2bd70452$var$gg();
    }
}
function $c208222f2bd70452$var$Mj(a, b) {
    var c = $c208222f2bd70452$var$W;
    $c208222f2bd70452$var$W |= 1;
    try {
        return a(b);
    } finally{
        $c208222f2bd70452$var$W = c, $c208222f2bd70452$var$W === $c208222f2bd70452$var$V && $c208222f2bd70452$var$gg();
    }
}
function $c208222f2bd70452$var$Nj(a, b) {
    var c = $c208222f2bd70452$var$W;
    $c208222f2bd70452$var$W &= -2;
    $c208222f2bd70452$var$W |= $c208222f2bd70452$var$ej;
    try {
        return a(b);
    } finally{
        $c208222f2bd70452$var$W = c, $c208222f2bd70452$var$W === $c208222f2bd70452$var$V && $c208222f2bd70452$var$gg();
    }
}
function $c208222f2bd70452$var$Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c208222f2bd70452$var$Id(c));
    if (null !== $c208222f2bd70452$var$X) for(c = $c208222f2bd70452$var$X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c208222f2bd70452$var$Df();
                break;
            case 3:
                $c208222f2bd70452$var$eh();
                $c208222f2bd70452$var$H($c208222f2bd70452$var$K);
                $c208222f2bd70452$var$H($c208222f2bd70452$var$J);
                break;
            case 5:
                $c208222f2bd70452$var$gh(d);
                break;
            case 4:
                $c208222f2bd70452$var$eh();
                break;
            case 13:
                $c208222f2bd70452$var$H($c208222f2bd70452$var$M);
                break;
            case 19:
                $c208222f2bd70452$var$H($c208222f2bd70452$var$M);
                break;
            case 10:
                $c208222f2bd70452$var$og(d);
        }
        c = c.return;
    }
    $c208222f2bd70452$var$T = a;
    $c208222f2bd70452$var$X = $c208222f2bd70452$var$Sg(a.current, null);
    $c208222f2bd70452$var$U = b;
    $c208222f2bd70452$var$S = $c208222f2bd70452$var$ti;
    $c208222f2bd70452$var$kj = null;
    $c208222f2bd70452$var$mj = $c208222f2bd70452$var$lj = 1073741823;
    $c208222f2bd70452$var$nj = null;
    $c208222f2bd70452$var$wi = 0;
    $c208222f2bd70452$var$oj = !1;
}
function $c208222f2bd70452$var$Hj(a, b) {
    do {
        try {
            $c208222f2bd70452$var$ng();
            $c208222f2bd70452$var$jh.current = $c208222f2bd70452$var$sh;
            if ($c208222f2bd70452$var$mh) for(var c = $c208222f2bd70452$var$N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            $c208222f2bd70452$var$lh = 0;
            $c208222f2bd70452$var$P = $c208222f2bd70452$var$O = $c208222f2bd70452$var$N = null;
            $c208222f2bd70452$var$mh = !1;
            if (null === $c208222f2bd70452$var$X || null === $c208222f2bd70452$var$X.return) return $c208222f2bd70452$var$S = $c208222f2bd70452$var$hj, $c208222f2bd70452$var$kj = b, $c208222f2bd70452$var$X = null;
            a: {
                var e = a, f = $c208222f2bd70452$var$X.return, g = $c208222f2bd70452$var$X, h = b;
                b = $c208222f2bd70452$var$U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== ($c208222f2bd70452$var$M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = $c208222f2bd70452$var$wg(1073741823, null);
                                        y.tag = 2;
                                        $c208222f2bd70452$var$xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new $c208222f2bd70452$var$Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = $c208222f2bd70452$var$Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error(($c208222f2bd70452$var$pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + $c208222f2bd70452$var$qb(g));
                }
                $c208222f2bd70452$var$S !== $c208222f2bd70452$var$jj && ($c208222f2bd70452$var$S = $c208222f2bd70452$var$ij);
                h = $c208222f2bd70452$var$Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = $c208222f2bd70452$var$Xi(p, k, b);
                            $c208222f2bd70452$var$yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === $c208222f2bd70452$var$aj || !$c208222f2bd70452$var$aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $c208222f2bd70452$var$$i(p, k, b);
                                $c208222f2bd70452$var$yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $c208222f2bd70452$var$X = $c208222f2bd70452$var$Pj($c208222f2bd70452$var$X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function $c208222f2bd70452$var$Fj() {
    var a = $c208222f2bd70452$var$cj.current;
    $c208222f2bd70452$var$cj.current = $c208222f2bd70452$var$sh;
    return null === a ? $c208222f2bd70452$var$sh : a;
}
function $c208222f2bd70452$var$Ag(a, b) {
    a < $c208222f2bd70452$var$lj && 2 < a && ($c208222f2bd70452$var$lj = a);
    null !== b && a < $c208222f2bd70452$var$mj && 2 < a && ($c208222f2bd70452$var$mj = a, $c208222f2bd70452$var$nj = b);
}
function $c208222f2bd70452$var$Bg(a) {
    a > $c208222f2bd70452$var$wi && ($c208222f2bd70452$var$wi = a);
}
function $c208222f2bd70452$var$Kj() {
    for(; null !== $c208222f2bd70452$var$X;)$c208222f2bd70452$var$X = $c208222f2bd70452$var$Qj($c208222f2bd70452$var$X);
}
function $c208222f2bd70452$var$Gj() {
    for(; null !== $c208222f2bd70452$var$X && !$c208222f2bd70452$var$Uf();)$c208222f2bd70452$var$X = $c208222f2bd70452$var$Qj($c208222f2bd70452$var$X);
}
function $c208222f2bd70452$var$Qj(a) {
    var b = $c208222f2bd70452$var$Rj(a.alternate, a, $c208222f2bd70452$var$U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = $c208222f2bd70452$var$Pj(a));
    $c208222f2bd70452$var$dj.current = null;
    return b;
}
function $c208222f2bd70452$var$Pj(a) {
    $c208222f2bd70452$var$X = a;
    do {
        var b = $c208222f2bd70452$var$X.alternate;
        a = $c208222f2bd70452$var$X.return;
        if (0 === ($c208222f2bd70452$var$X.effectTag & 2048)) {
            b = $c208222f2bd70452$var$si(b, $c208222f2bd70452$var$X, $c208222f2bd70452$var$U);
            if (1 === $c208222f2bd70452$var$U || 1 !== $c208222f2bd70452$var$X.childExpirationTime) {
                for(var c = 0, d = $c208222f2bd70452$var$X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                $c208222f2bd70452$var$X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = $c208222f2bd70452$var$X.firstEffect), null !== $c208222f2bd70452$var$X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = $c208222f2bd70452$var$X.firstEffect), a.lastEffect = $c208222f2bd70452$var$X.lastEffect), 1 < $c208222f2bd70452$var$X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = $c208222f2bd70452$var$X : a.firstEffect = $c208222f2bd70452$var$X, a.lastEffect = $c208222f2bd70452$var$X));
        } else {
            b = $c208222f2bd70452$var$zi($c208222f2bd70452$var$X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = $c208222f2bd70452$var$X.sibling;
        if (null !== b) return b;
        $c208222f2bd70452$var$X = a;
    }while (null !== $c208222f2bd70452$var$X);
    $c208222f2bd70452$var$S === $c208222f2bd70452$var$ti && ($c208222f2bd70452$var$S = $c208222f2bd70452$var$jj);
    return null;
}
function $c208222f2bd70452$var$Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function $c208222f2bd70452$var$Jj(a) {
    var b = $c208222f2bd70452$var$ag();
    $c208222f2bd70452$var$cg(99, $c208222f2bd70452$var$Sj.bind(null, a, b));
    return null;
}
function $c208222f2bd70452$var$Sj(a, b) {
    do $c208222f2bd70452$var$Dj();
    while (null !== $c208222f2bd70452$var$rj);
    if (($c208222f2bd70452$var$W & ($c208222f2bd70452$var$fj | $c208222f2bd70452$var$gj)) !== $c208222f2bd70452$var$V) throw Error($c208222f2bd70452$var$u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error($c208222f2bd70452$var$u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = $c208222f2bd70452$var$Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === $c208222f2bd70452$var$T && ($c208222f2bd70452$var$X = $c208222f2bd70452$var$T = null, $c208222f2bd70452$var$U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = $c208222f2bd70452$var$W;
        $c208222f2bd70452$var$W |= $c208222f2bd70452$var$gj;
        $c208222f2bd70452$var$dj.current = null;
        $c208222f2bd70452$var$Dd = $c208222f2bd70452$var$fd;
        var g = $c208222f2bd70452$var$xd();
        if ($c208222f2bd70452$var$yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $c208222f2bd70452$var$Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        $c208222f2bd70452$var$fd = !1;
        $c208222f2bd70452$var$Y = e;
        do try {
            $c208222f2bd70452$var$Tj();
        } catch (wb) {
            if (null === $c208222f2bd70452$var$Y) throw Error($c208222f2bd70452$var$u(330));
            $c208222f2bd70452$var$Ei($c208222f2bd70452$var$Y, wb);
            $c208222f2bd70452$var$Y = $c208222f2bd70452$var$Y.nextEffect;
        }
        while (null !== $c208222f2bd70452$var$Y);
        $c208222f2bd70452$var$Y = e;
        do try {
            for(g = a, h = b; null !== $c208222f2bd70452$var$Y;){
                var q = $c208222f2bd70452$var$Y.effectTag;
                q & 16 && $c208222f2bd70452$var$Rb($c208222f2bd70452$var$Y.stateNode, "");
                if (q & 128) {
                    var B = $c208222f2bd70452$var$Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        $c208222f2bd70452$var$Pi($c208222f2bd70452$var$Y);
                        $c208222f2bd70452$var$Y.effectTag &= -3;
                        break;
                    case 6:
                        $c208222f2bd70452$var$Pi($c208222f2bd70452$var$Y);
                        $c208222f2bd70452$var$Y.effectTag &= -3;
                        $c208222f2bd70452$var$Si($c208222f2bd70452$var$Y.alternate, $c208222f2bd70452$var$Y);
                        break;
                    case 1024:
                        $c208222f2bd70452$var$Y.effectTag &= -1025;
                        break;
                    case 1028:
                        $c208222f2bd70452$var$Y.effectTag &= -1025;
                        $c208222f2bd70452$var$Si($c208222f2bd70452$var$Y.alternate, $c208222f2bd70452$var$Y);
                        break;
                    case 4:
                        $c208222f2bd70452$var$Si($c208222f2bd70452$var$Y.alternate, $c208222f2bd70452$var$Y);
                        break;
                    case 8:
                        l = $c208222f2bd70452$var$Y, $c208222f2bd70452$var$Mi(g, l, h), $c208222f2bd70452$var$Ni(l);
                }
                $c208222f2bd70452$var$Y = $c208222f2bd70452$var$Y.nextEffect;
            }
        } catch (wb) {
            if (null === $c208222f2bd70452$var$Y) throw Error($c208222f2bd70452$var$u(330));
            $c208222f2bd70452$var$Ei($c208222f2bd70452$var$Y, wb);
            $c208222f2bd70452$var$Y = $c208222f2bd70452$var$Y.nextEffect;
        }
        while (null !== $c208222f2bd70452$var$Y);
        w = $c208222f2bd70452$var$Ed;
        B = $c208222f2bd70452$var$xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && $c208222f2bd70452$var$wd(q.ownerDocument.documentElement, q)) {
            null !== h && $c208222f2bd70452$var$yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = $c208222f2bd70452$var$vd(q, g), m = $c208222f2bd70452$var$vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        $c208222f2bd70452$var$fd = !!$c208222f2bd70452$var$Dd;
        $c208222f2bd70452$var$Ed = $c208222f2bd70452$var$Dd = null;
        a.current = c;
        $c208222f2bd70452$var$Y = e;
        do try {
            for(q = a; null !== $c208222f2bd70452$var$Y;){
                var ub = $c208222f2bd70452$var$Y.effectTag;
                ub & 36 && $c208222f2bd70452$var$Ji(q, $c208222f2bd70452$var$Y.alternate, $c208222f2bd70452$var$Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = $c208222f2bd70452$var$Y.ref;
                    if (null !== vb) {
                        var Xc = $c208222f2bd70452$var$Y.stateNode;
                        switch($c208222f2bd70452$var$Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                $c208222f2bd70452$var$Y = $c208222f2bd70452$var$Y.nextEffect;
            }
        } catch (wb) {
            if (null === $c208222f2bd70452$var$Y) throw Error($c208222f2bd70452$var$u(330));
            $c208222f2bd70452$var$Ei($c208222f2bd70452$var$Y, wb);
            $c208222f2bd70452$var$Y = $c208222f2bd70452$var$Y.nextEffect;
        }
        while (null !== $c208222f2bd70452$var$Y);
        $c208222f2bd70452$var$Y = null;
        $c208222f2bd70452$var$Vf();
        $c208222f2bd70452$var$W = f;
    } else a.current = c;
    if ($c208222f2bd70452$var$qj) $c208222f2bd70452$var$qj = !1, $c208222f2bd70452$var$rj = a, $c208222f2bd70452$var$sj = b;
    else for($c208222f2bd70452$var$Y = e; null !== $c208222f2bd70452$var$Y;)b = $c208222f2bd70452$var$Y.nextEffect, $c208222f2bd70452$var$Y.nextEffect = null, $c208222f2bd70452$var$Y = b;
    b = a.firstPendingTime;
    0 === b && ($c208222f2bd70452$var$aj = null);
    1073741823 === b ? a === $c208222f2bd70452$var$vj ? $c208222f2bd70452$var$uj++ : ($c208222f2bd70452$var$uj = 0, $c208222f2bd70452$var$vj = a) : $c208222f2bd70452$var$uj = 0;
    "function" === typeof $c208222f2bd70452$var$Uj && $c208222f2bd70452$var$Uj(c.stateNode, d);
    $c208222f2bd70452$var$Z(a);
    if ($c208222f2bd70452$var$Yi) throw $c208222f2bd70452$var$Yi = !1, a = $c208222f2bd70452$var$Zi, $c208222f2bd70452$var$Zi = null, a;
    if (($c208222f2bd70452$var$W & $c208222f2bd70452$var$ej) !== $c208222f2bd70452$var$V) return null;
    $c208222f2bd70452$var$gg();
    return null;
}
function $c208222f2bd70452$var$Tj() {
    for(; null !== $c208222f2bd70452$var$Y;){
        var a = $c208222f2bd70452$var$Y.effectTag;
        0 !== (a & 256) && $c208222f2bd70452$var$Gi($c208222f2bd70452$var$Y.alternate, $c208222f2bd70452$var$Y);
        0 === (a & 512) || $c208222f2bd70452$var$qj || ($c208222f2bd70452$var$qj = !0, $c208222f2bd70452$var$dg(97, function() {
            $c208222f2bd70452$var$Dj();
            return null;
        }));
        $c208222f2bd70452$var$Y = $c208222f2bd70452$var$Y.nextEffect;
    }
}
function $c208222f2bd70452$var$Dj() {
    if (90 !== $c208222f2bd70452$var$sj) {
        var a = 97 < $c208222f2bd70452$var$sj ? 97 : $c208222f2bd70452$var$sj;
        $c208222f2bd70452$var$sj = 90;
        return $c208222f2bd70452$var$cg(a, $c208222f2bd70452$var$Vj);
    }
}
function $c208222f2bd70452$var$Vj() {
    if (null === $c208222f2bd70452$var$rj) return !1;
    var a = $c208222f2bd70452$var$rj;
    $c208222f2bd70452$var$rj = null;
    if (($c208222f2bd70452$var$W & ($c208222f2bd70452$var$fj | $c208222f2bd70452$var$gj)) !== $c208222f2bd70452$var$V) throw Error($c208222f2bd70452$var$u(331));
    var b = $c208222f2bd70452$var$W;
    $c208222f2bd70452$var$W |= $c208222f2bd70452$var$gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    $c208222f2bd70452$var$Hi(5, c), $c208222f2bd70452$var$Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error($c208222f2bd70452$var$u(330));
            $c208222f2bd70452$var$Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    $c208222f2bd70452$var$W = b;
    $c208222f2bd70452$var$gg();
    return !0;
}
function $c208222f2bd70452$var$Wj(a, b, c) {
    b = $c208222f2bd70452$var$Ai(c, b);
    b = $c208222f2bd70452$var$Xi(a, b, 1073741823);
    $c208222f2bd70452$var$xg(a, b);
    a = $c208222f2bd70452$var$xj(a, 1073741823);
    null !== a && $c208222f2bd70452$var$Z(a);
}
function $c208222f2bd70452$var$Ei(a, b) {
    if (3 === a.tag) $c208222f2bd70452$var$Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $c208222f2bd70452$var$Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c208222f2bd70452$var$aj || !$c208222f2bd70452$var$aj.has(d))) {
                a = $c208222f2bd70452$var$Ai(b, a);
                a = $c208222f2bd70452$var$$i(c, a, 1073741823);
                $c208222f2bd70452$var$xg(c, a);
                c = $c208222f2bd70452$var$xj(c, 1073741823);
                null !== c && $c208222f2bd70452$var$Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function $c208222f2bd70452$var$Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    $c208222f2bd70452$var$T === a && $c208222f2bd70452$var$U === c ? $c208222f2bd70452$var$S === $c208222f2bd70452$var$vi || $c208222f2bd70452$var$S === $c208222f2bd70452$var$ui && 1073741823 === $c208222f2bd70452$var$lj && $c208222f2bd70452$var$$f() - $c208222f2bd70452$var$Ti < $c208222f2bd70452$var$pj ? $c208222f2bd70452$var$Ej(a, $c208222f2bd70452$var$U) : $c208222f2bd70452$var$oj = !0 : $c208222f2bd70452$var$Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, $c208222f2bd70452$var$Z(a)));
}
function $c208222f2bd70452$var$Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = $c208222f2bd70452$var$Gg(), b = $c208222f2bd70452$var$Hg(b, a, null));
    a = $c208222f2bd70452$var$xj(a, b);
    null !== a && $c208222f2bd70452$var$Z(a);
}
var $c208222f2bd70452$var$Rj;
$c208222f2bd70452$var$Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || $c208222f2bd70452$var$K.current) $c208222f2bd70452$var$rg = !0;
        else {
            if (d < c) {
                $c208222f2bd70452$var$rg = !1;
                switch(b.tag){
                    case 3:
                        $c208222f2bd70452$var$hi(b);
                        $c208222f2bd70452$var$Xh();
                        break;
                    case 5:
                        $c208222f2bd70452$var$fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        $c208222f2bd70452$var$L(b.type) && $c208222f2bd70452$var$Gf(b);
                        break;
                    case 4:
                        $c208222f2bd70452$var$dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        $c208222f2bd70452$var$I($c208222f2bd70452$var$jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return $c208222f2bd70452$var$ji(a, b, c);
                            $c208222f2bd70452$var$I($c208222f2bd70452$var$M, $c208222f2bd70452$var$M.current & 1);
                            b = $c208222f2bd70452$var$$h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        $c208222f2bd70452$var$I($c208222f2bd70452$var$M, $c208222f2bd70452$var$M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return $c208222f2bd70452$var$mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        $c208222f2bd70452$var$I($c208222f2bd70452$var$M, $c208222f2bd70452$var$M.current);
                        if (!d) return null;
                }
                return $c208222f2bd70452$var$$h(a, b, c);
            }
            $c208222f2bd70452$var$rg = !1;
        }
    } else $c208222f2bd70452$var$rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = $c208222f2bd70452$var$Cf(b, $c208222f2bd70452$var$J.current);
            $c208222f2bd70452$var$qg(b, c);
            e = $c208222f2bd70452$var$oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($c208222f2bd70452$var$L(d)) {
                    var f = !0;
                    $c208222f2bd70452$var$Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $c208222f2bd70452$var$ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $c208222f2bd70452$var$Fg(b, d, g, a);
                e.updater = $c208222f2bd70452$var$Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                $c208222f2bd70452$var$Ng(b, d, a, c);
                b = $c208222f2bd70452$var$gi(null, b, d, !0, f, c);
            } else b.tag = 0, $c208222f2bd70452$var$R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                $c208222f2bd70452$var$ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = $c208222f2bd70452$var$Xj(e);
                a = $c208222f2bd70452$var$ig(e, a);
                switch(f){
                    case 0:
                        b = $c208222f2bd70452$var$di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $c208222f2bd70452$var$fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $c208222f2bd70452$var$Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $c208222f2bd70452$var$ai(null, b, e, $c208222f2bd70452$var$ig(e.type, a), d, c);
                        break a;
                }
                throw Error($c208222f2bd70452$var$u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c208222f2bd70452$var$ig(d, e), $c208222f2bd70452$var$di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c208222f2bd70452$var$ig(d, e), $c208222f2bd70452$var$fi(a, b, d, e, c);
        case 3:
            $c208222f2bd70452$var$hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($c208222f2bd70452$var$u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $c208222f2bd70452$var$vg(a, b);
            $c208222f2bd70452$var$zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $c208222f2bd70452$var$Xh(), b = $c208222f2bd70452$var$$h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) $c208222f2bd70452$var$Ph = $c208222f2bd70452$var$Jd(b.stateNode.containerInfo.firstChild), $c208222f2bd70452$var$Oh = b, e = $c208222f2bd70452$var$Qh = !0;
                if (e) for(c = $c208222f2bd70452$var$Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else $c208222f2bd70452$var$R(a, b, d, c), $c208222f2bd70452$var$Xh();
                b = b.child;
            }
            return b;
        case 5:
            return $c208222f2bd70452$var$fh(b), null === a && $c208222f2bd70452$var$Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c208222f2bd70452$var$Gd(d, e) ? g = null : null !== f && $c208222f2bd70452$var$Gd(d, f) && (b.effectTag |= 16), $c208222f2bd70452$var$ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : ($c208222f2bd70452$var$R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && $c208222f2bd70452$var$Uh(b), null;
        case 13:
            return $c208222f2bd70452$var$ji(a, b, c);
        case 4:
            return $c208222f2bd70452$var$dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c208222f2bd70452$var$Xg(b, null, d, c) : $c208222f2bd70452$var$R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c208222f2bd70452$var$ig(d, e), $c208222f2bd70452$var$Zh(a, b, d, e, c);
        case 7:
            return $c208222f2bd70452$var$R(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c208222f2bd70452$var$R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c208222f2bd70452$var$R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $c208222f2bd70452$var$I($c208222f2bd70452$var$jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $c208222f2bd70452$var$$e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$c208222f2bd70452$var$K.current) {
                            b = $c208222f2bd70452$var$$h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $c208222f2bd70452$var$wg(c, null), l.tag = 2, $c208222f2bd70452$var$xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    $c208222f2bd70452$var$pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $c208222f2bd70452$var$R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $c208222f2bd70452$var$qg(b, c), e = $c208222f2bd70452$var$sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, $c208222f2bd70452$var$R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $c208222f2bd70452$var$ig(e, b.pendingProps), f = $c208222f2bd70452$var$ig(e.type, f), $c208222f2bd70452$var$ai(a, b, e, f, d, c);
        case 15:
            return $c208222f2bd70452$var$ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c208222f2bd70452$var$ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, $c208222f2bd70452$var$L(d) ? (a = !0, $c208222f2bd70452$var$Gf(b)) : a = !1, $c208222f2bd70452$var$qg(b, c), $c208222f2bd70452$var$Lg(b, d, e), $c208222f2bd70452$var$Ng(b, d, e, c), $c208222f2bd70452$var$gi(null, b, d, !0, a, c);
        case 19:
            return $c208222f2bd70452$var$mi(a, b, c);
    }
    throw Error($c208222f2bd70452$var$u(156, b.tag));
};
var $c208222f2bd70452$var$Uj = null, $c208222f2bd70452$var$Li = null;
function $c208222f2bd70452$var$Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        $c208222f2bd70452$var$Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        $c208222f2bd70452$var$Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function $c208222f2bd70452$var$Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function $c208222f2bd70452$var$Sh(a, b, c, d) {
    return new $c208222f2bd70452$var$Zj(a, b, c, d);
}
function $c208222f2bd70452$var$bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c208222f2bd70452$var$Xj(a) {
    if ("function" === typeof a) return $c208222f2bd70452$var$bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c208222f2bd70452$var$gb) return 11;
        if (a === $c208222f2bd70452$var$jb) return 14;
    }
    return 2;
}
function $c208222f2bd70452$var$Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = $c208222f2bd70452$var$Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c208222f2bd70452$var$Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c208222f2bd70452$var$bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c208222f2bd70452$var$ab:
            return $c208222f2bd70452$var$Wg(c.children, e, f, b);
        case $c208222f2bd70452$var$fb:
            g = 8;
            e |= 7;
            break;
        case $c208222f2bd70452$var$bb:
            g = 8;
            e |= 1;
            break;
        case $c208222f2bd70452$var$cb:
            return a = $c208222f2bd70452$var$Sh(12, c, b, e | 8), a.elementType = $c208222f2bd70452$var$cb, a.type = $c208222f2bd70452$var$cb, a.expirationTime = f, a;
        case $c208222f2bd70452$var$hb:
            return a = $c208222f2bd70452$var$Sh(13, c, b, e), a.type = $c208222f2bd70452$var$hb, a.elementType = $c208222f2bd70452$var$hb, a.expirationTime = f, a;
        case $c208222f2bd70452$var$ib:
            return a = $c208222f2bd70452$var$Sh(19, c, b, e), a.elementType = $c208222f2bd70452$var$ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c208222f2bd70452$var$db:
                    g = 10;
                    break a;
                case $c208222f2bd70452$var$eb:
                    g = 9;
                    break a;
                case $c208222f2bd70452$var$gb:
                    g = 11;
                    break a;
                case $c208222f2bd70452$var$jb:
                    g = 14;
                    break a;
                case $c208222f2bd70452$var$kb:
                    g = 16;
                    d = null;
                    break a;
                case $c208222f2bd70452$var$lb:
                    g = 22;
                    break a;
            }
            throw Error($c208222f2bd70452$var$u(130, null == a ? a : typeof a, ""));
    }
    b = $c208222f2bd70452$var$Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function $c208222f2bd70452$var$Wg(a, b, c, d) {
    a = $c208222f2bd70452$var$Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function $c208222f2bd70452$var$Tg(a, b, c) {
    a = $c208222f2bd70452$var$Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function $c208222f2bd70452$var$Vg(a, b, c) {
    b = $c208222f2bd70452$var$Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c208222f2bd70452$var$ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function $c208222f2bd70452$var$Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function $c208222f2bd70452$var$xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function $c208222f2bd70452$var$yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function $c208222f2bd70452$var$Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function $c208222f2bd70452$var$bk(a, b, c, d) {
    var e = b.current, f = $c208222f2bd70452$var$Gg(), g = $c208222f2bd70452$var$Dg.suspense;
    f = $c208222f2bd70452$var$Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if ($c208222f2bd70452$var$dc(c) !== c || 1 !== c.tag) throw Error($c208222f2bd70452$var$u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($c208222f2bd70452$var$L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($c208222f2bd70452$var$u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($c208222f2bd70452$var$L(k)) {
                c = $c208222f2bd70452$var$Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $c208222f2bd70452$var$Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c208222f2bd70452$var$wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $c208222f2bd70452$var$xg(e, b);
    $c208222f2bd70452$var$Ig(e, f);
    return f;
}
function $c208222f2bd70452$var$ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c208222f2bd70452$var$dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function $c208222f2bd70452$var$ek(a, b) {
    $c208222f2bd70452$var$dk(a, b);
    (a = a.alternate) && $c208222f2bd70452$var$dk(a, b);
}
function $c208222f2bd70452$var$fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new $c208222f2bd70452$var$ak(a, b, c), e = $c208222f2bd70452$var$Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    $c208222f2bd70452$var$ug(e);
    a[$c208222f2bd70452$var$Od] = d.current;
    c && 0 !== b && $c208222f2bd70452$var$Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
$c208222f2bd70452$var$fk.prototype.render = function(a) {
    $c208222f2bd70452$var$bk(a, this._internalRoot, null, null);
};
$c208222f2bd70452$var$fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $c208222f2bd70452$var$bk(null, a, null, function() {
        b[$c208222f2bd70452$var$Od] = null;
    });
};
function $c208222f2bd70452$var$gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c208222f2bd70452$var$hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $c208222f2bd70452$var$fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $c208222f2bd70452$var$ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c208222f2bd70452$var$ck(g);
                h.call(a);
            };
        }
        $c208222f2bd70452$var$bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $c208222f2bd70452$var$hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $c208222f2bd70452$var$ck(g);
                k.call(a);
            };
        }
        $c208222f2bd70452$var$Nj(function() {
            $c208222f2bd70452$var$bk(b, g, a, e);
        });
    }
    return $c208222f2bd70452$var$ck(g);
}
function $c208222f2bd70452$var$jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c208222f2bd70452$var$$a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
$c208222f2bd70452$var$wc = function(a) {
    if (13 === a.tag) {
        var b = $c208222f2bd70452$var$hg($c208222f2bd70452$var$Gg(), 150, 100);
        $c208222f2bd70452$var$Ig(a, b);
        $c208222f2bd70452$var$ek(a, b);
    }
};
$c208222f2bd70452$var$xc = function(a) {
    13 === a.tag && ($c208222f2bd70452$var$Ig(a, 3), $c208222f2bd70452$var$ek(a, 3));
};
$c208222f2bd70452$var$yc = function(a) {
    if (13 === a.tag) {
        var b = $c208222f2bd70452$var$Gg();
        b = $c208222f2bd70452$var$Hg(b, a, null);
        $c208222f2bd70452$var$Ig(a, b);
        $c208222f2bd70452$var$ek(a, b);
    }
};
$c208222f2bd70452$var$za = function(a, b, c) {
    switch(b){
        case "input":
            $c208222f2bd70452$var$Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c208222f2bd70452$var$Qd(d);
                        if (!e) throw Error($c208222f2bd70452$var$u(90));
                        $c208222f2bd70452$var$yb(d);
                        $c208222f2bd70452$var$Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c208222f2bd70452$var$Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && $c208222f2bd70452$var$Hb(a, !!c.multiple, b, !1);
    }
};
$c208222f2bd70452$var$Fa = $c208222f2bd70452$var$Mj;
$c208222f2bd70452$var$Ga = function(a, b, c, d, e) {
    var f = $c208222f2bd70452$var$W;
    $c208222f2bd70452$var$W |= 4;
    try {
        return $c208222f2bd70452$var$cg(98, a.bind(null, b, c, d, e));
    } finally{
        $c208222f2bd70452$var$W = f, $c208222f2bd70452$var$W === $c208222f2bd70452$var$V && $c208222f2bd70452$var$gg();
    }
};
$c208222f2bd70452$var$Ha = function() {
    ($c208222f2bd70452$var$W & (1 | $c208222f2bd70452$var$fj | $c208222f2bd70452$var$gj)) === $c208222f2bd70452$var$V && ($c208222f2bd70452$var$Lj(), $c208222f2bd70452$var$Dj());
};
$c208222f2bd70452$var$Ia = function(a, b) {
    var c = $c208222f2bd70452$var$W;
    $c208222f2bd70452$var$W |= 2;
    try {
        return a(b);
    } finally{
        $c208222f2bd70452$var$W = c, $c208222f2bd70452$var$W === $c208222f2bd70452$var$V && $c208222f2bd70452$var$gg();
    }
};
function $c208222f2bd70452$var$kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c208222f2bd70452$var$gk(b)) throw Error($c208222f2bd70452$var$u(200));
    return $c208222f2bd70452$var$jk(a, b, null, c);
}
var $c208222f2bd70452$var$lk = {
    Events: [
        $c208222f2bd70452$var$Nc,
        $c208222f2bd70452$var$Pd,
        $c208222f2bd70452$var$Qd,
        $c208222f2bd70452$var$xa,
        $c208222f2bd70452$var$ta,
        $c208222f2bd70452$var$Xd,
        function(a) {
            $c208222f2bd70452$var$jc(a, $c208222f2bd70452$var$Wd);
        },
        $c208222f2bd70452$var$Da,
        $c208222f2bd70452$var$Ea,
        $c208222f2bd70452$var$id,
        $c208222f2bd70452$var$mc,
        $c208222f2bd70452$var$Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return $c208222f2bd70452$var$Yj($70tqi({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: $c208222f2bd70452$var$Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = $c208222f2bd70452$var$hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: $c208222f2bd70452$var$tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
$c208222f2bd70452$export$ae55be85d98224ed = $c208222f2bd70452$var$lk;
$c208222f2bd70452$export$d39a5bbd09211389 = $c208222f2bd70452$var$kk;
$c208222f2bd70452$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c208222f2bd70452$var$u(188));
        throw Error($c208222f2bd70452$var$u(268, Object.keys(a)));
    }
    a = $c208222f2bd70452$var$hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c208222f2bd70452$export$cd75ccfd720a3cd4 = function(a, b) {
    if (($c208222f2bd70452$var$W & ($c208222f2bd70452$var$fj | $c208222f2bd70452$var$gj)) !== $c208222f2bd70452$var$V) throw Error($c208222f2bd70452$var$u(187));
    var c = $c208222f2bd70452$var$W;
    $c208222f2bd70452$var$W |= 1;
    try {
        return $c208222f2bd70452$var$cg(99, a.bind(null, b));
    } finally{
        $c208222f2bd70452$var$W = c, $c208222f2bd70452$var$gg();
    }
};
$c208222f2bd70452$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c208222f2bd70452$var$gk(b)) throw Error($c208222f2bd70452$var$u(200));
    return $c208222f2bd70452$var$ik(null, a, b, !0, c);
};
$c208222f2bd70452$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c208222f2bd70452$var$gk(b)) throw Error($c208222f2bd70452$var$u(200));
    return $c208222f2bd70452$var$ik(null, a, b, !1, c);
};
$c208222f2bd70452$export$502457920280e6be = function(a) {
    if (!$c208222f2bd70452$var$gk(a)) throw Error($c208222f2bd70452$var$u(40));
    return a._reactRootContainer ? ($c208222f2bd70452$var$Nj(function() {
        $c208222f2bd70452$var$ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c208222f2bd70452$var$Od] = null;
        });
    }), !0) : !1;
};
$c208222f2bd70452$export$c78a37762a8d58e1 = $c208222f2bd70452$var$Mj;
$c208222f2bd70452$export$2577ef5d2565d52f = function(a, b) {
    return $c208222f2bd70452$var$kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$c208222f2bd70452$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c208222f2bd70452$var$gk(c)) throw Error($c208222f2bd70452$var$u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error($c208222f2bd70452$var$u(38));
    return $c208222f2bd70452$var$ik(a, b, c, !1, d);
};
$c208222f2bd70452$export$83d89fbfd8236492 = "16.14.0";

});
parcelRequire.register("ezKtH", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3mkwB"));

});
parcelRequire.register("3mkwB", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $272358f6156b52f7$export$c4744153514ff05d; }, function (v) { return $272358f6156b52f7$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $272358f6156b52f7$export$d66a1c1c77bd778b; }, function (v) { return $272358f6156b52f7$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $272358f6156b52f7$export$3e506c1ccc9cc1a7; }, function (v) { return $272358f6156b52f7$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $272358f6156b52f7$export$e26fe2ed2fa76875; }, function (v) { return $272358f6156b52f7$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $272358f6156b52f7$export$502329bbf4b505b1; }, function (v) { return $272358f6156b52f7$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $272358f6156b52f7$export$6e3807111c4874c4; }, function (v) { return $272358f6156b52f7$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $272358f6156b52f7$export$c27134553091fb3a; }, function (v) { return $272358f6156b52f7$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $272358f6156b52f7$export$33ee1acdc04fd2a2; }, function (v) { return $272358f6156b52f7$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $272358f6156b52f7$export$b00a404bbd5edef2; }, function (v) { return $272358f6156b52f7$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $272358f6156b52f7$export$8352ce38b91d0c62; }, function (v) { return $272358f6156b52f7$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $272358f6156b52f7$export$d3dfb8e4810cb555; }, function (v) { return $272358f6156b52f7$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $272358f6156b52f7$export$839f9183b0465a69; }, function (v) { return $272358f6156b52f7$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $272358f6156b52f7$export$72fdf0e06517287b; }, function (v) { return $272358f6156b52f7$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $272358f6156b52f7$export$4b844e58a3e414b4; }, function (v) { return $272358f6156b52f7$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $272358f6156b52f7$export$816d2913ae6b83b1; }, function (v) { return $272358f6156b52f7$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $272358f6156b52f7$export$61bcfe829111a1d0; }, function (v) { return $272358f6156b52f7$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $272358f6156b52f7$export$7ee8c9beb337bc3f; }, function (v) { return $272358f6156b52f7$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $272358f6156b52f7$export$b5836b71941fa3ed; }, function (v) { return $272358f6156b52f7$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $272358f6156b52f7$export$cf845f2c119da08a; }, function (v) { return $272358f6156b52f7$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $272358f6156b52f7$export$c4744153514ff05d;
var $272358f6156b52f7$export$d66a1c1c77bd778b;
var $272358f6156b52f7$export$3e506c1ccc9cc1a7;
var $272358f6156b52f7$export$e26fe2ed2fa76875;
var $272358f6156b52f7$export$502329bbf4b505b1;
var $272358f6156b52f7$export$6e3807111c4874c4;
var $272358f6156b52f7$export$c27134553091fb3a;
var $272358f6156b52f7$export$33ee1acdc04fd2a2;
var $272358f6156b52f7$export$b00a404bbd5edef2;
var $272358f6156b52f7$export$8352ce38b91d0c62;
var $272358f6156b52f7$export$d3dfb8e4810cb555;
var $272358f6156b52f7$export$839f9183b0465a69;
var $272358f6156b52f7$export$72fdf0e06517287b;
var $272358f6156b52f7$export$4b844e58a3e414b4;
var $272358f6156b52f7$export$816d2913ae6b83b1;
var $272358f6156b52f7$export$61bcfe829111a1d0;
var $272358f6156b52f7$export$7ee8c9beb337bc3f;
var $272358f6156b52f7$export$b5836b71941fa3ed;
var $272358f6156b52f7$export$cf845f2c119da08a;
"use strict";
var $272358f6156b52f7$var$f, $272358f6156b52f7$var$g, $272358f6156b52f7$var$h, $272358f6156b52f7$var$k, $272358f6156b52f7$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $272358f6156b52f7$var$p = null, $272358f6156b52f7$var$q = null, $272358f6156b52f7$var$t = function() {
        if (null !== $272358f6156b52f7$var$p) try {
            var a = $272358f6156b52f7$export$c4744153514ff05d();
            $272358f6156b52f7$var$p(!0, a);
            $272358f6156b52f7$var$p = null;
        } catch (b) {
            throw setTimeout($272358f6156b52f7$var$t, 0), b;
        }
    }, $272358f6156b52f7$var$u = Date.now();
    $272358f6156b52f7$export$c4744153514ff05d = function() {
        return Date.now() - $272358f6156b52f7$var$u;
    };
    $272358f6156b52f7$var$f = function(a) {
        null !== $272358f6156b52f7$var$p ? setTimeout($272358f6156b52f7$var$f, 0, a) : ($272358f6156b52f7$var$p = a, setTimeout($272358f6156b52f7$var$t, 0));
    };
    $272358f6156b52f7$var$g = function(a, b) {
        $272358f6156b52f7$var$q = setTimeout(a, b);
    };
    $272358f6156b52f7$var$h = function() {
        clearTimeout($272358f6156b52f7$var$q);
    };
    $272358f6156b52f7$var$k = function() {
        return !1;
    };
    $272358f6156b52f7$var$l = $272358f6156b52f7$export$d66a1c1c77bd778b = function() {};
} else {
    var $272358f6156b52f7$var$w = window.performance, $272358f6156b52f7$var$x = window.Date, $272358f6156b52f7$var$y = window.setTimeout, $272358f6156b52f7$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $272358f6156b52f7$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $272358f6156b52f7$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $272358f6156b52f7$var$w && "function" === typeof $272358f6156b52f7$var$w.now) $272358f6156b52f7$export$c4744153514ff05d = function() {
        return $272358f6156b52f7$var$w.now();
    };
    else {
        var $272358f6156b52f7$var$B = $272358f6156b52f7$var$x.now();
        $272358f6156b52f7$export$c4744153514ff05d = function() {
            return $272358f6156b52f7$var$x.now() - $272358f6156b52f7$var$B;
        };
    }
    var $272358f6156b52f7$var$C = !1, $272358f6156b52f7$var$D = null, $272358f6156b52f7$var$E = -1, $272358f6156b52f7$var$F = 5, $272358f6156b52f7$var$G = 0;
    $272358f6156b52f7$var$k = function() {
        return $272358f6156b52f7$export$c4744153514ff05d() >= $272358f6156b52f7$var$G;
    };
    $272358f6156b52f7$var$l = function() {};
    $272358f6156b52f7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $272358f6156b52f7$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $272358f6156b52f7$var$H = new MessageChannel, $272358f6156b52f7$var$I = $272358f6156b52f7$var$H.port2;
    $272358f6156b52f7$var$H.port1.onmessage = function() {
        if (null !== $272358f6156b52f7$var$D) {
            var a = $272358f6156b52f7$export$c4744153514ff05d();
            $272358f6156b52f7$var$G = a + $272358f6156b52f7$var$F;
            try {
                $272358f6156b52f7$var$D(!0, a) ? $272358f6156b52f7$var$I.postMessage(null) : ($272358f6156b52f7$var$C = !1, $272358f6156b52f7$var$D = null);
            } catch (b) {
                throw $272358f6156b52f7$var$I.postMessage(null), b;
            }
        } else $272358f6156b52f7$var$C = !1;
    };
    $272358f6156b52f7$var$f = function(a) {
        $272358f6156b52f7$var$D = a;
        $272358f6156b52f7$var$C || ($272358f6156b52f7$var$C = !0, $272358f6156b52f7$var$I.postMessage(null));
    };
    $272358f6156b52f7$var$g = function(a, b) {
        $272358f6156b52f7$var$E = $272358f6156b52f7$var$y(function() {
            a($272358f6156b52f7$export$c4744153514ff05d());
        }, b);
    };
    $272358f6156b52f7$var$h = function() {
        $272358f6156b52f7$var$z($272358f6156b52f7$var$E);
        $272358f6156b52f7$var$E = -1;
    };
}
function $272358f6156b52f7$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $272358f6156b52f7$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $272358f6156b52f7$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $272358f6156b52f7$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $272358f6156b52f7$var$K(n, c)) void 0 !== r && 0 > $272358f6156b52f7$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $272358f6156b52f7$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $272358f6156b52f7$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $272358f6156b52f7$var$N = [], $272358f6156b52f7$var$O = [], $272358f6156b52f7$var$P = 1, $272358f6156b52f7$var$Q = null, $272358f6156b52f7$var$R = 3, $272358f6156b52f7$var$S = !1, $272358f6156b52f7$var$T = !1, $272358f6156b52f7$var$U = !1;
function $272358f6156b52f7$var$V(a) {
    for(var b = $272358f6156b52f7$var$L($272358f6156b52f7$var$O); null !== b;){
        if (null === b.callback) $272358f6156b52f7$var$M($272358f6156b52f7$var$O);
        else if (b.startTime <= a) $272358f6156b52f7$var$M($272358f6156b52f7$var$O), b.sortIndex = b.expirationTime, $272358f6156b52f7$var$J($272358f6156b52f7$var$N, b);
        else break;
        b = $272358f6156b52f7$var$L($272358f6156b52f7$var$O);
    }
}
function $272358f6156b52f7$var$W(a) {
    $272358f6156b52f7$var$U = !1;
    $272358f6156b52f7$var$V(a);
    if (!$272358f6156b52f7$var$T) {
        if (null !== $272358f6156b52f7$var$L($272358f6156b52f7$var$N)) $272358f6156b52f7$var$T = !0, $272358f6156b52f7$var$f($272358f6156b52f7$var$X);
        else {
            var b = $272358f6156b52f7$var$L($272358f6156b52f7$var$O);
            null !== b && $272358f6156b52f7$var$g($272358f6156b52f7$var$W, b.startTime - a);
        }
    }
}
function $272358f6156b52f7$var$X(a, b) {
    $272358f6156b52f7$var$T = !1;
    $272358f6156b52f7$var$U && ($272358f6156b52f7$var$U = !1, $272358f6156b52f7$var$h());
    $272358f6156b52f7$var$S = !0;
    var c = $272358f6156b52f7$var$R;
    try {
        $272358f6156b52f7$var$V(b);
        for($272358f6156b52f7$var$Q = $272358f6156b52f7$var$L($272358f6156b52f7$var$N); null !== $272358f6156b52f7$var$Q && (!($272358f6156b52f7$var$Q.expirationTime > b) || a && !$272358f6156b52f7$var$k());){
            var d = $272358f6156b52f7$var$Q.callback;
            if (null !== d) {
                $272358f6156b52f7$var$Q.callback = null;
                $272358f6156b52f7$var$R = $272358f6156b52f7$var$Q.priorityLevel;
                var e = d($272358f6156b52f7$var$Q.expirationTime <= b);
                b = $272358f6156b52f7$export$c4744153514ff05d();
                "function" === typeof e ? $272358f6156b52f7$var$Q.callback = e : $272358f6156b52f7$var$Q === $272358f6156b52f7$var$L($272358f6156b52f7$var$N) && $272358f6156b52f7$var$M($272358f6156b52f7$var$N);
                $272358f6156b52f7$var$V(b);
            } else $272358f6156b52f7$var$M($272358f6156b52f7$var$N);
            $272358f6156b52f7$var$Q = $272358f6156b52f7$var$L($272358f6156b52f7$var$N);
        }
        if (null !== $272358f6156b52f7$var$Q) var m = !0;
        else {
            var n = $272358f6156b52f7$var$L($272358f6156b52f7$var$O);
            null !== n && $272358f6156b52f7$var$g($272358f6156b52f7$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $272358f6156b52f7$var$Q = null, $272358f6156b52f7$var$R = c, $272358f6156b52f7$var$S = !1;
    }
}
function $272358f6156b52f7$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $272358f6156b52f7$var$Z = $272358f6156b52f7$var$l;
$272358f6156b52f7$export$3e506c1ccc9cc1a7 = 5;
$272358f6156b52f7$export$e26fe2ed2fa76875 = 1;
$272358f6156b52f7$export$502329bbf4b505b1 = 4;
$272358f6156b52f7$export$6e3807111c4874c4 = 3;
$272358f6156b52f7$export$c27134553091fb3a = null;
$272358f6156b52f7$export$33ee1acdc04fd2a2 = 2;
$272358f6156b52f7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$272358f6156b52f7$export$8352ce38b91d0c62 = function() {
    $272358f6156b52f7$var$T || $272358f6156b52f7$var$S || ($272358f6156b52f7$var$T = !0, $272358f6156b52f7$var$f($272358f6156b52f7$var$X));
};
$272358f6156b52f7$export$d3dfb8e4810cb555 = function() {
    return $272358f6156b52f7$var$R;
};
$272358f6156b52f7$export$839f9183b0465a69 = function() {
    return $272358f6156b52f7$var$L($272358f6156b52f7$var$N);
};
$272358f6156b52f7$export$72fdf0e06517287b = function(a) {
    switch($272358f6156b52f7$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $272358f6156b52f7$var$R;
    }
    var c = $272358f6156b52f7$var$R;
    $272358f6156b52f7$var$R = b;
    try {
        return a();
    } finally{
        $272358f6156b52f7$var$R = c;
    }
};
$272358f6156b52f7$export$4b844e58a3e414b4 = function() {};
$272358f6156b52f7$export$816d2913ae6b83b1 = $272358f6156b52f7$var$Z;
$272358f6156b52f7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $272358f6156b52f7$var$R;
    $272358f6156b52f7$var$R = a;
    try {
        return b();
    } finally{
        $272358f6156b52f7$var$R = c;
    }
};
$272358f6156b52f7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $272358f6156b52f7$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $272358f6156b52f7$var$Y(a);
    } else c = $272358f6156b52f7$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $272358f6156b52f7$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $272358f6156b52f7$var$J($272358f6156b52f7$var$O, a), null === $272358f6156b52f7$var$L($272358f6156b52f7$var$N) && a === $272358f6156b52f7$var$L($272358f6156b52f7$var$O) && ($272358f6156b52f7$var$U ? $272358f6156b52f7$var$h() : $272358f6156b52f7$var$U = !0, $272358f6156b52f7$var$g($272358f6156b52f7$var$W, e - d))) : (a.sortIndex = c, $272358f6156b52f7$var$J($272358f6156b52f7$var$N, a), $272358f6156b52f7$var$T || $272358f6156b52f7$var$S || ($272358f6156b52f7$var$T = !0, $272358f6156b52f7$var$f($272358f6156b52f7$var$X)));
    return a;
};
$272358f6156b52f7$export$b5836b71941fa3ed = function() {
    var a = $272358f6156b52f7$export$c4744153514ff05d();
    $272358f6156b52f7$var$V(a);
    var b = $272358f6156b52f7$var$L($272358f6156b52f7$var$N);
    return b !== $272358f6156b52f7$var$Q && null !== $272358f6156b52f7$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $272358f6156b52f7$var$Q.expirationTime || $272358f6156b52f7$var$k();
};
$272358f6156b52f7$export$cf845f2c119da08a = function(a) {
    var b = $272358f6156b52f7$var$R;
    return function() {
        var c = $272358f6156b52f7$var$R;
        $272358f6156b52f7$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $272358f6156b52f7$var$R = c;
        }
    };
};

});



parcelRequire.register("ef61Y", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $a5e724fe59f0018c$export$bdfd709ae4826697; }, function (v) { return $a5e724fe59f0018c$export$bdfd709ae4826697 = v; });
var $a5e724fe59f0018c$export$bdfd709ae4826697;
var $a5e724fe59f0018c$export$c9e73fbda7da57b6;
var $a5e724fe59f0018c$export$5a759dc7a1cfb72a;
"use strict";
var $a5e724fe59f0018c$var$bundleURL = {};
function $a5e724fe59f0018c$var$getBundleURLCached(id) {
    var value = $a5e724fe59f0018c$var$bundleURL[id];
    if (!value) {
        value = $a5e724fe59f0018c$var$getBundleURL();
        $a5e724fe59f0018c$var$bundleURL[id] = value;
    }
    return value;
}
function $a5e724fe59f0018c$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $a5e724fe59f0018c$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $a5e724fe59f0018c$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $a5e724fe59f0018c$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$a5e724fe59f0018c$export$bdfd709ae4826697 = $a5e724fe59f0018c$var$getBundleURLCached;
$a5e724fe59f0018c$export$c9e73fbda7da57b6 = $a5e724fe59f0018c$var$getBaseURL;
$a5e724fe59f0018c$export$5a759dc7a1cfb72a = $a5e724fe59f0018c$var$getOrigin;

});

parcelRequire.register("k9xxm", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

var $40ac97942f716825$exports = {};
"use strict";

$40ac97942f716825$exports = (parcelRequire("9AKcZ"));


parcelRequire("hJwnw");
var $a7721eb599d74a7a$exports = {};
"use strict";
function $a7721eb599d74a7a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a7721eb599d74a7a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a7721eb599d74a7a$var$checkDCE();

$a7721eb599d74a7a$exports = (parcelRequire("gEPfk"));




var $hJwnw = parcelRequire("hJwnw");
var $5468eea7b07c745b$var$niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    }
};
var $5468eea7b07c745b$var$errors = {};
function $5468eea7b07c745b$var$die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var $5468eea7b07c745b$var$mockGlobal = {};
function $5468eea7b07c745b$var$getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return $5468eea7b07c745b$var$mockGlobal;
}
var $5468eea7b07c745b$var$assign = Object.assign;
var $5468eea7b07c745b$var$getDescriptor = Object.getOwnPropertyDescriptor;
var $5468eea7b07c745b$var$defineProperty = Object.defineProperty;
var $5468eea7b07c745b$var$objectPrototype = Object.prototype;
var $5468eea7b07c745b$var$EMPTY_ARRAY = [];
Object.freeze($5468eea7b07c745b$var$EMPTY_ARRAY);
var $5468eea7b07c745b$var$EMPTY_OBJECT = {};
Object.freeze($5468eea7b07c745b$var$EMPTY_OBJECT);
var $5468eea7b07c745b$var$hasProxy = typeof Proxy !== "undefined";
var $5468eea7b07c745b$var$plainObjectString = /*#__PURE__*/ Object.toString();
function $5468eea7b07c745b$var$assertProxies() {
    if (!$5468eea7b07c745b$var$hasProxy) $5468eea7b07c745b$var$die("Proxy not available");
}
function $5468eea7b07c745b$var$warnAboutProxyRequirement(msg) {}
function $5468eea7b07c745b$var$getNextId() {
    return ++$5468eea7b07c745b$var$globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function $5468eea7b07c745b$var$once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var $5468eea7b07c745b$var$noop = function noop() {};
function $5468eea7b07c745b$var$isFunction(fn) {
    return typeof fn === "function";
}
function $5468eea7b07c745b$var$isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function $5468eea7b07c745b$var$isObject(value) {
    return value !== null && typeof value === "object";
}
function $5468eea7b07c745b$var$isPlainObject(value) {
    var _proto$constructor;
    if (!$5468eea7b07c745b$var$isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    return ((_proto$constructor = proto.constructor) == null ? void 0 : _proto$constructor.toString()) === $5468eea7b07c745b$var$plainObjectString;
} // https://stackoverflow.com/a/37865170
function $5468eea7b07c745b$var$isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function $5468eea7b07c745b$var$addHiddenProp(object, propName, value) {
    $5468eea7b07c745b$var$defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function $5468eea7b07c745b$var$addHiddenFinalProp(object, propName, value) {
    $5468eea7b07c745b$var$defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function $5468eea7b07c745b$var$createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return $5468eea7b07c745b$var$isObject(x) && x[propName] === true;
    };
}
function $5468eea7b07c745b$var$isES6Map(thing) {
    return thing instanceof Map;
}
function $5468eea7b07c745b$var$isES6Set(thing) {
    return thing instanceof Set;
}
var $5468eea7b07c745b$var$hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function $5468eea7b07c745b$var$getPlainObjectKeys(object) {
    var keys = Object.keys(object); // Not supported in IE, so there are not going to be symbol props anyway...
    if (!$5468eea7b07c745b$var$hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return $5468eea7b07c745b$var$objectPrototype.propertyIsEnumerable.call(object, s);
    }));
} // From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var $5468eea7b07c745b$var$ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : $5468eea7b07c745b$var$hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function $5468eea7b07c745b$var$stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function $5468eea7b07c745b$var$toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function $5468eea7b07c745b$var$hasProp(target, prop) {
    return $5468eea7b07c745b$var$objectPrototype.hasOwnProperty.call(target, prop);
} // From Immer utils
var $5468eea7b07c745b$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {}; // Note: without polyfill for ownKeys, symbols won't be picked up
    $5468eea7b07c745b$var$ownKeys(target).forEach(function(key) {
        res[key] = $5468eea7b07c745b$var$getDescriptor(target, key);
    });
    return res;
};
function $5468eea7b07c745b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5468eea7b07c745b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5468eea7b07c745b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5468eea7b07c745b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5468eea7b07c745b$var$_extends() {
    $5468eea7b07c745b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5468eea7b07c745b$var$_extends.apply(this, arguments);
}
function $5468eea7b07c745b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $5468eea7b07c745b$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $5468eea7b07c745b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5468eea7b07c745b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5468eea7b07c745b$var$_arrayLikeToArray(o, minLen);
}
function $5468eea7b07c745b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5468eea7b07c745b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $5468eea7b07c745b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
var $5468eea7b07c745b$var$storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function $5468eea7b07c745b$var$createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        $5468eea7b07c745b$var$storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function $5468eea7b07c745b$var$storeAnnotation(prototype, key, annotation) {
    if (!$5468eea7b07c745b$var$hasProp(prototype, $5468eea7b07c745b$var$storedAnnotationsSymbol)) $5468eea7b07c745b$var$addHiddenProp(prototype, $5468eea7b07c745b$var$storedAnnotationsSymbol, $5468eea7b07c745b$var$_extends({}, prototype[$5468eea7b07c745b$var$storedAnnotationsSymbol]));
     // @override must override something
    var fieldName;
    $5468eea7b07c745b$var$assertNotDecorated(prototype, annotation, key); // Ignore override
    if (!$5468eea7b07c745b$var$isOverride(annotation)) prototype[$5468eea7b07c745b$var$storedAnnotationsSymbol][key] = annotation;
}
function $5468eea7b07c745b$var$assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function $5468eea7b07c745b$var$collectStoredAnnotations(target) {
    if (!$5468eea7b07c745b$var$hasProp(target, $5468eea7b07c745b$var$storedAnnotationsSymbol)) $5468eea7b07c745b$var$addHiddenProp(target, $5468eea7b07c745b$var$storedAnnotationsSymbol, $5468eea7b07c745b$var$_extends({}, target[$5468eea7b07c745b$var$storedAnnotationsSymbol]));
    return target[$5468eea7b07c745b$var$storedAnnotationsSymbol];
}
var $5468eea7b07c745b$export$f246528900dd4467 = /*#__PURE__*/ Symbol("mobx administration");
var $5468eea7b07c745b$var$Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.isPendingUnobservation_ = false;
        this.isBeingObserved_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = $5468eea7b07c745b$var$IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    } // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return $5468eea7b07c745b$var$reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        $5468eea7b07c745b$var$startBatch();
        $5468eea7b07c745b$var$propagateChanged(this);
        $5468eea7b07c745b$var$endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var $5468eea7b07c745b$var$isAtom = /*#__PURE__*/ $5468eea7b07c745b$var$createInstanceofPredicate("Atom", $5468eea7b07c745b$var$Atom);
function $5468eea7b07c745b$export$2e17fe64ec9a826e(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = $5468eea7b07c745b$var$noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = $5468eea7b07c745b$var$noop;
    var atom = new $5468eea7b07c745b$var$Atom(name); // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== $5468eea7b07c745b$var$noop) $5468eea7b07c745b$export$24d7f9cdf0de2679(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== $5468eea7b07c745b$var$noop) $5468eea7b07c745b$export$f8586f6f22b9cba9(atom, onBecomeUnobservedHandler);
    return atom;
}
function $5468eea7b07c745b$var$identityComparer(a, b) {
    return a === b;
}
function $5468eea7b07c745b$var$structuralComparer(a, b) {
    return $5468eea7b07c745b$var$deepEqual(a, b);
}
function $5468eea7b07c745b$var$shallowComparer(a, b) {
    return $5468eea7b07c745b$var$deepEqual(a, b, 1);
}
function $5468eea7b07c745b$var$defaultComparer(a, b) {
    return Object.is(a, b);
}
var $5468eea7b07c745b$export$d9328cbeeb64e882 = {
    identity: $5468eea7b07c745b$var$identityComparer,
    structural: $5468eea7b07c745b$var$structuralComparer,
    "default": $5468eea7b07c745b$var$defaultComparer,
    shallow: $5468eea7b07c745b$var$shallowComparer
};
function $5468eea7b07c745b$var$deepEnhancer(v, _, name) {
    // it is an observable already, done
    if ($5468eea7b07c745b$export$5cd057a6046189f9(v)) return v; // something that can be converted and mutated?
    if (Array.isArray(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.array(v, {
        name: name
    });
    if ($5468eea7b07c745b$var$isPlainObject(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.object(v, undefined, {
        name: name
    });
    if ($5468eea7b07c745b$var$isES6Map(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.map(v, {
        name: name
    });
    if ($5468eea7b07c745b$var$isES6Set(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.set(v, {
        name: name
    });
    return v;
}
function $5468eea7b07c745b$var$shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if ($5468eea7b07c745b$export$31960fb081a18155(v) || $5468eea7b07c745b$export$f5afceff386badf9(v) || $5468eea7b07c745b$export$27a7faddcfd44960(v) || $5468eea7b07c745b$export$da6b063694cb52c1(v)) return v;
    if (Array.isArray(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.array(v, {
        name: name,
        deep: false
    });
    if ($5468eea7b07c745b$var$isPlainObject(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.object(v, undefined, {
        name: name,
        deep: false
    });
    if ($5468eea7b07c745b$var$isES6Map(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.map(v, {
        name: name,
        deep: false
    });
    if ($5468eea7b07c745b$var$isES6Set(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.set(v, {
        name: name,
        deep: false
    });
}
function $5468eea7b07c745b$var$referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function $5468eea7b07c745b$var$refStructEnhancer(v, oldValue) {
    if ($5468eea7b07c745b$var$deepEqual(v, oldValue)) return oldValue;
    return v;
}
var $5468eea7b07c745b$var$OVERRIDE = "override";
var $5468eea7b07c745b$export$a46fbcd73382caa5 = /*#__PURE__*/ $5468eea7b07c745b$var$createDecoratorAnnotation({
    annotationType_: $5468eea7b07c745b$var$OVERRIDE,
    make_: $5468eea7b07c745b$var$make_,
    extend_: $5468eea7b07c745b$var$extend_
});
function $5468eea7b07c745b$var$isOverride(annotation) {
    return annotation.annotationType_ === $5468eea7b07c745b$var$OVERRIDE;
}
function $5468eea7b07c745b$var$make_(adm, key) {}
function $5468eea7b07c745b$var$extend_(adm, key, descriptor, proxyTrap) {
    $5468eea7b07c745b$var$die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function $5468eea7b07c745b$var$createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $5468eea7b07c745b$var$make_$1,
        extend_: $5468eea7b07c745b$var$extend_$1
    };
}
function $5468eea7b07c745b$var$make_$1(adm, key) {
    var _this$options_$bound, _this$options_, _adm$target_$storedAn;
    var annotated = false;
    var source = adm.target_;
    var bound = (_this$options_$bound = (_this$options_ = this.options_) == null ? void 0 : _this$options_.bound) != null ? _this$options_$bound : false;
    while(source && source !== $5468eea7b07c745b$var$objectPrototype){
        var descriptor = $5468eea7b07c745b$var$getDescriptor(source, key);
        if (descriptor) {
            // Instance or bound
            // Keep first because the operation can be intercepted
            // and we don't want to end up with partially annotated proto chain
            if (source === adm.target_ || bound) {
                var actionDescriptor = $5468eea7b07c745b$var$createActionDescriptor(adm, this, key, descriptor);
                var definePropertyOutcome = adm.defineProperty_(key, actionDescriptor);
                if (!definePropertyOutcome) // Intercepted
                return;
                annotated = true; // Don't annotate protos if bound
                if (bound) break;
            } // Prototype
            if (source !== adm.target_) {
                if ($5468eea7b07c745b$export$b956e38827fca970(descriptor.value)) {
                    // A prototype could have been annotated already by other constructor,
                    // rest of the proto chain must be annotated already
                    annotated = true;
                    break;
                }
                var _actionDescriptor = $5468eea7b07c745b$var$createActionDescriptor(adm, this, key, descriptor, false);
                $5468eea7b07c745b$var$defineProperty(source, key, _actionDescriptor);
                annotated = true;
            }
        }
        source = Object.getPrototypeOf(source);
    }
    if (annotated) $5468eea7b07c745b$var$recordAnnotationApplied(adm, this, key);
    else if (!((_adm$target_$storedAn = adm.target_[$5468eea7b07c745b$var$storedAnnotationsSymbol]) == null ? void 0 : _adm$target_$storedAn[key])) // Throw on missing key, except for decorators:
    // Decorator annotations are collected from whole prototype chain.
    // When called from super() some props may not exist yet.
    // However we don't have to worry about missing prop,
    // because the decorator must have been applied to something.
    $5468eea7b07c745b$var$die(1, this.annotationType_, adm.name_ + "." + key.toString());
}
function $5468eea7b07c745b$var$extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = $5468eea7b07c745b$var$createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function $5468eea7b07c745b$var$assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function $5468eea7b07c745b$var$createActionDescriptor(adm, annotation, key, descriptor, safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3;
    if (safeDescriptors === void 0) safeDescriptors = $5468eea7b07c745b$var$globalState.safeDescriptors;
    $5468eea7b07c745b$var$assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: $5468eea7b07c745b$var$createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function $5468eea7b07c745b$var$createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $5468eea7b07c745b$var$make_$2,
        extend_: $5468eea7b07c745b$var$extend_$2
    };
}
function $5468eea7b07c745b$var$make_$2(adm, key) {
    var _adm$target_$storedAn;
    var annotated = false;
    var source = adm.target_;
    while(source && source !== $5468eea7b07c745b$var$objectPrototype){
        var descriptor = $5468eea7b07c745b$var$getDescriptor(source, key);
        if (descriptor) {
            if (source !== adm.target_) {
                // Prototype
                if ($5468eea7b07c745b$var$isFlow(descriptor.value)) {
                    // A prototype could have been annotated already by other constructor,
                    // rest of the proto chain must be annotated already
                    annotated = true;
                    break;
                }
                var flowDescriptor = $5468eea7b07c745b$var$createFlowDescriptor(adm, this, key, descriptor, false);
                $5468eea7b07c745b$var$defineProperty(source, key, flowDescriptor);
            } else {
                var _flowDescriptor = $5468eea7b07c745b$var$createFlowDescriptor(adm, this, key, descriptor);
                var definePropertyOutcome = adm.defineProperty_(key, _flowDescriptor);
                if (!definePropertyOutcome) // Intercepted
                return;
            }
            annotated = true;
        }
        source = Object.getPrototypeOf(source);
    }
    if (annotated) $5468eea7b07c745b$var$recordAnnotationApplied(adm, this, key);
    else if (!((_adm$target_$storedAn = adm.target_[$5468eea7b07c745b$var$storedAnnotationsSymbol]) == null ? void 0 : _adm$target_$storedAn[key])) // Throw on missing key, except for decorators:
    // Decorator annotations are collected from whole prototype chain.
    // When called from super() some props may not exist yet.
    // However we don't have to worry about missing prop,
    // because the decorator must have been applied to something.
    $5468eea7b07c745b$var$die(1, this.annotationType_, adm.name_ + "." + key.toString());
}
function $5468eea7b07c745b$var$extend_$2(adm, key, descriptor, proxyTrap) {
    var flowDescriptor = $5468eea7b07c745b$var$createFlowDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function $5468eea7b07c745b$var$assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function $5468eea7b07c745b$var$createFlowDescriptor(adm, annotation, key, descriptor, safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = $5468eea7b07c745b$var$globalState.safeDescriptors;
    $5468eea7b07c745b$var$assertFlowDescriptor(adm, annotation, key, descriptor);
    return {
        value: $5468eea7b07c745b$export$ccc7b0636abaffc3(descriptor.value),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function $5468eea7b07c745b$var$createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $5468eea7b07c745b$var$make_$3,
        extend_: $5468eea7b07c745b$var$extend_$3
    };
}
function $5468eea7b07c745b$var$make_$3(adm, key) {
    var _adm$target_$storedAn;
    var source = adm.target_;
    while(source && source !== $5468eea7b07c745b$var$objectPrototype){
        var descriptor = $5468eea7b07c745b$var$getDescriptor(source, key);
        if (descriptor) {
            $5468eea7b07c745b$var$assertComputedDescriptor(adm, this, key, descriptor);
            var definePropertyOutcome = adm.defineComputedProperty_(key, $5468eea7b07c745b$var$_extends({}, this.options_, {
                get: descriptor.get,
                set: descriptor.set
            }));
            if (!definePropertyOutcome) // Intercepted
            return;
            $5468eea7b07c745b$var$recordAnnotationApplied(adm, this, key);
            return;
        }
        source = Object.getPrototypeOf(source);
    }
    if (!((_adm$target_$storedAn = adm.target_[$5468eea7b07c745b$var$storedAnnotationsSymbol]) == null ? void 0 : _adm$target_$storedAn[key])) // Throw on missing key, except for decorators:
    // Decorator annotations are collected from whole prototype chain.
    // When called from super() some props may not exist yet.
    // However we don't have to worry about missing prop,
    // because the decorator must have been applied to something.
    $5468eea7b07c745b$var$die(1, this.annotationType_, adm.name_ + "." + key.toString());
}
function $5468eea7b07c745b$var$extend_$3(adm, key, descriptor, proxyTrap) {
    $5468eea7b07c745b$var$assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, $5468eea7b07c745b$var$_extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function $5468eea7b07c745b$var$assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function $5468eea7b07c745b$var$createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $5468eea7b07c745b$var$make_$4,
        extend_: $5468eea7b07c745b$var$extend_$4
    };
}
function $5468eea7b07c745b$var$make_$4(adm, key) {
    var _adm$target_$storedAn;
    var source = adm.target_; // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    while(source && source !== $5468eea7b07c745b$var$objectPrototype){
        var descriptor = $5468eea7b07c745b$var$getDescriptor(source, key);
        if (descriptor) {
            var _this$options_$enhanc, _this$options_;
            $5468eea7b07c745b$var$assertObservableDescriptor(adm, this, key, descriptor);
            var definePropertyOutcome = adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : $5468eea7b07c745b$var$deepEnhancer);
            if (!definePropertyOutcome) // Intercepted
            return;
            $5468eea7b07c745b$var$recordAnnotationApplied(adm, this, key);
            return;
        }
        source = Object.getPrototypeOf(source);
    }
    if (!((_adm$target_$storedAn = adm.target_[$5468eea7b07c745b$var$storedAnnotationsSymbol]) == null ? void 0 : _adm$target_$storedAn[key])) // Throw on missing key, except for decorators:
    // Decorator annotations are collected from whole prototype chain.
    // When called from super() some props may not exist yet.
    // However we don't have to worry about missing prop,
    // because the decorator must have been applied to something.
    $5468eea7b07c745b$var$die(1, this.annotationType_, adm.name_ + "." + key.toString());
}
function $5468eea7b07c745b$var$extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc2, _this$options_2;
    $5468eea7b07c745b$var$assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc2 = (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.enhancer) != null ? _this$options_$enhanc2 : $5468eea7b07c745b$var$deepEnhancer, proxyTrap);
}
function $5468eea7b07c745b$var$assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
// in the majority of cases
var $5468eea7b07c745b$var$defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze($5468eea7b07c745b$var$defaultCreateObservableOptions);
function $5468eea7b07c745b$var$asCreateObservableOptions(thing) {
    return thing || $5468eea7b07c745b$var$defaultCreateObservableOptions;
}
var $5468eea7b07c745b$var$observableAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createObservableAnnotation("observable");
var $5468eea7b07c745b$var$observableRefAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createObservableAnnotation("observable.ref", {
    enhancer: $5468eea7b07c745b$var$referenceEnhancer
});
var $5468eea7b07c745b$var$observableShallowAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createObservableAnnotation("observable.shallow", {
    enhancer: $5468eea7b07c745b$var$shallowEnhancer
});
var $5468eea7b07c745b$var$observableStructAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createObservableAnnotation("observable.struct", {
    enhancer: $5468eea7b07c745b$var$refStructEnhancer
});
var $5468eea7b07c745b$var$observableDecoratorAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createDecoratorAnnotation($5468eea7b07c745b$var$observableAnnotation);
function $5468eea7b07c745b$var$getEnhancerFromOptions(options) {
    return options.deep === true ? $5468eea7b07c745b$var$deepEnhancer : options.deep === false ? $5468eea7b07c745b$var$referenceEnhancer : $5468eea7b07c745b$var$getEnhancerFromAnnotation(options.defaultDecorator);
}
function $5468eea7b07c745b$var$getAnnotationFromOptions(options) {
    return options ? options.deep === true ? $5468eea7b07c745b$var$observableAnnotation : options.deep === false ? $5468eea7b07c745b$var$observableRefAnnotation : options.defaultDecorator : undefined;
}
function $5468eea7b07c745b$var$getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? $5468eea7b07c745b$var$deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : $5468eea7b07c745b$var$deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function $5468eea7b07c745b$var$createObservable(v, arg2, arg3) {
    // @observable someProp;
    if ($5468eea7b07c745b$var$isStringish(arg2)) {
        $5468eea7b07c745b$var$storeAnnotation(v, arg2, $5468eea7b07c745b$var$observableAnnotation);
        return;
    } // already observable - ignore
    if ($5468eea7b07c745b$export$5cd057a6046189f9(v)) return v; // plain object
    if ($5468eea7b07c745b$var$isPlainObject(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.object(v, arg2, arg3); // Array
    if (Array.isArray(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.array(v, arg2); // Map
    if ($5468eea7b07c745b$var$isES6Map(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.map(v, arg2); // Set
    if ($5468eea7b07c745b$var$isES6Set(v)) return $5468eea7b07c745b$export$5ab46cbf6120b33a.set(v, arg2); // other object - ignore
    if (typeof v === "object" && v !== null) return v; // anything else
    return $5468eea7b07c745b$export$5ab46cbf6120b33a.box(v, arg2);
}
Object.assign($5468eea7b07c745b$var$createObservable, $5468eea7b07c745b$var$observableDecoratorAnnotation);
var $5468eea7b07c745b$var$observableFactories = {
    box: function box(value, options) {
        var o = $5468eea7b07c745b$var$asCreateObservableOptions(options);
        return new $5468eea7b07c745b$var$ObservableValue(value, $5468eea7b07c745b$var$getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = $5468eea7b07c745b$var$asCreateObservableOptions(options);
        return ($5468eea7b07c745b$var$globalState.useProxies === false || o.proxy === false ? $5468eea7b07c745b$var$createLegacyArray : $5468eea7b07c745b$var$createObservableArray)(initialValues, $5468eea7b07c745b$var$getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = $5468eea7b07c745b$var$asCreateObservableOptions(options);
        return new $5468eea7b07c745b$export$db1c0901f08fc6fd(initialValues, $5468eea7b07c745b$var$getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = $5468eea7b07c745b$var$asCreateObservableOptions(options);
        return new $5468eea7b07c745b$export$2235f602a7a77c81(initialValues, $5468eea7b07c745b$var$getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return $5468eea7b07c745b$export$59d8134e963031bd($5468eea7b07c745b$var$globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? $5468eea7b07c745b$var$asObservableObject({}, options) : $5468eea7b07c745b$var$asDynamicObservableObject({}, options), props, decorators);
    },
    ref: /*#__PURE__*/ $5468eea7b07c745b$var$createDecoratorAnnotation($5468eea7b07c745b$var$observableRefAnnotation),
    shallow: /*#__PURE__*/ $5468eea7b07c745b$var$createDecoratorAnnotation($5468eea7b07c745b$var$observableShallowAnnotation),
    deep: $5468eea7b07c745b$var$observableDecoratorAnnotation,
    struct: /*#__PURE__*/ $5468eea7b07c745b$var$createDecoratorAnnotation($5468eea7b07c745b$var$observableStructAnnotation)
}; // eslint-disable-next-line
var $5468eea7b07c745b$export$5ab46cbf6120b33a = /*#__PURE__*/ $5468eea7b07c745b$var$assign($5468eea7b07c745b$var$createObservable, $5468eea7b07c745b$var$observableFactories);
var $5468eea7b07c745b$var$COMPUTED = "computed";
var $5468eea7b07c745b$var$COMPUTED_STRUCT = "computed.struct";
var $5468eea7b07c745b$var$computedAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createComputedAnnotation($5468eea7b07c745b$var$COMPUTED);
var $5468eea7b07c745b$var$computedStructAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createComputedAnnotation($5468eea7b07c745b$var$COMPUTED_STRUCT, {
    equals: $5468eea7b07c745b$export$d9328cbeeb64e882.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var $5468eea7b07c745b$export$2983e091f1a1e8e2 = function computed(arg1, arg2) {
    if ($5468eea7b07c745b$var$isStringish(arg2)) // @computed
    return $5468eea7b07c745b$var$storeAnnotation(arg1, arg2, $5468eea7b07c745b$var$computedAnnotation);
    if ($5468eea7b07c745b$var$isPlainObject(arg1)) // @computed({ options })
    return $5468eea7b07c745b$var$createDecoratorAnnotation($5468eea7b07c745b$var$createComputedAnnotation($5468eea7b07c745b$var$COMPUTED, arg1));
     // computed(expr, options?)
    var opts = $5468eea7b07c745b$var$isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || "");
    /* for generated name */ return new $5468eea7b07c745b$var$ComputedValue(opts);
};
Object.assign($5468eea7b07c745b$export$2983e091f1a1e8e2, $5468eea7b07c745b$var$computedAnnotation);
$5468eea7b07c745b$export$2983e091f1a1e8e2.struct = /*#__PURE__*/ $5468eea7b07c745b$var$createDecoratorAnnotation($5468eea7b07c745b$var$computedStructAnnotation);
var $5468eea7b07c745b$var$_getDescriptor$config, $5468eea7b07c745b$var$_getDescriptor;
// mobx versions
var $5468eea7b07c745b$var$currentActionId = 0;
var $5468eea7b07c745b$var$nextActionId = 1;
var $5468eea7b07c745b$var$isFunctionNameConfigurable = ($5468eea7b07c745b$var$_getDescriptor$config = ($5468eea7b07c745b$var$_getDescriptor = /*#__PURE__*/ $5468eea7b07c745b$var$getDescriptor(function() {}, "name")) == null ? void 0 : $5468eea7b07c745b$var$_getDescriptor.configurable) != null ? $5468eea7b07c745b$var$_getDescriptor$config : false; // we can safely recycle this object
var $5468eea7b07c745b$var$tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function $5468eea7b07c745b$var$createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return $5468eea7b07c745b$var$executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    if ($5468eea7b07c745b$var$isFunctionNameConfigurable) {
        $5468eea7b07c745b$var$tmpNameDescriptor.value = actionName;
        Object.defineProperty(res, "name", $5468eea7b07c745b$var$tmpNameDescriptor);
    }
    return res;
}
function $5468eea7b07c745b$var$executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = $5468eea7b07c745b$export$42f76bef54cf1cd3(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        $5468eea7b07c745b$export$9d569d1d4d631c2d(runInfo);
    }
}
function $5468eea7b07c745b$export$42f76bef54cf1cd3(actionName, canRunAsDerivation, scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = $5468eea7b07c745b$var$globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    $5468eea7b07c745b$var$startBatch();
    var prevAllowStateChanges_ = $5468eea7b07c745b$var$globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        $5468eea7b07c745b$var$untrackedStart();
        prevAllowStateChanges_ = $5468eea7b07c745b$var$allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = $5468eea7b07c745b$export$84c93b6404d77e6f(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: $5468eea7b07c745b$var$nextActionId++,
        parentActionId_: $5468eea7b07c745b$var$currentActionId
    };
    $5468eea7b07c745b$var$currentActionId = runInfo.actionId_;
    return runInfo;
}
function $5468eea7b07c745b$export$9d569d1d4d631c2d(runInfo) {
    if ($5468eea7b07c745b$var$currentActionId !== runInfo.actionId_) $5468eea7b07c745b$var$die(30);
    $5468eea7b07c745b$var$currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) $5468eea7b07c745b$var$globalState.suppressReactionErrors = true;
    $5468eea7b07c745b$var$allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    $5468eea7b07c745b$export$c7b7fb1b2b410642(runInfo.prevAllowStateReads_);
    $5468eea7b07c745b$var$endBatch();
    if (runInfo.runAsAction_) $5468eea7b07c745b$var$untrackedEnd(runInfo.prevDerivation_);
    $5468eea7b07c745b$var$globalState.suppressReactionErrors = false;
}
function $5468eea7b07c745b$export$e510c5d1ea4358b1(allowStateChanges, func) {
    var prev = $5468eea7b07c745b$var$allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        $5468eea7b07c745b$var$allowStateChangesEnd(prev);
    }
}
function $5468eea7b07c745b$var$allowStateChangesStart(allowStateChanges) {
    var prev = $5468eea7b07c745b$var$globalState.allowStateChanges;
    $5468eea7b07c745b$var$globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function $5468eea7b07c745b$var$allowStateChangesEnd(prev) {
    $5468eea7b07c745b$var$globalState.allowStateChanges = prev;
}
var $5468eea7b07c745b$var$_Symbol$toPrimitive;
var $5468eea7b07c745b$var$CREATE = "create";
$5468eea7b07c745b$var$_Symbol$toPrimitive = Symbol.toPrimitive;
var $5468eea7b07c745b$var$ObservableValue = /*#__PURE__*/ function(_Atom) {
    $5468eea7b07c745b$var$_inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = $5468eea7b07c745b$export$d9328cbeeb64e882["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== $5468eea7b07c745b$var$globalState.UNCHANGED) {
            var notifySpy = $5468eea7b07c745b$var$isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        $5468eea7b07c745b$var$checkIfStateModificationsAreAllowed(this);
        if ($5468eea7b07c745b$var$hasInterceptors(this)) {
            var change = $5468eea7b07c745b$var$interceptChange(this, {
                object: this,
                type: $5468eea7b07c745b$var$UPDATE,
                newValue: newValue
            });
            if (!change) return $5468eea7b07c745b$var$globalState.UNCHANGED;
            newValue = change.newValue;
        } // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? $5468eea7b07c745b$var$globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if ($5468eea7b07c745b$var$hasListeners(this)) $5468eea7b07c745b$var$notifyListeners(this, {
            type: $5468eea7b07c745b$var$UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return $5468eea7b07c745b$var$registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: $5468eea7b07c745b$var$UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return $5468eea7b07c745b$var$registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return $5468eea7b07c745b$var$toPrimitive(this.get());
    };
    _proto[$5468eea7b07c745b$var$_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}($5468eea7b07c745b$var$Atom);
var $5468eea7b07c745b$export$fafbc00dbefd1aef = /*#__PURE__*/ $5468eea7b07c745b$var$createInstanceofPredicate("ObservableValue", $5468eea7b07c745b$var$ObservableValue);
var $5468eea7b07c745b$var$_Symbol$toPrimitive$1;
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ $5468eea7b07c745b$var$_Symbol$toPrimitive$1 = Symbol.toPrimitive;
var $5468eea7b07c745b$var$ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // to check for cycles
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = $5468eea7b07c745b$var$IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.isBeingObserved_ = false;
        this.isPendingUnobservation_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new $5468eea7b07c745b$var$CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.isComputing_ = false;
        this.isRunningSetter_ = false;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = $5468eea7b07c745b$var$TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) $5468eea7b07c745b$var$die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = $5468eea7b07c745b$var$createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? $5468eea7b07c745b$export$d9328cbeeb64e882.structural : $5468eea7b07c745b$export$d9328cbeeb64e882["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = !!options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        $5468eea7b07c745b$var$propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ ;
    _proto.get = function get() {
        if (this.isComputing_) $5468eea7b07c745b$var$die(32, this.name_, this.derivation);
        if ($5468eea7b07c745b$var$globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if ($5468eea7b07c745b$var$shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                $5468eea7b07c745b$var$startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                $5468eea7b07c745b$var$endBatch();
            }
        } else {
            $5468eea7b07c745b$var$reportObserved(this);
            if ($5468eea7b07c745b$var$shouldCompute(this)) {
                var prevTrackingContext = $5468eea7b07c745b$var$globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) $5468eea7b07c745b$var$globalState.trackingContext = this;
                if (this.trackAndCompute()) $5468eea7b07c745b$var$propagateChangeConfirmed(this);
                $5468eea7b07c745b$var$globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if ($5468eea7b07c745b$var$isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter_) $5468eea7b07c745b$var$die(33, this.name_);
            this.isRunningSetter_ = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter_ = false;
            }
        } else $5468eea7b07c745b$var$die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === $5468eea7b07c745b$var$IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || $5468eea7b07c745b$var$isCaughtException(oldValue) || $5468eea7b07c745b$var$isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing_ = true; // don't allow state changes during computation
        var prev = $5468eea7b07c745b$var$allowStateChangesStart(false);
        var res;
        if (track) res = $5468eea7b07c745b$var$trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if ($5468eea7b07c745b$var$globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new $5468eea7b07c745b$var$CaughtException(e);
            }
        }
        $5468eea7b07c745b$var$allowStateChangesEnd(prev);
        this.isComputing_ = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            $5468eea7b07c745b$var$clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return $5468eea7b07c745b$export$4abd31caebb0bb24(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = $5468eea7b07c745b$var$untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: $5468eea7b07c745b$var$UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                $5468eea7b07c745b$var$untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return $5468eea7b07c745b$var$toPrimitive(this.get());
    };
    _proto[$5468eea7b07c745b$var$_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    return ComputedValue;
}();
var $5468eea7b07c745b$var$isComputedValue = /*#__PURE__*/ $5468eea7b07c745b$var$createInstanceofPredicate("ComputedValue", $5468eea7b07c745b$var$ComputedValue);
var $5468eea7b07c745b$var$IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_"; // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_"; // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_"; // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})($5468eea7b07c745b$var$IDerivationState_ || ($5468eea7b07c745b$var$IDerivationState_ = {}));
var $5468eea7b07c745b$var$TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})($5468eea7b07c745b$var$TraceMode || ($5468eea7b07c745b$var$TraceMode = {}));
var $5468eea7b07c745b$var$CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause; // Empty
};
function $5468eea7b07c745b$var$isCaughtException(e) {
    return e instanceof $5468eea7b07c745b$var$CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function $5468eea7b07c745b$var$shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_:
            return false;
        case $5468eea7b07c745b$var$IDerivationState_.NOT_TRACKING_:
        case $5468eea7b07c745b$var$IDerivationState_.STALE_:
            return true;
        case $5468eea7b07c745b$var$IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = $5468eea7b07c745b$export$84c93b6404d77e6f(true);
            var prevUntracked = $5468eea7b07c745b$var$untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if ($5468eea7b07c745b$var$isComputedValue(obj)) {
                    if ($5468eea7b07c745b$var$globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        $5468eea7b07c745b$var$untrackedEnd(prevUntracked);
                        $5468eea7b07c745b$export$c7b7fb1b2b410642(prevAllowStateReads);
                        return true;
                    }
                     // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === $5468eea7b07c745b$var$IDerivationState_.STALE_) {
                        $5468eea7b07c745b$var$untrackedEnd(prevUntracked);
                        $5468eea7b07c745b$export$c7b7fb1b2b410642(prevAllowStateReads);
                        return true;
                    }
                }
            }
            $5468eea7b07c745b$var$changeDependenciesStateTo0(derivation);
            $5468eea7b07c745b$var$untrackedEnd(prevUntracked);
            $5468eea7b07c745b$export$c7b7fb1b2b410642(prevAllowStateReads);
            return false;
    }
}
function $5468eea7b07c745b$export$34c53f8cb85e26c1() {
    return $5468eea7b07c745b$var$globalState.trackingDerivation !== null; // filter out actions inside computations
}
function $5468eea7b07c745b$var$checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function $5468eea7b07c745b$var$checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function $5468eea7b07c745b$var$trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = $5468eea7b07c745b$export$84c93b6404d77e6f(true); // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    $5468eea7b07c745b$var$changeDependenciesStateTo0(derivation);
    derivation.newObserving_ = new Array(derivation.observing_.length + 100);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++$5468eea7b07c745b$var$globalState.runId;
    var prevTracking = $5468eea7b07c745b$var$globalState.trackingDerivation;
    $5468eea7b07c745b$var$globalState.trackingDerivation = derivation;
    $5468eea7b07c745b$var$globalState.inBatch++;
    var result;
    if ($5468eea7b07c745b$var$globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new $5468eea7b07c745b$var$CaughtException(e);
    }
    $5468eea7b07c745b$var$globalState.inBatch--;
    $5468eea7b07c745b$var$globalState.trackingDerivation = prevTracking;
    $5468eea7b07c745b$var$bindDependencies(derivation);
    $5468eea7b07c745b$var$warnAboutDerivationWithoutDependencies(derivation);
    $5468eea7b07c745b$export$c7b7fb1b2b410642(prevAllowStateReads);
    return result;
}
function $5468eea7b07c745b$var$warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function $5468eea7b07c745b$var$bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_; // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        } // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) $5468eea7b07c745b$var$removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    } // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            $5468eea7b07c745b$var$addObserver(_dep2, derivation);
        }
    } // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function $5468eea7b07c745b$var$clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)$5468eea7b07c745b$var$removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = $5468eea7b07c745b$var$IDerivationState_.NOT_TRACKING_;
}
function $5468eea7b07c745b$export$8c437e4d572e2f99(action) {
    var prev = $5468eea7b07c745b$var$untrackedStart();
    try {
        return action();
    } finally{
        $5468eea7b07c745b$var$untrackedEnd(prev);
    }
}
function $5468eea7b07c745b$var$untrackedStart() {
    var prev = $5468eea7b07c745b$var$globalState.trackingDerivation;
    $5468eea7b07c745b$var$globalState.trackingDerivation = null;
    return prev;
}
function $5468eea7b07c745b$var$untrackedEnd(prev) {
    $5468eea7b07c745b$var$globalState.trackingDerivation = prev;
}
function $5468eea7b07c745b$export$84c93b6404d77e6f(allowStateReads) {
    var prev = $5468eea7b07c745b$var$globalState.allowStateReads;
    $5468eea7b07c745b$var$globalState.allowStateReads = allowStateReads;
    return prev;
}
function $5468eea7b07c745b$export$c7b7fb1b2b410642(prev) {
    $5468eea7b07c745b$var$globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function $5468eea7b07c745b$var$changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var $5468eea7b07c745b$var$persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var $5468eea7b07c745b$var$MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var $5468eea7b07c745b$var$canMergeGlobalState = true;
var $5468eea7b07c745b$var$isolateCalled = false;
var $5468eea7b07c745b$var$globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ $5468eea7b07c745b$var$getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) $5468eea7b07c745b$var$canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new $5468eea7b07c745b$var$MobXGlobals().version) $5468eea7b07c745b$var$canMergeGlobalState = false;
    if (!$5468eea7b07c745b$var$canMergeGlobalState) {
        setTimeout(function() {
            if (!$5468eea7b07c745b$var$isolateCalled) $5468eea7b07c745b$var$die(35);
        }, 1);
        return new $5468eea7b07c745b$var$MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new $5468eea7b07c745b$var$MobXGlobals();
    }
}();
function $5468eea7b07c745b$var$isolateGlobalState() {
    if ($5468eea7b07c745b$var$globalState.pendingReactions.length || $5468eea7b07c745b$var$globalState.inBatch || $5468eea7b07c745b$var$globalState.isRunningReactions) $5468eea7b07c745b$var$die(36);
    $5468eea7b07c745b$var$isolateCalled = true;
    if ($5468eea7b07c745b$var$canMergeGlobalState) {
        var global1 = $5468eea7b07c745b$var$getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        $5468eea7b07c745b$var$globalState = new $5468eea7b07c745b$var$MobXGlobals();
    }
}
function $5468eea7b07c745b$export$c78907783e606401() {
    return $5468eea7b07c745b$var$globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function $5468eea7b07c745b$export$5c18e491c80b9ab4() {
    var defaultGlobals = new $5468eea7b07c745b$var$MobXGlobals();
    for(var key in defaultGlobals)if ($5468eea7b07c745b$var$persistentKeys.indexOf(key) === -1) $5468eea7b07c745b$var$globalState[key] = defaultGlobals[key];
    $5468eea7b07c745b$var$globalState.allowStateChanges = !$5468eea7b07c745b$var$globalState.enforceActions;
}
function $5468eea7b07c745b$var$hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function $5468eea7b07c745b$var$getObservers(observable) {
    return observable.observers_;
} // function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function $5468eea7b07c745b$var$addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_; // invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function $5468eea7b07c745b$var$removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    $5468eea7b07c745b$var$queueForUnobservation(observable);
     // invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function $5468eea7b07c745b$var$queueForUnobservation(observable) {
    if (observable.isPendingUnobservation_ === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation_ = true;
        $5468eea7b07c745b$var$globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function $5468eea7b07c745b$var$startBatch() {
    $5468eea7b07c745b$var$globalState.inBatch++;
}
function $5468eea7b07c745b$var$endBatch() {
    if (--$5468eea7b07c745b$var$globalState.inBatch === 0) {
        $5468eea7b07c745b$var$runReactions(); // the batch is actually about to finish, all unobserving should happen here.
        var list = $5468eea7b07c745b$var$globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation_ = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved_) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved_ = false;
                    observable.onBUO();
                }
                if (observable instanceof $5468eea7b07c745b$var$ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        $5468eea7b07c745b$var$globalState.pendingUnobservations = [];
    }
}
function $5468eea7b07c745b$var$reportObserved(observable) {
    $5468eea7b07c745b$var$checkIfStateReadsAreAllowed(observable);
    var derivation = $5468eea7b07c745b$var$globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_; // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved_ && $5468eea7b07c745b$var$globalState.trackingContext) {
                observable.isBeingObserved_ = true;
                observable.onBO();
            }
        }
        return true;
    } else if (observable.observers_.size === 0 && $5468eea7b07c745b$var$globalState.inBatch > 0) $5468eea7b07c745b$var$queueForUnobservation(observable);
    return false;
} // function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function $5468eea7b07c745b$var$propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === $5468eea7b07c745b$var$IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = $5468eea7b07c745b$var$IDerivationState_.STALE_; // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = $5468eea7b07c745b$var$IDerivationState_.STALE_;
    }); // invariantLOS(observable, "changed end");
} // Called by ComputedValue when it recalculate and its value changed
function $5468eea7b07c745b$var$propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === $5468eea7b07c745b$var$IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = $5468eea7b07c745b$var$IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === $5468eea7b07c745b$var$IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = $5468eea7b07c745b$var$IDerivationState_.STALE_;
        else if (d.dependenciesState_ === $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_;
    }); // invariantLOS(observable, "confirmed end");
} // Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function $5468eea7b07c745b$var$propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = $5468eea7b07c745b$var$IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === $5468eea7b07c745b$var$IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = $5468eea7b07c745b$var$IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    }); // invariantLOS(observable, "maybe end");
}
function $5468eea7b07c745b$var$logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === $5468eea7b07c745b$var$TraceMode.BREAK) {
        var lines = [];
        $5468eea7b07c745b$var$printDepTree($5468eea7b07c745b$export$23fbf90e5d80a5ee(derivation), lines, 1); // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof $5468eea7b07c745b$var$ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function $5468eea7b07c745b$var$printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("	") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return $5468eea7b07c745b$var$printDepTree(child, lines, depth + 1);
    });
}
var $5468eea7b07c745b$export$d2ae4167a30cf6bb = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        if (requiresObservable_ === void 0) requiresObservable_ = false;
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = $5468eea7b07c745b$var$IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = $5468eea7b07c745b$var$TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            $5468eea7b07c745b$var$globalState.pendingReactions.push(this);
            $5468eea7b07c745b$var$runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            $5468eea7b07c745b$var$startBatch();
            this.isScheduled_ = false;
            var prev = $5468eea7b07c745b$var$globalState.trackingContext;
            $5468eea7b07c745b$var$globalState.trackingContext = this;
            if ($5468eea7b07c745b$var$shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            $5468eea7b07c745b$var$globalState.trackingContext = prev;
            $5468eea7b07c745b$var$endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return; // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
        $5468eea7b07c745b$var$startBatch();
        var notify = $5468eea7b07c745b$var$isSpyEnabled();
        var startTime;
        this.isRunning_ = true;
        var prevReaction = $5468eea7b07c745b$var$globalState.trackingContext; // reactions could create reactions...
        $5468eea7b07c745b$var$globalState.trackingContext = this;
        var result = $5468eea7b07c745b$var$trackDerivedFunction(this, fn, undefined);
        $5468eea7b07c745b$var$globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        $5468eea7b07c745b$var$clearObserving(this);
        if ($5468eea7b07c745b$var$isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        $5468eea7b07c745b$var$endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if ($5468eea7b07c745b$var$globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!$5468eea7b07c745b$var$globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        $5468eea7b07c745b$var$globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                $5468eea7b07c745b$var$startBatch();
                $5468eea7b07c745b$var$clearObserving(this);
                $5468eea7b07c745b$var$endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_() {
        var r = this.dispose.bind(this);
        r[$5468eea7b07c745b$export$f246528900dd4467] = this;
        return r;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        $5468eea7b07c745b$export$357889f174732d38(this, enterBreakPoint);
    };
    return Reaction;
}();
function $5468eea7b07c745b$export$d7203a53b5e117e4(handler) {
    $5468eea7b07c745b$var$globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = $5468eea7b07c745b$var$globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) $5468eea7b07c745b$var$globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var $5468eea7b07c745b$var$MAX_REACTION_ITERATIONS = 100;
var $5468eea7b07c745b$var$reactionScheduler = function reactionScheduler(f) {
    return f();
};
function $5468eea7b07c745b$var$runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if ($5468eea7b07c745b$var$globalState.inBatch > 0 || $5468eea7b07c745b$var$globalState.isRunningReactions) return;
    $5468eea7b07c745b$var$reactionScheduler($5468eea7b07c745b$var$runReactionsHelper);
}
function $5468eea7b07c745b$var$runReactionsHelper() {
    $5468eea7b07c745b$var$globalState.isRunningReactions = true;
    var allReactions = $5468eea7b07c745b$var$globalState.pendingReactions;
    var iterations = 0; // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === $5468eea7b07c745b$var$MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    $5468eea7b07c745b$var$globalState.isRunningReactions = false;
}
var $5468eea7b07c745b$var$isReaction = /*#__PURE__*/ $5468eea7b07c745b$var$createInstanceofPredicate("Reaction", $5468eea7b07c745b$export$d2ae4167a30cf6bb);
function $5468eea7b07c745b$var$setReactionScheduler(fn) {
    var baseScheduler = $5468eea7b07c745b$var$reactionScheduler;
    $5468eea7b07c745b$var$reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function $5468eea7b07c745b$var$isSpyEnabled() {
    return false;
}
function $5468eea7b07c745b$var$spyReport(event) {
    var listeners, i, l;
    return; // dead code elimination can do the rest
}
function $5468eea7b07c745b$var$spyReportStart(event) {
    var change;
    return;
}
var $5468eea7b07c745b$var$END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function $5468eea7b07c745b$var$spyReportEnd(change) {
    return;
}
function $5468eea7b07c745b$export$fcc0cd19e9fb2b4c(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var $5468eea7b07c745b$var$ACTION = "action";
var $5468eea7b07c745b$var$ACTION_BOUND = "action.bound";
var $5468eea7b07c745b$var$AUTOACTION = "autoAction";
var $5468eea7b07c745b$var$AUTOACTION_BOUND = "autoAction.bound";
var $5468eea7b07c745b$var$DEFAULT_ACTION_NAME = "<unnamed action>";
var $5468eea7b07c745b$var$actionAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createActionAnnotation($5468eea7b07c745b$var$ACTION);
var $5468eea7b07c745b$var$actionBoundAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createActionAnnotation($5468eea7b07c745b$var$ACTION_BOUND, {
    bound: true
});
var $5468eea7b07c745b$var$autoActionAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createActionAnnotation($5468eea7b07c745b$var$AUTOACTION, {
    autoAction: true
});
var $5468eea7b07c745b$var$autoActionBoundAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createActionAnnotation($5468eea7b07c745b$var$AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function $5468eea7b07c745b$var$createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if ($5468eea7b07c745b$var$isFunction(arg1)) return $5468eea7b07c745b$var$createAction(arg1.name || $5468eea7b07c745b$var$DEFAULT_ACTION_NAME, arg1, autoAction); // action("name", fn() {})
        if ($5468eea7b07c745b$var$isFunction(arg2)) return $5468eea7b07c745b$var$createAction(arg1, arg2, autoAction); // @action
        if ($5468eea7b07c745b$var$isStringish(arg2)) return $5468eea7b07c745b$var$storeAnnotation(arg1, arg2, autoAction ? $5468eea7b07c745b$var$autoActionAnnotation : $5468eea7b07c745b$var$actionAnnotation);
         // action("name") & @action("name")
        if ($5468eea7b07c745b$var$isStringish(arg1)) return $5468eea7b07c745b$var$createDecoratorAnnotation($5468eea7b07c745b$var$createActionAnnotation(autoAction ? $5468eea7b07c745b$var$AUTOACTION : $5468eea7b07c745b$var$ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var $5468eea7b07c745b$export$31eb53bd5b582a97 = /*#__PURE__*/ $5468eea7b07c745b$var$createActionFactory(false);
Object.assign($5468eea7b07c745b$export$31eb53bd5b582a97, $5468eea7b07c745b$var$actionAnnotation);
var $5468eea7b07c745b$export$b8aa795084cbf86b = /*#__PURE__*/ $5468eea7b07c745b$var$createActionFactory(true);
Object.assign($5468eea7b07c745b$export$b8aa795084cbf86b, $5468eea7b07c745b$var$autoActionAnnotation);
$5468eea7b07c745b$export$31eb53bd5b582a97.bound = /*#__PURE__*/ $5468eea7b07c745b$var$createDecoratorAnnotation($5468eea7b07c745b$var$actionBoundAnnotation);
$5468eea7b07c745b$export$b8aa795084cbf86b.bound = /*#__PURE__*/ $5468eea7b07c745b$var$createDecoratorAnnotation($5468eea7b07c745b$var$autoActionBoundAnnotation);
function $5468eea7b07c745b$export$832370e58be26204(fn) {
    return $5468eea7b07c745b$var$executeAction(fn.name || $5468eea7b07c745b$var$DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function $5468eea7b07c745b$export$b956e38827fca970(thing) {
    return $5468eea7b07c745b$var$isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function $5468eea7b07c745b$export$4abd31caebb0bb24(view, opts) {
    var _opts$name, _opts;
    if (opts === void 0) opts = $5468eea7b07c745b$var$EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new $5468eea7b07c745b$export$d2ae4167a30cf6bb(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = $5468eea7b07c745b$var$createSchedulerFromOptions(opts); // debounced autorun
        var isScheduled = false;
        reaction = new $5468eea7b07c745b$export$d2ae4167a30cf6bb(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule_();
    return reaction.getDisposer_();
}
var $5468eea7b07c745b$var$run = function run(f) {
    return f();
};
function $5468eea7b07c745b$var$createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : $5468eea7b07c745b$var$run;
}
function $5468eea7b07c745b$export$7203b476385689ae(expression, effect, opts) {
    var _opts$name2;
    if (opts === void 0) opts = $5468eea7b07c745b$var$EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = $5468eea7b07c745b$export$31eb53bd5b582a97(name, opts.onError ? $5468eea7b07c745b$var$wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = $5468eea7b07c745b$var$createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var oldValue = undefined; // only an issue with fireImmediately
    var equals = opts.compareStructural ? $5468eea7b07c745b$export$d9328cbeeb64e882.structural : opts.equals || $5468eea7b07c745b$export$d9328cbeeb64e882["default"];
    var r = new $5468eea7b07c745b$export$d2ae4167a30cf6bb(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        r.track(function() {
            var nextValue = $5468eea7b07c745b$export$e510c5d1ea4358b1(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            oldValue = value;
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    r.schedule_();
    return r.getDisposer_();
}
function $5468eea7b07c745b$var$wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var $5468eea7b07c745b$var$ON_BECOME_OBSERVED = "onBO";
var $5468eea7b07c745b$var$ON_BECOME_UNOBSERVED = "onBUO";
function $5468eea7b07c745b$export$24d7f9cdf0de2679(thing, arg2, arg3) {
    return $5468eea7b07c745b$var$interceptHook($5468eea7b07c745b$var$ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function $5468eea7b07c745b$export$f8586f6f22b9cba9(thing, arg2, arg3) {
    return $5468eea7b07c745b$var$interceptHook($5468eea7b07c745b$var$ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function $5468eea7b07c745b$var$interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? $5468eea7b07c745b$export$25fc416d10fa1afa(thing, arg2) : $5468eea7b07c745b$export$25fc416d10fa1afa(thing);
    var cb = $5468eea7b07c745b$var$isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var $5468eea7b07c745b$var$NEVER = "never";
var $5468eea7b07c745b$var$ALWAYS = "always";
var $5468eea7b07c745b$var$OBSERVED = "observed"; // const IF_AVAILABLE = "ifavailable"
function $5468eea7b07c745b$export$8d21e34596265fa2(options) {
    if (options.isolateGlobalState === true) $5468eea7b07c745b$var$isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) $5468eea7b07c745b$var$globalState.useProxies = useProxies === $5468eea7b07c745b$var$ALWAYS ? true : useProxies === $5468eea7b07c745b$var$NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") $5468eea7b07c745b$var$globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === $5468eea7b07c745b$var$ALWAYS ? $5468eea7b07c745b$var$ALWAYS : enforceActions === $5468eea7b07c745b$var$OBSERVED;
        $5468eea7b07c745b$var$globalState.enforceActions = ea;
        $5468eea7b07c745b$var$globalState.allowStateChanges = ea === true || ea === $5468eea7b07c745b$var$ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) $5468eea7b07c745b$var$globalState[key] = !!options[key];
    });
    $5468eea7b07c745b$var$globalState.allowStateReads = !$5468eea7b07c745b$var$globalState.observableRequiresReaction;
    if (options.reactionScheduler) $5468eea7b07c745b$var$setReactionScheduler(options.reactionScheduler);
}
function $5468eea7b07c745b$export$59d8134e963031bd(target, properties, annotations, options) {
    var descriptors = $5468eea7b07c745b$var$getOwnPropertyDescriptors(properties);
    var adm = $5468eea7b07c745b$var$asObservableObject(target, options)[$5468eea7b07c745b$export$f246528900dd4467];
    $5468eea7b07c745b$var$startBatch();
    try {
        $5468eea7b07c745b$var$ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], !annotations ? true : key in annotations ? annotations[key] : true);
        });
    } finally{
        $5468eea7b07c745b$var$endBatch();
    }
    return target;
}
function $5468eea7b07c745b$export$23fbf90e5d80a5ee(thing, property) {
    return $5468eea7b07c745b$var$nodeToDependencyTree($5468eea7b07c745b$export$25fc416d10fa1afa(thing, property));
}
function $5468eea7b07c745b$var$nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = $5468eea7b07c745b$var$unique(node.observing_).map($5468eea7b07c745b$var$nodeToDependencyTree);
    return result;
}
function $5468eea7b07c745b$export$3b1621dddf5aeacd(thing, property) {
    return $5468eea7b07c745b$var$nodeToObserverTree($5468eea7b07c745b$export$25fc416d10fa1afa(thing, property));
}
function $5468eea7b07c745b$var$nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if ($5468eea7b07c745b$var$hasObservers(node)) result.observers = Array.from($5468eea7b07c745b$var$getObservers(node)).map($5468eea7b07c745b$var$nodeToObserverTree);
    return result;
}
function $5468eea7b07c745b$var$unique(list) {
    return Array.from(new Set(list));
}
var $5468eea7b07c745b$var$generatorId = 0;
function $5468eea7b07c745b$export$134218f44485f691() {
    this.message = "FLOW_CANCELLED";
}
$5468eea7b07c745b$export$134218f44485f691.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function $5468eea7b07c745b$export$e01c2a57c655302d(error) {
    return error instanceof $5468eea7b07c745b$export$134218f44485f691;
}
var $5468eea7b07c745b$var$flowAnnotation = /*#__PURE__*/ $5468eea7b07c745b$var$createFlowAnnotation("flow");
var $5468eea7b07c745b$export$ccc7b0636abaffc3 = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow
    if ($5468eea7b07c745b$var$isStringish(arg2)) return $5468eea7b07c745b$var$storeAnnotation(arg1, arg2, $5468eea7b07c745b$var$flowAnnotation);
     // flow(fn)
    var generator = arg1;
    var name = generator.name || "<unnamed flow>"; // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++$5468eea7b07c745b$var$generatorId;
        var gen = $5468eea7b07c745b$export$31eb53bd5b582a97(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = $5468eea7b07c745b$export$31eb53bd5b582a97(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = $5468eea7b07c745b$export$31eb53bd5b582a97(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if ($5468eea7b07c745b$var$isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = $5468eea7b07c745b$export$31eb53bd5b582a97(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) $5468eea7b07c745b$var$cancelPromise(pendingPromise); // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined); // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then($5468eea7b07c745b$var$noop, $5468eea7b07c745b$var$noop);
                $5468eea7b07c745b$var$cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new $5468eea7b07c745b$export$134218f44485f691());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, $5468eea7b07c745b$var$flowAnnotation);
function $5468eea7b07c745b$var$cancelPromise(promise) {
    if ($5468eea7b07c745b$var$isFunction(promise.cancel)) promise.cancel();
}
function $5468eea7b07c745b$export$b1b0dfc8def25964(result) {
    return result; // just tricking TypeScript :)
}
function $5468eea7b07c745b$var$isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function $5468eea7b07c745b$export$bf4da824ef9b40d0(thing, propOrHandler, handler) {
    var target;
    if ($5468eea7b07c745b$export$27a7faddcfd44960(thing) || $5468eea7b07c745b$export$f5afceff386badf9(thing) || $5468eea7b07c745b$export$fafbc00dbefd1aef(thing)) target = $5468eea7b07c745b$export$71ff639cb8b2a36e(thing);
    else if ($5468eea7b07c745b$export$31960fb081a18155(thing)) target = $5468eea7b07c745b$export$71ff639cb8b2a36e(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function $5468eea7b07c745b$export$ab0f802c05dd969b(thing, propOrHandler, handler) {
    if ($5468eea7b07c745b$var$isFunction(handler)) return $5468eea7b07c745b$var$interceptProperty(thing, propOrHandler, handler);
    else return $5468eea7b07c745b$var$interceptInterceptable(thing, propOrHandler);
}
function $5468eea7b07c745b$var$interceptInterceptable(thing, handler) {
    return $5468eea7b07c745b$export$71ff639cb8b2a36e(thing).intercept_(handler);
}
function $5468eea7b07c745b$var$interceptProperty(thing, property, handler) {
    return $5468eea7b07c745b$export$71ff639cb8b2a36e(thing, property).intercept_(handler);
}
function $5468eea7b07c745b$var$_isComputed(value, property) {
    if (property !== undefined) {
        if ($5468eea7b07c745b$export$31960fb081a18155(value) === false) return false;
        if (!value[$5468eea7b07c745b$export$f246528900dd4467].values_.has(property)) return false;
        var atom = $5468eea7b07c745b$export$25fc416d10fa1afa(value, property);
        return $5468eea7b07c745b$var$isComputedValue(atom);
    }
    return $5468eea7b07c745b$var$isComputedValue(value);
}
function $5468eea7b07c745b$export$21bb8b7af2417cc3(value) {
    return $5468eea7b07c745b$var$_isComputed(value);
}
function $5468eea7b07c745b$export$3cf701ab9f66d86a(value, propName) {
    return $5468eea7b07c745b$var$_isComputed(value, propName);
}
function $5468eea7b07c745b$var$_isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if ($5468eea7b07c745b$export$31960fb081a18155(value)) return value[$5468eea7b07c745b$export$f246528900dd4467].values_.has(property);
        return false;
    } // For first check, see #701
    return $5468eea7b07c745b$export$31960fb081a18155(value) || !!value[$5468eea7b07c745b$export$f246528900dd4467] || $5468eea7b07c745b$var$isAtom(value) || $5468eea7b07c745b$var$isReaction(value) || $5468eea7b07c745b$var$isComputedValue(value);
}
function $5468eea7b07c745b$export$5cd057a6046189f9(value) {
    return $5468eea7b07c745b$var$_isObservable(value);
}
function $5468eea7b07c745b$export$7ad7acc949ba3cc7(value, propName) {
    return $5468eea7b07c745b$var$_isObservable(value, propName);
}
function $5468eea7b07c745b$export$ed97f33186d4b816(obj) {
    if ($5468eea7b07c745b$export$31960fb081a18155(obj)) return obj[$5468eea7b07c745b$export$f246528900dd4467].keys_();
    if ($5468eea7b07c745b$export$27a7faddcfd44960(obj) || $5468eea7b07c745b$export$da6b063694cb52c1(obj)) return Array.from(obj.keys());
    if ($5468eea7b07c745b$export$f5afceff386badf9(obj)) return obj.map(function(_, index) {
        return index;
    });
    $5468eea7b07c745b$var$die(5);
}
function $5468eea7b07c745b$export$68c286be0e7e55b7(obj) {
    if ($5468eea7b07c745b$export$31960fb081a18155(obj)) return $5468eea7b07c745b$export$ed97f33186d4b816(obj).map(function(key) {
        return obj[key];
    });
    if ($5468eea7b07c745b$export$27a7faddcfd44960(obj)) return $5468eea7b07c745b$export$ed97f33186d4b816(obj).map(function(key) {
        return obj.get(key);
    });
    if ($5468eea7b07c745b$export$da6b063694cb52c1(obj)) return Array.from(obj.values());
    if ($5468eea7b07c745b$export$f5afceff386badf9(obj)) return obj.slice();
    $5468eea7b07c745b$var$die(6);
}
function $5468eea7b07c745b$export$3e9f948b41964866(obj) {
    if ($5468eea7b07c745b$export$31960fb081a18155(obj)) return $5468eea7b07c745b$export$ed97f33186d4b816(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if ($5468eea7b07c745b$export$27a7faddcfd44960(obj)) return $5468eea7b07c745b$export$ed97f33186d4b816(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if ($5468eea7b07c745b$export$da6b063694cb52c1(obj)) return Array.from(obj.entries());
    if ($5468eea7b07c745b$export$f5afceff386badf9(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    $5468eea7b07c745b$var$die(7);
}
function $5468eea7b07c745b$export$adaa4cf7ef1b65be(obj, key, value) {
    if (arguments.length === 2 && !$5468eea7b07c745b$export$da6b063694cb52c1(obj)) {
        $5468eea7b07c745b$var$startBatch();
        var _values = key;
        try {
            for(var _key in _values)$5468eea7b07c745b$export$adaa4cf7ef1b65be(obj, _key, _values[_key]);
        } finally{
            $5468eea7b07c745b$var$endBatch();
        }
        return;
    }
    if ($5468eea7b07c745b$export$31960fb081a18155(obj)) obj[$5468eea7b07c745b$export$f246528900dd4467].set_(key, value);
    else if ($5468eea7b07c745b$export$27a7faddcfd44960(obj)) obj.set(key, value);
    else if ($5468eea7b07c745b$export$da6b063694cb52c1(obj)) obj.add(key);
    else if ($5468eea7b07c745b$export$f5afceff386badf9(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) $5468eea7b07c745b$var$die("Invalid index: '" + key + "'");
        $5468eea7b07c745b$var$startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        $5468eea7b07c745b$var$endBatch();
    } else $5468eea7b07c745b$var$die(8);
}
function $5468eea7b07c745b$export$cd7f480d6b8286c3(obj, key) {
    if ($5468eea7b07c745b$export$31960fb081a18155(obj)) obj[$5468eea7b07c745b$export$f246528900dd4467].delete_(key);
    else if ($5468eea7b07c745b$export$27a7faddcfd44960(obj)) obj["delete"](key);
    else if ($5468eea7b07c745b$export$da6b063694cb52c1(obj)) obj["delete"](key);
    else if ($5468eea7b07c745b$export$f5afceff386badf9(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else $5468eea7b07c745b$var$die(9);
}
function $5468eea7b07c745b$export$a4f4bb6b1453fff5(obj, key) {
    if ($5468eea7b07c745b$export$31960fb081a18155(obj)) return obj[$5468eea7b07c745b$export$f246528900dd4467].has_(key);
    else if ($5468eea7b07c745b$export$27a7faddcfd44960(obj)) return obj.has(key);
    else if ($5468eea7b07c745b$export$da6b063694cb52c1(obj)) return obj.has(key);
    else if ($5468eea7b07c745b$export$f5afceff386badf9(obj)) return key >= 0 && key < obj.length;
    $5468eea7b07c745b$var$die(10);
}
function $5468eea7b07c745b$export$3988ae62b71be9a3(obj, key) {
    if (!$5468eea7b07c745b$export$a4f4bb6b1453fff5(obj, key)) return undefined;
    if ($5468eea7b07c745b$export$31960fb081a18155(obj)) return obj[$5468eea7b07c745b$export$f246528900dd4467].get_(key);
    else if ($5468eea7b07c745b$export$27a7faddcfd44960(obj)) return obj.get(key);
    else if ($5468eea7b07c745b$export$f5afceff386badf9(obj)) return obj[key];
    $5468eea7b07c745b$var$die(11);
}
function $5468eea7b07c745b$export$d1203567a167490e(thing, propOrCb, cbOrFire, fireImmediately) {
    if ($5468eea7b07c745b$var$isFunction(cbOrFire)) return $5468eea7b07c745b$var$observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return $5468eea7b07c745b$var$observeObservable(thing, propOrCb, cbOrFire);
}
function $5468eea7b07c745b$var$observeObservable(thing, listener, fireImmediately) {
    return $5468eea7b07c745b$export$71ff639cb8b2a36e(thing).observe_(listener, fireImmediately);
}
function $5468eea7b07c745b$var$observeObservableProperty(thing, property, listener, fireImmediately) {
    return $5468eea7b07c745b$export$71ff639cb8b2a36e(thing, property).observe_(listener, fireImmediately);
}
function $5468eea7b07c745b$var$cache(map, key, value) {
    map.set(key, value);
    return value;
}
function $5468eea7b07c745b$var$toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !$5468eea7b07c745b$export$5cd057a6046189f9(source)) return source;
    if ($5468eea7b07c745b$export$fafbc00dbefd1aef(source)) return $5468eea7b07c745b$var$toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if ($5468eea7b07c745b$export$f5afceff386badf9(source)) {
        var res = $5468eea7b07c745b$var$cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = $5468eea7b07c745b$var$toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if ($5468eea7b07c745b$export$da6b063694cb52c1(source)) {
        var _res = $5468eea7b07c745b$var$cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add($5468eea7b07c745b$var$toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if ($5468eea7b07c745b$export$27a7faddcfd44960(source)) {
        var _res2 = $5468eea7b07c745b$var$cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, $5468eea7b07c745b$var$toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        $5468eea7b07c745b$export$ed97f33186d4b816(source); // make sure keys are observed
        var _res3 = $5468eea7b07c745b$var$cache(__alreadySeen, source, {});
        $5468eea7b07c745b$var$getPlainObjectKeys(source).forEach(function(key) {
            _res3[key] = $5468eea7b07c745b$var$toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Basically, a deep clone, so that no reactive property will exist anymore.
 */ function $5468eea7b07c745b$export$f08965dd1304d490(source, options) {
    return $5468eea7b07c745b$var$toJSHelper(source, new Map());
}
function $5468eea7b07c745b$export$357889f174732d38() {
    $5468eea7b07c745b$var$die("trace() is not available in production builds");
    var enterBreakPoint = false;
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
    var derivation = $5468eea7b07c745b$var$getAtomFromArgs(args);
    if (!derivation) return $5468eea7b07c745b$var$die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    if (derivation.isTracing_ === $5468eea7b07c745b$var$TraceMode.NONE) console.log("[mobx.trace] '" + derivation.name_ + "' tracing enabled");
    derivation.isTracing_ = enterBreakPoint ? $5468eea7b07c745b$var$TraceMode.BREAK : $5468eea7b07c745b$var$TraceMode.LOG;
}
function $5468eea7b07c745b$var$getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return $5468eea7b07c745b$var$globalState.trackingDerivation;
        case 1:
            return $5468eea7b07c745b$export$25fc416d10fa1afa(args[0]);
        case 2:
            return $5468eea7b07c745b$export$25fc416d10fa1afa(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function $5468eea7b07c745b$export$2d62d2646dd2fb3c(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    $5468eea7b07c745b$var$startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        $5468eea7b07c745b$var$endBatch();
    }
}
function $5468eea7b07c745b$export$a55877ca9db47377(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return $5468eea7b07c745b$var$whenPromise(predicate, arg1);
    return $5468eea7b07c745b$var$_when(predicate, arg1, arg2 || {});
}
function $5468eea7b07c745b$var$_when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") timeoutHandle = setTimeout(function() {
        if (!disposer[$5468eea7b07c745b$export$f246528900dd4467].isDisposed_) {
            disposer();
            var error = new Error("WHEN_TIMEOUT");
            if (opts.onError) opts.onError(error);
            else throw error;
        }
    }, opts.timeout);
    opts.name = "When";
    var effectAction = $5468eea7b07c745b$var$createAction("When-effect", effect); // eslint-disable-next-line
    var disposer = $5468eea7b07c745b$export$4abd31caebb0bb24(function(r) {
        // predicate should not change state
        var cond = $5468eea7b07c745b$export$e510c5d1ea4358b1(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function $5468eea7b07c745b$var$whenPromise(predicate, opts) {
    var cancel;
    var res = new Promise(function(resolve, reject) {
        var disposer = $5468eea7b07c745b$var$_when(predicate, resolve, $5468eea7b07c745b$var$_extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}
function $5468eea7b07c745b$var$getAdm(target) {
    return target[$5468eea7b07c745b$export$f246528900dd4467];
} // Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var $5468eea7b07c745b$var$objectProxyTraps = {
    has: function has(target, name) {
        return $5468eea7b07c745b$var$getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return $5468eea7b07c745b$var$getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!$5468eea7b07c745b$var$isStringish(name)) return false;
        return (_getAdm$set_ = $5468eea7b07c745b$var$getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!$5468eea7b07c745b$var$isStringish(name)) return false; // null (intercepted) -> true (success)
        return (_getAdm$delete_ = $5468eea7b07c745b$var$getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        return (_getAdm$definePropert = $5468eea7b07c745b$var$getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return $5468eea7b07c745b$var$getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        $5468eea7b07c745b$var$die(13);
    }
};
function $5468eea7b07c745b$var$asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    $5468eea7b07c745b$var$assertProxies();
    target = $5468eea7b07c745b$var$asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$5468eea7b07c745b$export$f246528900dd4467]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, $5468eea7b07c745b$var$objectProxyTraps);
}
function $5468eea7b07c745b$var$hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function $5468eea7b07c745b$var$registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return $5468eea7b07c745b$var$once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function $5468eea7b07c745b$var$interceptChange(interceptable, change) {
    var prevU = $5468eea7b07c745b$var$untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) $5468eea7b07c745b$var$die(14);
            if (!change) break;
        }
        return change;
    } finally{
        $5468eea7b07c745b$var$untrackedEnd(prevU);
    }
}
function $5468eea7b07c745b$var$hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function $5468eea7b07c745b$var$registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return $5468eea7b07c745b$var$once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function $5468eea7b07c745b$var$notifyListeners(listenable, change) {
    var prevU = $5468eea7b07c745b$var$untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    $5468eea7b07c745b$var$untrackedEnd(prevU);
}
function $5468eea7b07c745b$export$885e6ca7a4dc4b3e(target, annotations, options) {
    var adm = $5468eea7b07c745b$var$asObservableObject(target, options)[$5468eea7b07c745b$export$f246528900dd4467];
    $5468eea7b07c745b$var$startBatch();
    try {
        var _annotations;
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = $5468eea7b07c745b$var$collectStoredAnnotations(target); // Annotate
        $5468eea7b07c745b$var$ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    } finally{
        $5468eea7b07c745b$var$endBatch();
    }
    return target;
}
function $5468eea7b07c745b$export$1cfaca5abb185fe7(target, overrides, options) {
    // assumes that annotation.make_/.extend_ works the same for plain objects
    if ($5468eea7b07c745b$var$isPlainObject(target)) return $5468eea7b07c745b$export$59d8134e963031bd(target, target, overrides, options);
    var adm = $5468eea7b07c745b$var$asObservableObject(target, options)[$5468eea7b07c745b$export$f246528900dd4467];
    $5468eea7b07c745b$var$startBatch();
    try {
        // Use cached inferred annotations if available (only in classes)
        if (target[$5468eea7b07c745b$var$inferredAnnotationsSymbol]) target[$5468eea7b07c745b$var$inferredAnnotationsSymbol].forEach(function(value, key) {
            return adm.make_(key, value);
        });
        else {
            var _ignoreKeys;
            var ignoreKeys = (_ignoreKeys = {}, _ignoreKeys[$5468eea7b07c745b$export$f246528900dd4467] = 1, _ignoreKeys[$5468eea7b07c745b$var$inferredAnnotationsSymbol] = 1, _ignoreKeys.constructor = 1, _ignoreKeys);
            var make = function make(key) {
                if (ignoreKeys[key]) return;
                ignoreKeys[key] = 1;
                adm.make_(key, !overrides ? true : key in overrides ? overrides[key] : true);
            };
            var current = target;
            while(current && current !== $5468eea7b07c745b$var$objectPrototype){
                $5468eea7b07c745b$var$ownKeys(current).forEach(make);
                current = Object.getPrototypeOf(current);
            }
        }
    } finally{
        $5468eea7b07c745b$var$endBatch();
    }
    return target;
}
var $5468eea7b07c745b$var$SPLICE = "splice";
var $5468eea7b07c745b$var$UPDATE = "update";
var $5468eea7b07c745b$var$MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var $5468eea7b07c745b$var$arrayTraps = {
    get: function get(target, name) {
        var adm = target[$5468eea7b07c745b$export$f246528900dd4467];
        if (name === $5468eea7b07c745b$export$f246528900dd4467) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if ($5468eea7b07c745b$var$hasProp($5468eea7b07c745b$var$arrayExtensions, name)) return $5468eea7b07c745b$var$arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$5468eea7b07c745b$export$f246528900dd4467];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        $5468eea7b07c745b$var$die(15);
    }
};
var $5468eea7b07c745b$var$ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new $5468eea7b07c745b$var$Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return $5468eea7b07c745b$var$registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return $5468eea7b07c745b$var$registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || newLength < 0) $5468eea7b07c745b$var$die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) $5468eea7b07c745b$var$die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) $5468eea7b07c745b$var$reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        $5468eea7b07c745b$var$checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = $5468eea7b07c745b$var$EMPTY_ARRAY;
        if ($5468eea7b07c745b$var$hasInterceptors(this)) {
            var change = $5468eea7b07c745b$var$interceptChange(this, {
                object: this.proxy_,
                type: $5468eea7b07c745b$var$SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return $5468eea7b07c745b$var$EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < $5468eea7b07c745b$var$MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            var res = this.values_.slice(index, index + deleteCount);
            var oldItems = this.values_.slice(index + deleteCount);
            this.values_.length = index + newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && $5468eea7b07c745b$var$isSpyEnabled();
        var notify = $5468eea7b07c745b$var$hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: $5468eea7b07c745b$var$UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null; // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        this.atom_.reportChanged();
        if (notify) $5468eea7b07c745b$var$notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && $5468eea7b07c745b$var$isSpyEnabled();
        var notify = $5468eea7b07c745b$var$hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: $5468eea7b07c745b$var$SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged(); // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) $5468eea7b07c745b$var$notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (index < this.values_.length) {
            this.atom_.reportObserved();
            return this.dehanceValue_(this.values_[index]);
        }
        console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (index < values.length) {
            // update at index in range
            $5468eea7b07c745b$var$checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if ($5468eea7b07c745b$var$hasInterceptors(this)) {
                var change = $5468eea7b07c745b$var$interceptChange(this, {
                    type: $5468eea7b07c745b$var$UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else if (index === values.length) // add a new item
        this.spliceWithArray_(index, 0, [
            newValue
        ]);
        else // out of bounds
        $5468eea7b07c745b$var$die(17, index, values.length);
    };
    return ObservableArrayAdministration;
}();
function $5468eea7b07c745b$var$createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    $5468eea7b07c745b$var$assertProxies();
    var adm = new $5468eea7b07c745b$var$ObservableArrayAdministration(name, enhancer, owned, false);
    $5468eea7b07c745b$var$addHiddenFinalProp(adm.values_, $5468eea7b07c745b$export$f246528900dd4467, adm);
    var proxy = new Proxy(adm.values_, $5468eea7b07c745b$var$arrayTraps);
    adm.proxy_ = proxy;
    if (initialValues && initialValues.length) {
        var prev = $5468eea7b07c745b$var$allowStateChangesStart(true);
        adm.spliceWithArray_(0, 0, initialValues);
        $5468eea7b07c745b$var$allowStateChangesEnd(prev);
    }
    return proxy;
} // eslint-disable-next-line
var $5468eea7b07c745b$var$arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$5468eea7b07c745b$export$f246528900dd4467];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$5468eea7b07c745b$export$f246528900dd4467];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$5468eea7b07c745b$export$f246528900dd4467].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$5468eea7b07c745b$export$f246528900dd4467];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$5468eea7b07c745b$export$f246528900dd4467].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$5468eea7b07c745b$export$f246528900dd4467];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if ($5468eea7b07c745b$var$globalState.trackingDerivation) $5468eea7b07c745b$var$die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if ($5468eea7b07c745b$var$globalState.trackingDerivation) $5468eea7b07c745b$var$die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$5468eea7b07c745b$export$f246528900dd4467];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ $5468eea7b07c745b$var$addArrayExtension("concat", $5468eea7b07c745b$var$simpleFunc);
$5468eea7b07c745b$var$addArrayExtension("flat", $5468eea7b07c745b$var$simpleFunc);
$5468eea7b07c745b$var$addArrayExtension("includes", $5468eea7b07c745b$var$simpleFunc);
$5468eea7b07c745b$var$addArrayExtension("indexOf", $5468eea7b07c745b$var$simpleFunc);
$5468eea7b07c745b$var$addArrayExtension("join", $5468eea7b07c745b$var$simpleFunc);
$5468eea7b07c745b$var$addArrayExtension("lastIndexOf", $5468eea7b07c745b$var$simpleFunc);
$5468eea7b07c745b$var$addArrayExtension("slice", $5468eea7b07c745b$var$simpleFunc);
$5468eea7b07c745b$var$addArrayExtension("toString", $5468eea7b07c745b$var$simpleFunc);
$5468eea7b07c745b$var$addArrayExtension("toLocaleString", $5468eea7b07c745b$var$simpleFunc); // map
$5468eea7b07c745b$var$addArrayExtension("every", $5468eea7b07c745b$var$mapLikeFunc);
$5468eea7b07c745b$var$addArrayExtension("filter", $5468eea7b07c745b$var$mapLikeFunc);
$5468eea7b07c745b$var$addArrayExtension("find", $5468eea7b07c745b$var$mapLikeFunc);
$5468eea7b07c745b$var$addArrayExtension("findIndex", $5468eea7b07c745b$var$mapLikeFunc);
$5468eea7b07c745b$var$addArrayExtension("flatMap", $5468eea7b07c745b$var$mapLikeFunc);
$5468eea7b07c745b$var$addArrayExtension("forEach", $5468eea7b07c745b$var$mapLikeFunc);
$5468eea7b07c745b$var$addArrayExtension("map", $5468eea7b07c745b$var$mapLikeFunc);
$5468eea7b07c745b$var$addArrayExtension("some", $5468eea7b07c745b$var$mapLikeFunc); // reduce
$5468eea7b07c745b$var$addArrayExtension("reduce", $5468eea7b07c745b$var$reduceLikeFunc);
$5468eea7b07c745b$var$addArrayExtension("reduceRight", $5468eea7b07c745b$var$reduceLikeFunc);
function $5468eea7b07c745b$var$addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") $5468eea7b07c745b$var$arrayExtensions[funcName] = funcFactory(funcName);
} // Report and delegate to dehanced array
function $5468eea7b07c745b$var$simpleFunc(funcName) {
    return function() {
        var adm = this[$5468eea7b07c745b$export$f246528900dd4467];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
} // Make sure callbacks recieve correct array arg #2326
function $5468eea7b07c745b$var$mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$5468eea7b07c745b$export$f246528900dd4467];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
} // Make sure callbacks recieve correct array arg #2326
function $5468eea7b07c745b$var$reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$5468eea7b07c745b$export$f246528900dd4467];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_); // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var $5468eea7b07c745b$var$isObservableArrayAdministration = /*#__PURE__*/ $5468eea7b07c745b$var$createInstanceofPredicate("ObservableArrayAdministration", $5468eea7b07c745b$var$ObservableArrayAdministration);
function $5468eea7b07c745b$export$f5afceff386badf9(thing) {
    return $5468eea7b07c745b$var$isObject(thing) && $5468eea7b07c745b$var$isObservableArrayAdministration(thing[$5468eea7b07c745b$export$f246528900dd4467]);
}
var $5468eea7b07c745b$var$_Symbol$iterator, $5468eea7b07c745b$var$_Symbol$toStringTag;
var $5468eea7b07c745b$var$ObservableMapMarker = {};
var $5468eea7b07c745b$var$ADD = "add";
var $5468eea7b07c745b$var$DELETE = "delete"; // just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
$5468eea7b07c745b$var$_Symbol$iterator = Symbol.iterator;
$5468eea7b07c745b$var$_Symbol$toStringTag = Symbol.toStringTag;
var $5468eea7b07c745b$export$db1c0901f08fc6fd = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        if (enhancer_ === void 0) enhancer_ = $5468eea7b07c745b$var$deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$5468eea7b07c745b$export$f246528900dd4467] = $5468eea7b07c745b$var$ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!$5468eea7b07c745b$var$isFunction(Map)) $5468eea7b07c745b$var$die(18);
        this.keysAtom_ = $5468eea7b07c745b$export$2e17fe64ec9a826e("ObservableMap.keys()");
        this.data_ = new Map();
        this.hasMap_ = new Map();
        this.merge(initialData);
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this = this;
        if (!$5468eea7b07c745b$var$globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new $5468eea7b07c745b$var$ObservableValue(this.has_(key), $5468eea7b07c745b$var$referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            $5468eea7b07c745b$export$f8586f6f22b9cba9(newEntry, function() {
                return _this.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if ($5468eea7b07c745b$var$hasInterceptors(this)) {
            var change = $5468eea7b07c745b$var$interceptChange(this, {
                type: hasKey ? $5468eea7b07c745b$var$UPDATE : $5468eea7b07c745b$var$ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this2 = this;
        $5468eea7b07c745b$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        if ($5468eea7b07c745b$var$hasInterceptors(this)) {
            var change = $5468eea7b07c745b$var$interceptChange(this, {
                type: $5468eea7b07c745b$var$DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = $5468eea7b07c745b$var$isSpyEnabled();
            var notify = $5468eea7b07c745b$var$hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: $5468eea7b07c745b$var$DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            $5468eea7b07c745b$export$2d62d2646dd2fb3c(function() {
                _this2.keysAtom_.reportChanged();
                _this2.updateHasMapEntry_(key, false);
                var observable = _this2.data_.get(key);
                observable.setNewValue_(undefined);
                _this2.data_["delete"](key);
            });
            if (notify) $5468eea7b07c745b$var$notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateHasMapEntry_ = function updateHasMapEntry_(key, value) {
        var entry = this.hasMap_.get(key);
        if (entry) entry.setNewValue_(value);
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== $5468eea7b07c745b$var$globalState.UNCHANGED) {
            var notifySpy = $5468eea7b07c745b$var$isSpyEnabled();
            var notify = $5468eea7b07c745b$var$hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: $5468eea7b07c745b$var$UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) $5468eea7b07c745b$var$notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this3 = this;
        $5468eea7b07c745b$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        $5468eea7b07c745b$export$2d62d2646dd2fb3c(function() {
            var observable = new $5468eea7b07c745b$var$ObservableValue(newValue, _this3.enhancer_, "ObservableMap.key", false);
            _this3.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            _this3.updateHasMapEntry_(key, true);
            _this3.keysAtom_.reportChanged();
        });
        var notifySpy = $5468eea7b07c745b$var$isSpyEnabled();
        var notify = $5468eea7b07c745b$var$hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: $5468eea7b07c745b$var$ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) $5468eea7b07c745b$var$notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return $5468eea7b07c745b$var$makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return $5468eea7b07c745b$var$makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[$5468eea7b07c745b$var$_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = $5468eea7b07c745b$var$_createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this4 = this;
        if ($5468eea7b07c745b$export$27a7faddcfd44960(other)) other = new Map(other);
        $5468eea7b07c745b$export$2d62d2646dd2fb3c(function() {
            if ($5468eea7b07c745b$var$isPlainObject(other)) $5468eea7b07c745b$var$getPlainObjectKeys(other).forEach(function(key) {
                return _this4.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this4.set(key, value);
            });
            else if ($5468eea7b07c745b$var$isES6Map(other)) {
                if (other.constructor !== Map) $5468eea7b07c745b$var$die(19, other);
                other.forEach(function(value, key) {
                    return _this4.set(key, value);
                });
            } else if (other !== null && other !== undefined) $5468eea7b07c745b$var$die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this5 = this;
        $5468eea7b07c745b$export$2d62d2646dd2fb3c(function() {
            $5468eea7b07c745b$export$8c437e4d572e2f99(function() {
                for(var _iterator2 = $5468eea7b07c745b$var$_createForOfIteratorHelperLoose(_this5.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this5["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this6 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        $5468eea7b07c745b$export$2d62d2646dd2fb3c(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = $5468eea7b07c745b$var$convertToMap(values);
            var orderedData = new Map(); // Used for optimization
            var keysReportChangedCalled = false; // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = $5468eea7b07c745b$var$_createForOfIteratorHelperLoose(_this6.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this6["delete"](key); // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this6.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            } // Merge entries
            for(var _iterator4 = $5468eea7b07c745b$var$_createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this6.data_.has(_key); // Add or update value
                _this6.set(_key, _value); // The addition could have been prevent by interceptor
                if (_this6.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this6.data_.get(_key);
                    orderedData.set(_key, _value2); // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            } // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this6.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this6.keysAtom_.reportChanged();
                else {
                    var iter1 = _this6.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this6.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            } // Use correctly ordered map
            _this6.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return $5468eea7b07c745b$var$registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return $5468eea7b07c745b$var$registerInterceptor(this, handler);
    };
    $5468eea7b07c745b$var$_createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: $5468eea7b07c745b$var$_Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}(); // eslint-disable-next-line
var $5468eea7b07c745b$export$27a7faddcfd44960 = /*#__PURE__*/ $5468eea7b07c745b$var$createInstanceofPredicate("ObservableMap", $5468eea7b07c745b$export$db1c0901f08fc6fd);
function $5468eea7b07c745b$var$convertToMap(dataStructure) {
    if ($5468eea7b07c745b$var$isES6Map(dataStructure) || $5468eea7b07c745b$export$27a7faddcfd44960(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if ($5468eea7b07c745b$var$isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return $5468eea7b07c745b$var$die(21, dataStructure);
}
var $5468eea7b07c745b$var$_Symbol$iterator$1, $5468eea7b07c745b$var$_Symbol$toStringTag$1;
var $5468eea7b07c745b$var$ObservableSetMarker = {};
$5468eea7b07c745b$var$_Symbol$iterator$1 = Symbol.iterator;
$5468eea7b07c745b$var$_Symbol$toStringTag$1 = Symbol.toStringTag;
var $5468eea7b07c745b$export$2235f602a7a77c81 = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        if (enhancer === void 0) enhancer = $5468eea7b07c745b$var$deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$5468eea7b07c745b$export$f246528900dd4467] = $5468eea7b07c745b$var$ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!$5468eea7b07c745b$var$isFunction(Set)) $5468eea7b07c745b$var$die(22);
        this.atom_ = $5468eea7b07c745b$export$2e17fe64ec9a826e(this.name_);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        if (initialData) this.replace(initialData);
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this = this;
        $5468eea7b07c745b$export$2d62d2646dd2fb3c(function() {
            $5468eea7b07c745b$export$8c437e4d572e2f99(function() {
                for(var _iterator = $5468eea7b07c745b$var$_createForOfIteratorHelperLoose(_this.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = $5468eea7b07c745b$var$_createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this2 = this;
        $5468eea7b07c745b$var$checkIfStateModificationsAreAllowed(this.atom_);
        if ($5468eea7b07c745b$var$hasInterceptors(this)) {
            var change = $5468eea7b07c745b$var$interceptChange(this, {
                type: $5468eea7b07c745b$var$ADD,
                object: this,
                newValue: value
            });
            if (!change) return this; // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            $5468eea7b07c745b$export$2d62d2646dd2fb3c(function() {
                _this2.data_.add(_this2.enhancer_(value, undefined));
                _this2.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = $5468eea7b07c745b$var$hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: $5468eea7b07c745b$var$ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) $5468eea7b07c745b$var$notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this3 = this;
        if ($5468eea7b07c745b$var$hasInterceptors(this)) {
            var change = $5468eea7b07c745b$var$interceptChange(this, {
                type: $5468eea7b07c745b$var$DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = $5468eea7b07c745b$var$hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: $5468eea7b07c745b$var$DELETE,
                object: this,
                oldValue: value
            } : null;
            $5468eea7b07c745b$export$2d62d2646dd2fb3c(function() {
                _this3.atom_.reportChanged();
                _this3.data_["delete"](value);
            });
            if (notify) $5468eea7b07c745b$var$notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return $5468eea7b07c745b$var$makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return $5468eea7b07c745b$var$makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this4 = this;
        if ($5468eea7b07c745b$export$da6b063694cb52c1(other)) other = new Set(other);
        $5468eea7b07c745b$export$2d62d2646dd2fb3c(function() {
            if (Array.isArray(other)) {
                _this4.clear();
                other.forEach(function(value) {
                    return _this4.add(value);
                });
            } else if ($5468eea7b07c745b$var$isES6Set(other)) {
                _this4.clear();
                other.forEach(function(value) {
                    return _this4.add(value);
                });
            } else if (other !== null && other !== undefined) $5468eea7b07c745b$var$die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return $5468eea7b07c745b$var$registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return $5468eea7b07c745b$var$registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[$5468eea7b07c745b$var$_Symbol$iterator$1] = function() {
        return this.values();
    };
    $5468eea7b07c745b$var$_createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: $5468eea7b07c745b$var$_Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}(); // eslint-disable-next-line
var $5468eea7b07c745b$export$da6b063694cb52c1 = /*#__PURE__*/ $5468eea7b07c745b$var$createInstanceofPredicate("ObservableSet", $5468eea7b07c745b$export$2235f602a7a77c81);
var $5468eea7b07c745b$var$inferredAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-inferred-annotations");
var $5468eea7b07c745b$var$descriptorCache = /*#__PURE__*/ Object.create(null);
var $5468eea7b07c745b$var$REMOVE = "remove";
var $5468eea7b07c745b$var$ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, defaultAnnotation_, autoBind_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = $5468eea7b07c745b$export$5ab46cbf6120b33a;
        if (autoBind_ === void 0) autoBind_ = false;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.autoBind_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.autoBind_ = autoBind_;
        this.keysAtom_ = new $5468eea7b07c745b$var$Atom("ObservableObject.keys"); // Optimization: we use this frequently
        this.isPlainObject_ = $5468eea7b07c745b$var$isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof $5468eea7b07c745b$var$ComputedValue) {
            observable.set(newValue);
            return true;
        } // intercept
        if ($5468eea7b07c745b$var$hasInterceptors(this)) {
            var change = $5468eea7b07c745b$var$interceptChange(this, {
                type: $5468eea7b07c745b$var$UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue); // notify spy & observers
        if (newValue !== $5468eea7b07c745b$var$globalState.UNCHANGED) {
            var notify = $5468eea7b07c745b$var$hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: $5468eea7b07c745b$var$UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) $5468eea7b07c745b$var$notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if ($5468eea7b07c745b$var$globalState.trackingDerivation && !$5468eea7b07c745b$var$hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - infer from descriptor, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if ($5468eea7b07c745b$var$hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    } // Trap for "in"
    ;
    _proto.has_ = function has_(key) {
        if (!$5468eea7b07c745b$var$globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new $5468eea7b07c745b$var$ObservableValue(key in this.target_, $5468eea7b07c745b$var$referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - infer from object or it's prototype, false - ignore
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.inferAnnotation_(key);
        if (annotation === false) return;
        $5468eea7b07c745b$var$assertAnnotable(this, annotation, key);
        annotation.make_(this, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - infer from descriptor, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = $5468eea7b07c745b$var$inferAnnotationFromDescriptor(descriptor, this.defaultAnnotation_, this.autoBind_);
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        $5468eea7b07c745b$var$assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) $5468eea7b07c745b$var$recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.inferAnnotation_ = function inferAnnotation_(key) {
        var _this$target_$inferre;
        // Inherited is fine - annotation cannot differ in subclass
        var annotation = (_this$target_$inferre = this.target_[$5468eea7b07c745b$var$inferredAnnotationsSymbol]) == null ? void 0 : _this$target_$inferre.get(key);
        if (annotation) return annotation;
        var current = this.target_;
        while(current && current !== $5468eea7b07c745b$var$objectPrototype){
            var descriptor = $5468eea7b07c745b$var$getDescriptor(current, key);
            if (descriptor) {
                annotation = $5468eea7b07c745b$var$inferAnnotationFromDescriptor(descriptor, this.defaultAnnotation_, this.autoBind_);
                break;
            }
            current = Object.getPrototypeOf(current);
        } // Not found (false means ignore)
        if (annotation === undefined) $5468eea7b07c745b$var$die(1, "true", key);
         // Cache the annotation.
        // Note we can do this only because annotation and field can't change.
        if (!this.isPlainObject_) {
            // We could also place it on furthest proto, shoudn't matter
            var closestProto = Object.getPrototypeOf(this.target_);
            if (!$5468eea7b07c745b$var$hasProp(closestProto, $5468eea7b07c745b$var$inferredAnnotationsSymbol)) $5468eea7b07c745b$var$addHiddenProp(closestProto, $5468eea7b07c745b$var$inferredAnnotationsSymbol, new Map());
            closestProto[$5468eea7b07c745b$var$inferredAnnotationsSymbol].set(key, annotation);
        }
        return annotation;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        try {
            $5468eea7b07c745b$var$startBatch(); // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
             // ADD interceptor
            if ($5468eea7b07c745b$var$hasInterceptors(this)) {
                var change = $5468eea7b07c745b$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $5468eea7b07c745b$var$ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = $5468eea7b07c745b$var$_extends({}, descriptor, {
                    value: newValue
                });
            } // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $5468eea7b07c745b$var$defineProperty(this.target_, key, descriptor);
             // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            $5468eea7b07c745b$var$endBatch();
        }
        return true;
    } // If original descriptor becomes relevant, move this to annotation directly
    ;
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        try {
            $5468eea7b07c745b$var$startBatch(); // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
             // ADD interceptor
            if ($5468eea7b07c745b$var$hasInterceptors(this)) {
                var change = $5468eea7b07c745b$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $5468eea7b07c745b$var$ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = $5468eea7b07c745b$var$getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: $5468eea7b07c745b$var$globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            }; // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $5468eea7b07c745b$var$defineProperty(this.target_, key, descriptor);
            var _observable = new $5468eea7b07c745b$var$ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, _observable); // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, _observable.value_);
        } finally{
            $5468eea7b07c745b$var$endBatch();
        }
        return true;
    } // If original descriptor becomes relevant, move this to annotation directly
    ;
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        try {
            $5468eea7b07c745b$var$startBatch(); // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
             // ADD interceptor
            if ($5468eea7b07c745b$var$hasInterceptors(this)) {
                var change = $5468eea7b07c745b$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $5468eea7b07c745b$var$ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = $5468eea7b07c745b$var$getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: $5468eea7b07c745b$var$globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            }; // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $5468eea7b07c745b$var$defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new $5468eea7b07c745b$var$ComputedValue(options)); // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            $5468eea7b07c745b$var$endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // No such prop
        if (!$5468eea7b07c745b$var$hasProp(this.target_, key)) return true;
         // Intercept
        if ($5468eea7b07c745b$var$hasInterceptors(this)) {
            var change = $5468eea7b07c745b$var$interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: $5468eea7b07c745b$var$REMOVE
            }); // Cancelled
            if (!change) return null;
        } // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            $5468eea7b07c745b$var$startBatch();
            var notify = $5468eea7b07c745b$var$hasListeners(this);
            var notifySpy = false;
            var _observable2 = this.values_.get(key); // Value needed for spies/listeners
            var value = undefined; // Optimization: don't pull the value unless we will need it
            if (!_observable2 && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = $5468eea7b07c745b$var$getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            } // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
             // Allow re-annotating this field
            if (_observable2) {
                this.values_["delete"](key); // for computed, value is undefined
                if (_observable2 instanceof $5468eea7b07c745b$var$ObservableValue) value = _observable2.value_;
                 // Notify: autorun(() => obj[key]), see #1796
                $5468eea7b07c745b$var$propagateChanged(_observable2);
            } // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged(); // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_); // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: $5468eea7b07c745b$var$REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) $5468eea7b07c745b$var$notifyListeners(this, _change2);
            }
        } finally{
            $5468eea7b07c745b$var$endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return $5468eea7b07c745b$var$registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return $5468eea7b07c745b$var$registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = $5468eea7b07c745b$var$hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: $5468eea7b07c745b$var$ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) $5468eea7b07c745b$var$notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true); // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return $5468eea7b07c745b$var$ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function $5468eea7b07c745b$var$asObservableObject(target, options) {
    var _options$name;
    if ($5468eea7b07c745b$var$hasProp(target, $5468eea7b07c745b$export$f246528900dd4467)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new $5468eea7b07c745b$var$ObservableObjectAdministration(target, new Map(), String(name), $5468eea7b07c745b$var$getAnnotationFromOptions(options), options == null ? void 0 : options.autoBind);
    $5468eea7b07c745b$var$addHiddenProp(target, $5468eea7b07c745b$export$f246528900dd4467, adm);
    return target;
}
var $5468eea7b07c745b$var$isObservableObjectAdministration = /*#__PURE__*/ $5468eea7b07c745b$var$createInstanceofPredicate("ObservableObjectAdministration", $5468eea7b07c745b$var$ObservableObjectAdministration);
function $5468eea7b07c745b$var$getCachedObservablePropDescriptor(key) {
    return $5468eea7b07c745b$var$descriptorCache[key] || ($5468eea7b07c745b$var$descriptorCache[key] = {
        get: function get() {
            return this[$5468eea7b07c745b$export$f246528900dd4467].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$5468eea7b07c745b$export$f246528900dd4467].setObservablePropValue_(key, value);
        }
    });
}
function $5468eea7b07c745b$export$31960fb081a18155(thing) {
    if ($5468eea7b07c745b$var$isObject(thing)) return $5468eea7b07c745b$var$isObservableObjectAdministration(thing[$5468eea7b07c745b$export$f246528900dd4467]);
    return false;
}
function $5468eea7b07c745b$var$recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    (_adm$target_$storedAn = adm.target_[$5468eea7b07c745b$var$storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function $5468eea7b07c745b$var$assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var $5468eea7b07c745b$var$OBSERVABLE_ARRAY_BUFFER_SIZE = 0; // Typescript workaround to make sure ObservableArray extends Array
var $5468eea7b07c745b$var$StubArray = function StubArray() {};
function $5468eea7b07c745b$var$inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
$5468eea7b07c745b$var$inherit($5468eea7b07c745b$var$StubArray, Array.prototype); // Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var $5468eea7b07c745b$var$LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    $5468eea7b07c745b$var$_inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        var adm = new $5468eea7b07c745b$var$ObservableArrayAdministration(name, enhancer, owned, true);
        adm.proxy_ = $5468eea7b07c745b$var$_assertThisInitialized(_this);
        $5468eea7b07c745b$var$addHiddenFinalProp($5468eea7b07c745b$var$_assertThisInitialized(_this), $5468eea7b07c745b$export$f246528900dd4467, adm);
        if (initialValues && initialValues.length) {
            var prev = $5468eea7b07c745b$var$allowStateChangesStart(true); // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            $5468eea7b07c745b$var$allowStateChangesEnd(prev);
        }
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$5468eea7b07c745b$export$f246528900dd4467].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), arrays.map(function(a) {
            return $5468eea7b07c745b$export$f5afceff386badf9(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return $5468eea7b07c745b$var$makeIterable({
            next: function next() {
                // @ts-ignore
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    $5468eea7b07c745b$var$_createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$5468eea7b07c745b$export$f246528900dd4467].getArrayLength_();
            },
            set: function set(newLength) {
                this[$5468eea7b07c745b$export$f246528900dd4467].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}($5468eea7b07c745b$var$StubArray);
Object.entries($5468eea7b07c745b$var$arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") $5468eea7b07c745b$var$addHiddenProp($5468eea7b07c745b$var$LegacyObservableArray.prototype, prop, fn);
});
function $5468eea7b07c745b$var$createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$5468eea7b07c745b$export$f246528900dd4467].get_(index);
        },
        set: function set(value) {
            this[$5468eea7b07c745b$export$f246528900dd4467].set_(index, value);
        }
    };
}
function $5468eea7b07c745b$var$createArrayBufferItem(index) {
    $5468eea7b07c745b$var$defineProperty($5468eea7b07c745b$var$LegacyObservableArray.prototype, "" + index, $5468eea7b07c745b$var$createArrayEntryDescriptor(index));
}
function $5468eea7b07c745b$var$reserveArrayBuffer(max) {
    if (max > $5468eea7b07c745b$var$OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = $5468eea7b07c745b$var$OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)$5468eea7b07c745b$var$createArrayBufferItem(index);
        $5468eea7b07c745b$var$OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
$5468eea7b07c745b$var$reserveArrayBuffer(1000);
function $5468eea7b07c745b$var$createLegacyArray(initialValues, enhancer, name) {
    return new $5468eea7b07c745b$var$LegacyObservableArray(initialValues, enhancer, name);
}
function $5468eea7b07c745b$export$25fc416d10fa1afa(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if ($5468eea7b07c745b$export$f5afceff386badf9(thing)) {
            if (property !== undefined) $5468eea7b07c745b$var$die(23);
            return thing[$5468eea7b07c745b$export$f246528900dd4467].atom_;
        }
        if ($5468eea7b07c745b$export$da6b063694cb52c1(thing)) return thing[$5468eea7b07c745b$export$f246528900dd4467];
        if ($5468eea7b07c745b$export$27a7faddcfd44960(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) $5468eea7b07c745b$var$die(25, property, $5468eea7b07c745b$export$c48237bbccf30144(thing));
            return observable;
        }
        if ($5468eea7b07c745b$export$31960fb081a18155(thing)) {
            if (!property) return $5468eea7b07c745b$var$die(26);
            var _observable = thing[$5468eea7b07c745b$export$f246528900dd4467].values_.get(property);
            if (!_observable) $5468eea7b07c745b$var$die(27, property, $5468eea7b07c745b$export$c48237bbccf30144(thing));
            return _observable;
        }
        if ($5468eea7b07c745b$var$isAtom(thing) || $5468eea7b07c745b$var$isComputedValue(thing) || $5468eea7b07c745b$var$isReaction(thing)) return thing;
    } else if ($5468eea7b07c745b$var$isFunction(thing)) {
        if ($5468eea7b07c745b$var$isReaction(thing[$5468eea7b07c745b$export$f246528900dd4467])) // disposer function
        return thing[$5468eea7b07c745b$export$f246528900dd4467];
    }
    $5468eea7b07c745b$var$die(28);
}
function $5468eea7b07c745b$export$71ff639cb8b2a36e(thing, property) {
    if (!thing) $5468eea7b07c745b$var$die(29);
    if (property !== undefined) return $5468eea7b07c745b$export$71ff639cb8b2a36e($5468eea7b07c745b$export$25fc416d10fa1afa(thing, property));
    if ($5468eea7b07c745b$var$isAtom(thing) || $5468eea7b07c745b$var$isComputedValue(thing) || $5468eea7b07c745b$var$isReaction(thing)) return thing;
    if ($5468eea7b07c745b$export$27a7faddcfd44960(thing) || $5468eea7b07c745b$export$da6b063694cb52c1(thing)) return thing;
    if (thing[$5468eea7b07c745b$export$f246528900dd4467]) return thing[$5468eea7b07c745b$export$f246528900dd4467];
    $5468eea7b07c745b$var$die(24, thing);
}
function $5468eea7b07c745b$export$c48237bbccf30144(thing, property) {
    var named;
    if (property !== undefined) named = $5468eea7b07c745b$export$25fc416d10fa1afa(thing, property);
    else if ($5468eea7b07c745b$export$b956e38827fca970(thing)) return thing.name;
    else if ($5468eea7b07c745b$export$31960fb081a18155(thing) || $5468eea7b07c745b$export$27a7faddcfd44960(thing) || $5468eea7b07c745b$export$da6b063694cb52c1(thing)) named = $5468eea7b07c745b$export$71ff639cb8b2a36e(thing);
    else // valid for arrays as well
    named = $5468eea7b07c745b$export$25fc416d10fa1afa(thing);
    return named.name_;
}
var $5468eea7b07c745b$var$toString = $5468eea7b07c745b$var$objectPrototype.toString;
function $5468eea7b07c745b$var$deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return $5468eea7b07c745b$var$eq(a, b, depth);
} // Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function $5468eea7b07c745b$var$eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b; // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false; // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b; // Exhaust primitive checks
    var type = typeof a;
    if (!$5468eea7b07c745b$var$isFunction(type) && type !== "object" && typeof b != "object") return false; // Compare `[[Class]]` names.
    var className = $5468eea7b07c745b$var$toString.call(a);
    if (className !== $5468eea7b07c745b$var$toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b; // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    } // Unwrap any wrapped objects.
    a = $5468eea7b07c745b$var$unwrap(a);
    b = $5468eea7b07c745b$var$unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false; // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !($5468eea7b07c745b$var$isFunction(aCtor) && aCtor instanceof aCtor && $5468eea7b07c745b$var$isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
     // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    } // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b); // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false; // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$5468eea7b07c745b$var$eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length; // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!($5468eea7b07c745b$var$hasProp(b, key) && $5468eea7b07c745b$var$eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    } // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $5468eea7b07c745b$var$unwrap(a) {
    if ($5468eea7b07c745b$export$f5afceff386badf9(a)) return a.slice();
    if ($5468eea7b07c745b$var$isES6Map(a) || $5468eea7b07c745b$export$27a7faddcfd44960(a)) return Array.from(a.entries());
    if ($5468eea7b07c745b$var$isES6Set(a) || $5468eea7b07c745b$export$da6b063694cb52c1(a)) return Array.from(a.entries());
    return a;
}
function $5468eea7b07c745b$var$makeIterable(iterator) {
    iterator[Symbol.iterator] = $5468eea7b07c745b$var$getSelf;
    return iterator;
}
function $5468eea7b07c745b$var$getSelf() {
    return this;
}
/**
 * Infers the best fitting annotation from property descriptor or false if the field shoudn't be annotated
 * - getter(+setter) -> computed
 * - setter w/o getter -> false (ignore)
 * - flow -> false (ignore)
 * - generator -> flow
 * - action -> false (ignore)
 * - function -> action (optionally bound)
 * - other -> defaultAnnotation
 */ function $5468eea7b07c745b$var$inferAnnotationFromDescriptor(desc, defaultAnnotation, autoBind) {
    if (desc.get) return $5468eea7b07c745b$export$2983e091f1a1e8e2;
    if (desc.set) return false; // ignore lone setter
    // If already wrapped in action/flow, don't do that another time, but assume it is already set up properly.
    return $5468eea7b07c745b$var$isFunction(desc.value) ? $5468eea7b07c745b$var$isGenerator(desc.value) ? $5468eea7b07c745b$var$isFlow(desc.value) ? false : $5468eea7b07c745b$export$ccc7b0636abaffc3 : $5468eea7b07c745b$export$b956e38827fca970(desc.value) ? false : autoBind ? $5468eea7b07c745b$export$b8aa795084cbf86b.bound : $5468eea7b07c745b$export$b8aa795084cbf86b : defaultAnnotation;
}
function $5468eea7b07c745b$var$isAnnotation(thing) {
    return thing instanceof Object && typeof thing.annotationType_ === "string" && $5468eea7b07c745b$var$isFunction(thing.make_) && $5468eea7b07c745b$var$isFunction(thing.extend_);
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set",
    "Symbol"
].forEach(function(m) {
    var g = $5468eea7b07c745b$var$getGlobal();
    if (typeof g[m] === "undefined") $5468eea7b07c745b$var$die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: $5468eea7b07c745b$export$fcc0cd19e9fb2b4c,
    extras: {
        getDebugName: $5468eea7b07c745b$export$c48237bbccf30144
    },
    $mobx: $5468eea7b07c745b$export$f246528900dd4467
});



var $hJwnw = parcelRequire("hJwnw");
if (!(0, $hJwnw.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $5468eea7b07c745b$export$885e6ca7a4dc4b3e)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");






function $b09c9a6feabd9421$export$fb2daceae6f5097a(callback) {
    callback();
}
function $b09c9a6feabd9421$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $b09c9a6feabd9421$export$fb2daceae6f5097a;
    (0, $5468eea7b07c745b$export$8d21e34596265fa2)({
        reactionScheduler: reactionScheduler
    });
}
var $b09c9a6feabd9421$export$13ce1459b9a04b51 = function() {
    return true;
};


var $589f28171f8ba90c$var$deprecatedMessages = [];
function $589f28171f8ba90c$export$be38475be17599d(msg) {
    if (!$589f28171f8ba90c$var$deprecatedMessages.includes(msg)) {
        $589f28171f8ba90c$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}


var $4d62ffbebb6f386e$exports = {};

$parcel$export($4d62ffbebb6f386e$exports, "useObserver", function () { return $4d62ffbebb6f386e$export$b9c7ecd090a87b14; });


var $hJwnw = parcelRequire("hJwnw");

function $d54431f9be088843$export$ef795f1f307682c7(v) {
    return (0, $5468eea7b07c745b$export$23fbf90e5d80a5ee)(v);
}


var $2210f8342103c155$export$e901ba0ffe10ba41 = 10000;
var $2210f8342103c155$export$1ae22ce5a82f26b6 = 10000;
var $2210f8342103c155$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $2210f8342103c155$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $2210f8342103c155$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $2210f8342103c155$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $2210f8342103c155$export$b7a00d372cedeedd;


var $5ef9048bc741f6c6$export$10e8a12fbfd8583c = new (0, $2210f8342103c155$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $57fce153bb7d82b4$var$globalIsUsingStaticRendering = false;
function $57fce153bb7d82b4$export$5d52eaa7c0f24c9e(enable) {
    $57fce153bb7d82b4$var$globalIsUsingStaticRendering = enable;
}
function $57fce153bb7d82b4$export$55979271896d643e() {
    return $57fce153bb7d82b4$var$globalIsUsingStaticRendering;
}


var $4d62ffbebb6f386e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $4d62ffbebb6f386e$var$observerComponentNameFor(baseComponentName) {
    return "observer".concat(baseComponentName);
}
/**
 * We use class to make it easier to detect in heap snapshots by name
 */ var $4d62ffbebb6f386e$var$ObjectToBeRetainedByReact = /** @class */ function() {
    function ObjectToBeRetainedByReact() {}
    return ObjectToBeRetainedByReact;
}();
function $4d62ffbebb6f386e$var$objectToBeRetainedByReactFactory() {
    return new $4d62ffbebb6f386e$var$ObjectToBeRetainedByReact();
}
function $4d62ffbebb6f386e$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $57fce153bb7d82b4$export$55979271896d643e)()) return fn();
    var _a = $4d62ffbebb6f386e$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useState($4d62ffbebb6f386e$var$objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
    // Force update, see #2982
    var _b = $4d62ffbebb6f386e$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useState(), 2), setState = _b[1];
    var forceUpdate = function() {
        return setState([]);
    };
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useRef(null);
    if (!admRef.current) // First render
    admRef.current = {
        reaction: null,
        mounted: false,
        changedBeforeMount: false
    };
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or component was not committed and reaction was disposed by registry
        adm.reaction = new (0, $5468eea7b07c745b$export$d2ae4167a30cf6bb)($4d62ffbebb6f386e$var$observerComponentNameFor(baseComponentName), function() {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (adm.mounted) // We have reached useEffect(), so we're mounted, and can trigger an update
            forceUpdate();
            else // We haven't yet reached useEffect(), so we'll need to trigger a re-render
            // when (and if) useEffect() arrives.
            adm.changedBeforeMount = true;
        });
        (0, $5ef9048bc741f6c6$export$10e8a12fbfd8583c).register(objectRetainedByReact, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useDebugValue(adm.reaction, (0, $d54431f9be088843$export$ef795f1f307682c7));
    (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useEffect(function() {
        (0, $5ef9048bc741f6c6$export$10e8a12fbfd8583c).unregister(adm);
        adm.mounted = true;
        if (adm.reaction) {
            if (adm.changedBeforeMount) {
                // Got a change before mount, force an update
                adm.changedBeforeMount = false;
                forceUpdate();
            }
        } else {
            // The reaction we set up in our render has been disposed.
            // This can be due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up
            // Re-create the reaction
            adm.reaction = new (0, $5468eea7b07c745b$export$d2ae4167a30cf6bb)($4d62ffbebb6f386e$var$observerComponentNameFor(baseComponentName), function() {
                // We've definitely already been mounted at this point
                forceUpdate();
            });
            forceUpdate();
        }
        return function() {
            adm.reaction.dispose();
            adm.reaction = null;
            adm.mounted = false;
            adm.changedBeforeMount = false;
        };
    }, []);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var rendering;
    var exception;
    adm.reaction.track(function() {
        try {
            rendering = fn();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return rendering;
}





var $hJwnw = parcelRequire("hJwnw");


var $7eec34e2bbf7c2a1$var$warnObserverOptionsDeprecated = true;
var $7eec34e2bbf7c2a1$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $7eec34e2bbf7c2a1$var$ReactForwardRefSymbol = $7eec34e2bbf7c2a1$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $hJwnw.forwardRef) === "function" && (0, $hJwnw.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $7eec34e2bbf7c2a1$var$ReactMemoSymbol = $7eec34e2bbf7c2a1$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $hJwnw.memo) === "function" && (0, $hJwnw.memo)(function(props) {
    return null;
})["$$typeof"];
function $7eec34e2bbf7c2a1$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($7eec34e2bbf7c2a1$var$ReactMemoSymbol && baseComponent["$$typeof"] === $7eec34e2bbf7c2a1$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $57fce153bb7d82b4$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($7eec34e2bbf7c2a1$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $7eec34e2bbf7c2a1$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $4d62ffbebb6f386e$exports.useObserver)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    // Don't set `displayName` for anonymous components,
    // so the `displayName` can be customized by user, see #3192.
    if (baseComponentName !== "") observerComponent.displayName = baseComponentName;
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $hJwnw.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $hJwnw.memo)(observerComponent);
    $7eec34e2bbf7c2a1$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $7eec34e2bbf7c2a1$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $7eec34e2bbf7c2a1$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$7eec34e2bbf7c2a1$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $ff3e86dda4e11099$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $4d62ffbebb6f386e$exports.useObserver)(component);
}
$ff3e86dda4e11099$export$c1cbdee04e18ea8b.displayName = "Observer";
function $ff3e86dda4e11099$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}




var $hJwnw = parcelRequire("hJwnw");
function $2d0f9c1cac2091c2$export$aa207039f277c5f(initializer, annotations) {
    return (0, $hJwnw.useState)(function() {
        return (0, $5468eea7b07c745b$export$5ab46cbf6120b33a)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}




var $hJwnw = parcelRequire("hJwnw");

var $18b98c593583ac55$exports = {};

$parcel$export($18b98c593583ac55$exports, "useAsObservableSource", function () { return $18b98c593583ac55$export$e0ded3646391939c; });



var $hJwnw = parcelRequire("hJwnw");
var $18b98c593583ac55$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $18b98c593583ac55$export$e0ded3646391939c(current) {
    var _a = $18b98c593583ac55$var$__read((0, $hJwnw.useState)(function() {
        return (0, $5468eea7b07c745b$export$5ab46cbf6120b33a)(current, {}, {
            deep: false
        });
    }), 1), res = _a[0];
    (0, $5468eea7b07c745b$export$832370e58be26204)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $aa6264bbbfc077aa$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $18b98c593583ac55$exports.useAsObservableSource)(current);
    return (0, $hJwnw.useState)(function() {
        return (0, $5468eea7b07c745b$export$5ab46cbf6120b33a)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $7b9abd83d0e7c592$var$_a;
(0, $b09c9a6feabd9421$export$294943bbc3c74f4f)((0, $a7721eb599d74a7a$exports.unstable_batchedUpdates));
var $7b9abd83d0e7c592$export$469d51fb8d268227 = ($7b9abd83d0e7c592$var$_a = (0, $5ef9048bc741f6c6$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $7b9abd83d0e7c592$var$_a !== void 0 ? $7b9abd83d0e7c592$var$_a : function() {};
function $7b9abd83d0e7c592$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $4d62ffbebb6f386e$exports.useObserver)(fn, baseComponentName);
}
function $7b9abd83d0e7c592$export$7613124ee4202834(enable) {
    (0, $57fce153bb7d82b4$export$5d52eaa7c0f24c9e)(enable);
}


var $b7e9ce5848acd9e0$exports = {};
$b7e9ce5848acd9e0$exports = function(e) {
    var t = {};
    function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function(e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
        });
    }, n.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, n.t = function(e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var o in e)n.d(r, o, (function(t) {
            return e[t];
        }).bind(null, o));
        return r;
    }, n.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return n.d(t, "a", t), t;
    }, n.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 0);
}([
    function(e, t, n) {
        "use strict";
        function r(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        n.r(t), n.d(t, "Cookie", function() {
            return u;
        }), n.d(t, "LocalStorage", function() {
            return c;
        }), n.d(t, "SessionStorage", function() {
            return f;
        });
        var o = function() {
            function e(t) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.cookie = t;
            }
            var t, n, o;
            return t = e, n = [
                {
                    key: "get",
                    value: function(e) {
                        var t = this.cookie.match(new RegExp("(?:^|; )".concat(e.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1"), "=([^;]*)")));
                        return t ? decodeURIComponent(t[1]) : void 0;
                    }
                },
                {
                    key: "set",
                    value: function(e, t, n) {
                        var r = new Date;
                        r.setTime(r.getTime() + 24 * n * 3600000);
                        var o = "expires=".concat(r.toUTCString());
                        this.cookie = "".concat(e, "=").concat(t, ";").concat(o, ";path=/");
                    }
                },
                {
                    key: "remove",
                    value: function(e) {
                        this.set(e, "", -1);
                    }
                }
            ], r(t.prototype, n), o && r(t, o), e;
        }();
        function i(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        var a = function() {
            function e(t) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.storage = t;
            }
            var t, n, r;
            return t = e, n = [
                {
                    key: "set",
                    value: function(e, t) {
                        this.storage.setItem(e, "string" == typeof t ? t : JSON.stringify(t));
                    }
                },
                {
                    key: "get",
                    value: function(e) {
                        var t = this.storage.getItem(e), n = t && (t.indexOf("}") > t.indexOf("{") || t.indexOf("]") > t.indexOf("[")) ? JSON.parse(t) : t;
                        return t ? n : null;
                    }
                },
                {
                    key: "remove",
                    value: function(e) {
                        this.storage.removeItem(e);
                    }
                },
                {
                    key: "clear",
                    value: function() {
                        this.storage.clear();
                    }
                },
                {
                    key: "setObject",
                    value: function(e, t) {
                        this.storage.setItem(e, JSON.stringify(t));
                    }
                },
                {
                    key: "getObject",
                    value: function(e) {
                        return this.storage.getItem(e) ? JSON.parse(this.storage.getItem(e)) : {};
                    }
                }
            ], i(t.prototype, n), r && i(t, r), e;
        }(), u = new o(document.cookie), c = "undefined" != typeof localStorage ? new a(localStorage) : null, f = "undefined" != typeof sessionStorage ? new a(sessionStorage) : null;
    }
]);


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $4210dc1af4009341$var$extendStatics = function(d, b) {
    $4210dc1af4009341$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4210dc1af4009341$var$extendStatics(d, b);
};
function $4210dc1af4009341$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4210dc1af4009341$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4210dc1af4009341$export$18ce0697a983be9b = function() {
    $4210dc1af4009341$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4210dc1af4009341$export$18ce0697a983be9b.apply(this, arguments);
};
function $4210dc1af4009341$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4210dc1af4009341$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4210dc1af4009341$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4210dc1af4009341$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4210dc1af4009341$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4210dc1af4009341$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $4210dc1af4009341$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4210dc1af4009341$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4210dc1af4009341$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4210dc1af4009341$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4210dc1af4009341$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4210dc1af4009341$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4210dc1af4009341$export$45d3717a4c69092e(o, m, p);
}
function $4210dc1af4009341$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4210dc1af4009341$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4210dc1af4009341$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4210dc1af4009341$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4210dc1af4009341$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4210dc1af4009341$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4210dc1af4009341$export$10c90e4f7922046c(v) {
    return this instanceof $4210dc1af4009341$export$10c90e4f7922046c ? (this.v = v, this) : new $4210dc1af4009341$export$10c90e4f7922046c(v);
}
function $4210dc1af4009341$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4210dc1af4009341$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4210dc1af4009341$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4210dc1af4009341$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4210dc1af4009341$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4210dc1af4009341$export$19a8beecd37a4c45 === "function" ? $4210dc1af4009341$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4210dc1af4009341$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4210dc1af4009341$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $4210dc1af4009341$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4210dc1af4009341$export$45d3717a4c69092e(result, mod, k);
    }
    $4210dc1af4009341$var$__setModuleDefault(result, mod);
    return result;
}
function $4210dc1af4009341$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4210dc1af4009341$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4210dc1af4009341$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4210dc1af4009341$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4210dc1af4009341$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4210dc1af4009341$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4210dc1af4009341$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4210dc1af4009341$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $4210dc1af4009341$export$2e2bcd8739ae039 = {
    __extends: $4210dc1af4009341$export$a8ba968b8961cb8a,
    __assign: $4210dc1af4009341$export$18ce0697a983be9b,
    __rest: $4210dc1af4009341$export$3c9a16f847548506,
    __decorate: $4210dc1af4009341$export$29e00dfd3077644b,
    __param: $4210dc1af4009341$export$d5ad3fd78186038f,
    __metadata: $4210dc1af4009341$export$f1db080c865becb9,
    __awaiter: $4210dc1af4009341$export$1050f835b63b671e,
    __generator: $4210dc1af4009341$export$67ebef60e6f28a6,
    __createBinding: $4210dc1af4009341$export$45d3717a4c69092e,
    __exportStar: $4210dc1af4009341$export$f33643c0debef087,
    __values: $4210dc1af4009341$export$19a8beecd37a4c45,
    __read: $4210dc1af4009341$export$8d051b38c9118094,
    __spread: $4210dc1af4009341$export$afc72e2116322959,
    __spreadArrays: $4210dc1af4009341$export$6388937ca91ccae8,
    __spreadArray: $4210dc1af4009341$export$1216008129fb82ed,
    __await: $4210dc1af4009341$export$10c90e4f7922046c,
    __asyncGenerator: $4210dc1af4009341$export$e427f37a30a4de9b,
    __asyncDelegator: $4210dc1af4009341$export$bbd80228419bb833,
    __asyncValues: $4210dc1af4009341$export$e3b29a3d6162315f,
    __makeTemplateObject: $4210dc1af4009341$export$4fb47efe1390b86f,
    __importStar: $4210dc1af4009341$export$c21735bcef00d192,
    __importDefault: $4210dc1af4009341$export$da59b14a69baef04,
    __classPrivateFieldGet: $4210dc1af4009341$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4210dc1af4009341$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4210dc1af4009341$export$81fdc39f203e4e04,
    __addDisposableResource: $4210dc1af4009341$export$88ac25d8e944e405,
    __disposeResources: $4210dc1af4009341$export$8f076105dc360e92
};



const $f39ce8075185c88d$export$be3f796aed065412 = [
    {
        step: 1,
        label: "applicationStart",
        status: "done"
    },
    {
        step: 2,
        label: "idin",
        status: "",
        link: "idin"
    },
    {
        step: 3,
        label: "onfido",
        status: "disabled",
        link: "onfido"
    }
];


const $8e272ff57971c6ac$export$da3bc2f57520e3c3 = {
    pageBankSelection: {
        page: "bank",
        subpage: 1,
        isLoaded: true
    },
    pageContinue: {
        page: "continue",
        subpage: 1,
        isLoaded: true
    },
    pageUploadIdStart: {
        page: "uploadid",
        subpage: 1,
        isLoaded: true
    },
    pageCountrySelect: {
        page: "uploadid",
        subpage: 2,
        isLoaded: true
    },
    pageOnfido: {
        page: "uploadid",
        subpage: 3,
        isLoaded: true
    },
    pageFinish: {
        page: "uploadid",
        subpage: 4,
        isLoaded: true
    },
    pageError: {
        page: "error",
        subpage: 1,
        isLoaded: true
    }
};


const $d1720c836d6de09c$export$30f3b02011db23c0 = {
    errorDefault: {
        heading: "Error",
        message: "U ontvangt binnen ongeveer 20 minuten een e-mail met een link zodat u op ieder gewenst moment de identificatie kan afronden. Uit veiligheidsoverwegingen verloopt deze link na 48 uur.",
        type: "default"
    },
    errorExpired: {
        heading: "Deze link is verlopen",
        message: "Indien u de identificatie wilt voltooien, neem dan contact met ons op via 020- 504 8000.\n\nU kunt dit scherm sluiten.",
        type: "error-expired"
    },
    errorExpiredRem: {
        heading: "Deze link is verlopen",
        message: `Wij verzoeken u vriendelijk het opnieuw te proberen door de link opnieuw te openen. Klik <a href="https://www.americanexpress.com/nl-nl/service/identiteit/">hier</a> om het online identificatieproces opnieuw te starten.`,
        type: "error-expired"
    },
    errorMissingCookie: {
        heading: "Heeft u iDIN gestart vanuit een andere browser?",
        message: `We hebben niet terug kunnen vinden dat u iDIN gestart bent in deze browser, daarom kunnen we u niet inloggen. <br/><br/>Wat kunt u proberen?<br/><br/>Binnen 20 minuten ontvangt u van ons een link per email waarmee u het proces opnieuw kunt starten.<ul><li>Klik op de link op een desktopcomputer of;</li><li>Als u het op uw mobiele telefoon opent, zorg er dan voor dat u uw standaardbrowser gebruikt (anders werkt het niet).</li></ul>`,
        type: "error-cookie"
    },
    errorMissingCookieRem: {
        heading: "Heeft u iDIN gestart vanuit een andere browser?",
        message: `We hebben niet terug kunnen vinden dat u iDIN gestart bent in deze browser, daarom kunnen we u niet inloggen. </br></br>Wat kunt u proberen?<ul><li>Probeer de identiteitsverificatie uit te voeren op een desktopcomputer of;</li><li>Als u het op uw mobiele telefoon opent, zorg er dan voor dat u uw standaardbrowser gebruikt (anders werkt het niet).</li></ul>`,
        type: "error-cookie"
    },
    errorOnfidoTokenRem: {
        heading: "Error",
        message: "In verband met een technische storing kunnen wij op dit moment het identificatieproces niet voltooien. Wij vragen u vriendelijk het op een later moment nog eens te proberen.",
        type: "error-token-rem"
    },
    errorOnfidoTokenAcq: {
        heading: "Error",
        message: "U ontvangt binnen ongeveer 20 minuten een e-mail met een link zodat u op een ander moment de identificatie kan afronden. Uit veiligheidsoverwegingen verloopt deze link na 48 uur.",
        type: "error-token-acq"
    }
};


"use strict";
function $ca8521541aab6ce6$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $bc95957a5e7e0c39$var$toString } = Object.prototype;
const { getPrototypeOf: $bc95957a5e7e0c39$var$getPrototypeOf } = Object;
const $bc95957a5e7e0c39$var$kindOf = ((cache)=>(thing)=>{
        const str = $bc95957a5e7e0c39$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $bc95957a5e7e0c39$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$bc95957a5e7e0c39$var$kindOf(thing) === type;
};
const $bc95957a5e7e0c39$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $bc95957a5e7e0c39$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $bc95957a5e7e0c39$var$isUndefined = $bc95957a5e7e0c39$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $bc95957a5e7e0c39$var$isBuffer(val) {
    return val !== null && !$bc95957a5e7e0c39$var$isUndefined(val) && val.constructor !== null && !$bc95957a5e7e0c39$var$isUndefined(val.constructor) && $bc95957a5e7e0c39$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $bc95957a5e7e0c39$var$isArrayBuffer = $bc95957a5e7e0c39$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $bc95957a5e7e0c39$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $bc95957a5e7e0c39$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $bc95957a5e7e0c39$var$isString = $bc95957a5e7e0c39$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $bc95957a5e7e0c39$var$isFunction = $bc95957a5e7e0c39$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $bc95957a5e7e0c39$var$isNumber = $bc95957a5e7e0c39$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $bc95957a5e7e0c39$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $bc95957a5e7e0c39$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $bc95957a5e7e0c39$var$isPlainObject = (val)=>{
    if ($bc95957a5e7e0c39$var$kindOf(val) !== "object") return false;
    const prototype = $bc95957a5e7e0c39$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $bc95957a5e7e0c39$var$isDate = $bc95957a5e7e0c39$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $bc95957a5e7e0c39$var$isFile = $bc95957a5e7e0c39$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $bc95957a5e7e0c39$var$isBlob = $bc95957a5e7e0c39$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $bc95957a5e7e0c39$var$isFileList = $bc95957a5e7e0c39$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $bc95957a5e7e0c39$var$isStream = (val)=>$bc95957a5e7e0c39$var$isObject(val) && $bc95957a5e7e0c39$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $bc95957a5e7e0c39$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $bc95957a5e7e0c39$var$isFunction(thing.append) && ((kind = $bc95957a5e7e0c39$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $bc95957a5e7e0c39$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $bc95957a5e7e0c39$var$isURLSearchParams = $bc95957a5e7e0c39$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $bc95957a5e7e0c39$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $bc95957a5e7e0c39$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($bc95957a5e7e0c39$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $bc95957a5e7e0c39$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $bc95957a5e7e0c39$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $bc95957a5e7e0c39$var$isContextDefined = (context)=>!$bc95957a5e7e0c39$var$isUndefined(context) && context !== $bc95957a5e7e0c39$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $bc95957a5e7e0c39$var$merge() {
    const { caseless: caseless } = $bc95957a5e7e0c39$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $bc95957a5e7e0c39$var$findKey(result, key) || key;
        if ($bc95957a5e7e0c39$var$isPlainObject(result[targetKey]) && $bc95957a5e7e0c39$var$isPlainObject(val)) result[targetKey] = $bc95957a5e7e0c39$var$merge(result[targetKey], val);
        else if ($bc95957a5e7e0c39$var$isPlainObject(val)) result[targetKey] = $bc95957a5e7e0c39$var$merge({}, val);
        else if ($bc95957a5e7e0c39$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $bc95957a5e7e0c39$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $bc95957a5e7e0c39$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $bc95957a5e7e0c39$var$forEach(b, (val, key)=>{
        if (thisArg && $bc95957a5e7e0c39$var$isFunction(val)) a[key] = (0, $ca8521541aab6ce6$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $bc95957a5e7e0c39$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $bc95957a5e7e0c39$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $bc95957a5e7e0c39$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $bc95957a5e7e0c39$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $bc95957a5e7e0c39$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $bc95957a5e7e0c39$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($bc95957a5e7e0c39$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$bc95957a5e7e0c39$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $bc95957a5e7e0c39$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $bc95957a5e7e0c39$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $bc95957a5e7e0c39$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $bc95957a5e7e0c39$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $bc95957a5e7e0c39$var$isHTMLForm = $bc95957a5e7e0c39$var$kindOfTest("HTMLFormElement");
const $bc95957a5e7e0c39$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $bc95957a5e7e0c39$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $bc95957a5e7e0c39$var$isRegExp = $bc95957a5e7e0c39$var$kindOfTest("RegExp");
const $bc95957a5e7e0c39$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $bc95957a5e7e0c39$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $bc95957a5e7e0c39$var$freezeMethods = (obj)=>{
    $bc95957a5e7e0c39$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($bc95957a5e7e0c39$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$bc95957a5e7e0c39$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $bc95957a5e7e0c39$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $bc95957a5e7e0c39$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $bc95957a5e7e0c39$var$noop = ()=>{};
const $bc95957a5e7e0c39$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $bc95957a5e7e0c39$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $bc95957a5e7e0c39$var$DIGIT = "0123456789";
const $bc95957a5e7e0c39$var$ALPHABET = {
    DIGIT: $bc95957a5e7e0c39$var$DIGIT,
    ALPHA: $bc95957a5e7e0c39$var$ALPHA,
    ALPHA_DIGIT: $bc95957a5e7e0c39$var$ALPHA + $bc95957a5e7e0c39$var$ALPHA.toUpperCase() + $bc95957a5e7e0c39$var$DIGIT
};
const $bc95957a5e7e0c39$var$generateString = (size = 16, alphabet = $bc95957a5e7e0c39$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $bc95957a5e7e0c39$var$isSpecCompliantForm(thing) {
    return !!(thing && $bc95957a5e7e0c39$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $bc95957a5e7e0c39$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($bc95957a5e7e0c39$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $bc95957a5e7e0c39$var$isArray(source) ? [] : {};
                $bc95957a5e7e0c39$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$bc95957a5e7e0c39$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $bc95957a5e7e0c39$var$isAsyncFn = $bc95957a5e7e0c39$var$kindOfTest("AsyncFunction");
const $bc95957a5e7e0c39$var$isThenable = (thing)=>thing && ($bc95957a5e7e0c39$var$isObject(thing) || $bc95957a5e7e0c39$var$isFunction(thing)) && $bc95957a5e7e0c39$var$isFunction(thing.then) && $bc95957a5e7e0c39$var$isFunction(thing.catch);
var $bc95957a5e7e0c39$export$2e2bcd8739ae039 = {
    isArray: $bc95957a5e7e0c39$var$isArray,
    isArrayBuffer: $bc95957a5e7e0c39$var$isArrayBuffer,
    isBuffer: $bc95957a5e7e0c39$var$isBuffer,
    isFormData: $bc95957a5e7e0c39$var$isFormData,
    isArrayBufferView: $bc95957a5e7e0c39$var$isArrayBufferView,
    isString: $bc95957a5e7e0c39$var$isString,
    isNumber: $bc95957a5e7e0c39$var$isNumber,
    isBoolean: $bc95957a5e7e0c39$var$isBoolean,
    isObject: $bc95957a5e7e0c39$var$isObject,
    isPlainObject: $bc95957a5e7e0c39$var$isPlainObject,
    isUndefined: $bc95957a5e7e0c39$var$isUndefined,
    isDate: $bc95957a5e7e0c39$var$isDate,
    isFile: $bc95957a5e7e0c39$var$isFile,
    isBlob: $bc95957a5e7e0c39$var$isBlob,
    isRegExp: $bc95957a5e7e0c39$var$isRegExp,
    isFunction: $bc95957a5e7e0c39$var$isFunction,
    isStream: $bc95957a5e7e0c39$var$isStream,
    isURLSearchParams: $bc95957a5e7e0c39$var$isURLSearchParams,
    isTypedArray: $bc95957a5e7e0c39$var$isTypedArray,
    isFileList: $bc95957a5e7e0c39$var$isFileList,
    forEach: $bc95957a5e7e0c39$var$forEach,
    merge: $bc95957a5e7e0c39$var$merge,
    extend: $bc95957a5e7e0c39$var$extend,
    trim: $bc95957a5e7e0c39$var$trim,
    stripBOM: $bc95957a5e7e0c39$var$stripBOM,
    inherits: $bc95957a5e7e0c39$var$inherits,
    toFlatObject: $bc95957a5e7e0c39$var$toFlatObject,
    kindOf: $bc95957a5e7e0c39$var$kindOf,
    kindOfTest: $bc95957a5e7e0c39$var$kindOfTest,
    endsWith: $bc95957a5e7e0c39$var$endsWith,
    toArray: $bc95957a5e7e0c39$var$toArray,
    forEachEntry: $bc95957a5e7e0c39$var$forEachEntry,
    matchAll: $bc95957a5e7e0c39$var$matchAll,
    isHTMLForm: $bc95957a5e7e0c39$var$isHTMLForm,
    hasOwnProperty: $bc95957a5e7e0c39$var$hasOwnProperty,
    hasOwnProp: $bc95957a5e7e0c39$var$hasOwnProperty,
    reduceDescriptors: $bc95957a5e7e0c39$var$reduceDescriptors,
    freezeMethods: $bc95957a5e7e0c39$var$freezeMethods,
    toObjectSet: $bc95957a5e7e0c39$var$toObjectSet,
    toCamelCase: $bc95957a5e7e0c39$var$toCamelCase,
    noop: $bc95957a5e7e0c39$var$noop,
    toFiniteNumber: $bc95957a5e7e0c39$var$toFiniteNumber,
    findKey: $bc95957a5e7e0c39$var$findKey,
    global: $bc95957a5e7e0c39$var$_global,
    isContextDefined: $bc95957a5e7e0c39$var$isContextDefined,
    ALPHABET: $bc95957a5e7e0c39$var$ALPHABET,
    generateString: $bc95957a5e7e0c39$var$generateString,
    isSpecCompliantForm: $bc95957a5e7e0c39$var$isSpecCompliantForm,
    toJSONObject: $bc95957a5e7e0c39$var$toJSONObject,
    isAsyncFn: $bc95957a5e7e0c39$var$isAsyncFn,
    isThenable: $bc95957a5e7e0c39$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $637759389b2d8179$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).inherits($637759389b2d8179$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $637759389b2d8179$var$prototype = $637759389b2d8179$var$AxiosError.prototype;
const $637759389b2d8179$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $637759389b2d8179$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($637759389b2d8179$var$AxiosError, $637759389b2d8179$var$descriptors);
Object.defineProperty($637759389b2d8179$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$637759389b2d8179$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($637759389b2d8179$var$prototype);
    (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $637759389b2d8179$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $637759389b2d8179$export$2e2bcd8739ae039 = $637759389b2d8179$var$AxiosError;


// eslint-disable-next-line strict
var $dc533cf245b452e2$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $650295a739324ed1$export$a143d493d941bafc;
var $650295a739324ed1$export$e4cf37d7f6fb9e0a;
var $650295a739324ed1$export$f99ded8fe4b79145;
var $650295a739324ed1$export$599f31c3813fae4d;
"use strict";
var $49889c39bbce8f14$export$a48f0734ac7c2329;
var $49889c39bbce8f14$export$d622b2ad8d90c771;
var $49889c39bbce8f14$export$6100ba28696e12de;
"use strict";
$49889c39bbce8f14$export$a48f0734ac7c2329 = $49889c39bbce8f14$var$byteLength;
$49889c39bbce8f14$export$d622b2ad8d90c771 = $49889c39bbce8f14$var$toByteArray;
$49889c39bbce8f14$export$6100ba28696e12de = $49889c39bbce8f14$var$fromByteArray;
var $49889c39bbce8f14$var$lookup = [];
var $49889c39bbce8f14$var$revLookup = [];
var $49889c39bbce8f14$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $49889c39bbce8f14$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $49889c39bbce8f14$var$i = 0, $49889c39bbce8f14$var$len = $49889c39bbce8f14$var$code.length; $49889c39bbce8f14$var$i < $49889c39bbce8f14$var$len; ++$49889c39bbce8f14$var$i){
    $49889c39bbce8f14$var$lookup[$49889c39bbce8f14$var$i] = $49889c39bbce8f14$var$code[$49889c39bbce8f14$var$i];
    $49889c39bbce8f14$var$revLookup[$49889c39bbce8f14$var$code.charCodeAt($49889c39bbce8f14$var$i)] = $49889c39bbce8f14$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$49889c39bbce8f14$var$revLookup["-".charCodeAt(0)] = 62;
$49889c39bbce8f14$var$revLookup["_".charCodeAt(0)] = 63;
function $49889c39bbce8f14$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $49889c39bbce8f14$var$byteLength(b64) {
    var lens = $49889c39bbce8f14$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $49889c39bbce8f14$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $49889c39bbce8f14$var$toByteArray(b64) {
    var tmp;
    var lens = $49889c39bbce8f14$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $49889c39bbce8f14$var$Arr($49889c39bbce8f14$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i)] << 18 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i)] << 2 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i)] << 10 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $49889c39bbce8f14$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $49889c39bbce8f14$var$tripletToBase64(num) {
    return $49889c39bbce8f14$var$lookup[num >> 18 & 0x3F] + $49889c39bbce8f14$var$lookup[num >> 12 & 0x3F] + $49889c39bbce8f14$var$lookup[num >> 6 & 0x3F] + $49889c39bbce8f14$var$lookup[num & 0x3F];
}
function $49889c39bbce8f14$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($49889c39bbce8f14$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $49889c39bbce8f14$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($49889c39bbce8f14$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($49889c39bbce8f14$var$lookup[tmp >> 2] + $49889c39bbce8f14$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($49889c39bbce8f14$var$lookup[tmp >> 10] + $49889c39bbce8f14$var$lookup[tmp >> 4 & 0x3F] + $49889c39bbce8f14$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $d29f0355f5b6c666$export$aafa59e2e03f2942;
var $d29f0355f5b6c666$export$68d8715fc104d294;
$d29f0355f5b6c666$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$d29f0355f5b6c666$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $650295a739324ed1$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$650295a739324ed1$export$a143d493d941bafc = $650295a739324ed1$var$Buffer;
$650295a739324ed1$export$e4cf37d7f6fb9e0a = $650295a739324ed1$var$SlowBuffer;
$650295a739324ed1$export$f99ded8fe4b79145 = 50;
var $650295a739324ed1$var$K_MAX_LENGTH = 0x7fffffff;
$650295a739324ed1$export$599f31c3813fae4d = $650295a739324ed1$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $650295a739324ed1$var$Buffer.TYPED_ARRAY_SUPPORT = $650295a739324ed1$var$typedArraySupport();
if (!$650295a739324ed1$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $650295a739324ed1$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($650295a739324ed1$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$650295a739324ed1$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($650295a739324ed1$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$650295a739324ed1$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $650295a739324ed1$var$createBuffer(length) {
    if (length > $650295a739324ed1$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $650295a739324ed1$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $650295a739324ed1$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $650295a739324ed1$var$allocUnsafe(arg);
    }
    return $650295a739324ed1$var$from(arg, encodingOrOffset, length);
}
$650295a739324ed1$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $650295a739324ed1$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $650295a739324ed1$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $650295a739324ed1$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($650295a739324ed1$var$isInstance(value, ArrayBuffer) || value && $650295a739324ed1$var$isInstance(value.buffer, ArrayBuffer)) return $650295a739324ed1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($650295a739324ed1$var$isInstance(value, SharedArrayBuffer) || value && $650295a739324ed1$var$isInstance(value.buffer, SharedArrayBuffer))) return $650295a739324ed1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $650295a739324ed1$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $650295a739324ed1$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $650295a739324ed1$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $650295a739324ed1$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $650295a739324ed1$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($650295a739324ed1$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($650295a739324ed1$var$Buffer, Uint8Array);
function $650295a739324ed1$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $650295a739324ed1$var$alloc(size, fill, encoding) {
    $650295a739324ed1$var$assertSize(size);
    if (size <= 0) return $650295a739324ed1$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $650295a739324ed1$var$createBuffer(size).fill(fill, encoding) : $650295a739324ed1$var$createBuffer(size).fill(fill);
    return $650295a739324ed1$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $650295a739324ed1$var$Buffer.alloc = function(size, fill, encoding) {
    return $650295a739324ed1$var$alloc(size, fill, encoding);
};
function $650295a739324ed1$var$allocUnsafe(size) {
    $650295a739324ed1$var$assertSize(size);
    return $650295a739324ed1$var$createBuffer(size < 0 ? 0 : $650295a739324ed1$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $650295a739324ed1$var$Buffer.allocUnsafe = function(size) {
    return $650295a739324ed1$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $650295a739324ed1$var$Buffer.allocUnsafeSlow = function(size) {
    return $650295a739324ed1$var$allocUnsafe(size);
};
function $650295a739324ed1$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$650295a739324ed1$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $650295a739324ed1$var$byteLength(string, encoding) | 0;
    var buf = $650295a739324ed1$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $650295a739324ed1$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $650295a739324ed1$var$checked(array.length) | 0;
    var buf = $650295a739324ed1$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $650295a739324ed1$var$fromArrayView(arrayView) {
    if ($650295a739324ed1$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $650295a739324ed1$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $650295a739324ed1$var$fromArrayLike(arrayView);
}
function $650295a739324ed1$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $650295a739324ed1$var$Buffer.prototype);
    return buf;
}
function $650295a739324ed1$var$fromObject(obj) {
    if ($650295a739324ed1$var$Buffer.isBuffer(obj)) {
        var len = $650295a739324ed1$var$checked(obj.length) | 0;
        var buf = $650295a739324ed1$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $650295a739324ed1$var$numberIsNaN(obj.length)) return $650295a739324ed1$var$createBuffer(0);
        return $650295a739324ed1$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $650295a739324ed1$var$fromArrayLike(obj.data);
}
function $650295a739324ed1$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $650295a739324ed1$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $650295a739324ed1$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $650295a739324ed1$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $650295a739324ed1$var$Buffer.alloc(+length);
}
$650295a739324ed1$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $650295a739324ed1$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$650295a739324ed1$var$Buffer.compare = function compare(a, b) {
    if ($650295a739324ed1$var$isInstance(a, Uint8Array)) a = $650295a739324ed1$var$Buffer.from(a, a.offset, a.byteLength);
    if ($650295a739324ed1$var$isInstance(b, Uint8Array)) b = $650295a739324ed1$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$650295a739324ed1$var$Buffer.isBuffer(a) || !$650295a739324ed1$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$650295a739324ed1$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$650295a739324ed1$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $650295a739324ed1$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $650295a739324ed1$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($650295a739324ed1$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $650295a739324ed1$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$650295a739324ed1$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $650295a739324ed1$var$byteLength(string, encoding) {
    if ($650295a739324ed1$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $650295a739324ed1$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $650295a739324ed1$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $650295a739324ed1$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $650295a739324ed1$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$650295a739324ed1$var$Buffer.byteLength = $650295a739324ed1$var$byteLength;
function $650295a739324ed1$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $650295a739324ed1$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $650295a739324ed1$var$utf8Slice(this, start, end);
        case "ascii":
            return $650295a739324ed1$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $650295a739324ed1$var$latin1Slice(this, start, end);
        case "base64":
            return $650295a739324ed1$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $650295a739324ed1$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$650295a739324ed1$var$Buffer.prototype._isBuffer = true;
function $650295a739324ed1$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$650295a739324ed1$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$650295a739324ed1$var$swap(this, i, i + 1);
    return this;
};
$650295a739324ed1$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $650295a739324ed1$var$swap(this, i, i + 3);
        $650295a739324ed1$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$650295a739324ed1$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $650295a739324ed1$var$swap(this, i, i + 7);
        $650295a739324ed1$var$swap(this, i + 1, i + 6);
        $650295a739324ed1$var$swap(this, i + 2, i + 5);
        $650295a739324ed1$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$650295a739324ed1$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $650295a739324ed1$var$utf8Slice(this, 0, length);
    return $650295a739324ed1$var$slowToString.apply(this, arguments);
};
$650295a739324ed1$var$Buffer.prototype.toLocaleString = $650295a739324ed1$var$Buffer.prototype.toString;
$650295a739324ed1$var$Buffer.prototype.equals = function equals(b) {
    if (!$650295a739324ed1$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $650295a739324ed1$var$Buffer.compare(this, b) === 0;
};
$650295a739324ed1$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $650295a739324ed1$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($650295a739324ed1$var$customInspectSymbol) $650295a739324ed1$var$Buffer.prototype[$650295a739324ed1$var$customInspectSymbol] = $650295a739324ed1$var$Buffer.prototype.inspect;
$650295a739324ed1$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($650295a739324ed1$var$isInstance(target, Uint8Array)) target = $650295a739324ed1$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$650295a739324ed1$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $650295a739324ed1$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($650295a739324ed1$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $650295a739324ed1$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($650295a739324ed1$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $650295a739324ed1$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $650295a739324ed1$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $650295a739324ed1$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$650295a739324ed1$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$650295a739324ed1$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $650295a739324ed1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$650295a739324ed1$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $650295a739324ed1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $650295a739324ed1$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($650295a739324ed1$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $650295a739324ed1$var$utf8Write(buf, string, offset, length) {
    return $650295a739324ed1$var$blitBuffer($650295a739324ed1$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $650295a739324ed1$var$asciiWrite(buf, string, offset, length) {
    return $650295a739324ed1$var$blitBuffer($650295a739324ed1$var$asciiToBytes(string), buf, offset, length);
}
function $650295a739324ed1$var$base64Write(buf, string, offset, length) {
    return $650295a739324ed1$var$blitBuffer($650295a739324ed1$var$base64ToBytes(string), buf, offset, length);
}
function $650295a739324ed1$var$ucs2Write(buf, string, offset, length) {
    return $650295a739324ed1$var$blitBuffer($650295a739324ed1$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$650295a739324ed1$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $650295a739324ed1$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $650295a739324ed1$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $650295a739324ed1$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $650295a739324ed1$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $650295a739324ed1$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$650295a739324ed1$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $650295a739324ed1$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $49889c39bbce8f14$export$6100ba28696e12de(buf);
    else return $49889c39bbce8f14$export$6100ba28696e12de(buf.slice(start, end));
}
function $650295a739324ed1$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $650295a739324ed1$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $650295a739324ed1$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $650295a739324ed1$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $650295a739324ed1$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $650295a739324ed1$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $650295a739324ed1$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $650295a739324ed1$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $650295a739324ed1$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $650295a739324ed1$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $650295a739324ed1$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$650295a739324ed1$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $650295a739324ed1$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $650295a739324ed1$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$650295a739324ed1$var$Buffer.prototype.readUintLE = $650295a739324ed1$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$650295a739324ed1$var$Buffer.prototype.readUintBE = $650295a739324ed1$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$650295a739324ed1$var$Buffer.prototype.readUint8 = $650295a739324ed1$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$650295a739324ed1$var$Buffer.prototype.readUint16LE = $650295a739324ed1$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$650295a739324ed1$var$Buffer.prototype.readUint16BE = $650295a739324ed1$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$650295a739324ed1$var$Buffer.prototype.readUint32LE = $650295a739324ed1$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$650295a739324ed1$var$Buffer.prototype.readUint32BE = $650295a739324ed1$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$650295a739324ed1$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$650295a739324ed1$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$650295a739324ed1$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$650295a739324ed1$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$650295a739324ed1$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$650295a739324ed1$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$650295a739324ed1$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$650295a739324ed1$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return $d29f0355f5b6c666$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$650295a739324ed1$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 4, this.length);
    return $d29f0355f5b6c666$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$650295a739324ed1$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 8, this.length);
    return $d29f0355f5b6c666$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$650295a739324ed1$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkOffset(offset, 8, this.length);
    return $d29f0355f5b6c666$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $650295a739324ed1$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$650295a739324ed1$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$650295a739324ed1$var$Buffer.prototype.writeUintLE = $650295a739324ed1$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $650295a739324ed1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$650295a739324ed1$var$Buffer.prototype.writeUintBE = $650295a739324ed1$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $650295a739324ed1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$650295a739324ed1$var$Buffer.prototype.writeUint8 = $650295a739324ed1$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$650295a739324ed1$var$Buffer.prototype.writeUint16LE = $650295a739324ed1$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$650295a739324ed1$var$Buffer.prototype.writeUint16BE = $650295a739324ed1$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$650295a739324ed1$var$Buffer.prototype.writeUint32LE = $650295a739324ed1$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$650295a739324ed1$var$Buffer.prototype.writeUint32BE = $650295a739324ed1$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$650295a739324ed1$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $650295a739324ed1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$650295a739324ed1$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $650295a739324ed1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$650295a739324ed1$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$650295a739324ed1$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$650295a739324ed1$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$650295a739324ed1$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$650295a739324ed1$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $650295a739324ed1$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $650295a739324ed1$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $d29f0355f5b6c666$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$650295a739324ed1$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $650295a739324ed1$var$writeFloat(this, value, offset, true, noAssert);
};
$650295a739324ed1$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $650295a739324ed1$var$writeFloat(this, value, offset, false, noAssert);
};
function $650295a739324ed1$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $650295a739324ed1$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $d29f0355f5b6c666$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$650295a739324ed1$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $650295a739324ed1$var$writeDouble(this, value, offset, true, noAssert);
};
$650295a739324ed1$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $650295a739324ed1$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$650295a739324ed1$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$650295a739324ed1$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$650295a739324ed1$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$650295a739324ed1$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $650295a739324ed1$var$Buffer.isBuffer(val) ? val : $650295a739324ed1$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $650295a739324ed1$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $650295a739324ed1$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($650295a739324ed1$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $650295a739324ed1$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $650295a739324ed1$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $650295a739324ed1$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $650295a739324ed1$var$base64ToBytes(str) {
    return $49889c39bbce8f14$export$d622b2ad8d90c771($650295a739324ed1$var$base64clean(str));
}
function $650295a739324ed1$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $650295a739324ed1$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $650295a739324ed1$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $650295a739324ed1$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $29926b85f190cc00$require$Buffer = $650295a739324ed1$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $29926b85f190cc00$var$isVisitable(thing) {
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $29926b85f190cc00$var$removeBrackets(key) {
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $29926b85f190cc00$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $29926b85f190cc00$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $29926b85f190cc00$var$isFlatArray(arr) {
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(arr) && !arr.some($29926b85f190cc00$var$isVisitable);
}
const $29926b85f190cc00$var$predicates = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toFlatObject((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $29926b85f190cc00$var$toFormData(obj, formData, options) {
    if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $dc533cf245b452e2$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $29926b85f190cc00$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(value) && $29926b85f190cc00$var$isFlatArray(value) || ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFileList(value) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $29926b85f190cc00$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $29926b85f190cc00$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($29926b85f190cc00$var$isVisitable(value)) return true;
        formData.append($29926b85f190cc00$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($29926b85f190cc00$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $29926b85f190cc00$var$isVisitable
    });
    function build(value, path) {
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $29926b85f190cc00$export$2e2bcd8739ae039 = $29926b85f190cc00$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $fc14c25407d98aa2$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $fc14c25407d98aa2$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $29926b85f190cc00$export$2e2bcd8739ae039)(params, this, options);
}
const $fc14c25407d98aa2$var$prototype = $fc14c25407d98aa2$var$AxiosURLSearchParams.prototype;
$fc14c25407d98aa2$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$fc14c25407d98aa2$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $fc14c25407d98aa2$var$encode);
    } : $fc14c25407d98aa2$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $fc14c25407d98aa2$export$2e2bcd8739ae039 = $fc14c25407d98aa2$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $d1c352dffd6c37f8$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $d1c352dffd6c37f8$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $d1c352dffd6c37f8$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $fc14c25407d98aa2$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $cac6c0aeb085b4f1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $cac6c0aeb085b4f1$export$2e2bcd8739ae039 = $cac6c0aeb085b4f1$var$InterceptorManager;





"use strict";
var $742f8ca1004f36cf$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $824300454ef6f06d$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $fc14c25407d98aa2$export$2e2bcd8739ae039);


"use strict";
var $b9beeee9d03e6871$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $804e230012604cc4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $2b3c464133eb8a7c$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $824300454ef6f06d$export$2e2bcd8739ae039,
        FormData: $b9beeee9d03e6871$export$2e2bcd8739ae039,
        Blob: $804e230012604cc4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $4524f791c8d6a57e$exports = {};

$parcel$export($4524f791c8d6a57e$exports, "hasBrowserEnv", function () { return $4524f791c8d6a57e$export$c4996c4b7b93b0bf; });
$parcel$export($4524f791c8d6a57e$exports, "hasStandardBrowserEnv", function () { return $4524f791c8d6a57e$export$c0bcc9250309d66; });
$parcel$export($4524f791c8d6a57e$exports, "hasStandardBrowserWebWorkerEnv", function () { return $4524f791c8d6a57e$export$c81692cf5af97dac; });
const $4524f791c8d6a57e$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $4524f791c8d6a57e$export$c0bcc9250309d66 = ((product)=>{
    return $4524f791c8d6a57e$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $4524f791c8d6a57e$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $66f0fd32aa1c7d39$export$2e2bcd8739ae039 = {
    ...$4524f791c8d6a57e$exports,
    ...(0, $2b3c464133eb8a7c$export$2e2bcd8739ae039)
};


"use strict";
function $49a617acb9dfa85e$export$2e2bcd8739ae039(data, options) {
    return (0, $29926b85f190cc00$export$2e2bcd8739ae039)(data, new (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).isNode && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $d73a975fa518ebeb$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $d73a975fa518ebeb$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $d73a975fa518ebeb$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $d73a975fa518ebeb$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFormData(formData) && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($d73a975fa518ebeb$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $d73a975fa518ebeb$export$2e2bcd8739ae039 = $d73a975fa518ebeb$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $64102e3a924041e9$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $64102e3a924041e9$var$defaults = {
    transitional: (0, $742f8ca1004f36cf$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $d73a975fa518ebeb$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isBuffer(data) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isStream(data) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFile(data) || (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $49a617acb9dfa85e$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $29926b85f190cc00$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $64102e3a924041e9$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $64102e3a924041e9$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $637759389b2d8179$export$2e2bcd8739ae039).from(e, (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $64102e3a924041e9$var$defaults.headers[method] = {};
});
var $64102e3a924041e9$export$2e2bcd8739ae039 = $64102e3a924041e9$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $66aa18902245fdef$var$ignoreDuplicateOf = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $66aa18902245fdef$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $66aa18902245fdef$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $c44fec3be66b208e$var$$internals = Symbol("internals");
function $c44fec3be66b208e$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c44fec3be66b208e$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(value) ? value.map($c44fec3be66b208e$var$normalizeValue) : String(value);
}
function $c44fec3be66b208e$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c44fec3be66b208e$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c44fec3be66b208e$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c44fec3be66b208e$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c44fec3be66b208e$var$buildAccessors(obj, header) {
    const accessorName = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c44fec3be66b208e$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c44fec3be66b208e$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c44fec3be66b208e$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c44fec3be66b208e$var$isValidHeaderName(header)) setHeaders((0, $66aa18902245fdef$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c44fec3be66b208e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c44fec3be66b208e$var$parseTokens(value);
                if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c44fec3be66b208e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c44fec3be66b208e$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c44fec3be66b208e$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c44fec3be66b208e$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c44fec3be66b208e$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c44fec3be66b208e$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c44fec3be66b208e$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c44fec3be66b208e$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c44fec3be66b208e$var$$internals] = this[$c44fec3be66b208e$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c44fec3be66b208e$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c44fec3be66b208e$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c44fec3be66b208e$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).reduceDescriptors($c44fec3be66b208e$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).freezeMethods($c44fec3be66b208e$var$AxiosHeaders);
var $c44fec3be66b208e$export$2e2bcd8739ae039 = $c44fec3be66b208e$var$AxiosHeaders;


"use strict";
function $c1a1b13357d0a140$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $64102e3a924041e9$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $9b9075f5b4b4a6ff$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $26bae45c8db1f1d9$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $637759389b2d8179$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).inherits($26bae45c8db1f1d9$var$CanceledError, (0, $637759389b2d8179$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $26bae45c8db1f1d9$export$2e2bcd8739ae039 = $26bae45c8db1f1d9$var$CanceledError;







"use strict";
function $e952e434899d7c98$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $16d3d1c46f3bf7d7$export$2e2bcd8739ae039 = (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $3f515d5eeddff0d0$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $1ef7e307329b6570$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $788e5dad59537aca$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $3f515d5eeddff0d0$export$2e2bcd8739ae039)(requestedURL)) return (0, $1ef7e307329b6570$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $546edfc2eed161c9$export$2e2bcd8739ae039 = (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $3c329c250ab05a1c$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $74c620fbb6ed3830$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $74c620fbb6ed3830$export$2e2bcd8739ae039 = $74c620fbb6ed3830$var$speedometer;


"use strict";
function $8a47eaadb4f44311$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $74c620fbb6ed3830$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $8a47eaadb4f44311$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $8a47eaadb4f44311$export$2e2bcd8739ae039 = $8a47eaadb4f44311$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $788e5dad59537aca$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $d1c352dffd6c37f8$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $e952e434899d7c98$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Request aborted", (0, $637759389b2d8179$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Network Error", (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $742f8ca1004f36cf$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $637759389b2d8179$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $637759389b2d8179$export$2e2bcd8739ae039).ETIMEDOUT : (0, $637759389b2d8179$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $546edfc2eed161c9$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $16d3d1c46f3bf7d7$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $8a47eaadb4f44311$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $8a47eaadb4f44311$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $26bae45c8db1f1d9$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $3c329c250ab05a1c$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $66f0fd32aa1c7d39$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $8957550d004fb8e7$var$knownAdapters = {
    http: (0, $dc533cf245b452e2$export$2e2bcd8739ae039),
    xhr: (0, $8a47eaadb4f44311$export$2e2bcd8739ae039)
};
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach($8957550d004fb8e7$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $8957550d004fb8e7$var$renderReason = (reason)=>`- ${reason}`;
const $8957550d004fb8e7$var$isResolvedHandle = (adapter)=>(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $8957550d004fb8e7$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$8957550d004fb8e7$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $8957550d004fb8e7$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($8957550d004fb8e7$var$renderReason).join("\n") : " " + $8957550d004fb8e7$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $8957550d004fb8e7$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a90e695ce52f20ae$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $26bae45c8db1f1d9$export$2e2bcd8739ae039)(null, config);
}
function $a90e695ce52f20ae$export$2e2bcd8739ae039(config) {
    $a90e695ce52f20ae$var$throwIfCancellationRequested(config);
    config.headers = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $c1a1b13357d0a140$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $8957550d004fb8e7$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $64102e3a924041e9$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $a90e695ce52f20ae$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $c1a1b13357d0a140$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $9b9075f5b4b4a6ff$export$2e2bcd8739ae039)(reason)) {
            $a90e695ce52f20ae$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $c1a1b13357d0a140$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $ff39e254535c25ce$var$headersToObject = (thing)=>thing instanceof (0, $c44fec3be66b208e$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $ff39e254535c25ce$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isPlainObject(target) && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($ff39e254535c25ce$var$headersToObject(a), $ff39e254535c25ce$var$headersToObject(b), true)
    };
    (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $c16788b5149ee7e6$export$a4ad2735b021c132 = "1.6.8";



"use strict";
const $75ac3759707f3593$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $75ac3759707f3593$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $75ac3759707f3593$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $75ac3759707f3593$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $c16788b5149ee7e6$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$75ac3759707f3593$var$deprecatedWarnings[opt]) {
            $75ac3759707f3593$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $75ac3759707f3593$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)("options must be an object", (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $637759389b2d8179$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $637759389b2d8179$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $75ac3759707f3593$export$2e2bcd8739ae039 = {
    assertOptions: $75ac3759707f3593$var$assertOptions,
    validators: $75ac3759707f3593$var$validators
};



"use strict";
const $0cdbc7e535a536fd$var$validators = (0, $75ac3759707f3593$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $0cdbc7e535a536fd$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $cac6c0aeb085b4f1$export$2e2bcd8739ae039)(),
            response: new (0, $cac6c0aeb085b4f1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $ff39e254535c25ce$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $75ac3759707f3593$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $0cdbc7e535a536fd$var$validators.transitional($0cdbc7e535a536fd$var$validators.boolean),
            forcedJSONParsing: $0cdbc7e535a536fd$var$validators.transitional($0cdbc7e535a536fd$var$validators.boolean),
            clarifyTimeoutError: $0cdbc7e535a536fd$var$validators.transitional($0cdbc7e535a536fd$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $75ac3759707f3593$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $0cdbc7e535a536fd$var$validators.function,
                serialize: $0cdbc7e535a536fd$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c44fec3be66b208e$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $a90e695ce52f20ae$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $a90e695ce52f20ae$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $ff39e254535c25ce$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $788e5dad59537aca$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $d1c352dffd6c37f8$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $0cdbc7e535a536fd$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $ff39e254535c25ce$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $ff39e254535c25ce$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $0cdbc7e535a536fd$var$Axios.prototype[method] = generateHTTPMethod();
    $0cdbc7e535a536fd$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $0cdbc7e535a536fd$export$2e2bcd8739ae039 = $0cdbc7e535a536fd$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $d14d3ef8f50745ec$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $26bae45c8db1f1d9$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $d14d3ef8f50745ec$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $d14d3ef8f50745ec$export$2e2bcd8739ae039 = $d14d3ef8f50745ec$var$CancelToken;






"use strict";
function $96dec4d5bb99217c$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $3b1a439533ee9426$export$2e2bcd8739ae039(payload) {
    return (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $23aa36a2db2c13f0$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($23aa36a2db2c13f0$var$HttpStatusCode).forEach(([key, value])=>{
    $23aa36a2db2c13f0$var$HttpStatusCode[value] = key;
});
var $23aa36a2db2c13f0$export$2e2bcd8739ae039 = $23aa36a2db2c13f0$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $cd771979e180c558$var$createInstance(defaultConfig) {
    const context = new (0, $0cdbc7e535a536fd$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $ca8521541aab6ce6$export$2e2bcd8739ae039)((0, $0cdbc7e535a536fd$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).extend(instance, (0, $0cdbc7e535a536fd$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $cd771979e180c558$var$createInstance((0, $ff39e254535c25ce$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $cd771979e180c558$var$axios = $cd771979e180c558$var$createInstance((0, $64102e3a924041e9$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$cd771979e180c558$var$axios.Axios = (0, $0cdbc7e535a536fd$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$cd771979e180c558$var$axios.CanceledError = (0, $26bae45c8db1f1d9$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.CancelToken = (0, $d14d3ef8f50745ec$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.isCancel = (0, $9b9075f5b4b4a6ff$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.VERSION = (0, $c16788b5149ee7e6$export$a4ad2735b021c132);
$cd771979e180c558$var$axios.toFormData = (0, $29926b85f190cc00$export$2e2bcd8739ae039);
// Expose AxiosError class
$cd771979e180c558$var$axios.AxiosError = (0, $637759389b2d8179$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$cd771979e180c558$var$axios.Cancel = $cd771979e180c558$var$axios.CanceledError;
// Expose all/spread
$cd771979e180c558$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$cd771979e180c558$var$axios.spread = (0, $96dec4d5bb99217c$export$2e2bcd8739ae039);
// Expose isAxiosError
$cd771979e180c558$var$axios.isAxiosError = (0, $3b1a439533ee9426$export$2e2bcd8739ae039);
// Expose mergeConfig
$cd771979e180c558$var$axios.mergeConfig = (0, $ff39e254535c25ce$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.AxiosHeaders = (0, $c44fec3be66b208e$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.formToJSON = (thing)=>(0, $d73a975fa518ebeb$export$2e2bcd8739ae039)((0, $bc95957a5e7e0c39$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$cd771979e180c558$var$axios.getAdapter = (0, $8957550d004fb8e7$export$2e2bcd8739ae039).getAdapter;
$cd771979e180c558$var$axios.HttpStatusCode = (0, $23aa36a2db2c13f0$export$2e2bcd8739ae039);
$cd771979e180c558$var$axios.default = $cd771979e180c558$var$axios;
var // this module should only have a default export
$cd771979e180c558$export$2e2bcd8739ae039 = $cd771979e180c558$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b7070c4fc492ac8b$export$1c00760e9e5a4e95, AxiosError: $b7070c4fc492ac8b$export$c1fbed17c2f6a328, CanceledError: $b7070c4fc492ac8b$export$1ab0c6b20d94fa14, isCancel: $b7070c4fc492ac8b$export$3b22524397b493c6, CancelToken: $b7070c4fc492ac8b$export$fd08e3cb425f0d61, VERSION: $b7070c4fc492ac8b$export$a4ad2735b021c132, all: $b7070c4fc492ac8b$export$84bf76cd7afc7469, Cancel: $b7070c4fc492ac8b$export$848c9b7ead0df967, isAxiosError: $b7070c4fc492ac8b$export$fbafdbe06a5b5a9a, spread: $b7070c4fc492ac8b$export$3ae0fd4797ed47c8, toFormData: $b7070c4fc492ac8b$export$10ae0d317ea97f8b, AxiosHeaders: $b7070c4fc492ac8b$export$4e7d6ff0f3e6520, HttpStatusCode: $b7070c4fc492ac8b$export$a972f69c851492b3, formToJSON: $b7070c4fc492ac8b$export$86d7c59254d6a2c9, getAdapter: $b7070c4fc492ac8b$export$17ddc20a97d669e2, mergeConfig: $b7070c4fc492ac8b$export$7ec1ebcfa9d8bd6a } = (0, $cd771979e180c558$export$2e2bcd8739ae039);


const $aad9051021d3a449$export$116a2a95e81fe3c3 = ()=>{
    const currentUrl = window.location.origin;
    const schemaLenght = 8;
    const authorityFirstPart = currentUrl.split(".")[0].slice(schemaLenght); //eg. sandbox-web
    const domainDetails = authorityFirstPart.substr(0, authorityFirstPart.search("web")); //eg. sandbox-
    let output = `https://${domainDetails}web-api.attempt.signicat.io`;
    return output;
};


const $016b5408f4f39711$export$66a2189a71063a10 = async ()=>{
    try {
        await (0, $cd771979e180c558$export$2e2bcd8739ae039).request({
            method: "POST",
            url: `${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/interactions/keepAlive`,
            withCredentials: true
        });
    } catch (e) {
        console.log(e);
    }
};




const $6040ad3a9ba48cfe$export$9816d14951310418 = async ()=>{
    try {
        await (0, $cd771979e180c558$export$2e2bcd8739ae039).post(`${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/interactions/finishLater`, {});
    } catch (e) {
        console.log(e);
    }
};


const $45843b22ada4386e$export$f4cd0081cd474598 = 172800;
const $45843b22ada4386e$export$eb0533d3407a48ba = 1200;
const $45843b22ada4386e$export$447fac0519549abf = {
    terminateProcessEnabled: true,
    attemptExpirationBufferTimeSeconds: 0
};
const $45843b22ada4386e$export$351ee06fa9b95cc2 = false;
const $45843b22ada4386e$export$2707f038bb5e8d05 = "amex-nl-b2c-acquisition";
const $45843b22ada4386e$export$7d1b589b83d5fb2e = "amex-nl-b2c-remediation";


class $ce86999d70e24b03$export$a7fbe9ff12d812bf {
    constructor(rootStore){
        this.currentScreen = (0, $8e272ff57971c6ac$export$da3bc2f57520e3c3).pageBankSelection;
        this.currentStep = (0, $f39ce8075185c88d$export$be3f796aed065412)[1];
        this.steps = (0, $f39ce8075185c88d$export$be3f796aed065412);
        this.showSteps = true;
        this.error = (0, $d1720c836d6de09c$export$30f3b02011db23c0).errorDefault;
        this.activePage = "";
        (0, $5468eea7b07c745b$export$1cfaca5abb185fe7)(this);
        this.rootStore = rootStore;
        // setScreenError
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.activePage != "bank-select" && this.activePage != "onfido" && this.activePage != "onfido-no-loader" && this.activePage != "onfido-complete" && this.activePage != "", ()=>{
            if (this.currentScreen.subpage !== 4) {
                this.setError((0, $d1720c836d6de09c$export$30f3b02011db23c0).errorDefault);
                this.changePage("error", 1);
            }
        });
        // setExpiredError
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.activePage === "session-expired" || this.activePage === "error-auth", ()=>{
            if (this.rootStore.ClientState.flow === (0, $45843b22ada4386e$export$7d1b589b83d5fb2e)) this.setError((0, $d1720c836d6de09c$export$30f3b02011db23c0).errorExpiredRem);
            else this.setError((0, $d1720c836d6de09c$export$30f3b02011db23c0).errorExpired);
            this.changePage("error", 1);
        });
        // setCookieError
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.activePage === "error-missing-cookie-on-redirect-from-oidc", ()=>{
            if (this.rootStore.ClientState.flow === (0, $45843b22ada4386e$export$7d1b589b83d5fb2e)) this.setError((0, $d1720c836d6de09c$export$30f3b02011db23c0).errorMissingCookieRem);
            else this.setError((0, $d1720c836d6de09c$export$30f3b02011db23c0).errorMissingCookie);
            this.changePage("error", 1);
        });
        // setScreenBankSelection
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.activePage === "bank-select", ()=>{
            this.changePage("bank", 1);
            this.changeStep((0, $f39ce8075185c88d$export$be3f796aed065412)[1]);
            this.setSteps((0, $f39ce8075185c88d$export$be3f796aed065412));
        });
        // setScreenOnfido
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.activePage === "onfido", ()=>{
            this.changePage("uploadid", 1);
            this.changeStep((0, $f39ce8075185c88d$export$be3f796aed065412)[2]);
            this.setSteps([
                (0, $f39ce8075185c88d$export$be3f796aed065412)[0],
                {
                    ...(0, $f39ce8075185c88d$export$be3f796aed065412)[1],
                    status: "done"
                },
                {
                    ...(0, $f39ce8075185c88d$export$be3f796aed065412)[2],
                    status: ""
                }
            ]);
        });
        // setScreenOnfidoNoLoader
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.activePage === "onfido-no-loader", ()=>{
            this.rootStore.AppConfig.setOnfidoShowLoading(false);
            this.changePage("uploadid", 1);
            this.changeStep((0, $f39ce8075185c88d$export$be3f796aed065412)[2]);
            this.setSteps([
                (0, $f39ce8075185c88d$export$be3f796aed065412)[0],
                {
                    ...(0, $f39ce8075185c88d$export$be3f796aed065412)[1],
                    status: "done"
                },
                {
                    ...(0, $f39ce8075185c88d$export$be3f796aed065412)[2],
                    status: ""
                }
            ]);
        });
        // setScreenOnfidoComplete
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.activePage === "onfido-complete", ()=>{
            this.changePage("uploadid", 4);
            this.changeStep((0, $f39ce8075185c88d$export$be3f796aed065412)[2]);
            this.setSteps([
                {
                    ...(0, $f39ce8075185c88d$export$be3f796aed065412)[0],
                    status: "done"
                },
                {
                    ...(0, $f39ce8075185c88d$export$be3f796aed065412)[1],
                    status: "done"
                },
                {
                    ...(0, $f39ce8075185c88d$export$be3f796aed065412)[2],
                    status: "done"
                }
            ]);
        });
        // setScreenContinue
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.activePage === "continue", ()=>{
            this.changePage("continue", 1);
            this.setShowSteps(false);
        });
        // setStepsVisibleNotContinue
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.currentScreen.page !== "continue", ()=>{
            this.setShowSteps(true);
        });
        // setStepsVisibileNotError
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.currentScreen.page !== "error", ()=>{
            this.setShowSteps(true);
        });
        // setStepsHiddenContinue
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.currentScreen.page === "continue", async ()=>{
            try {
                await (0, $6040ad3a9ba48cfe$export$9816d14951310418)();
                this.setShowSteps(false);
            } catch (e) {
                this.changePage("error", 1);
            }
        });
        // setStepsHiddenError
        (0, $5468eea7b07c745b$export$a55877ca9db47377)(()=>this.currentScreen.page === "error", ()=>{
            this.setShowSteps(false);
        });
    }
    changePage(page, subpage) {
        this.rootStore.ClientState.flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) && subpage !== 4 && (0, $016b5408f4f39711$export$66a2189a71063a10)();
        this.currentScreen = {
            page: page,
            subpage: subpage,
            isLoaded: true
        };
    }
    changeStep(step) {
        this.currentStep = step;
    }
    setSteps(newSteps) {
        this.steps = newSteps;
    }
    setShowSteps(showSteps) {
        this.showSteps = showSteps;
    }
    setError(error) {
        this.error = error;
    }
    setActivePage(activePage) {
        this.activePage = activePage;
    }
}
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "changePage", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "changeStep", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setSteps", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setShowSteps", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setError", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $ce86999d70e24b03$export$a7fbe9ff12d812bf.prototype, "setActivePage", null);




const $726689d1d537df2f$export$9c64ee4d84d79ce1 = {
    acquisition: {
        stepsLabels: {
            applicationStart: "Aanvraagformulier verstuurd",
            idin: "Identificeren met iDIN",
            onfido: "Upload ID"
        },
        learnMore: "Meer informatie",
        helpText: "Heeft u nog vragen? Bel ons dan op 020 - 504 8000 en houd uw referentienummer bij de hand: ",
        cookieText: "Heeft u nog vragen? Bel ons dan op 020 - 504 8000.",
        close: "Sluiten",
        goToHomepage: "Naar American Express homepage",
        pageContinueLater: {
            heading: "U ontvangt binnen ongeveer 20 minuten een e-mail om uw identificatie later af te ronden",
            buttonEmail: "Geen e-mail ontvangen?",
            close: "Sluiten",
            modal: {
                heading: "Heeft u de e-mail niet ontvangen?",
                description: "Voer uw e-mailadres in, zodat we de e-mail opnieuw kunnen verzenden.",
                error: "Vul een geldig e-mailadres in",
                submit: "Verzenden",
                sent: "De e-mail is verzonden!"
            }
        },
        continueLabel: "Doorgaan",
        finishLaterLabel: "Later afronden",
        pageBankSelection: {
            heading: "Selecteer uw bank",
            loginToYourBank: "Log in bij uw bank met iDIN om uw identiteit te verifi\xebren.",
            pleaseChoseYourBank: "Selecteer",
            bankNotListed: "Overslaan: ik heb geen Nederlandse bankrekening of mijn bank staat er niet tussen.",
            modal: {
                heading: "Staat uw bank niet in de lijst?",
                text: "Met deze optie slaat u de verificatie via iDIN over en gaat u direct door naar het uploaden van een ID-document. Wij nemen op een later tijdstip per e-mail contact met u op voor additionele documentatie.",
                continue: "Doorgaan",
                goBack: "Terug naar iDIN"
            }
        },
        pageUploadIdLoading: {
            idinComplete: "iDIN afgerond",
            subtitle: "Dank u wel."
        },
        pageUploadIdStart: {
            heading: "Upload een ID-document",
            pleaseUpload: "Upload een kopie van uw ID-document naar Onfido, onze betrouwbare partner voor identiteitsverificatie. Uw burgerservicenummer (BSN) wordt  automatisch afgeschermd op uw ID-document voordat deze wordt verstuurd naar American Express.",
            learnMore: "Meer informatie over Onfido",
            americanExpressDescription: "Meer informatie over hoe American Express of onze dienstverleners uw gegevens verzamelen, opslaan en verwerken vindt u",
            submittingDocuments: "",
            redirected: "U wordt doorgestuurd naar de website van Onfido",
            modal: {
                text: "Onfido is onze betrouwbare Dienstverlener die het mogelijk maakt ID-documenten (zoals paspoort of identiteitsbewijs) van een computer of mobiele telefoon te uploaden in een beveiligde omgeving."
            },
            modalFinishLater: {
                heading: "Weet u zeker dat u de pagina wil verlaten?",
                paragraphFirst: "Indien u de identificatie nu stopt, sturen wij u een e-mail met een link om deze op een later tijdstip alsnog af te ronden. Uit veiligheidsoverwegingen verloopt deze link na 48 uur.",
                paragraphSecond: "",
                buttonComplete: "Identificatie afronden",
                buttonLeave: "Identificatie verlaten en later afronden"
            },
            pleaseWait: "Een moment geduld alstublieft.",
            pleaseWaitLonger: "Een moment geduld alstublieft. Het duurt iets langer dan normaal."
        },
        pageCountrySelect: {
            heading: "Zoek het land waar mijn identiteitsbewijs is verstrekt.",
            searchCountry: "Zoek land",
            suggestedCountry: "Bedoelt u:",
            pleaseWait: "",
            pleaseWaitLonger: ""
        },
        pageComplete: {
            heading: "Gefeliciteerd, uw aanvraag is afgerond!",
            textIdin: "Bedankt voor het opsturen van uw informatie. Wij nemen uw aanvraag in behandeling en nemen binnen 10 werkdagen contact met u op.\n\n U mag dit scherm nu afsluiten",
            textSkip: "Uw aanvraag is ontvangen en wacht op beoordeling. We nemen contact met u op voor eventuele aanvullende documentatie. Je kunt dit venster sluiten."
        },
        pageError: {
            haventRecieved: "Geen e-mail ontvangen?",
            close: "Sluiten"
        },
        idinInfoModal: "iDIN is een initiatief van de Nederlandse banken. Een snelle, veilige en gemakkelijke manier voor  online identificatie via de veilige en vertrouwde inlogmethode van uw eigen bank. Met iDIN worden bepaalde gegevens bevestigd die reeds bij uw bank bekend zijn, zoals uw naam, adres en geboortedatum.",
        onfidoInfoModal: "Onfido is onze betrouwbare Dienstverlener die het mogelijk maakt ID-documenten (zoals paspoort of identiteitsbewijs) van een computer of mobiele telefoon te uploaden in een beveiligde omgeving.",
        print: "Afdrukken",
        footer: {
            copyright: "Copyright \xa9 2017 ",
            americanExpress: "American Express Company",
            rightsReserved: "Alle rechten, typefouten en prijswijzigingen voorbehouden."
        },
        modalSessionTimer: {
            text: "Uw sessie verloopt binnenkort. Klik op Doorgaan om de applicatie terug te sturen",
            buttonComplete: "Doorgaan",
            buttonLeave: "Later afronden"
        }
    },
    remediation: {
        stepsLabels: {
            applicationStart: "Aanvraagformulier verstuurd",
            idin: "Identificeren met iDIN",
            onfido: "Upload ID"
        },
        learnMore: "Meer informatie",
        helpText: `Vragen? Bekijk <a href="https://www.americanexpress.com/nl/informatie/veilig-met-uw-kaart/index.html#faq" target="_blank" rel="noreferrer">hier</a> de Veelgestelde Vragen.`,
        cookieText: `Vragen? Bekijk <a href="https://www.americanexpress.com/nl/informatie/veilig-met-uw-kaart/index.html#faq" target="_blank" rel="noreferrer">hier</a> de Veelgestelde Vragen.`,
        close: "Sluiten",
        goToHomepage: "Naar American Express homepage",
        pageContinueLater: {
            heading: "U ontvangt binnen ongeveer 20 minuten een e-mail om uw identificatie later af te ronden",
            buttonEmail: "Geen e-mail ontvangen?",
            close: "Sluiten",
            modal: {
                heading: "Heeft u de e-mail niet ontvangen?",
                description: "Voer uw e-mailadres in, zodat we de e-mail opnieuw kunnen verzenden.",
                error: "Vul een geldig e-mailadres in",
                submit: "Verzenden",
                sent: "De e-mail is verzonden!"
            }
        },
        continueLabel: "Doorgaan",
        finishLaterLabel: "Later afronden",
        pageBankSelection: {
            heading: "Selecteer uw bank",
            loginToYourBank: "Log in bij uw bank met iDIN om uw identiteit te verifi\xebren.",
            pleaseChoseYourBank: "Selecteer",
            bankNotListed: "Overslaan: ik heb geen Nederlandse bankrekening of mijn bank staat er niet tussen.",
            modal: {
                heading: "Staat uw bank er niet bij?",
                text: "Dan kunt u de verificatie via iDIN overslaan en gaat u direct door naar het uploaden van een ID-document. Wij nemen later contact met u op voor additionele documentatie.",
                continue: "iDIN overslaan",
                goBack: "Terug naar iDIN"
            }
        },
        pageUploadIdLoading: {
            idinComplete: "iDIN afgerond",
            subtitle: "Dank u wel."
        },
        pageUploadIdStart: {
            heading: "Upload een ID-document",
            pleaseUpload: "Upload een kopie van uw ID-document naar Onfido, onze betrouwbare partner voor identiteitsverificatie. Uw burgerservicenummer (BSN) wordt  automatisch afgeschermd op uw ID-document voordat deze wordt verstuurd naar American Express.",
            learnMore: "Meer informatie over Onfido",
            americanExpressDescription: "Meer informatie over hoe American Express of onze dienstverleners uw gegevens verzamelen, opslaan en verwerken vindt u",
            submittingDocuments: "",
            redirected: "U wordt doorgestuurd naar de website van Onfido",
            modal: {
                text: "Onfido is onze betrouwbare Dienstverlener die het mogelijk maakt ID-documenten (zoals paspoort of identiteitsbewijs) van een computer of mobiele telefoon te uploaden in een beveiligde omgeving."
            },
            modalFinishLater: {
                heading: "Weet u zeker dat u de pagina wil verlaten?",
                paragraphFirst: "Indien u de identificatie nu stopt, sturen wij u een e-mail met een link om deze op een later tijdstip alsnog af te ronden. Uit veiligheidsoverwegingen verloopt deze link na 48 uur.",
                paragraphSecond: "",
                buttonComplete: "Identificatie afronden",
                buttonLeave: "Identificatie verlaten en later afronden"
            },
            pleaseWait: "",
            pleaseWaitLonger: ""
        },
        pageCountrySelect: {
            heading: "Selecteer het land dat uw identiteitsbewijs heeft uitgegeven.",
            searchCountry: "Zoek land",
            suggestedCountry: "Bedoelt u:",
            pleaseWait: "Even geduld aub.",
            pleaseWaitLonger: "Even geduld aub. Het kost iets meer tijd dan normaal."
        },
        pageComplete: {
            heading: "Gefeliciteerd, uw aanvraag is afgerond!",
            textIdin: "Bedankt voor het opsturen van uw informatie. Wij nemen uw aanvraag in behandeling en nemen binnen 10 werkdagen contact met u op.\n\n U mag dit scherm nu afsluiten",
            textSkip: "Uw aanvraag is ontvangen en wacht op beoordeling. We nemen contact met u op voor eventuele aanvullende documentatie. Je kunt dit venster sluiten."
        },
        pageError: {
            haventRecieved: "Geen e-mail ontvangen?",
            close: "Sluiten"
        },
        idinInfoModal: "iDIN is een initiatief van de Nederlandse banken. Een snelle, veilige en gemakkelijke manier voor online identificatie via de vertrouwde inlogmethode van uw eigen bank. Met iDIN worden bepaalde gegevens bevestigd die reeds bij uw bank bekend zijn, zoals uw naam, adres en geboortedatum.",
        onfidoInfoModal: "Onfido is een betrouwbare dienstverlener die het mogelijk maakt in een beveiligde omgeving, ID-documenten (zoals paspoort of identiteitskaart) van een computer of mobiele telefoon te uploaden.",
        print: "Afdrukken",
        footer: {
            copyright: "Copyright \xa9 2020 ",
            americanExpress: "American Express Company",
            rightsReserved: "Alle rechten, typefouten en prijswijzigingen voorbehouden."
        },
        modalSessionTimer: {
            text: "Uw sessie verloopt bijna.",
            buttonComplete: "Vervolg de sessie",
            buttonLeave: "Later afronden"
        }
    }
};


class $1df4d9529f7e54fa$export$f68b6d5c82b72947 {
    constructor(rootStore){
        this.browserLanguage = window.navigator["userLanguage"] || window.navigator.language // IE fallback: userLanguage
        ;
        this.sessionStartTime = "";
        this.finishLaterVisible = false;
        this.onfidoConfig = {
            documentTypes: {
                passport: true,
                // eslint-disable-next-line @typescript-eslint/camelcase
                driving_licence: false,
                // eslint-disable-next-line @typescript-eslint/camelcase
                national_identity_card: true
            },
            showLoading: true
        };
        this.translations = (0, $726689d1d537df2f$export$9c64ee4d84d79ce1).acquisition;
        (0, $5468eea7b07c745b$export$1cfaca5abb185fe7)(this);
        this.rootStore = rootStore;
    }
    setLanguage(languageSet) {
        this.translations = languageSet;
    }
    setSessionStartTime(sessionStartTime) {
        this.sessionStartTime = sessionStartTime;
    }
    setFinishLaterVisible(finishLaterVisible) {
        this.finishLaterVisible = finishLaterVisible;
    }
    setOnfidoShowLoading(showLoading) {
        this.onfidoConfig.showLoading = showLoading;
    }
    setOnfidoConfig(config) {
        this.onfidoConfig = config;
    }
}
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $1df4d9529f7e54fa$export$f68b6d5c82b72947.prototype, "setLanguage", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $1df4d9529f7e54fa$export$f68b6d5c82b72947.prototype, "setSessionStartTime", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $1df4d9529f7e54fa$export$f68b6d5c82b72947.prototype, "setFinishLaterVisible", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $1df4d9529f7e54fa$export$f68b6d5c82b72947.prototype, "setOnfidoShowLoading", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $1df4d9529f7e54fa$export$f68b6d5c82b72947.prototype, "setOnfidoConfig", null);






/* eslint-disable @typescript-eslint/camelcase */ const $53337d58c2d64731$export$e5ad74579c86b003 = [
    {
        name: "Afghanistan",
        id: "AF",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Albani\xeb",
        id: "AL",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Algerije",
        id: "DZ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Andorra",
        id: "AD",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Angola",
        id: "AO",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Anguilla",
        id: "AI",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Antigua en Barbuda",
        id: "AG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Argentini\xeb",
        id: "AR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Armeni\xeb",
        id: "AM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Australi\xeb",
        id: "AU",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Azerbeidzjan",
        id: "AZ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Bahama's",
        id: "BS",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Bahrein",
        id: "BH",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Bangladesh",
        id: "BD",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Barbados",
        id: "BB",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Belgi\xeb",
        id: "BE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Belize",
        id: "BZ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Benin",
        id: "BJ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Bermuda",
        id: "BM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Bhutan",
        id: "BT",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Bolivia",
        id: "BO",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Bosni\xeb - Herzegovina",
        id: "BA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Botswana",
        id: "BW",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Brazili\xeb",
        id: "BR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Britse Maagdeneilanden",
        id: "VG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Brunei",
        id: "BN",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Bulgarije",
        id: "BG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Burkina Faso",
        id: "BF",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Burundi",
        id: "BI",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Cambodja",
        id: "KH",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Canada",
        id: "CA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Centraal-Afrikaanse Republiek",
        id: "CF",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Chili",
        id: "CL",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "China",
        id: "CN",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Colombia",
        id: "CO",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Comoren",
        id: "KM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Congo (Democratische Republiek)",
        id: "CD",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Congo-Brazzaville",
        id: "CG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Costa Rica",
        id: "CR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Cuba",
        id: "CU",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Cyprus",
        id: "CY",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Denemarken",
        id: "DK",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Djibouti",
        id: "DJ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Dominica",
        id: "DM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Dominicaanse Republiek",
        id: "DO",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Duitsland",
        id: "DE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Ecuador",
        id: "EC",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Egypte",
        id: "EG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "El Salvador",
        id: "SV",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Equatoriaal-Guinea",
        id: "GQ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Eritrea",
        id: "ER",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Estland",
        id: "EE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Ethiopi\xeb",
        id: "ET",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Faer\xf6er Eilanden",
        id: "FO",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Fiji",
        id: "FJ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Filipijnen",
        id: "PH",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Finland",
        id: "FI",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Frankrijk",
        id: "FR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Gabon",
        id: "GA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Gambia",
        id: "GM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Georgi\xeb",
        id: "GE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Ghana",
        id: "GH",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Gibraltar",
        id: "GI",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Grenada",
        id: "GD",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Griekenland",
        id: "GR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Guatemala",
        id: "GT",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Guernsey",
        id: "GG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Guinee",
        id: "GN",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Guinee-Bissau",
        id: "GW",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Guyana",
        id: "GY",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Ha\xefti",
        id: "HT",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Het eiland Man",
        id: "IM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Honduras",
        id: "HN",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Hong Kong",
        id: "HK",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Hongarije",
        id: "HU",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Ierland",
        id: "IE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "IJsland",
        id: "IS",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "India",
        id: "IN",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Indonesi\xeb",
        id: "ID",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Irak",
        id: "IQ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Iran",
        id: "IR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Isra\xebl",
        id: "IL",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Itali\xeb",
        id: "IT",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Ivoorkust",
        id: "CI",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Jamaica",
        id: "JM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Japan",
        id: "JP",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Jemen",
        id: "YE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Jersey",
        id: "JE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Jordani\xeb",
        id: "JO",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Kaaimaneilanden",
        id: "KY",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Kaapverdi\xeb",
        id: "CV",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Kameroen",
        id: "CM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Kazachstan",
        id: "KZ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Kenia",
        id: "KE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Kirgizi\xeb",
        id: "KG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Kiribati",
        id: "KI",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Koeweit",
        id: "KW",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Kosovo",
        id: "XK",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Kroati\xeb",
        id: "HR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Laos",
        id: "LA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Lesotho",
        id: "LS",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Letland",
        id: "LV",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Libanon",
        id: "LB",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Liberia",
        id: "LR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Libi\xeb",
        id: "LY",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Liechtenstein",
        id: "LI",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Litouwen",
        id: "LT",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Luxemburg",
        id: "LU",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Madagaskar",
        id: "MG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Malawi",
        id: "MW",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Maldiven",
        id: "MV",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Maleisi\xeb",
        id: "MY",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Mali",
        id: "ML",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Malta",
        id: "MT",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Marokko",
        id: "MA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Marshalleilanden",
        id: "MH",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Mauritani\xeb",
        id: "MR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Mauritius",
        id: "MU",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Mexico",
        id: "MX",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Micronesi\xeb",
        id: "FM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Moldavi\xeb",
        id: "MD",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Monaco",
        id: "MC",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Mongoli\xeb",
        id: "MN",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Montenegro",
        id: "ME",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Montserrat",
        id: "MS",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Mozambique",
        id: "MZ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Myanmar",
        id: "MM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Namibi\xeb",
        id: "NA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Nauru",
        id: "NR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Nederland",
        id: "NL",
        documentTypes: {
            passport: true,
            driving_licence: true,
            national_identity_card: true
        }
    },
    {
        name: "Nepal",
        id: "NP",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Nicaragua",
        id: "NI",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Nieuw-Zeeland",
        id: "NZ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Niger",
        id: "NE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Nigeria",
        id: "NG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Noord-Korea",
        id: "KP",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Noord-Macedoni\xeb",
        id: "MK",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Noorwegen",
        id: "NO",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Oeganda",
        id: "UG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Oekra\xefne",
        id: "UA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Oezbekistan",
        id: "UZ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Oman",
        id: "OM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Oostenrijk",
        id: "AT",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Oost-Timor",
        id: "TL",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Pakistan",
        id: "PK",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Palau",
        id: "PW",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Palestina",
        id: "PS",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Panama",
        id: "PA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Papoea-Nieuw-Guinea",
        id: "PG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Paraguay",
        id: "PY",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Peru",
        id: "PE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Polen",
        id: "PL",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Portugal",
        id: "PT",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Puerto Rico",
        id: "PR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Qatar",
        id: "QA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Roemeni\xeb",
        id: "RO",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Rusland",
        id: "RU",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Rwanda",
        id: "RW",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Saint Kitts en Nevis",
        id: "KN",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Saint Vincent en The Grenadines",
        id: "VC",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Saint-Lucia",
        id: "LC",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Salomonseilanden",
        id: "SB",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "San Marino",
        id: "SM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Sao Tom\xe9 en Principe",
        id: "ST",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Saoedi-Arabi\xeb",
        id: "SA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Senegal",
        id: "SN",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Servi\xeb",
        id: "RS",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Seychellen",
        id: "SC",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Sierra Leone",
        id: "SL",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Singapor",
        id: "SG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Sloveni\xeb",
        id: "SI",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Slowakije",
        id: "SK",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Soedan",
        id: "SD",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Somali\xeb",
        id: "SO",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Somoa",
        id: "WS",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Spanje",
        id: "ES",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Sri Lanka",
        id: "LK",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Suriname",
        id: "SR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Swaziland",
        id: "SZ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Syri\xeb",
        id: "SY",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Tadzjikistan",
        id: "TJ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Taiwan",
        id: "TW",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Tanzania",
        id: "TZ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Thailand",
        id: "TH",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Togo",
        id: "TG",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Tonga",
        id: "TO",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Trinidad en Tobago",
        id: "TT",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Tsjaad",
        id: "TD",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Tsjechi\xeb",
        id: "CZ",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Tunesi\xeb",
        id: "TN",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Turkije",
        id: "TR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Turkmenistan",
        id: "TM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Turks- en Caicoseilanden",
        id: "TC",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Tuvalu",
        id: "TV",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Uruguay",
        id: "UY",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Vaticaanstad",
        id: "VA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Venezuela",
        id: "VE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Venuatu",
        id: "VU",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Verenigd Koninkrijk",
        id: "GB",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Verenigde Arabische Emiraten",
        id: "AE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Verenigde Staten van Amerika",
        id: "US",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Vietnam",
        id: "VN",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Wit-Rusland",
        id: "BY",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Zambia",
        id: "ZM",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Zimbabwe",
        id: "ZW",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Zuid-Afrika",
        id: "ZA",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Zuid-Korea",
        id: "KR",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Zuid-Soedan",
        id: "SS",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    },
    {
        name: "Zweden",
        id: "SE",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: true
        }
    },
    {
        name: "Zwisterland",
        id: "CH",
        documentTypes: {
            passport: true,
            driving_licence: false,
            national_identity_card: false
        }
    }
];


class $3f1129e68b885a55$export$a1a64b19a64b069 {
    constructor(rootStore){
        this.selectedCountry = "";
        this.sdkToken = "";
        this.attemptId = "";
        this.webHook = "";
        this.pcn = "";
        this.clic = "";
        this.flow = (0, $45843b22ada4386e$export$2707f038bb5e8d05);
        this.redirectUri = "";
        this.forceMobile = false;
        this.onfidoNew = "0";
        (0, $5468eea7b07c745b$export$1cfaca5abb185fe7)(this);
        this.rootStore = rootStore;
        (0, $5468eea7b07c745b$export$7203b476385689ae)(()=>this.selectedCountry, ()=>{
            if (this.selectedCountry.length) {
                const country = (0, $53337d58c2d64731$export$e5ad74579c86b003).find((country)=>country.id.toLowerCase() === this.selectedCountry.toLowerCase());
                this.rootStore.AppConfig.setOnfidoConfig({
                    ...this.rootStore.AppConfig.onfidoConfig,
                    documentTypes: country.documentTypes
                });
            }
        });
    }
    setSelectedCountry(country) {
        this.selectedCountry = country;
    }
    setSdkToken(sdkToken) {
        this.sdkToken = sdkToken;
    }
    setAttemptId(attemptId) {
        this.attemptId = attemptId;
    }
    setWebHook(webHook) {
        this.webHook = webHook;
    }
    setPcn(pcn) {
        this.pcn = pcn;
    }
    setClic(clic) {
        this.clic = clic;
    }
    setFlow(flow) {
        this.flow = flow;
        if (flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05)) this.rootStore.AppConfig.setLanguage((0, $726689d1d537df2f$export$9c64ee4d84d79ce1).acquisition);
        if (flow === (0, $45843b22ada4386e$export$7d1b589b83d5fb2e)) this.rootStore.AppConfig.setLanguage((0, $726689d1d537df2f$export$9c64ee4d84d79ce1).remediation);
    }
    setRedirectUri(redirectUri) {
        this.redirectUri = redirectUri;
    }
    setForceMobile(forceMobile) {
        this.forceMobile = forceMobile;
    }
    setOnfidoNew(onfidoNew) {
        this.onfidoNew = onfidoNew;
    }
}
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $3f1129e68b885a55$export$a1a64b19a64b069.prototype, "setSelectedCountry", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $3f1129e68b885a55$export$a1a64b19a64b069.prototype, "setSdkToken", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $3f1129e68b885a55$export$a1a64b19a64b069.prototype, "setAttemptId", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $3f1129e68b885a55$export$a1a64b19a64b069.prototype, "setWebHook", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $3f1129e68b885a55$export$a1a64b19a64b069.prototype, "setPcn", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $3f1129e68b885a55$export$a1a64b19a64b069.prototype, "setClic", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $3f1129e68b885a55$export$a1a64b19a64b069.prototype, "setFlow", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $3f1129e68b885a55$export$a1a64b19a64b069.prototype, "setRedirectUri", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $3f1129e68b885a55$export$a1a64b19a64b069.prototype, "setForceMobile", null);
(0, $4210dc1af4009341$export$29e00dfd3077644b)([
    (0, $5468eea7b07c745b$export$31eb53bd5b582a97).bound
], $3f1129e68b885a55$export$a1a64b19a64b069.prototype, "setOnfidoNew", null);


class $6a0b0eac07d647c3$export$5b19c597f1926e87 {
    constructor(){
        this.AppState = new (0, $ce86999d70e24b03$export$a7fbe9ff12d812bf)(this);
        this.AppConfig = new (0, $1df4d9529f7e54fa$export$f68b6d5c82b72947)(this);
        this.ClientState = new (0, $3f1129e68b885a55$export$a1a64b19a64b069)(this);
    }
}
const $6a0b0eac07d647c3$export$8ee67b622d91e484 = new $6a0b0eac07d647c3$export$5b19c597f1926e87();



parcelRequire("hJwnw");
var $79d12c4f62fb62d8$exports = {};


$79d12c4f62fb62d8$exports = (parcelRequire("ef61Y")).getBundleURL("eot5l") + (parcelRequire("5pfIs")).resolve("lhX5j");



const $3a90b4fb2a20515c$export$1ca1e38143dcc152 = ()=>{
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
        className: "topbar",
        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
            href: "https://www.americanexpress.com/nl/",
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($79d12c4f62fb62d8$exports)))
            })
        })
    });
};




var $hJwnw = parcelRequire("hJwnw");
var $f793f10c8744cbcb$exports = {};
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) classes.push(inner);
            } else if (argType === "object") {
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $f793f10c8744cbcb$exports) {
        classNames.default = classNames;
        $f793f10c8744cbcb$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();




var $hJwnw = parcelRequire("hJwnw");

var $b9e73c0b2a621f3b$var$symbolId = 0;
function $b9e73c0b2a621f3b$var$createSymbol(name) {
    if (typeof Symbol === "function") return Symbol(name);
    var symbol = "__$mobx-react " + name + " (" + $b9e73c0b2a621f3b$var$symbolId + ")";
    $b9e73c0b2a621f3b$var$symbolId++;
    return symbol;
}
var $b9e73c0b2a621f3b$var$createdSymbols = {};
function $b9e73c0b2a621f3b$var$newSymbol(name) {
    if (!$b9e73c0b2a621f3b$var$createdSymbols[name]) $b9e73c0b2a621f3b$var$createdSymbols[name] = $b9e73c0b2a621f3b$var$createSymbol(name);
    return $b9e73c0b2a621f3b$var$createdSymbols[name];
}
function $b9e73c0b2a621f3b$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($b9e73c0b2a621f3b$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$b9e73c0b2a621f3b$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $b9e73c0b2a621f3b$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
} // based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $b9e73c0b2a621f3b$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    propTypes: 1
};
function $b9e73c0b2a621f3b$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$b9e73c0b2a621f3b$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */ function $b9e73c0b2a621f3b$var$setHiddenProp(target, prop, value) {
    if (!Object.hasOwnProperty.call(target, prop)) Object.defineProperty(target, prop, {
        enumerable: false,
        configurable: true,
        writable: true,
        value: value
    });
    else target[prop] = value;
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $b9e73c0b2a621f3b$var$mobxMixins = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("patchMixins");
var $b9e73c0b2a621f3b$var$mobxPatchedDefinition = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("patchedDefinition");
function $b9e73c0b2a621f3b$var$getMixins(target, methodName) {
    var mixins = target[$b9e73c0b2a621f3b$var$mobxMixins] = target[$b9e73c0b2a621f3b$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $b9e73c0b2a621f3b$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $b9e73c0b2a621f3b$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $b9e73c0b2a621f3b$var$wrapper.call.apply($b9e73c0b2a621f3b$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $b9e73c0b2a621f3b$var$patch(target, methodName, mixinMethod) {
    var mixins = $b9e73c0b2a621f3b$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$b9e73c0b2a621f3b$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $b9e73c0b2a621f3b$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $b9e73c0b2a621f3b$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $b9e73c0b2a621f3b$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$b9e73c0b2a621f3b$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $b9e73c0b2a621f3b$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $b9e73c0b2a621f3b$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $b9e73c0b2a621f3b$var$mobxAdminProperty = (0, $5468eea7b07c745b$export$f246528900dd4467) || "$mobx";
var $b9e73c0b2a621f3b$var$mobxObserverProperty = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("isMobXReactObserver");
var $b9e73c0b2a621f3b$var$mobxIsUnmounted = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("isUnmounted");
var $b9e73c0b2a621f3b$var$skipRenderKey = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("skipRender");
var $b9e73c0b2a621f3b$var$isForcingUpdateKey = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("isForcingUpdate");
function $b9e73c0b2a621f3b$var$makeClassComponentObserver(componentClass) {
    var target = componentClass.prototype;
    if (componentClass[$b9e73c0b2a621f3b$var$mobxObserverProperty]) {
        var displayName = $b9e73c0b2a621f3b$var$getDisplayName(target);
        console.warn("The provided component class (" + displayName + ") \n                has already been declared as an observer component.");
    } else componentClass[$b9e73c0b2a621f3b$var$mobxObserverProperty] = true;
    if (target.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $hJwnw.PureComponent)) {
        if (!target.shouldComponentUpdate) target.shouldComponentUpdate = $b9e73c0b2a621f3b$var$observerSCU;
        else if (target.shouldComponentUpdate !== $b9e73c0b2a621f3b$var$observerSCU) throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    } // this.props and this.state are made observable, just to make sure @computed fields that
    // are defined inside the component, and which rely on state or props, re-compute if state or props change
    // (otherwise the computed wouldn't update and become stale on props change, since props are not observable)
    // However, this solution is not without it's own problems: https://github.com/mobxjs/mobx-react/issues?utf8=%E2%9C%93&q=is%3Aissue+label%3Aobservable-props-or-not+
    $b9e73c0b2a621f3b$var$makeObservableProp(target, "props");
    $b9e73c0b2a621f3b$var$makeObservableProp(target, "state");
    var baseRender = target.render;
    target.render = function() {
        return $b9e73c0b2a621f3b$var$makeComponentReactive.call(this, baseRender);
    };
    $b9e73c0b2a621f3b$var$patch(target, "componentWillUnmount", function() {
        var _this$render$mobxAdmi;
        if ((0, $57fce153bb7d82b4$export$55979271896d643e)() === true) return;
        (_this$render$mobxAdmi = this.render[$b9e73c0b2a621f3b$var$mobxAdminProperty]) == null || _this$render$mobxAdmi.dispose();
        this[$b9e73c0b2a621f3b$var$mobxIsUnmounted] = true;
        if (!this.render[$b9e73c0b2a621f3b$var$mobxAdminProperty]) {
            // Render may have been hot-swapped and/or overriden by a subclass.
            var _displayName = $b9e73c0b2a621f3b$var$getDisplayName(this);
            console.warn("The reactive render of an observer class component (" + _displayName + ") \n                was overriden after MobX attached. This may result in a memory leak if the \n                overriden reactive render was not properly disposed.");
        }
    });
    return componentClass;
} // Generates a friendly name for debugging
function $b9e73c0b2a621f3b$var$getDisplayName(comp) {
    return comp.displayName || comp.name || comp.constructor && (comp.constructor.displayName || comp.constructor.name) || "<component>";
}
function $b9e73c0b2a621f3b$var$makeComponentReactive(render) {
    var _this = this;
    if ((0, $57fce153bb7d82b4$export$55979271896d643e)() === true) return render.call(this);
    /**
   * If props are shallowly modified, react will render anyway,
   * so atom.reportChanged() should not result in yet another re-render
   */ $b9e73c0b2a621f3b$var$setHiddenProp(this, $b9e73c0b2a621f3b$var$skipRenderKey, false);
    /**
   * forceUpdate will re-assign this.props. We don't want that to cause a loop,
   * so detect these changes
   */ $b9e73c0b2a621f3b$var$setHiddenProp(this, $b9e73c0b2a621f3b$var$isForcingUpdateKey, false);
    var initialName = $b9e73c0b2a621f3b$var$getDisplayName(this);
    var baseRender = render.bind(this);
    var isRenderingPending = false;
    var reaction = new (0, $5468eea7b07c745b$export$d2ae4167a30cf6bb)(initialName + ".render()", function() {
        if (!isRenderingPending) {
            // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
            // This unidiomatic React usage but React will correctly warn about this so we continue as usual
            // See #85 / Pull #44
            isRenderingPending = true;
            if (_this[$b9e73c0b2a621f3b$var$mobxIsUnmounted] !== true) {
                var hasError = true;
                try {
                    $b9e73c0b2a621f3b$var$setHiddenProp(_this, $b9e73c0b2a621f3b$var$isForcingUpdateKey, true);
                    if (!_this[$b9e73c0b2a621f3b$var$skipRenderKey]) (0, $hJwnw.Component).prototype.forceUpdate.call(_this);
                    hasError = false;
                } finally{
                    $b9e73c0b2a621f3b$var$setHiddenProp(_this, $b9e73c0b2a621f3b$var$isForcingUpdateKey, false);
                    if (hasError) reaction.dispose();
                }
            }
        }
    });
    reaction["reactComponent"] = this;
    reactiveRender[$b9e73c0b2a621f3b$var$mobxAdminProperty] = reaction;
    this.render = reactiveRender;
    function reactiveRender() {
        isRenderingPending = false;
        var exception = undefined;
        var rendering = undefined;
        reaction.track(function() {
            try {
                rendering = (0, $5468eea7b07c745b$export$e510c5d1ea4358b1)(false, baseRender);
            } catch (e) {
                exception = e;
            }
        });
        if (exception) throw exception;
        return rendering;
    }
    return reactiveRender.call(this);
}
function $b9e73c0b2a621f3b$var$observerSCU(nextProps, nextState) {
    if ((0, $57fce153bb7d82b4$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
     // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
     // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$b9e73c0b2a621f3b$var$shallowEqual(this.props, nextProps);
}
function $b9e73c0b2a621f3b$var$makeObservableProp(target, propName) {
    var valueHolderKey = $b9e73c0b2a621f3b$var$newSymbol("reactProp_" + propName + "_valueHolder");
    var atomHolderKey = $b9e73c0b2a621f3b$var$newSymbol("reactProp_" + propName + "_atomHolder");
    function getAtom() {
        if (!this[atomHolderKey]) $b9e73c0b2a621f3b$var$setHiddenProp(this, atomHolderKey, (0, $5468eea7b07c745b$export$2e17fe64ec9a826e)("reactive " + propName));
        return this[atomHolderKey];
    }
    Object.defineProperty(target, propName, {
        configurable: true,
        enumerable: true,
        get: function get() {
            var prevReadState = false;
            if ((0, $5468eea7b07c745b$export$84c93b6404d77e6f) && (0, $5468eea7b07c745b$export$c7b7fb1b2b410642)) prevReadState = (0, $5468eea7b07c745b$export$84c93b6404d77e6f)(true);
            getAtom.call(this).reportObserved();
            if ((0, $5468eea7b07c745b$export$84c93b6404d77e6f) && (0, $5468eea7b07c745b$export$c7b7fb1b2b410642)) (0, $5468eea7b07c745b$export$c7b7fb1b2b410642)(prevReadState);
            return this[valueHolderKey];
        },
        set: function set(v) {
            if (!this[$b9e73c0b2a621f3b$var$isForcingUpdateKey] && !$b9e73c0b2a621f3b$var$shallowEqual(this[valueHolderKey], v)) {
                $b9e73c0b2a621f3b$var$setHiddenProp(this, valueHolderKey, v);
                $b9e73c0b2a621f3b$var$setHiddenProp(this, $b9e73c0b2a621f3b$var$skipRenderKey, true);
                getAtom.call(this).reportChanged();
                $b9e73c0b2a621f3b$var$setHiddenProp(this, $b9e73c0b2a621f3b$var$skipRenderKey, false);
            } else $b9e73c0b2a621f3b$var$setHiddenProp(this, valueHolderKey, v);
        }
    });
}
var $b9e73c0b2a621f3b$var$hasSymbol = typeof Symbol === "function" && Symbol["for"]; // Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $b9e73c0b2a621f3b$var$ReactForwardRefSymbol = $b9e73c0b2a621f3b$var$hasSymbol ? /*#__PURE__*/ Symbol["for"]("react.forward_ref") : typeof (0, $hJwnw.forwardRef) === "function" && /*#__PURE__*/ (0, $hJwnw.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $b9e73c0b2a621f3b$var$ReactMemoSymbol = $b9e73c0b2a621f3b$var$hasSymbol ? /*#__PURE__*/ Symbol["for"]("react.memo") : typeof (0, $hJwnw.memo) === "function" && /*#__PURE__*/ (0, $hJwnw.memo)(function(props) {
    return null;
})["$$typeof"];
/**
 * Observer function / decorator
 */ function $b9e73c0b2a621f3b$export$b6ae1bc530f4c149(component) {
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    if ($b9e73c0b2a621f3b$var$ReactMemoSymbol && component["$$typeof"] === $b9e73c0b2a621f3b$var$ReactMemoSymbol) throw new Error("Mobx observer: You are trying to use 'observer' on a function component wrapped in either another observer or 'React.memo'. The observer already applies 'React.memo' for you.");
     // Unwrap forward refs into `<Observer>` component
    // we need to unwrap the render, because it is the inner render that needs to be tracked,
    // not the ForwardRef HoC
    if ($b9e73c0b2a621f3b$var$ReactForwardRefSymbol && component["$$typeof"] === $b9e73c0b2a621f3b$var$ReactForwardRefSymbol) {
        var baseRender = component["render"];
        if (typeof baseRender !== "function") throw new Error("render property of ForwardRef was not a function");
        return (0, $hJwnw.forwardRef)(function ObserverForwardRef() {
            var args = arguments;
            return (0, $hJwnw.createElement)((0, $ff3e86dda4e11099$export$c1cbdee04e18ea8b), null, function() {
                return baseRender.apply(undefined, args);
            });
        });
    } // Function component
    if (typeof component === "function" && (!component.prototype || !component.prototype.render) && !component["isReactClass"] && !Object.prototype.isPrototypeOf.call((0, $hJwnw.Component), component)) return (0, $7eec34e2bbf7c2a1$export$b6ae1bc530f4c149)(component);
    return $b9e73c0b2a621f3b$var$makeClassComponentObserver(component);
}
function $b9e73c0b2a621f3b$var$_extends() {
    $b9e73c0b2a621f3b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b9e73c0b2a621f3b$var$_extends.apply(this, arguments);
}
function $b9e73c0b2a621f3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b9e73c0b2a621f3b$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createContext({});
function $b9e73c0b2a621f3b$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $b9e73c0b2a621f3b$var$_objectWithoutPropertiesLoose(props, [
        "children"
    ]);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useContext($b9e73c0b2a621f3b$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useRef($b9e73c0b2a621f3b$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement($b9e73c0b2a621f3b$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$b9e73c0b2a621f3b$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $b9e73c0b2a621f3b$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).forwardRef(function(props, ref) {
        var newProps = $b9e73c0b2a621f3b$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useContext($b9e73c0b2a621f3b$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $b9e73c0b2a621f3b$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $b9e73c0b2a621f3b$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $b9e73c0b2a621f3b$var$getInjectName(component, injectNames);
    return Injector;
}
function $b9e73c0b2a621f3b$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $b9e73c0b2a621f3b$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $b9e73c0b2a621f3b$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $b9e73c0b2a621f3b$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $b9e73c0b2a621f3b$var$createStoreInjector($b9e73c0b2a621f3b$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $b9e73c0b2a621f3b$var$protoStoreKey = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("disposeOnUnmountProto");
var $b9e73c0b2a621f3b$var$instStoreKey = /*#__PURE__*/ $b9e73c0b2a621f3b$var$newSymbol("disposeOnUnmountInst");
function $b9e73c0b2a621f3b$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$b9e73c0b2a621f3b$var$protoStoreKey] || [], this[$b9e73c0b2a621f3b$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
function $b9e73c0b2a621f3b$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $b9e73c0b2a621f3b$export$4e749cb731da87a9(target, fn);
    });
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor); // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
     // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string"; // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$b9e73c0b2a621f3b$var$protoStoreKey] || !!target[$b9e73c0b2a621f3b$var$instStoreKey];
    var store = isDecorator ? target[$b9e73c0b2a621f3b$var$protoStoreKey] || (target[$b9e73c0b2a621f3b$var$protoStoreKey] = []) : target[$b9e73c0b2a621f3b$var$instStoreKey] || (target[$b9e73c0b2a621f3b$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $b9e73c0b2a621f3b$var$patch(target, "componentWillUnmount", $b9e73c0b2a621f3b$var$runDisposersOnWillUnmount);
     // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
function $b9e73c0b2a621f3b$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $5468eea7b07c745b$export$8c437e4d572e2f99)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false); // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
} // Copied from React.PropTypes
function $b9e73c0b2a621f3b$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
     // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
     // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
} // Copied from React.PropTypes
function $b9e73c0b2a621f3b$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($b9e73c0b2a621f3b$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
} // This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $b9e73c0b2a621f3b$var$getPreciseType(propValue) {
    var propType = $b9e73c0b2a621f3b$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $b9e73c0b2a621f3b$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $5468eea7b07c745b$export$8c437e4d572e2f99)(function() {
            if (allowNativeType) {
                if ($b9e73c0b2a621f3b$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $5468eea7b07c745b$export$f5afceff386badf9);
                    break;
                case "Object":
                    mobxChecker = (0, $5468eea7b07c745b$export$31960fb081a18155);
                    break;
                case "Map":
                    mobxChecker = (0, $5468eea7b07c745b$export$27a7faddcfd44960);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $b9e73c0b2a621f3b$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $b9e73c0b2a621f3b$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $b9e73c0b2a621f3b$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $5468eea7b07c745b$export$8c437e4d572e2f99)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $b9e73c0b2a621f3b$var$observableArray = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(false, "Array");
var $b9e73c0b2a621f3b$var$observableArrayOf = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableArrayOfTypeChecker.bind(null, false);
var $b9e73c0b2a621f3b$var$observableMap = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(false, "Map");
var $b9e73c0b2a621f3b$var$observableObject = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(false, "Object");
var $b9e73c0b2a621f3b$var$arrayOrObservableArray = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(true, "Array");
var $b9e73c0b2a621f3b$var$arrayOrObservableArrayOf = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableArrayOfTypeChecker.bind(null, true);
var $b9e73c0b2a621f3b$var$objectOrObservableObject = /*#__PURE__*/ $b9e73c0b2a621f3b$var$createObservableTypeCheckerCreator(true, "Object");
var $b9e73c0b2a621f3b$export$e0c95a451cd220b7 = {
    observableArray: $b9e73c0b2a621f3b$var$observableArray,
    observableArrayOf: $b9e73c0b2a621f3b$var$observableArrayOf,
    observableMap: $b9e73c0b2a621f3b$var$observableMap,
    observableObject: $b9e73c0b2a621f3b$var$observableObject,
    arrayOrObservableArray: $b9e73c0b2a621f3b$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $b9e73c0b2a621f3b$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $b9e73c0b2a621f3b$var$objectOrObservableObject
};
if (!(0, $hJwnw.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $5468eea7b07c745b$export$5ab46cbf6120b33a)) throw new Error("mobx-react requires mobx to be available");




parcelRequire("hJwnw");

const $ce888247d742db17$export$2b77a92f1a5ad772 = ({ children: children, modalVisible: modalVisible, setModalVisible: setModalVisible })=>{
    return modalVisible ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
        className: "modal-overlay",
        children: [
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                className: "modal-overlay-bg",
                onClick: ()=>setModalVisible(false)
            }),
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                className: "modal",
                children: [
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                        className: "modal-close",
                        onClick: ()=>setModalVisible(false)
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                        className: "modal--inner",
                        children: children
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {});
};


var $ed615beef7229e84$exports = {};


$ed615beef7229e84$exports = (parcelRequire("ef61Y")).getBundleURL("eot5l") + (parcelRequire("5pfIs")).resolve("f2x3T");


var $402704ae93060332$exports = {};


$402704ae93060332$exports = (parcelRequire("ef61Y")).getBundleURL("eot5l") + (parcelRequire("5pfIs")).resolve("aBEzp");




const $7b4509ffc6ef60a7$var$isEdgeChromium = !!window["chrome"] && (!!window["chrome"].webstore || !!window["chrome"].runtime) && navigator.userAgent.indexOf("Edg") != -1;
const $7b4509ffc6ef60a7$var$Step = ({ content: content, labels: labels, current: current, learnMore: learnMore, stepIndex: stepIndex, handleLearnMore: handleLearnMore, classNames: classNames })=>{
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
        className: `step ${content.status} ${content.step === current.step ? "active" : ""} step-${stepIndex + 1} ${classNames ? classNames : ""}`,
        children: [
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                className: `step__count ${$7b4509ffc6ef60a7$var$isEdgeChromium ? "step__auto-height" : ""}`,
                children: content.status === "done" ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                    className: "icon-step-done"
                }) : content.step
            }),
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                className: "step__label",
                children: labels[content.label]
            }),
            content.link && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
                href: "#",
                onClick: ()=>handleLearnMore(content.link),
                children: learnMore
            })
        ]
    });
};
const $7b4509ffc6ef60a7$export$fb587a27d5a722e7 = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const [idinModal, setIdinModal] = (0, $hJwnw.useState)(false);
    const [onfidoModal, setOnfidoModal] = (0, $hJwnw.useState)(false);
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { currentStep: currentStep, steps: steps, showSteps: showSteps } = store.AppState;
    const { flow: flow } = store.ClientState;
    const { translations: translations } = store.AppConfig;
    const { stepsLabels: stepsLabels, learnMore: learnMore } = translations;
    const handleLearnMore = (modalName)=>{
        if (modalName) {
            if (modalName === "idin") setIdinModal(true);
            else if (modalName === "onfido") setOnfidoModal(true);
        }
    };
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)((0, $hJwnw.Fragment), {
        children: [
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                className: "steps__wrapper",
                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f793f10c8744cbcb$exports)))("steps", showSteps ? "" : "steps--hidden", flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) ? "withApplication" : ""),
                    children: [
                        flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) && steps.map((item, index)=>/*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)($7b4509ffc6ef60a7$var$Step, {
                                content: item,
                                labels: stepsLabels,
                                current: currentStep,
                                learnMore: learnMore,
                                stepIndex: index,
                                handleLearnMore: handleLearnMore
                            }, index + 1)),
                        flow === (0, $45843b22ada4386e$export$7d1b589b83d5fb2e) && steps.slice(1).map((item, index)=>/*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)($7b4509ffc6ef60a7$var$Step, {
                                content: {
                                    ...item,
                                    step: item.step - 1
                                },
                                labels: stepsLabels,
                                current: {
                                    ...currentStep,
                                    step: currentStep.step - 1
                                },
                                learnMore: learnMore,
                                stepIndex: index,
                                handleLearnMore: handleLearnMore,
                                classNames: "noApplication"
                            }, index + 1))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $ce888247d742db17$export$2b77a92f1a5ad772), {
                modalVisible: idinModal,
                setModalVisible: setIdinModal,
                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                    className: "modal--idin-steps",
                    children: [
                        /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($402704ae93060332$exports)))
                        }),
                        /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                            children: translations.idinInfoModal
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $ce888247d742db17$export$2b77a92f1a5ad772), {
                modalVisible: onfidoModal,
                setModalVisible: setOnfidoModal,
                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                    className: "modal--onfido-steps",
                    children: [
                        /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ed615beef7229e84$exports)))
                        }),
                        /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                            children: translations.onfidoInfoModal
                        })
                    ]
                })
            })
        ]
    });
});




var $hJwnw = parcelRequire("hJwnw");




var $hJwnw = parcelRequire("hJwnw");







var $hJwnw = parcelRequire("hJwnw");

const $ddcb2c7b91838bec$export$d6701e98ab1a6725 = ({ categories: categories, onChange: onChange, placeholder: placeholder = "Select" })=>{
    const node = (0, $hJwnw.useRef)(null);
    const [currentValue, setCurrentValue] = (0, $hJwnw.useState)({
        name: "",
        value: ""
    });
    const [listVisible, setListVisible] = (0, $hJwnw.useState)(false);
    const handleValue = (value)=>{
        setCurrentValue(value);
        setListVisible(false);
    };
    const handleOutsideClick = (event)=>{
        if (node.current.contains(event.target)) return;
        setListVisible(false);
    };
    (0, $hJwnw.useEffect)(()=>{
        onChange(currentValue);
    }, [
        currentValue
    ]);
    (0, $hJwnw.useEffect)(()=>{
        document.addEventListener("mousedown", handleOutsideClick);
        return ()=>{
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
        className: `select-input ${listVisible ? "select-input--focus" : ""}`,
        ref: node,
        children: [
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                className: "select-input__value",
                onClick: ()=>setListVisible(!listVisible),
                children: [
                    currentValue.name.length ? currentValue.name : placeholder,
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                        className: `select-input__arrow ${listVisible ? "select-input__arrow--down" : "select-input__arrow--up"}`
                    })
                ]
            }),
            listVisible && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("ul", {
                className: "select-input__list",
                children: categories.map((category)=>/*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                                className: "select-input__category-name",
                                children: category.name
                            }),
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("ul", {
                                children: category.values.map((value)=>/*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("li", {
                                        className: value.value,
                                        onClick: ()=>handleValue(value),
                                        children: value.name
                                    }, value.value))
                            })
                        ]
                    }, category.name))
            })
        ]
    });
};





const $fcbc31c3a20ef8e6$export$34c5a9262f934fa5 = (variable)=>{
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for(let i = 0; i < vars.length; i++){
        const pair = vars[i].split("=");
        if (pair[0] == variable) return pair[1];
    }
    return false;
};


const $4356e789fc213a2a$export$bb7166d635bfa18e = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const [selectValue, setSelectValue] = (0, $hJwnw.useState)("");
    const [list, setList] = (0, $hJwnw.useState)([]);
    const [infoModalVisible, setInfoModalVisible] = (0, $hJwnw.useState)(false);
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { translations: translations } = store.AppConfig;
    const { pcn: pcn, clic: clic, flow: flow, attemptId: attemptId } = store.ClientState;
    const handleListData = (listData)=>{
        const output = Object.keys(listData).map((category)=>{
            return {
                name: category,
                values: listData[category].map((value)=>{
                    return {
                        name: value.issuerName,
                        value: value.issuerID
                    };
                })
            };
        });
        setList(output);
    };
    const handleSubmit = ()=>{
        if (selectValue && selectValue.length) window.location.href = `${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/proceed/eid/${selectValue}`;
    };
    const handleSkipIdin = async ()=>{
        try {
            await (0, $cd771979e180c558$export$2e2bcd8739ae039).request({
                method: "POST",
                url: `${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/idin/skipped`,
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json"
                },
                data: {}
            });
        } catch (e) {
            if (e.response?.status === 403) store.AppState.changePage("error", 1);
            else console.log(e);
        }
    };
    const handleGoToOnfido = async ()=>{
        try {
            await handleSkipIdin();
            setInfoModalVisible(false);
            const onfidoNew = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("onfido_new");
            store.AppConfig.setOnfidoShowLoading(false);
            store.AppState.changePage("uploadid", 1);
            store.AppState.setSteps([
                (0, $f39ce8075185c88d$export$be3f796aed065412)[0],
                {
                    ...(0, $f39ce8075185c88d$export$be3f796aed065412)[1],
                    status: "done"
                },
                {
                    ...(0, $f39ce8075185c88d$export$be3f796aed065412)[2],
                    status: ""
                }
            ]);
            if (pcn !== "") window.history.pushState("", "", `/?step=onfido-no-loader&pcn=${pcn}&attemptId=${attemptId}flow=${flow}${onfidoNew && onfidoNew.length ? "&onfido_new=1&force_mobile=true" : ""}`);
            if (clic !== "") window.history.pushState("", "", `/?step=onfido-no-loader&clic=${clic}&attemptId=${attemptId}&flow=${flow}${onfidoNew && onfidoNew.length ? "&onfido_new=1&force_mobile=true" : ""}`);
        } catch (e) {
            console.log(e);
            store.AppState.changePage("error", 1);
        }
    };
    (0, $hJwnw.useEffect)(()=>{
        const fetchList = async ()=>{
            try {
                const result = await (0, $cd771979e180c558$export$2e2bcd8739ae039).request({
                    method: "GET",
                    url: `${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/banks`,
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: {}
                });
                handleListData(result.data);
            } catch (e) {
                store.AppState.changePage("error", 1);
            }
        };
        fetchList();
    }, []);
    const { heading: heading, loginToYourBank: loginToYourBank, pleaseChoseYourBank: pleaseChoseYourBank, modal: modal, bankNotListed: bankNotListed } = translations.pageBankSelection;
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)((0, $40ac97942f716825$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                className: "page page--bank-selection",
                children: [
                    flow !== (0, $45843b22ada4386e$export$2707f038bb5e8d05) ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                        className: "idin-logo--container",
                        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("img", {
                            className: "idin-logo--image",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($402704ae93060332$exports)))
                        })
                    }) : "",
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("h1", {
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                        className: "line centered subtitle",
                        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                            className: "text",
                            children: loginToYourBank
                        })
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                        className: "bank-select--wrapper",
                        children: [
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $ddcb2c7b91838bec$export$d6701e98ab1a6725), {
                                onChange: (item)=>{
                                    setSelectValue(item.value);
                                },
                                categories: list,
                                placeholder: pleaseChoseYourBank
                            }),
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                                className: "line centered",
                                children: [
                                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("button", {
                                        className: "btn",
                                        disabled: !selectValue.length,
                                        onClick: ()=>handleSubmit(),
                                        children: translations.continueLabel
                                    }),
                                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
                                        href: "#",
                                        onClick: ()=>setInfoModalVisible(true),
                                        children: bankNotListed
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $ce888247d742db17$export$2b77a92f1a5ad772), {
                setModalVisible: setInfoModalVisible,
                modalVisible: infoModalVisible,
                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                    className: "modal--bank-selection",
                    children: [
                        /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("h2", {
                            children: modal.heading
                        }),
                        /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                            className: "line centered",
                            children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                                children: modal.text
                            })
                        }),
                        /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
                            className: "btn line",
                            onClick: ()=>handleGoToOnfido(),
                            children: modal.continue
                        }),
                        /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
                            className: "btn btn--bordered",
                            onClick: ()=>setInfoModalVisible(false),
                            children: modal.goBack
                        })
                    ]
                })
            })
        ]
    });
});




var $hJwnw = parcelRequire("hJwnw");
var $b360ccb1ae1ee64e$exports = {};

$parcel$export($b360ccb1ae1ee64e$exports, "UploadIdStart", function () { return $b360ccb1ae1ee64e$export$59ce2961430906cb; });


var $hJwnw = parcelRequire("hJwnw");



function $8f3817af52d94be1$export$5ddf9e484e541d6f(t) {
    return (t = t || (0, $cd771979e180c558$export$2e2bcd8739ae039)).interceptors.response.use($8f3817af52d94be1$var$n, $8f3817af52d94be1$var$s);
}
function $8f3817af52d94be1$export$3f780019ff766da6(t, r) {
    (r = r || (0, $cd771979e180c558$export$2e2bcd8739ae039)).interceptors.response.eject(t);
}
function $8f3817af52d94be1$var$n(e) {
    return e;
}
function $8f3817af52d94be1$var$o(e) {
    var t = [];
    if (e) return Array.isArray(e) ? e : ("object" == typeof e && Object.keys(e).forEach(function(r) {
        "number" == typeof r && (t[r] = e[r]);
    }), t);
}
function $8f3817af52d94be1$var$s(t) {
    if ((0, $cd771979e180c558$export$2e2bcd8739ae039).isCancel(t)) return Promise.reject(t);
    var r = $8f3817af52d94be1$export$44487a86467333c3(t) || {};
    if (r.currentRetryAttempt = r.currentRetryAttempt || 0, r.retry = "number" == typeof r.retry ? r.retry : 3, r.retryDelay = "number" == typeof r.retryDelay ? r.retryDelay : 100, r.instance = r.instance || (0, $cd771979e180c558$export$2e2bcd8739ae039), r.backoffType = r.backoffType || "exponential", r.httpMethodsToRetry = $8f3817af52d94be1$var$o(r.httpMethodsToRetry) || [
        "GET",
        "HEAD",
        "PUT",
        "OPTIONS",
        "DELETE"
    ], r.noResponseRetries = "number" == typeof r.noResponseRetries ? r.noResponseRetries : 2, r.statusCodesToRetry = $8f3817af52d94be1$var$o(r.statusCodesToRetry) || [
        [
            100,
            199
        ],
        [
            429,
            429
        ],
        [
            500,
            599
        ]
    ], t.config = t.config || {}, t.config.raxConfig = Object.assign({}, r), !(r.shouldRetry || $8f3817af52d94be1$export$c0b08516e1e88b05)(t)) return Promise.reject(t);
    var n = new Promise(function(e) {
        var n;
        n = "linear" === r.backoffType ? 1e3 * r.currentRetryAttempt : "static" === r.backoffType ? r.retryDelay : (Math.pow(2, r.currentRetryAttempt) - 1) / 2 * 1e3, t.config.raxConfig.currentRetryAttempt += 1, setTimeout(e, n);
    }), s = r.onRetryAttempt ? Promise.resolve(r.onRetryAttempt(t)) : Promise.resolve();
    return Promise.resolve().then(function() {
        return n;
    }).then(function() {
        return s;
    }).then(function() {
        return r.instance.request(t.config);
    });
}
function $8f3817af52d94be1$export$c0b08516e1e88b05(e) {
    var t = e.config.raxConfig;
    if (!t || 0 === t.retry) return !1;
    if (!e.response && (t.currentRetryAttempt || 0) >= t.noResponseRetries) return !1;
    if (!e.config.method || t.httpMethodsToRetry.indexOf(e.config.method.toUpperCase()) < 0) return !1;
    if (e.response && e.response.status) {
        for(var r = !1, n = 0, o = t.statusCodesToRetry; n < o.length; n += 1){
            var s = o[n], i = e.response.status;
            if (i >= s[0] && i <= s[1]) {
                r = !0;
                break;
            }
        }
        if (!r) return !1;
    }
    return t.currentRetryAttempt = t.currentRetryAttempt || 0, !(t.currentRetryAttempt >= t.retry);
}
function $8f3817af52d94be1$export$44487a86467333c3(e) {
    if (e && e.config) return e.config.raxConfig;
}






const $fa59c124bcc240a9$export$adbecee0bccf191 = (axiosInstance)=>{
    return {
        instance: axiosInstance,
        retry: 15,
        noResponseRetries: 5,
        retryDelay: 1000,
        backoffType: "exponential",
        statusCodesToRetry: [
            [
                100,
                199
            ],
            [
                400,
                429
            ],
            [
                500,
                599
            ]
        ]
    };
};




const $b360ccb1ae1ee64e$export$59ce2961430906cb = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { translations: translations } = store.AppConfig;
    const { showLoading: showLoading } = store.AppConfig.onfidoConfig;
    const { sdkToken: sdkToken, onfidoNew: onfidoNew } = store.ClientState;
    const { finishLaterLabel: finishLaterLabel, continueLabel: continueLabel, pageUploadIdLoading: pageUploadIdLoading } = translations;
    const { heading: heading, pleaseUpload: pleaseUpload, learnMore: learnMore, americanExpressDescription: americanExpressDescription, submittingDocuments: submittingDocuments, redirected: redirected, modal: modal, modalFinishLater: modalFinishLater, pleaseWait: pleaseWait, pleaseWaitLonger: pleaseWaitLonger } = translations.pageUploadIdStart;
    const [loading, setLoading] = (0, $hJwnw.useState)(true);
    const [laterModalVisible, setLaterModalVisible] = (0, $hJwnw.useState)(false);
    const [infoModalVisible, setInfoModalVisible] = (0, $hJwnw.useState)(false);
    const [spinnerText, setSpinnerText] = (0, $hJwnw.useState)(pleaseWait);
    const axiosInstance = (0, $cd771979e180c558$export$2e2bcd8739ae039).create();
    axiosInstance.defaults.raxConfig = {
        ...(0, $fa59c124bcc240a9$export$adbecee0bccf191)(axiosInstance),
        onRetryAttempt: (err)=>{
            const cfg = $8f3817af52d94be1$export$44487a86467333c3(err);
            if (cfg.currentRetryAttempt === 5) store.AppState.changePage("error", 1);
        }
    };
    const interceptorId = $8f3817af52d94be1$export$5ddf9e484e541d6f(axiosInstance);
    const getOnfidoToken = async ()=>{
        try {
            const response = await axiosInstance.request({
                method: "GET",
                url: `${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/onfido/token`,
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json"
                },
                data: {}
            });
            return response.data.onfidoSdkToken;
        } catch (e) {
            console.log(e);
        }
    };
    const handleOnfidoToken = async ()=>{
        try {
            setLoading(false);
            const token = await getOnfidoToken();
            if (token && token.length) {
                store.ClientState.setSdkToken(token);
                setLoading(false);
            }
        } catch (e) {
            store.ClientState.flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) ? store.AppState.setError((0, $d1720c836d6de09c$export$30f3b02011db23c0).errorOnfidoTokenAcq) : store.AppState.setError((0, $d1720c836d6de09c$export$30f3b02011db23c0).errorOnfidoTokenRem);
            store.AppState.changePage("error", 1);
            console.log(e);
        }
    };
    const changeSubpageDependsOnFlow = ()=>{
        if (store.ClientState.flow === (0, $45843b22ada4386e$export$7d1b589b83d5fb2e)) store.AppState.changePage("uploadid", 2);
    };
    (0, $hJwnw.useEffect)(()=>{
        changeSubpageDependsOnFlow();
        store.ClientState.flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) && handleOnfidoToken();
        setTimeout(()=>{
            setSpinnerText(pleaseWaitLonger);
            clearTimeout(Number(undefined));
        }, 5000);
    }, []);
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $hJwnw.Fragment), {
        children: showLoading && loading ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
            className: "page page--loading",
            children: [
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                    className: "loading-spinner"
                }),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("h1", {
                    children: pageUploadIdLoading.idinComplete
                }),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                    className: "subtitle",
                    children: "Onfido laden"
                })
            ]
        }) : /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $40ac97942f716825$exports.Fragment), {
            children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                className: "page page--upload-id",
                children: [
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("h1", {
                        className: "onfido-intro-heading",
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                        className: "text",
                        children: pleaseUpload
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                        className: "provider-logo",
                        children: [
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                                className: "liner centered",
                                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ed615beef7229e84$exports)))
                                })
                            }),
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                                className: "liner centered",
                                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
                                    href: "#",
                                    onClick: ()=>setInfoModalVisible(true),
                                    children: learnMore
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("p", {
                        className: "text",
                        children: [
                            americanExpressDescription,
                            " ",
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
                                href: "https://www.americanexpress.com/nl/informatie/voorwaarden/signicat/privacy-voorwaarden.html",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "hier."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                        className: "text",
                        children: submittingDocuments
                    }),
                    onfidoNew && onfidoNew === "1" ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                        className: "info-box",
                        children: [
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                                className: "icon-info"
                            }),
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("span", {
                                className: "text",
                                children: [
                                    "Let op: een rijbewijs accepteren wij",
                                    " ",
                                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("u", {
                                            children: "niet"
                                        })
                                    }),
                                    " ",
                                    "als een geldig identiteitsbewijs. U kunt zich identificeren met een paspoort of ID-document uit een EER-land."
                                ]
                            })
                        ]
                    }) : "",
                    !sdkToken ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                        className: "onfido-token__holder",
                        children: [
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                                className: "onfido-token-spinner"
                            }),
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                                className: "redirect-info",
                                children: spinnerText
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                        className: "liner centered",
                        children: [
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("button", {
                                className: "btn btn-continue",
                                onClick: ()=>store.AppState.changePage("uploadid", 2),
                                children: continueLabel
                            }),
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                                className: "redirect-info",
                                children: redirected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                        className: "liner centered",
                        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
                            href: "#",
                            onClick: ()=>setLaterModalVisible(true),
                            className: "finish-later",
                            children: finishLaterLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $ce888247d742db17$export$2b77a92f1a5ad772), {
                        modalVisible: infoModalVisible,
                        setModalVisible: setInfoModalVisible,
                        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                            className: "modal--onfido-info",
                            children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                                className: "line centered",
                                children: [
                                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ed615beef7229e84$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                                        children: modal.text
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $ce888247d742db17$export$2b77a92f1a5ad772), {
                        modalVisible: laterModalVisible,
                        setModalVisible: setLaterModalVisible,
                        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                            className: "modal--finish-later-onfido",
                            children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                                className: "line centered",
                                children: [
                                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("h2", {
                                        children: modalFinishLater.heading
                                    }),
                                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                                        children: modalFinishLater.paragraphFirst
                                    }),
                                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                                        children: modalFinishLater.paragraphSecond
                                    }),
                                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("button", {
                                        className: "btn btn-primary",
                                        onClick: ()=>setLaterModalVisible(false),
                                        children: modalFinishLater.buttonComplete
                                    }),
                                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("button", {
                                        className: "btn btn--bordered",
                                        onClick: ()=>store.AppState.changePage("continue", 1),
                                        children: modalFinishLater.buttonLeave
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
});




var $hJwnw = parcelRequire("hJwnw");









var $hJwnw = parcelRequire("hJwnw");
var $146bc239513a01b7$exports = {};


$146bc239513a01b7$exports = (parcelRequire("ef61Y")).getBundleURL("eot5l") + (parcelRequire("5pfIs")).resolve("g5wjA");



const $a23e28407b9b714a$var$visibleSuggestions = 4;
const $a23e28407b9b714a$var$suggestionsHeight = 52;
const $a23e28407b9b714a$export$3ee5f1febb02809b = ({ values: values, onChange: onChange, defaultSuggest: defaultSuggest, placeholder: placeholder, suggestLabel: suggestLabel })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const node = (0, $hJwnw.useRef)(null);
    const [currentLabel, setCurrentLabel] = (0, $hJwnw.useState)("");
    const [suggestions, setSuggestions] = (0, $hJwnw.useState)([]);
    const [hasFocus, setHasFocus] = (0, $hJwnw.useState)(false);
    const [autoselectVisible, setAutoselectVisible] = (0, $hJwnw.useState)(true);
    const [defaultSuggestVisible, setDefaultSuggestVisible] = (0, $hJwnw.useState)(false);
    const handleInput = (value)=>{
        setCurrentLabel(value);
        setDefaultSuggestVisible(false);
        setAutoselectVisible(true);
        onChange && onChange("");
    };
    const selectValue = (value)=>{
        setAutoselectVisible(false);
        setDefaultSuggestVisible(false);
        setCurrentLabel(value.name);
        onChange && onChange(value.id);
    };
    const handleOutsideClick = (event)=>{
        if (node.current.contains(event.target)) return;
        setAutoselectVisible(false);
        setDefaultSuggestVisible(false);
    };
    const handleClear = ()=>{
        setCurrentLabel("");
        onChange && onChange("");
    };
    (0, $hJwnw.useEffect)(()=>{
        document.addEventListener("mousedown", handleOutsideClick);
        return ()=>{
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);
    (0, $hJwnw.useEffect)(()=>{
        const filtered = values.filter((value)=>value.name.toLowerCase().includes(currentLabel.toLowerCase()));
        setSuggestions(filtered);
    }, [
        currentLabel
    ]);
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
        ref: node,
        className: `suggest-input__wrapper ${hasFocus && (autoselectVisible || defaultSuggestVisible) && "focused"}`,
        children: [
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($146bc239513a01b7$exports))),
                className: "search-icon"
            }),
            currentLabel.length ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                className: "clear-input",
                onClick: ()=>handleClear()
            }) : "",
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("input", {
                type: "text",
                value: currentLabel,
                onChange: (e)=>handleInput(e.target.value),
                onFocus: ()=>{
                    setHasFocus(true);
                    defaultSuggest && !currentLabel.length && setDefaultSuggestVisible(true);
                },
                onBlur: ()=>setHasFocus(false),
                placeholder: placeholder,
                className: "suggest-input__input"
            }),
            autoselectVisible && currentLabel.length >= 1 && suggestions.length ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("ul", {
                className: "suggest-input__search",
                style: {
                    height: `${(suggestions.length < $a23e28407b9b714a$var$visibleSuggestions ? suggestions.length : $a23e28407b9b714a$var$visibleSuggestions) * $a23e28407b9b714a$var$suggestionsHeight + 10}px`,
                    bottom: `-${(suggestions.length < $a23e28407b9b714a$var$visibleSuggestions ? suggestions.length : $a23e28407b9b714a$var$visibleSuggestions) * $a23e28407b9b714a$var$suggestionsHeight + 7}px`
                },
                children: suggestions.map((value, index)=>{
                    if (index <= $a23e28407b9b714a$var$visibleSuggestions) return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("li", {
                        onClick: ()=>selectValue(value),
                        children: [
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                                className: `fp ${value.id.toLowerCase()}`
                            }),
                            value.name
                        ]
                    }, value.id);
                })
            }) : "",
            autoselectVisible && currentLabel.length >= 1 && !suggestions.length && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("ul", {
                className: "suggest-input__search suggest-input__search--no-results",
                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("li", {
                    children: "No Results Found"
                })
            }),
            defaultSuggestVisible && defaultSuggest && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)((0, $40ac97942f716825$exports.Fragment), {
                children: [
                    suggestLabel ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                        className: "suggest-input__suggest-label",
                        children: suggestLabel
                    }) : "",
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("ul", {
                        className: "suggest-input__autosuggest",
                        style: {
                            height: "62px",
                            bottom: "-59px"
                        },
                        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("li", {
                            onClick: ()=>selectValue(defaultSuggest),
                            children: [
                                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                                    className: `fp ${defaultSuggest.id.toLowerCase()}`
                                }),
                                defaultSuggest.name
                            ]
                        }, defaultSuggest.id)
                    })
                ]
            })
        ]
    });
};




const $479f1395045fe468$var$defaultSuggest = {
    name: "Nederland",
    id: "NL",
    documentTypes: {
        passport: true,
        // eslint-disable-next-line @typescript-eslint/camelcase
        driving_licence: false,
        // eslint-disable-next-line @typescript-eslint/camelcase
        national_identity_card: true
    }
};
const $479f1395045fe468$export$626a0430d29b9cc1 = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const onfido = window.Onfido;
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { translations: translations } = store.AppConfig;
    const { selectedCountry: selectedCountry, flow: flow, sdkToken: sdkToken, onfidoNew: onfidoNew } = store.ClientState;
    const { continueLabel: continueLabel } = translations;
    const { heading: heading, searchCountry: searchCountry, suggestedCountry: suggestedCountry, pleaseWait: pleaseWait, pleaseWaitLonger: pleaseWaitLonger } = translations.pageCountrySelect;
    const [spinnerText, setSpinnerText] = (0, $hJwnw.useState)(pleaseWait);
    const axiosInstance = (0, $cd771979e180c558$export$2e2bcd8739ae039).create();
    axiosInstance.defaults.raxConfig = {
        ...(0, $fa59c124bcc240a9$export$adbecee0bccf191)(axiosInstance),
        onRetryAttempt: (err)=>{
            const cfg = $8f3817af52d94be1$export$44487a86467333c3(err);
            if (cfg.currentRetryAttempt === 5) store.AppState.changePage("error", 1);
        }
    };
    const interceptorId = $8f3817af52d94be1$export$5ddf9e484e541d6f(axiosInstance);
    const getOnfidoToken = async ()=>{
        try {
            const response = await axiosInstance.request({
                method: "GET",
                url: `${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/onfido/token`,
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json"
                },
                data: {}
            });
            return response.data.onfidoSdkToken;
        } catch (e) {
            console.log(e);
        }
    };
    const handleOnfidoToken = async ()=>{
        try {
            const token = await getOnfidoToken();
            if (token && token.length) store.ClientState.setSdkToken(token);
        } catch (e) {
            store.AppState.changePage("error", 1);
            console.log(e);
        }
    };
    const handlePageChange = (event)=>{
        event.preventDefault();
        store.AppState.changePage("uploadid", 3);
    };
    const validateCurrentSelection = ()=>{
        const validator = (0, $53337d58c2d64731$export$e5ad74579c86b003).filter((country)=>country.id === selectedCountry);
        return !!validator.length;
    };
    (0, $hJwnw.useEffect)(()=>{
        validateCurrentSelection();
    }, [
        selectedCountry
    ]);
    (0, $hJwnw.useEffect)(()=>{
        store.ClientState.flow === (0, $45843b22ada4386e$export$7d1b589b83d5fb2e) && handleOnfidoToken();
    // setTimeout(() => {
    //   setSpinnerText(pleaseWaitLonger)
    //   clearTimeout(this)
    // }, 30000)
    }, []);
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
        className: "page page--country-select",
        children: [
            flow !== (0, $45843b22ada4386e$export$2707f038bb5e8d05) ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                className: "onfido-logo--container",
                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("img", {
                    className: "onfido-logo--image",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ed615beef7229e84$exports)))
                })
            }) : "",
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("h1", {
                        children: onfidoNew && onfidoNew === "1" ? "Zoek het land waar uw identiteitsbewijs is verstrekt." : heading
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                        className: "country-select--wrapper",
                        children: [
                            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $a23e28407b9b714a$export$3ee5f1febb02809b), {
                                values: (0, $53337d58c2d64731$export$e5ad74579c86b003),
                                onChange: (countryId)=>store.ClientState.setSelectedCountry(countryId),
                                defaultSuggest: $479f1395045fe468$var$defaultSuggest,
                                placeholder: searchCountry,
                                suggestLabel: suggestedCountry
                            }),
                            onfido === undefined || !sdkToken ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                                className: "onfido-token__holder",
                                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                                    className: "onfido-token-spinner"
                                })
                            }) : /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                                className: "liner centered",
                                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("button", {
                                    className: "btn",
                                    onClick: handlePageChange,
                                    disabled: !validateCurrentSelection(),
                                    children: continueLabel
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});




var $hJwnw = parcelRequire("hJwnw");

var $c2e5bbb2812aaec2$exports = {};
var $c2e5bbb2812aaec2$var$countryISOMapping = {
    AF: "AFG",
    AX: "ALA",
    AL: "ALB",
    DZ: "DZA",
    AS: "ASM",
    AD: "AND",
    AO: "AGO",
    AI: "AIA",
    AQ: "ATA",
    AG: "ATG",
    AR: "ARG",
    AM: "ARM",
    AW: "ABW",
    AU: "AUS",
    AT: "AUT",
    AZ: "AZE",
    BS: "BHS",
    BH: "BHR",
    BD: "BGD",
    BB: "BRB",
    BY: "BLR",
    BE: "BEL",
    BZ: "BLZ",
    BJ: "BEN",
    BM: "BMU",
    BT: "BTN",
    BO: "BOL",
    BA: "BIH",
    BW: "BWA",
    BV: "BVT",
    BR: "BRA",
    VG: "VGB",
    IO: "IOT",
    BN: "BRN",
    BG: "BGR",
    BF: "BFA",
    BI: "BDI",
    KH: "KHM",
    CM: "CMR",
    CA: "CAN",
    CV: "CPV",
    KY: "CYM",
    CF: "CAF",
    TD: "TCD",
    CL: "CHL",
    CN: "CHN",
    HK: "HKG",
    MO: "MAC",
    CX: "CXR",
    CC: "CCK",
    CO: "COL",
    KM: "COM",
    CG: "COG",
    CD: "COD",
    CK: "COK",
    CR: "CRI",
    CI: "CIV",
    HR: "HRV",
    CU: "CUB",
    CY: "CYP",
    CZ: "CZE",
    DK: "DNK",
    DJ: "DJI",
    DM: "DMA",
    DO: "DOM",
    EC: "ECU",
    EG: "EGY",
    SV: "SLV",
    GQ: "GNQ",
    ER: "ERI",
    EE: "EST",
    ET: "ETH",
    FK: "FLK",
    FO: "FRO",
    FJ: "FJI",
    FI: "FIN",
    FR: "FRA",
    GF: "GUF",
    PF: "PYF",
    TF: "ATF",
    GA: "GAB",
    GM: "GMB",
    GE: "GEO",
    DE: "DEU",
    GH: "GHA",
    GI: "GIB",
    GR: "GRC",
    GL: "GRL",
    GD: "GRD",
    GP: "GLP",
    GU: "GUM",
    GT: "GTM",
    GG: "GGY",
    GN: "GIN",
    GW: "GNB",
    GY: "GUY",
    HT: "HTI",
    HM: "HMD",
    VA: "VAT",
    HN: "HND",
    HU: "HUN",
    IS: "ISL",
    IN: "IND",
    ID: "IDN",
    IR: "IRN",
    IQ: "IRQ",
    IE: "IRL",
    IM: "IMN",
    IL: "ISR",
    IT: "ITA",
    JM: "JAM",
    JP: "JPN",
    JE: "JEY",
    JO: "JOR",
    KZ: "KAZ",
    KE: "KEN",
    KI: "KIR",
    KP: "PRK",
    KR: "KOR",
    KW: "KWT",
    KG: "KGZ",
    LA: "LAO",
    LV: "LVA",
    LB: "LBN",
    LS: "LSO",
    LR: "LBR",
    LY: "LBY",
    LI: "LIE",
    LT: "LTU",
    LU: "LUX",
    MK: "MKD",
    MG: "MDG",
    MW: "MWI",
    MY: "MYS",
    MV: "MDV",
    ML: "MLI",
    MT: "MLT",
    MH: "MHL",
    MQ: "MTQ",
    MR: "MRT",
    MU: "MUS",
    YT: "MYT",
    MX: "MEX",
    FM: "FSM",
    MD: "MDA",
    MC: "MCO",
    MN: "MNG",
    ME: "MNE",
    MS: "MSR",
    MA: "MAR",
    MZ: "MOZ",
    MM: "MMR",
    NA: "NAM",
    NR: "NRU",
    NP: "NPL",
    NL: "NLD",
    AN: "ANT",
    NC: "NCL",
    NZ: "NZL",
    NI: "NIC",
    NE: "NER",
    NG: "NGA",
    NU: "NIU",
    NF: "NFK",
    MP: "MNP",
    NO: "NOR",
    OM: "OMN",
    PK: "PAK",
    PW: "PLW",
    PS: "PSE",
    PA: "PAN",
    PG: "PNG",
    PY: "PRY",
    PE: "PER",
    PH: "PHL",
    PN: "PCN",
    PL: "POL",
    PT: "PRT",
    PR: "PRI",
    QA: "QAT",
    RE: "REU",
    RO: "ROU",
    RU: "RUS",
    RW: "RWA",
    BL: "BLM",
    SH: "SHN",
    KN: "KNA",
    LC: "LCA",
    MF: "MAF",
    PM: "SPM",
    VC: "VCT",
    WS: "WSM",
    SM: "SMR",
    ST: "STP",
    SA: "SAU",
    SN: "SEN",
    RS: "SRB",
    SC: "SYC",
    SL: "SLE",
    SG: "SGP",
    SK: "SVK",
    SI: "SVN",
    SB: "SLB",
    SO: "SOM",
    ZA: "ZAF",
    GS: "SGS",
    SS: "SSD",
    ES: "ESP",
    LK: "LKA",
    SD: "SDN",
    SR: "SUR",
    SJ: "SJM",
    SZ: "SWZ",
    SE: "SWE",
    CH: "CHE",
    SY: "SYR",
    TW: "TWN",
    TJ: "TJK",
    TZ: "TZA",
    TH: "THA",
    TL: "TLS",
    TG: "TGO",
    TK: "TKL",
    TO: "TON",
    TT: "TTO",
    TN: "TUN",
    TR: "TUR",
    TM: "TKM",
    TC: "TCA",
    TV: "TUV",
    UG: "UGA",
    UA: "UKR",
    AE: "ARE",
    GB: "GBR",
    US: "USA",
    UM: "UMI",
    UY: "URY",
    UZ: "UZB",
    VU: "VUT",
    VE: "VEN",
    VN: "VNM",
    VI: "VIR",
    WF: "WLF",
    EH: "ESH",
    YE: "YEM",
    ZM: "ZMB",
    ZW: "ZWE",
    XK: "XKX"
};
$c2e5bbb2812aaec2$exports = function getCountryISO3(countryCode) {
    return $c2e5bbb2812aaec2$var$countryISOMapping[countryCode];
};


var $e435c181395b7814$exports = {};
"use strict";
var $042d3b70db130764$exports = {};
$042d3b70db130764$exports = JSON.parse('[{"state":"assigned","alpha2":"AD","alpha3":"AND","numeric":"020","name":"Andorra"},{"state":"assigned","alpha2":"AE","alpha3":"ARE","numeric":"784","name":"United Arab Emirates"},{"state":"assigned","alpha2":"AF","alpha3":"AFG","numeric":"004","name":"Afghanistan"},{"state":"assigned","alpha2":"AG","alpha3":"ATG","numeric":"028","name":"Antigua and Barbuda"},{"state":"assigned","alpha2":"AI","alpha3":"AIA","numeric":"660","name":"Anguilla"},{"state":"assigned","alpha2":"AL","alpha3":"ALB","numeric":"008","name":"Albania"},{"state":"assigned","alpha2":"AM","alpha3":"ARM","numeric":"051","name":"Armenia"},{"state":"assigned","alpha2":"AO","alpha3":"AGO","numeric":"024","name":"Angola"},{"state":"assigned","alpha2":"AQ","alpha3":"ATA","numeric":"010","name":"Antarctica"},{"state":"assigned","alpha2":"AR","alpha3":"ARG","numeric":"032","name":"Argentina"},{"state":"assigned","alpha2":"AS","alpha3":"ASM","numeric":"016","name":"American Samoa"},{"state":"assigned","alpha2":"AT","alpha3":"AUT","numeric":"040","name":"Austria"},{"state":"assigned","alpha2":"AU","alpha3":"AUS","numeric":"036","name":"Australia"},{"state":"assigned","alpha2":"AW","alpha3":"ABW","numeric":"533","name":"Aruba"},{"state":"assigned","alpha2":"AX","alpha3":"ALA","numeric":"248","name":"\xc5land Islands"},{"state":"assigned","alpha2":"AZ","alpha3":"AZE","numeric":"031","name":"Azerbaijan"},{"state":"assigned","alpha2":"BA","alpha3":"BIH","numeric":"070","name":"Bosnia and Herzegovina"},{"state":"assigned","alpha2":"BB","alpha3":"BRB","numeric":"052","name":"Barbados"},{"state":"assigned","alpha2":"BD","alpha3":"BGD","numeric":"050","name":"Bangladesh"},{"state":"assigned","alpha2":"BE","alpha3":"BEL","numeric":"056","name":"Belgium"},{"state":"assigned","alpha2":"BF","alpha3":"BFA","numeric":"854","name":"Burkina Faso"},{"state":"assigned","alpha2":"BG","alpha3":"BGR","numeric":"100","name":"Bulgaria"},{"state":"assigned","alpha2":"BH","alpha3":"BHR","numeric":"048","name":"Bahrain"},{"state":"assigned","alpha2":"BI","alpha3":"BDI","numeric":"108","name":"Burundi"},{"state":"assigned","alpha2":"BJ","alpha3":"BEN","numeric":"204","name":"Benin"},{"state":"assigned","alpha2":"BL","alpha3":"BLM","numeric":"652","name":"Saint Barth\xe9lemy"},{"state":"assigned","alpha2":"BM","alpha3":"BMU","numeric":"060","name":"Bermuda"},{"state":"assigned","alpha2":"BN","alpha3":"BRN","numeric":"096","name":"Brunei Darussalam"},{"state":"assigned","alpha2":"BO","alpha3":"BOL","numeric":"068","name":"Bolivia (Plurinational State of)"},{"state":"assigned","alpha2":"BQ","alpha3":"BES","numeric":"535","name":"Bonaire, Sint Eustatius and Saba"},{"state":"assigned","alpha2":"BR","alpha3":"BRA","numeric":"076","name":"Brazil"},{"state":"assigned","alpha2":"BS","alpha3":"BHS","numeric":"044","name":"Bahamas"},{"state":"assigned","alpha2":"BT","alpha3":"BTN","numeric":"064","name":"Bhutan"},{"state":"assigned","alpha2":"BV","alpha3":"BVT","numeric":"074","name":"Bouvet Island"},{"state":"assigned","alpha2":"BW","alpha3":"BWA","numeric":"072","name":"Botswana"},{"state":"assigned","alpha2":"BY","alpha3":"BLR","numeric":"112","name":"Belarus"},{"state":"assigned","alpha2":"BZ","alpha3":"BLZ","numeric":"084","name":"Belize"},{"state":"assigned","alpha2":"CA","alpha3":"CAN","numeric":"124","name":"Canada"},{"state":"assigned","alpha2":"CC","alpha3":"CCK","numeric":"166","name":"Cocos (Keeling) Islands"},{"state":"assigned","alpha2":"CD","alpha3":"COD","numeric":"180","name":"Congo, Democratic Republic of the"},{"state":"assigned","alpha2":"CF","alpha3":"CAF","numeric":"140","name":"Central African Republic"},{"state":"assigned","alpha2":"CG","alpha3":"COG","numeric":"178","name":"Congo"},{"state":"assigned","alpha2":"CH","alpha3":"CHE","numeric":"756","name":"Switzerland"},{"state":"assigned","alpha2":"CI","alpha3":"CIV","numeric":"384","name":"C\xf4te d\'Ivoire"},{"state":"assigned","alpha2":"CK","alpha3":"COK","numeric":"184","name":"Cook Islands"},{"state":"assigned","alpha2":"CL","alpha3":"CHL","numeric":"152","name":"Chile"},{"state":"assigned","alpha2":"CM","alpha3":"CMR","numeric":"120","name":"Cameroon"},{"state":"assigned","alpha2":"CN","alpha3":"CHN","numeric":"156","name":"China"},{"state":"assigned","alpha2":"CO","alpha3":"COL","numeric":"170","name":"Colombia"},{"state":"assigned","alpha2":"CR","alpha3":"CRI","numeric":"188","name":"Costa Rica"},{"state":"assigned","alpha2":"CU","alpha3":"CUB","numeric":"192","name":"Cuba"},{"state":"assigned","alpha2":"CV","alpha3":"CPV","numeric":"132","name":"Cabo Verde"},{"state":"assigned","alpha2":"CW","alpha3":"CUW","numeric":"531","name":"Cura\xe7ao"},{"state":"assigned","alpha2":"CX","alpha3":"CXR","numeric":"162","name":"Christmas Island"},{"state":"assigned","alpha2":"CY","alpha3":"CYP","numeric":"196","name":"Cyprus"},{"state":"assigned","alpha2":"CZ","alpha3":"CZE","numeric":"203","name":"Czechia"},{"state":"assigned","alpha2":"DE","alpha3":"DEU","numeric":"276","name":"Germany"},{"state":"assigned","alpha2":"DJ","alpha3":"DJI","numeric":"262","name":"Djibouti"},{"state":"assigned","alpha2":"DK","alpha3":"DNK","numeric":"208","name":"Denmark"},{"state":"assigned","alpha2":"DM","alpha3":"DMA","numeric":"212","name":"Dominica"},{"state":"assigned","alpha2":"DO","alpha3":"DOM","numeric":"214","name":"Dominican Republic"},{"state":"assigned","alpha2":"DZ","alpha3":"DZA","numeric":"012","name":"Algeria"},{"state":"assigned","alpha2":"EC","alpha3":"ECU","numeric":"218","name":"Ecuador"},{"state":"assigned","alpha2":"EE","alpha3":"EST","numeric":"233","name":"Estonia"},{"state":"assigned","alpha2":"EG","alpha3":"EGY","numeric":"818","name":"Egypt"},{"state":"assigned","alpha2":"EH","alpha3":"ESH","numeric":"732","name":"Western Sahara"},{"state":"assigned","alpha2":"ER","alpha3":"ERI","numeric":"232","name":"Eritrea"},{"state":"assigned","alpha2":"ES","alpha3":"ESP","numeric":"724","name":"Spain"},{"state":"assigned","alpha2":"ET","alpha3":"ETH","numeric":"231","name":"Ethiopia"},{"state":"assigned","alpha2":"FI","alpha3":"FIN","numeric":"246","name":"Finland"},{"state":"assigned","alpha2":"FJ","alpha3":"FJI","numeric":"242","name":"Fiji"},{"state":"assigned","alpha2":"FK","alpha3":"FLK","numeric":"238","name":"Falkland Islands (Malvinas)"},{"state":"assigned","alpha2":"FM","alpha3":"FSM","numeric":"583","name":"Micronesia (Federated States of)"},{"state":"assigned","alpha2":"FO","alpha3":"FRO","numeric":"234","name":"Faroe Islands"},{"state":"assigned","alpha2":"FR","alpha3":"FRA","numeric":"250","name":"France"},{"state":"assigned","alpha2":"GA","alpha3":"GAB","numeric":"266","name":"Gabon"},{"state":"assigned","alpha2":"GB","alpha3":"GBR","numeric":"826","name":"United Kingdom of Great Britain and Northern Ireland"},{"state":"assigned","alpha2":"GD","alpha3":"GRD","numeric":"308","name":"Grenada"},{"state":"assigned","alpha2":"GE","alpha3":"GEO","numeric":"268","name":"Georgia"},{"state":"assigned","alpha2":"GF","alpha3":"GUF","numeric":"254","name":"French Guiana"},{"state":"assigned","alpha2":"GG","alpha3":"GGY","numeric":"831","name":"Guernsey"},{"state":"assigned","alpha2":"GH","alpha3":"GHA","numeric":"288","name":"Ghana"},{"state":"assigned","alpha2":"GI","alpha3":"GIB","numeric":"292","name":"Gibraltar"},{"state":"assigned","alpha2":"GL","alpha3":"GRL","numeric":"304","name":"Greenland"},{"state":"assigned","alpha2":"GM","alpha3":"GMB","numeric":"270","name":"Gambia"},{"state":"assigned","alpha2":"GN","alpha3":"GIN","numeric":"324","name":"Guinea"},{"state":"assigned","alpha2":"GP","alpha3":"GLP","numeric":"312","name":"Guadeloupe"},{"state":"assigned","alpha2":"GQ","alpha3":"GNQ","numeric":"226","name":"Equatorial Guinea"},{"state":"assigned","alpha2":"GR","alpha3":"GRC","numeric":"300","name":"Greece"},{"state":"assigned","alpha2":"GS","alpha3":"SGS","numeric":"239","name":"South Georgia and the South Sandwich Islands"},{"state":"assigned","alpha2":"GT","alpha3":"GTM","numeric":"320","name":"Guatemala"},{"state":"assigned","alpha2":"GU","alpha3":"GUM","numeric":"316","name":"Guam"},{"state":"assigned","alpha2":"GW","alpha3":"GNB","numeric":"624","name":"Guinea-Bissau"},{"state":"assigned","alpha2":"GY","alpha3":"GUY","numeric":"328","name":"Guyana"},{"state":"assigned","alpha2":"HK","alpha3":"HKG","numeric":"344","name":"Hong Kong"},{"state":"assigned","alpha2":"HM","alpha3":"HMD","numeric":"334","name":"Heard Island and McDonald Islands"},{"state":"assigned","alpha2":"HN","alpha3":"HND","numeric":"340","name":"Honduras"},{"state":"assigned","alpha2":"HR","alpha3":"HRV","numeric":"191","name":"Croatia"},{"state":"assigned","alpha2":"HT","alpha3":"HTI","numeric":"332","name":"Haiti"},{"state":"assigned","alpha2":"HU","alpha3":"HUN","numeric":"348","name":"Hungary"},{"state":"assigned","alpha2":"ID","alpha3":"IDN","numeric":"360","name":"Indonesia"},{"state":"assigned","alpha2":"IE","alpha3":"IRL","numeric":"372","name":"Ireland"},{"state":"assigned","alpha2":"IL","alpha3":"ISR","numeric":"376","name":"Israel"},{"state":"assigned","alpha2":"IM","alpha3":"IMN","numeric":"833","name":"Isle of Man"},{"state":"assigned","alpha2":"IN","alpha3":"IND","numeric":"356","name":"India"},{"state":"assigned","alpha2":"IO","alpha3":"IOT","numeric":"086","name":"British Indian Ocean Territory"},{"state":"assigned","alpha2":"IQ","alpha3":"IRQ","numeric":"368","name":"Iraq"},{"state":"assigned","alpha2":"IR","alpha3":"IRN","numeric":"364","name":"Iran (Islamic Republic of)"},{"state":"assigned","alpha2":"IS","alpha3":"ISL","numeric":"352","name":"Iceland"},{"state":"assigned","alpha2":"IT","alpha3":"ITA","numeric":"380","name":"Italy"},{"state":"assigned","alpha2":"JE","alpha3":"JEY","numeric":"832","name":"Jersey"},{"state":"assigned","alpha2":"JM","alpha3":"JAM","numeric":"388","name":"Jamaica"},{"state":"assigned","alpha2":"JO","alpha3":"JOR","numeric":"400","name":"Jordan"},{"state":"assigned","alpha2":"JP","alpha3":"JPN","numeric":"392","name":"Japan"},{"state":"assigned","alpha2":"KE","alpha3":"KEN","numeric":"404","name":"Kenya"},{"state":"assigned","alpha2":"KG","alpha3":"KGZ","numeric":"417","name":"Kyrgyzstan"},{"state":"assigned","alpha2":"KH","alpha3":"KHM","numeric":"116","name":"Cambodia"},{"state":"assigned","alpha2":"KI","alpha3":"KIR","numeric":"296","name":"Kiribati"},{"state":"assigned","alpha2":"KM","alpha3":"COM","numeric":"174","name":"Comoros"},{"state":"assigned","alpha2":"KN","alpha3":"KNA","numeric":"659","name":"Saint Kitts and Nevis"},{"state":"assigned","alpha2":"KP","alpha3":"PRK","numeric":"408","name":"Korea (Democratic People\'s Republic of)"},{"state":"assigned","alpha2":"KR","alpha3":"KOR","numeric":"410","name":"Korea, Republic of"},{"state":"assigned","alpha2":"KW","alpha3":"KWT","numeric":"414","name":"Kuwait"},{"state":"assigned","alpha2":"KY","alpha3":"CYM","numeric":"136","name":"Cayman Islands"},{"state":"assigned","alpha2":"KZ","alpha3":"KAZ","numeric":"398","name":"Kazakhstan"},{"state":"assigned","alpha2":"LA","alpha3":"LAO","numeric":"418","name":"Lao People\'s Democratic Republic"},{"state":"assigned","alpha2":"LB","alpha3":"LBN","numeric":"422","name":"Lebanon"},{"state":"assigned","alpha2":"LC","alpha3":"LCA","numeric":"662","name":"Saint Lucia"},{"state":"assigned","alpha2":"LI","alpha3":"LIE","numeric":"438","name":"Liechtenstein"},{"state":"assigned","alpha2":"LK","alpha3":"LKA","numeric":"144","name":"Sri Lanka"},{"state":"assigned","alpha2":"LR","alpha3":"LBR","numeric":"430","name":"Liberia"},{"state":"assigned","alpha2":"LS","alpha3":"LSO","numeric":"426","name":"Lesotho"},{"state":"assigned","alpha2":"LT","alpha3":"LTU","numeric":"440","name":"Lithuania"},{"state":"assigned","alpha2":"LU","alpha3":"LUX","numeric":"442","name":"Luxembourg"},{"state":"assigned","alpha2":"LV","alpha3":"LVA","numeric":"428","name":"Latvia"},{"state":"assigned","alpha2":"LY","alpha3":"LBY","numeric":"434","name":"Libya"},{"state":"assigned","alpha2":"MA","alpha3":"MAR","numeric":"504","name":"Morocco"},{"state":"assigned","alpha2":"MC","alpha3":"MCO","numeric":"492","name":"Monaco"},{"state":"assigned","alpha2":"MD","alpha3":"MDA","numeric":"498","name":"Moldova, Republic of"},{"state":"assigned","alpha2":"ME","alpha3":"MNE","numeric":"499","name":"Montenegro"},{"state":"assigned","alpha2":"MF","alpha3":"MAF","numeric":"663","name":"Saint Martin (French part)"},{"state":"assigned","alpha2":"MG","alpha3":"MDG","numeric":"450","name":"Madagascar"},{"state":"assigned","alpha2":"MH","alpha3":"MHL","numeric":"584","name":"Marshall Islands"},{"state":"assigned","alpha2":"MK","alpha3":"MKD","numeric":"807","name":"North Macedonia"},{"state":"assigned","alpha2":"ML","alpha3":"MLI","numeric":"466","name":"Mali"},{"state":"assigned","alpha2":"MM","alpha3":"MMR","numeric":"104","name":"Myanmar"},{"state":"assigned","alpha2":"MN","alpha3":"MNG","numeric":"496","name":"Mongolia"},{"state":"assigned","alpha2":"MO","alpha3":"MAC","numeric":"446","name":"Macao"},{"state":"assigned","alpha2":"MP","alpha3":"MNP","numeric":"580","name":"Northern Mariana Islands"},{"state":"assigned","alpha2":"MQ","alpha3":"MTQ","numeric":"474","name":"Martinique"},{"state":"assigned","alpha2":"MR","alpha3":"MRT","numeric":"478","name":"Mauritania"},{"state":"assigned","alpha2":"MS","alpha3":"MSR","numeric":"500","name":"Montserrat"},{"state":"assigned","alpha2":"MT","alpha3":"MLT","numeric":"470","name":"Malta"},{"state":"assigned","alpha2":"MU","alpha3":"MUS","numeric":"480","name":"Mauritius"},{"state":"assigned","alpha2":"MV","alpha3":"MDV","numeric":"462","name":"Maldives"},{"state":"assigned","alpha2":"MW","alpha3":"MWI","numeric":"454","name":"Malawi"},{"state":"assigned","alpha2":"MX","alpha3":"MEX","numeric":"484","name":"Mexico"},{"state":"assigned","alpha2":"MY","alpha3":"MYS","numeric":"458","name":"Malaysia"},{"state":"assigned","alpha2":"MZ","alpha3":"MOZ","numeric":"508","name":"Mozambique"},{"state":"assigned","alpha2":"NA","alpha3":"NAM","numeric":"516","name":"Namibia"},{"state":"assigned","alpha2":"NC","alpha3":"NCL","numeric":"540","name":"New Caledonia"},{"state":"assigned","alpha2":"NE","alpha3":"NER","numeric":"562","name":"Niger"},{"state":"assigned","alpha2":"NF","alpha3":"NFK","numeric":"574","name":"Norfolk Island"},{"state":"assigned","alpha2":"NG","alpha3":"NGA","numeric":"566","name":"Nigeria"},{"state":"assigned","alpha2":"NI","alpha3":"NIC","numeric":"558","name":"Nicaragua"},{"state":"assigned","alpha2":"NL","alpha3":"NLD","numeric":"528","name":"Netherlands"},{"state":"assigned","alpha2":"NO","alpha3":"NOR","numeric":"578","name":"Norway"},{"state":"assigned","alpha2":"NP","alpha3":"NPL","numeric":"524","name":"Nepal"},{"state":"assigned","alpha2":"NR","alpha3":"NRU","numeric":"520","name":"Nauru"},{"state":"assigned","alpha2":"NU","alpha3":"NIU","numeric":"570","name":"Niue"},{"state":"assigned","alpha2":"NZ","alpha3":"NZL","numeric":"554","name":"New Zealand"},{"state":"assigned","alpha2":"OM","alpha3":"OMN","numeric":"512","name":"Oman"},{"state":"assigned","alpha2":"PA","alpha3":"PAN","numeric":"591","name":"Panama"},{"state":"assigned","alpha2":"PE","alpha3":"PER","numeric":"604","name":"Peru"},{"state":"assigned","alpha2":"PF","alpha3":"PYF","numeric":"258","name":"French Polynesia"},{"state":"assigned","alpha2":"PG","alpha3":"PNG","numeric":"598","name":"Papua New Guinea"},{"state":"assigned","alpha2":"PH","alpha3":"PHL","numeric":"608","name":"Philippines"},{"state":"assigned","alpha2":"PK","alpha3":"PAK","numeric":"586","name":"Pakistan"},{"state":"assigned","alpha2":"PL","alpha3":"POL","numeric":"616","name":"Poland"},{"state":"assigned","alpha2":"PM","alpha3":"SPM","numeric":"666","name":"Saint Pierre and Miquelon"},{"state":"assigned","alpha2":"PN","alpha3":"PCN","numeric":"612","name":"Pitcairn"},{"state":"assigned","alpha2":"PR","alpha3":"PRI","numeric":"630","name":"Puerto Rico"},{"state":"assigned","alpha2":"PS","alpha3":"PSE","numeric":"275","name":"Palestine, State of"},{"state":"assigned","alpha2":"PT","alpha3":"PRT","numeric":"620","name":"Portugal"},{"state":"assigned","alpha2":"PW","alpha3":"PLW","numeric":"585","name":"Palau"},{"state":"assigned","alpha2":"PY","alpha3":"PRY","numeric":"600","name":"Paraguay"},{"state":"assigned","alpha2":"QA","alpha3":"QAT","numeric":"634","name":"Qatar"},{"state":"assigned","alpha2":"RE","alpha3":"REU","numeric":"638","name":"R\xe9union"},{"state":"assigned","alpha2":"RO","alpha3":"ROU","numeric":"642","name":"Romania"},{"state":"assigned","alpha2":"RS","alpha3":"SRB","numeric":"688","name":"Serbia"},{"state":"assigned","alpha2":"RU","alpha3":"RUS","numeric":"643","name":"Russian Federation"},{"state":"assigned","alpha2":"RW","alpha3":"RWA","numeric":"646","name":"Rwanda"},{"state":"assigned","alpha2":"SA","alpha3":"SAU","numeric":"682","name":"Saudi Arabia"},{"state":"assigned","alpha2":"SB","alpha3":"SLB","numeric":"090","name":"Solomon Islands"},{"state":"assigned","alpha2":"SC","alpha3":"SYC","numeric":"690","name":"Seychelles"},{"state":"assigned","alpha2":"SD","alpha3":"SDN","numeric":"729","name":"Sudan"},{"state":"assigned","alpha2":"SE","alpha3":"SWE","numeric":"752","name":"Sweden"},{"state":"assigned","alpha2":"SG","alpha3":"SGP","numeric":"702","name":"Singapore"},{"state":"assigned","alpha2":"SH","alpha3":"SHN","numeric":"654","name":"Saint Helena, Ascension and Tristan da Cunha"},{"state":"assigned","alpha2":"SI","alpha3":"SVN","numeric":"705","name":"Slovenia"},{"state":"assigned","alpha2":"SJ","alpha3":"SJM","numeric":"744","name":"Svalbard and Jan Mayen"},{"state":"assigned","alpha2":"SK","alpha3":"SVK","numeric":"703","name":"Slovakia"},{"state":"assigned","alpha2":"SL","alpha3":"SLE","numeric":"694","name":"Sierra Leone"},{"state":"assigned","alpha2":"SM","alpha3":"SMR","numeric":"674","name":"San Marino"},{"state":"assigned","alpha2":"SN","alpha3":"SEN","numeric":"686","name":"Senegal"},{"state":"assigned","alpha2":"SO","alpha3":"SOM","numeric":"706","name":"Somalia"},{"state":"assigned","alpha2":"SR","alpha3":"SUR","numeric":"740","name":"Suriname"},{"state":"assigned","alpha2":"SS","alpha3":"SSD","numeric":"728","name":"South Sudan"},{"state":"assigned","alpha2":"ST","alpha3":"STP","numeric":"678","name":"Sao Tome and Principe"},{"state":"assigned","alpha2":"SV","alpha3":"SLV","numeric":"222","name":"El Salvador"},{"state":"assigned","alpha2":"SX","alpha3":"SXM","numeric":"534","name":"Sint Maarten (Dutch part)"},{"state":"assigned","alpha2":"SY","alpha3":"SYR","numeric":"760","name":"Syrian Arab Republic"},{"state":"assigned","alpha2":"SZ","alpha3":"SWZ","numeric":"748","name":"Eswatini"},{"state":"assigned","alpha2":"TC","alpha3":"TCA","numeric":"796","name":"Turks and Caicos Islands"},{"state":"assigned","alpha2":"TD","alpha3":"TCD","numeric":"148","name":"Chad"},{"state":"assigned","alpha2":"TF","alpha3":"ATF","numeric":"260","name":"French Southern Territories"},{"state":"assigned","alpha2":"TG","alpha3":"TGO","numeric":"768","name":"Togo"},{"state":"assigned","alpha2":"TH","alpha3":"THA","numeric":"764","name":"Thailand"},{"state":"assigned","alpha2":"TJ","alpha3":"TJK","numeric":"762","name":"Tajikistan"},{"state":"assigned","alpha2":"TK","alpha3":"TKL","numeric":"772","name":"Tokelau"},{"state":"assigned","alpha2":"TL","alpha3":"TLS","numeric":"626","name":"Timor-Leste"},{"state":"assigned","alpha2":"TM","alpha3":"TKM","numeric":"795","name":"Turkmenistan"},{"state":"assigned","alpha2":"TN","alpha3":"TUN","numeric":"788","name":"Tunisia"},{"state":"assigned","alpha2":"TO","alpha3":"TON","numeric":"776","name":"Tonga"},{"state":"assigned","alpha2":"TR","alpha3":"TUR","numeric":"792","name":"Turkey"},{"state":"assigned","alpha2":"TT","alpha3":"TTO","numeric":"780","name":"Trinidad and Tobago"},{"state":"assigned","alpha2":"TV","alpha3":"TUV","numeric":"798","name":"Tuvalu"},{"state":"assigned","alpha2":"TW","alpha3":"TWN","numeric":"158","name":"Taiwan, Province of China"},{"state":"assigned","alpha2":"TZ","alpha3":"TZA","numeric":"834","name":"Tanzania, United Republic of"},{"state":"assigned","alpha2":"UA","alpha3":"UKR","numeric":"804","name":"Ukraine"},{"state":"assigned","alpha2":"UG","alpha3":"UGA","numeric":"800","name":"Uganda"},{"state":"assigned","alpha2":"UM","alpha3":"UMI","numeric":"581","name":"United States Minor Outlying Islands"},{"state":"assigned","alpha2":"US","alpha3":"USA","numeric":"840","name":"United States of America"},{"state":"assigned","alpha2":"UY","alpha3":"URY","numeric":"858","name":"Uruguay"},{"state":"assigned","alpha2":"UZ","alpha3":"UZB","numeric":"860","name":"Uzbekistan"},{"state":"assigned","alpha2":"VA","alpha3":"VAT","numeric":"336","name":"Holy See"},{"state":"assigned","alpha2":"VC","alpha3":"VCT","numeric":"670","name":"Saint Vincent and the Grenadines"},{"state":"assigned","alpha2":"VE","alpha3":"VEN","numeric":"862","name":"Venezuela (Bolivarian Republic of)"},{"state":"assigned","alpha2":"VG","alpha3":"VGB","numeric":"092","name":"Virgin Islands (British)"},{"state":"assigned","alpha2":"VI","alpha3":"VIR","numeric":"850","name":"Virgin Islands (U.S.)"},{"state":"assigned","alpha2":"VN","alpha3":"VNM","numeric":"704","name":"Viet Nam"},{"state":"assigned","alpha2":"VU","alpha3":"VUT","numeric":"548","name":"Vanuatu"},{"state":"assigned","alpha2":"WF","alpha3":"WLF","numeric":"876","name":"Wallis and Futuna"},{"state":"assigned","alpha2":"WS","alpha3":"WSM","numeric":"882","name":"Samoa"},{"state":"assigned","alpha2":"YE","alpha3":"YEM","numeric":"887","name":"Yemen"},{"state":"assigned","alpha2":"YT","alpha3":"MYT","numeric":"175","name":"Mayotte"},{"state":"assigned","alpha2":"ZA","alpha3":"ZAF","numeric":"710","name":"South Africa"},{"state":"assigned","alpha2":"ZM","alpha3":"ZMB","numeric":"894","name":"Zambia"},{"state":"assigned","alpha2":"ZW","alpha3":"ZWE","numeric":"716","name":"Zimbabwe"}]');


const $e435c181395b7814$var$EU_COUNTRIES = [
    "Austria",
    "Belgium",
    "Bulgaria",
    "Croatia",
    "Cyprus",
    "Czechia",
    "Denmark",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Hungary",
    "Ireland",
    "Italy",
    "Latvia",
    "Lithuania",
    "Luxembourg",
    "Malta",
    "Netherlands",
    "Poland",
    "Portugal",
    "Romania",
    "Slovakia",
    "Slovenia",
    "Spain",
    "Sweden"
];
const $e435c181395b7814$var$EEA_COUNTRIES = $e435c181395b7814$var$EU_COUNTRIES.concat([
    "Iceland",
    "Liechtenstein",
    "Norway"
]);
const $e435c181395b7814$var$isEqual = (str1, str2)=>str1.toLowerCase() === str2.toLowerCase();
const $e435c181395b7814$var$isNumber = (input)=>typeof input === "number";
const $e435c181395b7814$var$getValidator = (input)=>{
    if ($e435c181395b7814$var$isNumber(input)) return (item)=>input === Number(item.numeric);
    if (input.length === 2) return (item)=>$e435c181395b7814$var$isEqual(input, item.alpha2);
    if (input.length === 3) return (item)=>$e435c181395b7814$var$isEqual(input, item.alpha3);
    return (item)=>$e435c181395b7814$var$isEqual(input, item.name);
};
const $e435c181395b7814$var$getCountry = (input)=>$042d3b70db130764$exports.find($e435c181395b7814$var$getValidator(input));
const $e435c181395b7814$var$factory = (collection)=>(input)=>collection.includes($e435c181395b7814$var$getCountry(input).name);
/* European Economic Area Members */ const $e435c181395b7814$var$eeaMember = $e435c181395b7814$var$factory($e435c181395b7814$var$EEA_COUNTRIES);
/* European Union Members */ const $e435c181395b7814$var$euMember = $e435c181395b7814$var$factory($e435c181395b7814$var$EU_COUNTRIES);
$e435c181395b7814$exports = {
    eeaMember: $e435c181395b7814$var$eeaMember,
    euMember: $e435c181395b7814$var$euMember,
    getCountry: $e435c181395b7814$var$getCountry
};





/* eslint-disable @typescript-eslint/camelcase */ const $b0e50f9e208e1095$export$1b39cf5f2d489ad3 = {
    acquisition: {
        accessibility: {
            camera_view: "Camera",
            close_sdk_screen: "Scherm sluiten",
            country_select: "Selecteer land",
            cross_device_verification: "Hoe kunt u doorgaan op mobiel?",
            dismiss_alert: "Dismiss alert",
            document_types: "Geldige identiteitsbewijzen",
            replay_video: "Replay your recorded video",
            selfie_video_actions: "Actions to record a selfie video",
            shutter: "Neem een foto",
            start_recording: "Start recording",
            stop_recording: "Stop recording"
        },
        back: "terug",
        bank_building_society_statement: "Bank or building society statement",
        benefit_letters: "Benefits Letter",
        cancel: "Cancel",
        capture: {
            bank_building_society_statement: {
                front: {
                    instructions: "Provide the whole document page for best results",
                    sub_title: "Must be issued in the <strong>last 3 months</strong>",
                    title: "Submit statement",
                    webcam: "Position your bank statement in the frame (it will be automatically detected)"
                }
            },
            benefit_letters: {
                front: {
                    instructions: "Provide the whole document page for best results",
                    sub_title: "Must be issued in the <strong>last 12 months</strong>",
                    title: "Submit letter",
                    webcam: "Position your benefits letter in the frame (it will be automatically detected)"
                }
            },
            council_tax: {
                front: {
                    instructions: "Provide the whole document page for best results",
                    sub_title: "Must be issued in the <strong>last 12 months</strong>",
                    title: "Submit letter",
                    webcam: "Position your council tax letter in the frame (it will be automatically detected)"
                }
            },
            driving_licence: {
                back: {
                    instructions: "Upload back of license from your computer",
                    title: "Submit license (back)",
                    webcam: "Position the back of license in the frame (it will be automatically detected)"
                },
                front: {
                    instructions: "Upload front of license from your computer",
                    title: "Submit license (front)",
                    webcam: "Position the front of license in the frame (it will be automatically detected)"
                }
            },
            face: {
                instructions: "Upload a selfie from your computer",
                intro: {
                    accessibility: {
                        selfie_capture_tips: "Tips to take a good selfie"
                    },
                    glasses_instruction: "Remove your glasses, if necessary",
                    selfie_instruction: "Face forward and make sure your eyes are clearly visible",
                    subtitle: "We'll compare it with your document",
                    title: "Take a selfie"
                },
                title: "Take a selfie",
                upload_title: "Selfie"
            },
            government_letter: {
                front: {
                    instructions: "Provide the whole document page for best results",
                    sub_title: "Must be issued in the <strong>last 12 months</strong>",
                    title: "Government Letter",
                    webcam: "Position your government letter in the frame (it will be automatically detected)"
                }
            },
            liveness: {
                challenges: {
                    done_next: "When you're done, press next",
                    done_stop: "When you're done, press stop",
                    left: "left",
                    movement: "Look over your %{side} shoulder",
                    next: "Next",
                    position_face: "Position your face in the oval",
                    recite: "Say each digit out loud",
                    right: "right"
                },
                intro: {
                    continue: "Continue",
                    speak_out_loud: "One will involve <strong>speaking out loud</strong>",
                    title: "Let's make sure nobody's impersonating you",
                    two_actions: "We'll ask you to film yourself performing <strong>2 simple actions</strong>"
                },
                press_record: "Press record and follow the instructions",
                recording: "Recording",
                start: "Start",
                stop: "Stop"
            },
            national_identity_card: {
                back: {
                    instructions: "Upload the achterzijde van uw kaart vanaf uw computer. Alleen JPG, PNG en PDF zijn toegestaan.",
                    title: "Verstuur uw identiteitskaart (achterzijde)",
                    webcam: "Plaats de achterkant van uw kaart in het frame (hij wordt automatisch herkend)"
                },
                front: {
                    instructions: "Upload the voorkant van uw kaart vanaf uw computer. Alleen JPG, PNG en PDF zijn toegestaan.",
                    title: "Verstuur uw identiteitskaart (voorzijde)",
                    webcam: "Plaats de voorkant van uw kaart in het frame (hij wordt automatisch herkend)"
                }
            },
            passport: {
                front: {
                    instructions: "Upload een foto van de voorkant van een geldig paspoort (de harde plastic kaart). Alleen JPG, PNG en PDF zijn toegestaan.",
                    title: "Verstuur de foto van uw paspoort",
                    webcam: "Plaats de achterkant van uw kaart in het frame (hij wordt automatisch herkend)"
                }
            },
            switch_device: "Verder gaan op mobiel",
            take_photo: "Neem een foto",
            upload_document: "Uploaden",
            upload_file: "of upload een foto - geen scan of kopie gebruiken",
            utility_bill: {
                front: {
                    instructions: "Provide the whole document page for best results",
                    sub_title: "Must be issued in the <strong>last 3 months</strong>",
                    title: "Submit bill",
                    webcam: "Position your utility bill in the frame (it will be automatically detected)"
                }
            }
        },
        close: "sluiten",
        complete: {
            message: "Identificatie afgerond",
            submessage: "Dank u wel"
        },
        confirm: {
            bank_building_society_statement: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            benefit_letters: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            confirm: "Bevestig",
            continue: "Doorgaan",
            council_tax: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            document: {
                alt: "Foto van uw document",
                title: "Controleer de kwaliteit van de afbeelding"
            },
            driving_licence: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            enlarge_image: {
                close: "Sluiten",
                enlarge: "Vergroot afbeelding"
            },
            face: {
                standard: {
                    alt: "Photo of your face",
                    message: "Make sure your selfie clearly shows your face",
                    title: "Check selfie"
                },
                video: {
                    title: "Check selfie video"
                }
            },
            national_identity_card: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            passport: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            redo: "Opnieuw",
            utility_bill: {
                message: "Is de afbeelding scherp en leesbaar?"
            }
        },
        continue: "Doorgaan",
        council_tax: "Council Tax Letter",
        cross_device: {
            client_success: {
                body: "Het updaten van de aanvraag op uw computer kan enkele seconden duren",
                sub_title: "Ga terug naar uw computer om door te gaan",
                title: "Upload geslaagd"
            },
            intro: {
                face: {
                    title: "Identificatie veilig vervolgen op uw mobiel",
                    take_photos: "Open de link om de identificatie af te ronden",
                    action: "Doorgaan"
                },
                document: {
                    title: "Identificatie veilig vervolgen op uw mobiel",
                    take_photos: "Open de link om de identificatie af te ronden",
                    action: "Doorgaan"
                },
                link: {
                    sub_title: "Wij sturen u eenmalig een link naar uw mobiele telefoon",
                    link_copy: {
                        action: "Kopieer",
                        success: "Gekopieerd"
                    }
                },
                action: "Stuur mij de beveiligde link",
                description_li_1: "Stuur een beveiligde link naar mijn telefoon",
                description_li_2: "Open de link om de identificatie af te ronden",
                description_li_3: "Keer terug om de aanvraag af te ronden",
                sms: "Stuur een beveiligde link naar mijn telefoon",
                "take-photos": "Open de link om de identificatie af te ronden",
                "return-to-computer": "Keer terug om de aanvraag af te ronden",
                return_computer: "Keer terug om de aanvraag af te ronden",
                sub_title: "Zo werkt het:",
                title: "Doorgaan op mobiel"
            },
            link: {
                sub_title: "Wij sturen u eenmalig een link naar uw mobiele telefoon",
                button_copy: {
                    action: "Verstuur link",
                    status: "Versturen"
                },
                link_copy: {
                    action: "Kopieer",
                    success: "Gekopieerd"
                },
                copy_link_label: "Kopieer de link in uw mobiele browser",
                copy_link_option: "Link kopi\xebren",
                copy_link_sub_title: "Open the link on your mobile",
                copy_link: {
                    action: "Kopieer",
                    success: "Gekopieerd"
                },
                options_divider_label: "of",
                qr_code_option: "Scan de QR code",
                qr_code_sub_title: "Scan de QR code met uw mobiel",
                qr_code: {
                    help_label: "Hoe scant u de QR code?",
                    help_step_1: "Richt de camera van uw telefoon op de QR code",
                    help_step_2: "Werkt dit niet? Download dan de QR code scanner in de Google Play of App Store"
                },
                sms_label: "Voer het nummer van uw mobiele telefoon in:",
                sms_option: "Ontvang een link per SMS",
                sms_sub_title: "Stuur de one-time link naar uw mobiel",
                title: "Ontvang een beveiligde link"
            },
            loading: "Laden….",
            mobile_connected: {
                tips: {
                    item_1: "Houd het huidige scherm open terwijl u verder gaat op uw mobiele telefoon",
                    item_2: "De link die wij u hebben verstuurd blijft \xe9\xe9n uur actief",
                    item_3: "Ververs deze pagina niet"
                },
                title: {
                    message: "Verbonden met uw mobiele telefoon",
                    submessage: "Zodra u klaar bent, nemen wij u mee naar de volgende stap"
                }
            },
            mobile_notification_sent: {
                bold_message: "Het kan enkele minuten duren voordat u de SMS van ons ontvangt",
                resend_link: "Link nogmaals versturen",
                submessage: "Wij hebben een beveiligde link verstuurd naar: %{number}",
                tips: {
                    item_1: "Houd het huidige scherm open terwijl u verder gaat op uw mobiele telefoon",
                    item_2: "De link die wij u hebben verstuurd blijft \xe9\xe9n uur actief"
                },
                title: "Controleer uw mobiel"
            },
            phone_number_placeholder: "Voer uw telefoonnummer in",
            submit: {
                action: "Identificatie afronden",
                multiple_docs_uploaded: "Documenten ge\xfcpload",
                one_doc_uploaded: "Document ge\xfcpload",
                selfie_uploaded: "Selfie uploaded",
                sub_title: "Wij kunnen nu uw identiteit verifi\xebren",
                title: "Bedankt, wij hebben alles in goede orde ontvangen",
                video_uploaded: "Video uploaded"
            },
            switch_device: {
                header: "Maak een foto met uw telefoon",
                submessage: "Identificatie veilig vervolgen op uw mobiel"
            },
            tips: "Tips"
        },
        document_selector: {
            identity: {
                driving_licence_hint: "Voor- en achterkant",
                hint: "Kies het document waarmee u zichzelf wil identificeren",
                national_identity_card_hint: "Voor- en achterkant",
                passport_hint: "Pagina met uw pasfoto",
                title: "Identificeren"
            },
            proof_of_address: {
                benefits_letter_hint: "Government authorised household benefits eg. Jobseeker allowance, Housing benefit, Tax credits",
                estatements_accepted: "e-statements accepted",
                government_letter_hint: "Any government issued letter eg. Benefits entitlement, Voting letters, Tax letters, etc",
                hint: "These are the documents most likely to show your current home address",
                title: "Select a %{country} document",
                utility_bill_hint: "Gas, electricity, water, landline, or broadband",
                utility_bill_warning: "Sorry, no mobile phone bills"
            }
        },
        driving_licence: "Rijbewijs",
        errors: {
            camera_inactive_no_fallback: {
                instruction: "Make sure your device has a working camera"
            },
            camera_inactive: {
                instruction: "Check that it is connected and functional. You can also <fallback>continue verification on your phone</fallback>",
                message: "Camera werkt niet?"
            },
            camera_not_working_no_fallback: {
                instruction: "Zorg ervoor dat de camera van uw apparaat werkt"
            },
            camera_not_working: {
                instruction: "Mogelijk is de verbinding verbroken. <fallback>Probeer in plaats daarvan je telefoon te gebruiken</fallback>.",
                message: "Camera werkt niet"
            },
            forbidden_client_error: {
                instruction: "Deze link werkt uitsluitend op mobiele apparaten",
                message: "Er gaat iets mis"
            },
            generic_client_error: {
                instruction: "Wij vragen u de identificatie opnieuw te starten op uw computer",
                message: "Er gaat iets mis"
            },
            glare_detected: {
                instruction: "Alle gegevens moeten duidelijk en leesbaar zijn",
                message: "Te veel reflectie"
            },
            interrupted_flow_error: {
                instruction: "Probeer het opnieuw op een ander apparaat",
                message: "Camera niet gevonden"
            },
            invalid_capture: {
                instruction: "Zorg ervoor dat het gehele document op de foto staat",
                message: "Geen document gevonden"
            },
            invalid_number: {
                message: "Controleer uw nummer"
            },
            invalid_size: {
                instruction: "Maximaal 10MB.",
                message: "Het bestand is te groot."
            },
            invalid_type: {
                instruction: "Probeer een ander bestandsformaat.",
                message: "Bestand niet ge\xfcpload."
            },
            lazy_loading: {
                message: "Er is iets mis gegaan bij het laden van dit onderdeel"
            },
            liveness_timeout: {
                instruction: "Remember to press stop when you're done. <fallback>Redo video actions</fallback>",
                message: "U heeft te lang niets gedaan"
            },
            multiple_faces: {
                instruction: "Only your face can be in the selfie",
                message: "Multiple faces found"
            },
            no_face: {
                instruction: "Your face is needed in the selfie",
                message: "No face found"
            },
            server_error: {
                instruction: "Probeer het opnieuw",
                message: "Verbinding verbroken"
            },
            sms_failed: {
                instruction: "Kopieer de link naar uw mobiele telefoon",
                message: "Er gaat iets mis"
            },
            sms_overuse: {
                instruction: "Kopieer de link naar uw mobiele telefoon",
                message: "Te veel pogingen ondernomen"
            },
            unsupported_android_browser: {
                instruction: "Probeer het opnieuw in de laatste versie van Google Chrome.",
                message: "Deze browser wordt niet ondersteund"
            },
            unsupported_file: {
                instruction: "Probeer een JPG of PNG bestand",
                message: "Dit bestandsformaat wordt niet ondersteund"
            },
            unsupported_ios_browser: {
                instruction: "Probeer het opnieuw in de laatste versie van Safari",
                message: "Deze browser wordt niet ondersteund"
            }
        },
        government_letter: "Government Letter",
        loading: "Laden….",
        mobilePhrases: {
            capture: {
                driving_licence: {
                    back: {
                        instructions: "Take a photo of the back of your license"
                    },
                    front: {
                        instructions: "Take a photo of the front of your license"
                    }
                },
                face: {
                    instructions: "Take a selfie showing your face"
                },
                national_identity_card: {
                    back: {
                        instructions: "Maak een foto van de achterkant van uw kaart"
                    },
                    front: {
                        instructions: "Maak een foto van de voorkant van uw kaart"
                    }
                },
                passport: {
                    front: {
                        instructions: "Maak een foto van de harde plastic pagina in uw paspoort met daarop uw pasfoto"
                    }
                }
            },
            errors: {
                camera_inactive: {
                    instruction: "Take a photo using the <fallback>basic camera mode</fallback> instead"
                },
                camera_not_working: {
                    instruction: "Take a photo using the <fallback>basic camera mode</fallback> instead"
                }
            }
        },
        national_identity_card: "Identiteitskaart",
        passport: "Paspoort",
        proof_of_address: {
            guidance: {
                continue: "Doorgaan",
                current_address: "Current address",
                full_name: "Full name",
                issue_date: "Issue date or summary period",
                logo: "Logo",
                make_sure_it_shows: "Make sure it clearly shows:"
            },
            intro: {
                is_recent: "Is your most <strong>recent</strong> document",
                matches_signup: "<strong>Matches</strong> the address you used on signup",
                requirements: "You'll need a document that:",
                shows_address: "Shows your <strong>current</strong> address",
                start: "Start verification",
                title: "Let's verify your %{country} address"
            }
        },
        short_driving_licence: "Rijbewijs",
        short_national_identity_card: "kaart",
        short_passport: "paspoort",
        utility_bill: "Utility Bill",
        webcam_permissions: {
            access_denied: "Camera access is denied",
            allow: "Allow",
            allow_access: "Allow camera access",
            click_allow: "We cannot verify you without using your camera",
            enable_webcam: "Enable camera",
            enable_webcam_for_selfie: "When prompted, you must enable camera access to continue",
            follow_steps: "Follow these steps to recover camera access:",
            grant_access: "Grant access to your camera from your browser settings",
            if_denied: "If you deny camera access, you won't be able to take pictures and complete verification process.",
            recover_access: "Recover camera access to continue face verification",
            recovery: "Recovery",
            refresh: "Refresh",
            refresh_page: "Refresh this page to restart the identity verification process",
            why: "Why do I need to do this?"
        },
        welcome: {
            description_p_1: "To open a bank account, we will need to verify your identity.",
            description_p_2: "It will only take a couple of minutes.",
            next_button: "Identificeren",
            title: "Open your new bank account"
        }
    },
    remediation: {
        accessibility: {
            camera_view: "Camera",
            close_sdk_screen: "Scherm sluiten",
            country_select: "Selecteer land",
            cross_device_verification: "Hoe kunt u doorgaan op mobiel?",
            dismiss_alert: "Dismiss alert",
            document_types: "Geldige identiteitsbewijzen",
            replay_video: "Replay your recorded video",
            selfie_video_actions: "Actions to record a selfie video",
            shutter: "Maak een foto",
            start_recording: "Start recording",
            stop_recording: "Stop recording"
        },
        back: "terug",
        bank_building_society_statement: "Bank or building society statement",
        benefit_letters: "Benefits Letter",
        cancel: "Cancel",
        capture: {
            bank_building_society_statement: {
                front: {
                    instructions: "Provide the whole document page for best results",
                    sub_title: "Must be issued in the <strong>last 3 months</strong>",
                    title: "Submit statement",
                    webcam: "Position your bank statement in the frame (it will be automatically detected)"
                }
            },
            benefit_letters: {
                front: {
                    instructions: "Provide the whole document page for best results",
                    sub_title: "Must be issued in the <strong>last 12 months</strong>",
                    title: "Submit letter",
                    webcam: "Position your benefits letter in the frame (it will be automatically detected)"
                }
            },
            council_tax: {
                front: {
                    instructions: "Provide the whole document page for best results",
                    sub_title: "Must be issued in the <strong>last 12 months</strong>",
                    title: "Submit letter",
                    webcam: "Position your council tax letter in the frame (it will be automatically detected)"
                }
            },
            driving_licence: {
                back: {
                    instructions: "Upload back of license from your computer",
                    title: "Submit license (back)",
                    webcam: "Position the back of license in the frame (it will be automatically detected)"
                },
                front: {
                    instructions: "Upload front of license from your computer",
                    title: "Submit license (front)",
                    webcam: "Position the front of license in the frame (it will be automatically detected)"
                }
            },
            face: {
                instructions: "Upload a selfie from your computer",
                intro: {
                    accessibility: {
                        selfie_capture_tips: "Tips to take a good selfie"
                    },
                    glasses_instruction: "Remove your glasses, if necessary",
                    selfie_instruction: "Face forward and make sure your eyes are clearly visible",
                    subtitle: "We'll compare it with your document",
                    title: "Take a selfie"
                },
                title: "Take a selfie",
                upload_title: "Selfie"
            },
            government_letter: {
                front: {
                    instructions: "Provide the whole document page for best results",
                    sub_title: "Must be issued in the <strong>last 12 months</strong>",
                    title: "Government Letter",
                    webcam: "Position your government letter in the frame (it will be automatically detected)"
                }
            },
            liveness: {
                challenges: {
                    done_next: "When you're done, press next",
                    done_stop: "When you're done, press stop",
                    left: "left",
                    movement: "Look over your %{side} shoulder",
                    next: "Next",
                    position_face: "Position your face in the oval",
                    recite: "Say each digit out loud",
                    right: "right"
                },
                intro: {
                    continue: "Continue",
                    speak_out_loud: "One will involve <strong>speaking out loud</strong>",
                    title: "Let's make sure nobody's impersonating you",
                    two_actions: "We'll ask you to film yourself performing <strong>2 simple actions</strong>"
                },
                press_record: "Press record and follow the instructions",
                recording: "Recording",
                start: "Start",
                stop: "Stop"
            },
            national_identity_card: {
                back: {
                    instructions: "Upload een foto van de achterkant van uw identiteitskaart. (JPG, PNG of PDF)",
                    title: "Verstuur uw identiteitskaart (achterzijde)",
                    webcam: "Plaats de achterkant van uw kaart in het frame (hij wordt automatisch herkend)"
                },
                front: {
                    instructions: "Upload een foto van de voorkant van uw identiteitskaart. (JPG, PNG of PDF)",
                    title: "Verstuur uw identiteitskaart (voorzijde)",
                    webcam: "Plaats de voorkant van uw kaart in het frame (hij wordt automatisch herkend)"
                }
            },
            passport: {
                front: {
                    instructions: "Upload een foto van de voorkant van uw paspoort (harde plastic kaart). (JPG, PNG of PDF)",
                    title: "Verstuur de foto van uw paspoort",
                    webcam: "Plaats de achterkant van uw kaart in het frame (hij wordt automatisch herkend)"
                }
            },
            switch_device: "Verder gaan op mobiel",
            take_photo: "Maak een foto",
            upload_document: "Uploaden",
            upload_file: "Upload een foto",
            utility_bill: {
                front: {
                    instructions: "Provide the whole document page for best results",
                    sub_title: "Must be issued in the <strong>last 3 months</strong>",
                    title: "Submit bill",
                    webcam: "Position your utility bill in the frame (it will be automatically detected)"
                }
            }
        },
        close: "sluiten",
        complete: {
            message: "Identificatie afgerond",
            submessage: "Dank u wel"
        },
        confirm: {
            bank_building_society_statement: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            benefit_letters: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            confirm: "Bevestig",
            continue: "Doorgaan",
            council_tax: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            document: {
                alt: "Foto van uw document",
                title: "Controleer de kwaliteit van de afbeelding"
            },
            driving_licence: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            enlarge_image: {
                close: "Sluiten",
                enlarge: "Vergroot afbeelding"
            },
            face: {
                standard: {
                    alt: "Photo of your face",
                    message: "Make sure your selfie clearly shows your face",
                    title: "Check selfie"
                },
                video: {
                    title: "Check selfie video"
                }
            },
            national_identity_card: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            passport: {
                message: "Is de afbeelding scherp en leesbaar?"
            },
            redo: "Opnieuw",
            utility_bill: {
                message: "Is de afbeelding scherp en leesbaar?"
            }
        },
        continue: "Doorgaan",
        council_tax: "Council Tax Letter",
        cross_device: {
            client_success: {
                body: "Het updaten van het identificatieproces op uw computer kan enkele seconden duren.",
                sub_title: "Ga terug naar uw computer om door te gaan",
                title: "Upload ID-document geslaagd"
            },
            intro: {
                face: {
                    title: "Identificatie veilig vervolgen op uw mobiel",
                    take_photos: "Open de link om de identificatie af te ronden",
                    action: "Doorgaan"
                },
                document: {
                    title: "Identificatie veilig vervolgen op uw mobiel",
                    take_photos: "Open de link om de identificatie af te ronden",
                    action: "Doorgaan"
                },
                link: {
                    sub_title: "Wij sturen u eenmalig een link uw mobiele telefoon.",
                    link_copy: {
                        action: "Kopieer",
                        success: "Gekopieerd"
                    }
                },
                action: "Stuur mij de beveiligde link",
                description_li_1: "Stuur per sms een beveiligde link naar mijn telefoon.",
                description_li_2: "Open de link om de identificatie af te ronden",
                description_li_3: "Keer terug om de aanvraag af te ronden",
                sms: "Stuur per sms een beveiligde link naar mijn telefoon.",
                "take-photos": "Open de link om de identificatie af te ronden",
                "return-to-computer": "Keer terug om de aanvraag af te ronden",
                return_computer: "Keer terug om de aanvraag af te ronden",
                sub_title: "Zo werkt het:",
                title: "Doorgaan op mobiel"
            },
            link: {
                sub_title: "Wij sturen u eenmalig een link uw mobiele telefoon.",
                button_copy: {
                    action: "Verstuur link",
                    status: "Versturen"
                },
                link_copy: {
                    action: "Kopieer",
                    success: "Gekopieerd"
                },
                copy_link_label: "Kopieer de link in uw mobiele browser",
                copy_link_option: "Link kopi\xebren",
                copy_link_sub_title: "Open the link on your mobile",
                copy_link: {
                    action: "Kopieer",
                    success: "Gekopieerd"
                },
                options_divider_label: "of",
                qr_code_option: "Scan de QR code",
                qr_code_sub_title: "Scan de QR code met uw mobiel",
                qr_code: {
                    help_label: "Hoe scant u de QR code?",
                    help_step_1: "Richt de camera van uw telefoon op de QR code",
                    help_step_2: "Werkt dit niet? Download dan de QR code scanner in de Google Play of App Store"
                },
                sms_label: "Voer het nummer van uw mobiele telefoon in:",
                sms_option: "Ontvang een link per SMS",
                sms_sub_title: "Stuur de one-time link naar uw mobiel",
                title: "Ontvang een beveiligde link"
            },
            loading: "Laden….",
            mobile_connected: {
                tips: {
                    item_1: "Houd het huidige scherm open terwijl u verder gaat op uw mobiele telefoon",
                    item_2: "De link die wij naar u hebben gestuurd blijft \xe9\xe9n uur actief.",
                    item_3: "Ververs deze pagina niet"
                },
                title: {
                    message: "Verbonden met uw mobiele telefoon",
                    submessage: "Zodra u klaar bent, nemen wij u mee naar de volgende stap"
                }
            },
            mobile_notification_sent: {
                bold_message: "Het kan enkele minuten duren voordat u de SMS van ons ontvangt",
                resend_link: "Link nogmaals versturen",
                submessage: "Wij hebben een beveiligde link verstuurd naar: %{number}",
                tips: {
                    item_1: "Houd het huidige scherm open terwijl u verder gaat op uw mobiele telefoon",
                    item_2: "De link die wij naar u hebben gestuurd blijft \xe9\xe9n uur actief."
                },
                title: "Controleer uw mobiel"
            },
            phone_number_placeholder: "Voer uw telefoonnummer in",
            submit: {
                action: "Identificatie afronden",
                multiple_docs_uploaded: "Documenten ge\xfcpload",
                one_doc_uploaded: "Document ge\xfcpload",
                selfie_uploaded: "Selfie uploaded",
                sub_title: "Wij kunnen nu uw identiteit verifi\xebren",
                title: "Bedankt, wij hebben alles in goede orde ontvangen",
                video_uploaded: "Video uploaded"
            },
            switch_device: {
                header: "Maak een foto met uw telefoon",
                submessage: "Identificatie veilig vervolgen op uw mobiel"
            },
            tips: "Tips"
        },
        document_selector: {
            identity: {
                driving_licence_hint: "Voor- en achterkant",
                hint: "Kies het document waarmee u zichzelf wilt identificeren.",
                national_identity_card_hint: "Voor- en achterkant",
                passport_hint: "Pagina met uw pasfoto",
                title: "Upload uw ID-document"
            },
            proof_of_address: {
                benefits_letter_hint: "Government authorised household benefits eg. Jobseeker allowance, Housing benefit, Tax credits",
                estatements_accepted: "e-statements accepted",
                government_letter_hint: "Any government issued letter eg. Benefits entitlement, Voting letters, Tax letters, etc",
                hint: "These are the documents most likely to show your current home address",
                title: "Select a %{country} document",
                utility_bill_hint: "Gas, electricity, water, landline, or broadband",
                utility_bill_warning: "Sorry, no mobile phone bills"
            }
        },
        driving_licence: "Rijbewijs",
        errors: {
            camera_inactive_no_fallback: {
                instruction: "Make sure your device has a working camera"
            },
            camera_inactive: {
                instruction: "Check that it is connected and functional. You can also <fallback>continue verification on your phone</fallback>",
                message: "Camera werkt niet?"
            },
            camera_not_working_no_fallback: {
                instruction: "Zorg ervoor dat de camera van uw apparaat werkt"
            },
            camera_not_working: {
                instruction: "Mogelijk is de verbinding verbroken. <fallback>Probeer in plaats daarvan je telefoon te gebruiken</fallback>.",
                message: "Camera werkt niet"
            },
            forbidden_client_error: {
                instruction: "Deze link werkt uitsluitend op mobiele apparaten",
                message: "Er gaat iets mis"
            },
            generic_client_error: {
                instruction: "Wij vragen u de identificatie opnieuw te starten op uw computer",
                message: "Er gaat iets mis"
            },
            glare_detected: {
                instruction: "Alle gegevens moeten duidelijk en leesbaar zijn",
                message: "Te veel reflectie"
            },
            interrupted_flow_error: {
                instruction: "Probeer het opnieuw op een ander apparaat",
                message: "Camera niet gevonden"
            },
            invalid_capture: {
                instruction: "Zorg ervoor dat het gehele document op de foto staat",
                message: "Geen document gevonden"
            },
            invalid_number: {
                message: "Controleer uw nummer"
            },
            invalid_size: {
                instruction: "Maximaal 10MB.",
                message: "Het bestand is te groot."
            },
            invalid_type: {
                instruction: "Probeer een ander bestandsformaat.",
                message: "Bestand niet ge\xfcpload."
            },
            lazy_loading: {
                message: "Er is iets mis gegaan bij het laden van dit onderdeel"
            },
            liveness_timeout: {
                instruction: "Remember to press stop when you're done. <fallback>Redo video actions</fallback>",
                message: "U heeft te lang niets gedaan"
            },
            multiple_faces: {
                instruction: "Only your face can be in the selfie",
                message: "Multiple faces found"
            },
            no_face: {
                instruction: "Your face is needed in the selfie",
                message: "No face found"
            },
            server_error: {
                instruction: "Probeer het opnieuw",
                message: "Verbinding verbroken"
            },
            sms_failed: {
                instruction: "Kopieer de link naar uw mobiele telefoon",
                message: "Er gaat iets mis"
            },
            sms_overuse: {
                instruction: "Kopieer de link naar uw mobiele telefoon",
                message: "Te veel pogingen ondernomen"
            },
            unsupported_android_browser: {
                instruction: "Probeer het opnieuw in de laatste versie van Google Chrome.",
                message: "Deze browser wordt niet ondersteund"
            },
            unsupported_file: {
                instruction: "Probeer een JPG of PNG bestand",
                message: "Dit bestandsformaat wordt niet ondersteund"
            },
            unsupported_ios_browser: {
                instruction: "Probeer het opnieuw in de laatste versie van Safari",
                message: "Deze browser wordt niet ondersteund"
            }
        },
        government_letter: "Government Letter",
        loading: "Laden….",
        mobilePhrases: {
            capture: {
                driving_licence: {
                    back: {
                        instructions: "Take a photo of the back of your license"
                    },
                    front: {
                        instructions: "Take a photo of the front of your license"
                    }
                },
                face: {
                    instructions: "Take a selfie showing your face"
                },
                national_identity_card: {
                    back: {
                        instructions: "Maak een foto van de achterkant van uw kaart"
                    },
                    front: {
                        instructions: "Maak een foto van de voorkant van uw kaart"
                    }
                },
                passport: {
                    front: {
                        instructions: "Maak een foto van de harde plastic pagina in uw paspoort met daarop uw pasfoto"
                    }
                }
            },
            errors: {
                camera_inactive: {
                    instruction: "Take a photo using the <fallback>basic camera mode</fallback> instead"
                },
                camera_not_working: {
                    instruction: "Take a photo using the <fallback>basic camera mode</fallback> instead"
                }
            }
        },
        national_identity_card: "Identiteitskaart",
        passport: "Paspoort",
        proof_of_address: {
            guidance: {
                continue: "Doorgaan",
                current_address: "Current address",
                full_name: "Full name",
                issue_date: "Issue date or summary period",
                logo: "Logo",
                make_sure_it_shows: "Make sure it clearly shows:"
            },
            intro: {
                is_recent: "Is your most <strong>recent</strong> document",
                matches_signup: "<strong>Matches</strong> the address you used on signup",
                requirements: "You'll need a document that:",
                shows_address: "Shows your <strong>current</strong> address",
                start: "Start verification",
                title: "Let's verify your %{country} address"
            }
        },
        short_driving_licence: "Rijbewijs",
        short_national_identity_card: "kaart",
        short_passport: "paspoort",
        utility_bill: "Utility Bill",
        webcam_permissions: {
            access_denied: "Camera access is denied",
            allow: "Allow",
            allow_access: "Allow camera access",
            click_allow: "We cannot verify you without using your camera",
            enable_webcam: "Enable camera",
            enable_webcam_for_selfie: "When prompted, you must enable camera access to continue",
            follow_steps: "Follow these steps to recover camera access:",
            grant_access: "Grant access to your camera from your browser settings",
            if_denied: "If you deny camera access, you won't be able to take pictures and complete verification process.",
            recover_access: "Recover camera access to continue face verification",
            recovery: "Recovery",
            refresh: "Refresh",
            refresh_page: "Refresh this page to restart the identity verification process",
            why: "Why do I need to do this?"
        },
        welcome: {
            description_p_1: "To open a bank account, we will need to verify your identity.",
            description_p_2: "It will only take a couple of minutes.",
            next_button: "Identificeren",
            title: "Open your new bank account"
        }
    }
};


/* eslint-disable @typescript-eslint/camelcase */ const $bebfea808891e4bf$export$da6d97d62be0b0d8 = {
    acquisition: {
        country_select: {
            alert_dropdown: {
                country_not_found: "Land niet gevonden"
            },
            alert: {
                another_doc: "Documenten uit dat land worden momenteel niet ondersteund — <fallback>probeer een ander document type</fallback>"
            },
            button_primary: "Verzend document",
            search: {
                accessibility: "Selecteer land",
                input_placeholder: "Standaard land",
                label: "Zoek land"
            },
            title: "Zoek land van uitgave"
        },
        cross_device_checklist: {
            button_primary: "Verzend verificatie",
            info: "Tips",
            list_item_doc_multiple: "Documenten ge\xfcpload",
            list_item_doc_one: "Document ge\xfcpload",
            list_item_selfie: "Foto van uzelf ge\xfcpload",
            list_item_video: "Video ge\xfcpload",
            subtitle: "Wij zijn nu gereed om uw identiteit te verifi\xebren",
            title: "Bedankt, dat is alles wat we nodig hebben"
        },
        cross_device_error_desktop: {
            subtitle: "Deze linkt werkt alleen op een mobiele telefoon",
            title: "Er ging iets verkeerd"
        },
        cross_device_error_restart: {
            subtitle: "U zult de verificatie moeten herstarten op uw computer",
            title: "Er ging iets verkeerd"
        },
        cross_device_intro: {
            button_primary: "Ontvang de beveiligde link",
            list_accessibility: "Vereiste stappen om door te gaan met de verificatie op uw mobiele telefoon",
            list_item_finish: "Kom hier terug om uw aanvraag af te ronden",
            list_item_open_link: "Open de link en voltooi de openstaande taken",
            list_item_send_phone: "Stuur een beveiligde link naar uw mobiele telefoon",
            subtitle: "Zo werkt het:",
            title: "Ga verder op uw telefoon"
        },
        cross_device_return: {
            body: "Uw computer heeft wellicht enkele seconden nodig om te updaten",
            subtitle: "U kunt nu verder gaan op uw computer",
            title: "Upload geslaagd"
        },
        doc_confirmation: {
            alert: {
                blur_detail: "Zorg ervoor dat u een heldere foto kunt maken",
                blur_title: "Onscherpe foto gedetecteerd",
                crop_detail: "Zorg ervoor dat het gehele document goed zichtbaar is",
                crop_title: "Afgesneden beelden gedetecteerd",
                glare_detail: "Stap weg van direct licht",
                glare_title: "Schitteringen gedetecteerd",
                no_doc_detail: "Zorg ervoor dat het gehele document goed zichtbaar is in de foto",
                no_doc_title: "Geen document gevonden"
            },
            body_bank_statement: "Zorg ervoor dat details goed leesbaar zijn, scherp zijn en zonder schittering",
            body_benefits_letter: "Zorg ervoor dat details goed leesbaar zijn, scherp zijn en zonder schittering",
            body_bill: "Zorg ervoor dat details goed leesbaar zijn, scherp zijn en zonder schittering",
            body_id: "Zijn de details op uw kaart goed leesbaar? Is de foto scherp en zonder schitteringen?",
            body_image_medium: "De verificatie kan langer duren indien het document niet goed leesbaar is",
            body_image_poor: "Om u goed te kunnen verifi\xebren hebben wij een betere foto nodig",
            body_license: "Is uw rijbewijs goed leesbaar? Is de foto scherp en zonder schitteringen?",
            body_passport: "Is uw paspoort goed leesbaar? Is de foto scherp en zonder schitteringen?",
            body_permit: "Is uw verblijfsvergunning goed leesbaar? Is de foto scherp en zonder schitteringen?",
            body_tax_letter: "Zijn alle details goed leesbaar? Is de foto scherp en zonder schitteringen?",
            button_close: "Sluiten",
            button_primary_redo: "Opnieuw",
            button_primary_upload: "Bevestig",
            button_primary_upload_anyway: "Toch uploaden",
            button_secondary_redo: "Opnieuw",
            button_zoom: "Vergroot afbeelding",
            image_accessibility: "Foto van uw document",
            title: "Controleer uw foto"
        },
        doc_select: {
            button_bank_statement: "een recent bankafschrift;",
            button_benefits_letter: "Opgave van uw uitkeringsinstantie",
            button_benefits_letter_detail: "Opgave van uw uitkeringsinstantie zoals bijvoorbeeld WW uitkering of Pensioen uitkering.",
            button_bill: "een document vanuit een overheidsinstantie",
            button_bill_detail: "Gas, water, licht, telefoon, internet",
            button_government_letter: "een document vanuit een overheidsinstantie",
            button_government_letter_detail: "Een document vanuit een overheidsinstantie zoals WW opgave of belastingaanslag",
            button_id: "Identiteitskaart",
            button_id_detail: "Voor en achterzijde",
            button_license: "Rijbewijs",
            button_license_detail: "Voor en achterzijde",
            button_passport: "Paspoort",
            button_passport_detail: "Pagina met uw pasfoto",
            button_permit: "Verblijfsvergunning",
            button_permit_detail: "Voor en achterzijde",
            button_tax_letter: "Gemeentebelastingen document",
            extra_estatements_ok: "digitale afschriften worden geaccepteerd",
            extra_no_mobile: "Excuus, geen mobiele telefoonrekeningen ",
            list_accessibility: "Documenten die u kunt gebruiken om uw identiteit te verifieren",
            subtitle: "Dit dient een officieel identiteitsbewijs met foto te zijn",
            subtitle_poa: "De volgende documenten bevatten hoogst waarschijnlijk uw huidige woonadres",
            title: "Kies uw document",
            title_poa: "Selecteer een %{country} document"
        },
        doc_submit: {
            button_link_upload: "of upload foto - geen scans of fotokopie\xebn toegestaan",
            button_primary: "Ga verder op telefoon",
            subtitle: "Neem een foto met uw telefoon",
            title_bank_statement: "Verstuur bankafschrift",
            title_benefits_letter: "Verstuur brief ",
            title_bill: "Verstuur rekening",
            title_government_letter: "Overheidsdocument",
            title_id_back: "Neem een foto van de achterzijde van uw identiteitskaart",
            title_id_front: "Neem een foto van de voorzijde van uw identiteitskaart",
            title_license_back: "Verstuur rijbewijs toe (achterzijde)",
            title_license_front: "Verstuur rijbewijs toe (voorzijde)",
            title_passport: "Neem een foto van de fotopagina van uw paspoort",
            title_permit_back: "Neem een foto van de achterzijde van uw verblijfsvergunning",
            title_permit_front: "Neem een foto van de voorzijde van uw verblijfsvergunning",
            title_tax_letter: "Verstuur belastingaangifte"
        },
        error_unsupported_browser: {
            subtitle_android: "Herstart het proces met de laatste versie van Google Chrome",
            subtitle_ios: "Herstart het proces met de laatste versie van Safari",
            title_android: "Niet ondersteunde browser",
            title_ios: "Niet ondersteunde browser"
        },
        generic: {
            accessibility: {
                close_sdk_screen: "Sluit het verificatie scherm",
                dismiss_alert: "Dismiss alert"
            },
            back: "terug",
            close: "Sluit",
            errors: {
                interrupted_flow_error: {
                    instruction: "Probeer het proces opnieuw te starten op een ander apparaat",
                    message: "Camera niet gedetecteerd"
                },
                invalid_size: {
                    instruction: "Maximaal 10MB",
                    message: "Maximum grootte overschreden"
                },
                invalid_type: {
                    instruction: "Probeer een andere type file",
                    message: "Bestand niet geupload"
                },
                lazy_loading: {
                    message: "Er is een fout opgetreden tijdens het laden"
                },
                multiple_faces: {
                    instruction: "Alleen uw gezicht mag in de foto van uzelf",
                    message: "Meerdere gezichten gedetecteerd"
                },
                no_face: {
                    instruction: "Uw gezicht is vereist in de foto van uzelf",
                    message: "Geen gezicht gedetecteerd"
                },
                request_error: {
                    instruction: "Probeer het a.u.b. opnieuw",
                    message: "Connectie verloren"
                },
                sms_failed: {
                    instruction: "Kopier de link naar uw telefoon",
                    message: "Er ging iets mis"
                },
                sms_overuse: {
                    instruction: "Kopier de link naar uw telefoon",
                    message: "Teveel verkeerde pogingen"
                },
                unsupported_file: {
                    instruction: "Probeer een JPG of een PNG bestand",
                    message: "Document wordt niet ondersteund"
                }
            },
            lazy_load_placeholder: "Laden...",
            loading: "Laden..."
        },
        get_link: {
            alert_wrong_number: "Controleer of uw nummer correct is",
            button_copied: "Gekopieerd",
            button_copy: "Kopieer",
            button_submit: "Verstuur link",
            info_qr_how: "Hoe scant u de QR code?",
            info_qr_how_list_item_camera: "Richt de camera van uw telefoon op de QR code",
            info_qr_how_list_item_download: "Indien het niet werkt download dan een QR code scanner van Google Play of vanuit de App Store",
            link_divider: "of",
            link_qr: "Scan QR code",
            link_sms: "Ontvang link via SMS",
            link_url: "Kopier link",
            loader_sending: "Versturen",
            number_field_input_placeholder: "Voer uw mobiele nummer in",
            number_field_label: "Voer mobiele nummer in",
            subtitle_qr: "Scan de QR code met uw mobiel",
            subtitle_sms: "Stuur deze eenmalige link naar uw telefoon",
            subtitle_url: "Open de link op uw mobiele telefoon",
            title: "Ontvang de beveiligde link",
            url_field_label: "Kopieer de link in uw mobiele browser"
        },
        linked_computer: {
            button_primary: "Doorgaan",
            info: "Zorg ervoor",
            list_item_desktop_open: "Uw desktop tabblad blijft open",
            list_item_sent_by_you: "De link is door u verstuurd",
            subtitle: "Ga door met de verificatie",
            title: "Verbonden met uw computer"
        },
        mobilePhrases: {
            photo_upload: {
                body_id_back: "Neem een foto van de achterzijde van uw kaart",
                body_id_front: "Neem een foto van de voorzijde van uw kaart",
                body_license_back: "Neem een foto van de achterzijde van uw rijbewijs",
                body_license_front: "Neem een foto van de voorzijde van uw rijbewijs",
                body_passport: "Neem een foto van de paspoort fotopagina",
                body_selfie: "Neem een foto van uw gezicht"
            },
            selfie_capture: {
                alert: {
                    camera_inactive: {
                        detail: "Neem een foto met de </fallback> standaard camera modus </fallback>"
                    },
                    camera_not_working: {
                        detail: "Neem een foto met de </fallback> standaard camera modus </fallback>"
                    }
                }
            },
            upload_guide: {
                button_primary: "Neem een foto",
                title: "Paspoort fotopagina"
            }
        },
        outro: {
            body: "Dank u wel",
            title: "Verificatie compleet"
        },
        permission_recovery: {
            button_primary: "Vernieuw",
            info: "Herstel",
            list_header_cam: "Volg deze stappen om uw camera opnieuw toegang te geven",
            list_item_action_cam: "Ververs deze pagina om het identificatie verificatie proces te herstarten",
            list_item_how_to_cam: "Geef toegang aan uw camera vanuit uw browser instellingen",
            subtitle_cam: "Geef camera opnieuw toegang om gezichtverficatie te continueren",
            title_cam: "Camera toegang is geweigerd"
        },
        permission: {
            body_cam: "Wij kunnen u niet verifieren zonder het gebruik van uw camera",
            button_primary_cam: "Inschakelen camera",
            subtitle_cam: "Wanneer gevraagd dient u eerst toegang te geven tot uw camera",
            title_cam: "Geef toegang tot uw camera"
        },
        photo_upload: {
            body_bank_statement: "Geef het hele document weer voor het beste resultaat",
            body_benefits_letter: "Geef het hele document weer voor het beste resultaat",
            body_bill: "Geef het hele document weer voor het beste resultaat",
            body_government_letter: "Geef het hele document weer voor het beste resultaat",
            body_id_back: " ",
            body_id_front: " ",
            body_license_back: " ",
            body_license_front: " ",
            body_passport: " ",
            body_selfie: " ",
            body_tax_letter: "Geef de hele pagina weer voor het beste resultaat",
            button_take_photo: "Neem een foto",
            button_upload: "Upload",
            title_selfie: "Foto van uzelf"
        },
        poa_guidance: {
            button_primary: "Doorgaan",
            instructions: {
                address: "Huidig adres",
                full_name: "Volledige naam",
                issue_date: "Datum van uitgifte",
                label: "Zorg ervoor dat alles goed duidelijk is",
                logo: "Logo"
            },
            subtitle_bank_statement: "Moet zijn uitgegeven in de <strong>laatste 3 maanden</strong>",
            subtitle_benefits_letter: "Moet zijn uitgegeven in de <strong>laatste 12 maanden</strong>",
            subtitle_bill: "Moet zijn uitgegeven in de <strong>laatste 12 maanden</strong>",
            subtitle_government_letter: "Moet zijn uitgegeven in de <strong>laatste 12 maanden</strong>",
            subtitle_tax_letter: "Moet zijn uitgegeven in de <strong>laatste 12 maanden</strong>"
        },
        poa_intro: {
            button_primary: "Start verificatie",
            list_matches_signup: "<strong>Komt overeen met</strong> het adres dat u gebruikt heeft met uw aanvraag",
            list_most_recent: "Is uw meest <strong>recente</strong> document",
            list_shows_address: "Toont uw <strong>huidige</strong> adres",
            subtitle: "U heeft een document nodig dat:",
            title: "Laten we uw %{country} adres"
        },
        selfie_capture: {
            alert: {
                camera_inactive: {
                    detail: "Controleer of uw verbonden bent en alles goed werkt. U kunt ook <fallback>verdergaan met de verificatie via uw telefoon</fallback>",
                    detail_no_fallback: "Zorg ervoor dat uw apparaat een werkende camera heeft",
                    title: "Werkt uw camera niet?"
                },
                camera_not_working: {
                    detail: "De verbinding lijkt verbroken. <fallback>Probeer het via anders via uw telefoon</fallback>",
                    detail_no_fallback: "Zorg ervoor dat de camera van uw apparaat werkt",
                    title: "Camera werkt niet"
                },
                timeout: {
                    detail: "Druk op stop wanneer u klaar bent. <fallback>Opnieuw</fallback>",
                    title: "Het duurde te lang"
                }
            },
            button_accessibility: "Neem een foto",
            frame_accessibility: "Zo ziet het eruit",
            title: "Neem een foto van uzelf "
        },
        selfie_confirmation: {
            image_accessibility: "Foto van uw gezicht",
            subtitle: "Zorg ervoor dat uw gezicht duidelijk zichtbaar is op de foto",
            title: "Bekijk uw eigen foto"
        },
        selfie_intro: {
            button_primary: "Doorgaan",
            list_accessibility: "Tips om een goede foto van uzelf te maken",
            list_item_face_forward: "Gezicht naar voren en zorg ervoor dat uw ogen goed zichtbaar zijn",
            list_item_no_glasses: "Verwijder uw bril indien nodig",
            subtitle: "We vergelijken het met uw document",
            title: "Neem een foto van uzelf"
        },
        sms_sent: {
            info: "Tips",
            info_link_expire: "Uw link is 1 uur geldig",
            info_link_window: "Houd dit tabblad open wanneer u uw telefoon gebruikt",
            link: "Link nogmaals versturen",
            subtitle: "We hebben een beveiligde link gestuurd naar %{number}",
            subtitle_minutes: "Het kan enkele minuten duren voordat u het ontvangt",
            title: "Controleer uw mobiel"
        },
        switch_phone: {
            info: "Tips",
            info_link_expire: "De link die u heeft ontvangen op uw mobiele telefoon is 1 uur geldig",
            info_link_refresh: "Ververs deze pagina niet",
            info_link_window: "Houd dit tabblad open wanneer u uw telefoon gebruikt",
            link: "Cancel",
            subtitle: "Wanneer u gereed bent gaan we door naar de volgende stap",
            title: "Verbonden met uw mobiele telefoon"
        },
        upload_guide: {
            button_primary: "Neem een foto",
            image_detail_blur_alt: "Voorbeeld van een onscherp document",
            image_detail_blur_label: "Alle details moeten goed zichtbaar zijn - niet vaag",
            image_detail_cutoff_alt: "Voorbeeld van een afgesneden document",
            image_detail_cutoff_label: "Laat alle details zien - inclusief de onderste 2 regels",
            image_detail_glare_alt: "Voorbeeld van een document met schitteringen",
            image_detail_glare_label: "Stap uit direct licht - geen schittering",
            image_detail_good_alt: "Voorbeeld document",
            image_detail_good_label: "Op de foto dient uw document goed zichtbaar te zijn",
            subtitle: "Scans en fotokopie\xebn zijn niet toegestaan",
            title: "Neem een foto van de fotopagina van uw paspoort"
        },
        video_capture: {
            body: "Plaats uw gezicht in het ovaal",
            body_next: "Wanneer u gereed bent, klik op volgende",
            body_record: "Druk op opnemen en volg de instructies",
            body_stop: "Wanneer u gereed bent, klik op stop",
            button_primary_next: "Volgende",
            button_record_accessibility: "Start opnemen",
            button_stop_accessibility: "Stop opnemen",
            frame_accessibility: "Camera standpunt",
            header: {
                challenge_digit_instructions: "Zeg elk cijfer hardop",
                challenge_turn_left: "Linker",
                challenge_turn_right: "Rechter",
                challenge_turn_template: "Kijk over uw %{side} schouder"
            },
            status: "Opnemen"
        },
        video_confirmation: {
            title: "Bekijk uw de video van uzelf",
            video_accessibility: "Speel uw opgenomen video nogmaals af"
        },
        video_intro: {
            button_primary: "Doorgaan",
            list_accessibility: "Stappen om een video van uzelf te maken",
            list_item_actions: "Wij vragen u uzelf op te nemen terwijl u <strong>2 simpele handelingen uitvoerd</strong>",
            list_item_speak: "Een daarvan vereist dat u <strong>hardop spreekt</strong>",
            title: "Laten we zorgen dat niemand u imiteert"
        },
        welcome: {
            description_p_1: "Om een bankrekening te openen zullen wij uw gegevens moeten verifieren ",
            description_p_2: "Het duurt maar enkele minuten",
            next_button: "Veifieer identiteit",
            title: "Open uw nieuwe bankrekening"
        }
    }
};




const $0dc99bcc7526b6f0$export$62cc401851868c8a = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { sdkToken: sdkToken, flow: flow, forceMobile: forceMobile, onfidoNew: onfidoNew } = store.ClientState;
    const mountOnfido = ()=>{
        const onfido = window.Onfido;
        const documentTypesOnfidoOld = {
            passport: store.AppConfig.onfidoConfig.documentTypes.passport,
            // eslint-disable-next-line @typescript-eslint/camelcase
            driving_licence: false,
            // eslint-disable-next-line @typescript-eslint/camelcase
            national_identity_card: store.AppConfig.onfidoConfig.documentTypes.national_identity_card
        };
        const documentTypesOnfidoNew = {
            passport: true,
            // eslint-disable-next-line @typescript-eslint/camelcase
            driving_licence: false,
            // eslint-disable-next-line @typescript-eslint/camelcase
            national_identity_card: {
                country: (0, (/*@__PURE__*/$parcel$interopDefault($c2e5bbb2812aaec2$exports)))(store.ClientState.selectedCountry.toUpperCase())
            }
        };
        if (store.ClientState.selectedCountry === "NL") // eslint-disable-next-line @typescript-eslint/camelcase
        documentTypesOnfidoNew.residence_permit = {
            country: (0, (/*@__PURE__*/$parcel$interopDefault($c2e5bbb2812aaec2$exports)))(store.ClientState.selectedCountry.toUpperCase())
        };
        else // eslint-disable-next-line @typescript-eslint/camelcase
        documentTypesOnfidoNew.residence_permit = false;
        if ((0, $e435c181395b7814$exports.eeaMember)(store.ClientState.selectedCountry.toUpperCase())) // eslint-disable-next-line @typescript-eslint/camelcase
        documentTypesOnfidoNew.national_identity_card = {
            country: (0, (/*@__PURE__*/$parcel$interopDefault($c2e5bbb2812aaec2$exports)))(store.ClientState.selectedCountry.toUpperCase())
        };
        else // eslint-disable-next-line @typescript-eslint/camelcase
        documentTypesOnfidoNew.national_identity_card = false;
        if (sdkToken) onfido.init({
            token: sdkToken,
            containerId: "onfido-mount",
            steps: [
                {
                    type: "document",
                    options: {
                        documentTypes: flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) && onfidoNew === "1" ? documentTypesOnfidoNew : documentTypesOnfidoOld,
                        forceCrossDevice: forceMobile
                    }
                },
                "complete"
            ],
            language: {
                phrases: flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) && onfidoNew === "1" ? (0, $bebfea808891e4bf$export$da6d97d62be0b0d8).acquisition : (0, $b0e50f9e208e1095$export$1b39cf5f2d489ad3).remediation
            },
            smsNumberCountryCode: "NL",
            onComplete: async ()=>{
                try {
                    const response = await (0, $cd771979e180c558$export$2e2bcd8739ae039).request({
                        method: "POST",
                        url: `${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/onfido/complete`,
                        withCredentials: true,
                        headers: {
                            "Content-Type": "application/json"
                        },
                        data: {}
                    });
                    if (response.data) {
                        flow !== (0, $45843b22ada4386e$export$7d1b589b83d5fb2e) && store.AppState.changePage("uploadid", 4);
                        store.AppState.changeStep({
                            step: 0,
                            label: "",
                            status: ""
                        });
                        store.AppState.setSteps([
                            {
                                ...(0, $f39ce8075185c88d$export$be3f796aed065412)[0],
                                status: "done"
                            },
                            {
                                ...(0, $f39ce8075185c88d$export$be3f796aed065412)[1],
                                status: "done"
                            },
                            {
                                ...(0, $f39ce8075185c88d$export$be3f796aed065412)[2],
                                status: "done"
                            }
                        ]);
                        if (flow !== (0, $45843b22ada4386e$export$2707f038bb5e8d05)) setTimeout(()=>{
                            document.location.href = `${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/complete`;
                        }, 2000);
                    }
                } catch (e) {
                    if (e.response?.status === 403) store.AppState.changePage("error", 1);
                    else console.log(e);
                }
            },
            disableAnalytics: true
        });
    };
    (0, $hJwnw.useEffect)(()=>{
        mountOnfido();
    }, []);
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $hJwnw.Fragment), {
        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
            className: `onfido ${flow === (0, $45843b22ada4386e$export$7d1b589b83d5fb2e) && "onfido-rem"}`,
            id: "onfido-mount"
        })
    });
});




var $hJwnw = parcelRequire("hJwnw");


var $c58d3bd86b891f26$exports = {};


$c58d3bd86b891f26$exports = (parcelRequire("ef61Y")).getBundleURL("eot5l") + (parcelRequire("5pfIs")).resolve("8knTd");


const $7c2eb59cd450bfa5$export$5d4bfa2be1911d16 = ()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { translations: translations, onfidoConfig: onfidoConfig } = store.AppConfig;
    const { showLoading: showLoading } = onfidoConfig;
    const { heading: heading, textIdin: textIdin, textSkip: textSkip } = translations.pageComplete;
    (0, $hJwnw.useEffect)(()=>{
        (0, $b7e9ce5848acd9e0$exports.LocalStorage).remove("amex_session_counter");
        store.AppState.setActivePage("onfido-complete");
    }, []);
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
        className: "page page--completed-flow",
        children: [
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($c58d3bd86b891f26$exports)))
            }),
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("h1", {
                children: heading
            }),
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                className: "text subtitle",
                children: showLoading ? textIdin : textSkip
            })
        ]
    });
};



const $64f1c00b24f078b6$export$fd262a064e867ce6 = ()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { currentScreen: currentScreen } = store.AppState;
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)((0, $hJwnw.Fragment), {
        children: [
            currentScreen.subpage === 1 && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $b360ccb1ae1ee64e$exports.UploadIdStart), {}),
            currentScreen.subpage === 2 && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $479f1395045fe468$export$626a0430d29b9cc1), {}),
            currentScreen.subpage === 3 && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $0dc99bcc7526b6f0$export$62cc401851868c8a), {}),
            currentScreen.subpage === 4 && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $7c2eb59cd450bfa5$export$5d4bfa2be1911d16), {})
        ]
    });
};




var $hJwnw = parcelRequire("hJwnw");


const $49ca10cbe1feea22$export$b692000a405fed6b = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { translations: translations } = store.AppConfig;
    const { pageContinueLater: pageContinueLater } = translations;
    const { heading: heading } = pageContinueLater;
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
        className: "page page--continue-later",
        children: [
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                className: "line centered",
                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                    className: "mail-icon"
                })
            }),
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("h1", {
                children: heading
            })
        ]
    });
});




var $hJwnw = parcelRequire("hJwnw");

var $129df9dbafd48283$exports = {};
"use strict";
Object.defineProperty($129df9dbafd48283$exports, "__esModule", {
    value: true
});
$129df9dbafd48283$exports["default"] = void 0;

var $129df9dbafd48283$var$_react = $129df9dbafd48283$var$_interopRequireDefault((parcelRequire("hJwnw")));
function $129df9dbafd48283$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $129df9dbafd48283$var$_slicedToArray(arr, i) {
    return $129df9dbafd48283$var$_arrayWithHoles(arr) || $129df9dbafd48283$var$_iterableToArrayLimit(arr, i) || $129df9dbafd48283$var$_unsupportedIterableToArray(arr, i) || $129df9dbafd48283$var$_nonIterableRest();
}
function $129df9dbafd48283$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $129df9dbafd48283$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $129df9dbafd48283$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $129df9dbafd48283$var$_arrayLikeToArray(o, minLen);
}
function $129df9dbafd48283$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $129df9dbafd48283$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $129df9dbafd48283$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $129df9dbafd48283$var$useCountDown = function useCountDown() {
    var timeToCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60000;
    var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    var _React$useState = $129df9dbafd48283$var$_react["default"].useState(0), _React$useState2 = $129df9dbafd48283$var$_slicedToArray(_React$useState, 2), timeLeft = _React$useState2[0], setTimeLeft = _React$useState2[1];
    var timer = $129df9dbafd48283$var$_react["default"].useRef({});
    var run = function run(ts) {
        if (!timer.current.started) {
            timer.current.started = ts;
            timer.current.lastInterval = ts;
        }
        if (ts - timer.current.lastInterval >= interval) {
            timer.current.lastInterval += interval;
            setTimeLeft(function(timeLeft) {
                return timeLeft - interval;
            });
        }
        if (ts - timer.current.started < timer.current.timeToCount) timer.current.requestId = window.requestAnimationFrame(run);
    };
    var start = $129df9dbafd48283$var$_react["default"].useCallback(function(ttc) {
        window.cancelAnimationFrame(timer.current.requestId);
        var newTimeToCount = ttc !== undefined ? ttc : timeToCount;
        timer.current.started = null;
        timer.current.lastInterval = null;
        timer.current.timeToCount = newTimeToCount;
        timer.current.requestId = window.requestAnimationFrame(run);
        setTimeLeft(newTimeToCount);
    }, [
        timer,
        setTimeLeft
    ]);
    return [
        timeLeft,
        start
    ];
};
var $129df9dbafd48283$var$_default = $129df9dbafd48283$var$useCountDown;
$129df9dbafd48283$exports["default"] = $129df9dbafd48283$var$_default;




const $c1fa6ff1560e12f7$var$timeBase = 1000;
const $c1fa6ff1560e12f7$var$counterBaseTimeMiliseconds = 6000;
const $c1fa6ff1560e12f7$export$c120a0e80fd44ca6 = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { error: error, activePage: activePage } = store.AppState;
    const { flow: flow } = store.ClientState;
    const { heading: heading, message: message } = error;
    const [counter, start] = (0, (/*@__PURE__*/$parcel$interopDefault($129df9dbafd48283$exports)))($c1fa6ff1560e12f7$var$counterBaseTimeMiliseconds, $c1fa6ff1560e12f7$var$timeBase);
    function textContent() {
        return {
            __html: message
        };
    }
    (0, $hJwnw.useEffect)(()=>{
        if (counter === 1000 && flow === (0, $45843b22ada4386e$export$7d1b589b83d5fb2e) && error.type === "error-expired") document.location.href = `https://www.americanexpress.com/nl-nl/service/identiteit/`;
    }, [
        counter
    ]);
    (0, $hJwnw.useEffect)(()=>{
        start($c1fa6ff1560e12f7$var$counterBaseTimeMiliseconds);
    }, []);
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
        className: "page page--error",
        children: [
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                className: "line centered",
                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                    className: "error-icon"
                })
            }),
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("h1", {
                children: heading
            }),
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                className: "line centered",
                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                    className: "text",
                    dangerouslySetInnerHTML: textContent()
                })
            })
        ]
    });
});




const $e44d7f65cce98464$export$7c6e2c02157bb7d2 = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { currentScreen: currentScreen } = store.AppState;
    const { page: page, subpage: subpage } = currentScreen;
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f793f10c8744cbcb$exports)))("content-wrapper", page === "error" ? "content-wrapper--margin-top" : ""),
        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
            className: `content content--${page}-${subpage}`,
            children: [
                page === "bank" && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $4356e789fc213a2a$export$bb7166d635bfa18e), {}),
                page === "uploadid" && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $64f1c00b24f078b6$export$fd262a064e867ce6), {}),
                page === "continue" && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $49ca10cbe1feea22$export$b692000a405fed6b), {}),
                page === "error" && /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $c1fa6ff1560e12f7$export$c120a0e80fd44ca6), {})
            ]
        })
    });
});




var $hJwnw = parcelRequire("hJwnw");




const $bedc61021e1834cd$export$1be7516c0280bee8 = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { activePage: activePage, error: error } = store.AppState;
    const { translations: translations } = store.AppConfig;
    const { pcn: pcn, clic: clic, flow: flow } = store.ClientState;
    const [showPrint, setShowPrint] = (0, $hJwnw.useState)(false);
    function helpContent() {
        return {
            __html: error.type === "error-cookie" ? translations.cookieText : translations.helpText
        };
    }
    (0, $hJwnw.useEffect)(()=>{
        if (activePage === "onfido-complete") setShowPrint(true);
    }, [
        activePage
    ]);
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
        className: "help",
        children: [
            /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
                className: "help--inner",
                dangerouslySetInnerHTML: helpContent()
            }),
            pcn !== "" ? pcn : "",
            " ",
            flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) && clic !== "" ? `(CLIC) ${clic}` : "",
            " ",
            showPrint ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
                href: "#",
                onClick: ()=>window.print(),
                children: translations.print
            }) : ""
        ]
    });
});




var $hJwnw = parcelRequire("hJwnw");


const $e3517af9fe976995$export$970c6d219c1734d3 = [
    {
        url: "https://www.americanexpress.com/nl/rules-and-regulations.html?inav=nl_legalfooter_rulesandreg",
        label: "website regels en voorschriften"
    },
    {
        url: "https://www.americanexpress.com/nl/amex-trademarks.html?inav=nl_legalfooter_trademarks",
        label: "handelsmerken"
    },
    {
        url: "https://www.americanexpress.com/nl/legal/online-privacyverklaring.html",
        label: "privacy verklaring"
    }
];



parcelRequire("hJwnw");
const $d1685d1bbb157633$export$9a83bdc89ac70dc4 = ({ items: items })=>{
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("ul", {
        className: "footer__menu",
        children: items.map((item)=>/*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
                    href: item.url,
                    target: "_blank",
                    rel: "noreferrer",
                    children: item.label
                })
            }, item.label))
    });
};



const $b3eb5b99e3987ef2$export$a06f1c675e846f6f = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { translations: translations } = store.AppConfig;
    const { footer: footer } = translations;
    const { copyright: copyright, americanExpress: americanExpress, rightsReserved: rightsReserved } = footer;
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
        className: "footer",
        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
            className: "footer__wrapper",
            children: [
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $d1685d1bbb157633$export$9a83bdc89ac70dc4), {
                    items: (0, $e3517af9fe976995$export$970c6d219c1734d3)
                }),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("span", {
                    className: "footer__copyright",
                    children: [
                        copyright,
                        /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("a", {
                            href: "https://www.americanexpress.com/nl/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: americanExpress
                        }),
                        ". ",
                        rightsReserved
                    ]
                })
            ]
        })
    });
});




var $hJwnw = parcelRequire("hJwnw");




var $k9xxm = parcelRequire("k9xxm");



const $e39024ee80b1599c$export$a86190deb5c4a8d0 = ()=>{
    const currentdate = new Date();
    return currentdate.toString();
};
function $e39024ee80b1599c$export$2287e3d29250119e(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
}




const $03e149312dc257ed$var$timeBase = 1000;
const $03e149312dc257ed$var$counterBaseTimeMinutes = 20;
const $03e149312dc257ed$var$counterBaseTimeMiliseconds = 1200000;
const $03e149312dc257ed$var$showCounterTime = 60000;
const $03e149312dc257ed$export$eaff3ecf1ac85d93 = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const [counter, start] = (0, (/*@__PURE__*/$parcel$interopDefault($129df9dbafd48283$exports)))($03e149312dc257ed$var$counterBaseTimeMiliseconds, $03e149312dc257ed$var$timeBase);
    const [modalVisible, setModalVisible] = (0, $hJwnw.useState)(false);
    const [countdownStart, setCountdownStart] = (0, $hJwnw.useState)(false);
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { translations: translations, sessionStartTime: sessionStartTime } = store.AppConfig;
    const { currentScreen: currentScreen, activePage: activePage } = store.AppState;
    const { flow: flow } = store.ClientState;
    const { page: page, subpage: subpage } = currentScreen;
    const { modalSessionTimer: modalSessionTimer } = translations;
    const handleRedirect = ()=>{
        if (page !== "error" && activePage !== "onfido-complete" && page !== "continue" || subpage !== 4) window.location.href = `${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/session/expire`;
    };
    const restart = (0, (/*@__PURE__*/$parcel$interopDefault($hJwnw))).useCallback((newTime)=>{
        start(newTime);
    }, [
        start
    ]);
    const handleSavedSessionTime = ()=>{
        const savedTime = sessionStartTime;
        const currentTime = (0, $e39024ee80b1599c$export$a86190deb5c4a8d0)();
        const counterEndDate = (0, $e39024ee80b1599c$export$2287e3d29250119e)(new Date(savedTime), $03e149312dc257ed$var$counterBaseTimeMinutes);
        const counterExpired = Date.parse(counterEndDate.toString()) < Date.parse(currentTime);
        if (!counterExpired) {
            const durationLeft = (0, (/*@__PURE__*/$parcel$interopDefault($k9xxm))).duration((0, (/*@__PURE__*/$parcel$interopDefault($k9xxm)))(counterEndDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($k9xxm)))(new Date())));
            restart(durationLeft.asMilliseconds());
            setCountdownStart(true);
        } else handleRedirect();
    };
    const handleVisibleCounter = ()=>{
        const minutes = Math.floor(counter / 1000 / 60);
        const seconds = Math.floor(counter / 1000) % 60;
        return `${minutes > 9 ? minutes : "0" + minutes}:${seconds > 9 ? seconds : "0" + seconds}`;
    };
    const handleModalCloseByUser = (modalVisibility)=>{
        setModalVisible(modalVisibility);
    };
    const resetStartTime = ()=>{
        const currentTime = (0, $e39024ee80b1599c$export$a86190deb5c4a8d0)();
        (0, $b7e9ce5848acd9e0$exports.LocalStorage).set("amex_session_counter", currentTime);
        store.AppConfig.setSessionStartTime(currentTime);
        handleSavedSessionTime();
        setModalVisible(false);
    };
    const handleContinue = ()=>{
        resetStartTime();
        flow === (0, $45843b22ada4386e$export$7d1b589b83d5fb2e) && (0, $016b5408f4f39711$export$66a2189a71063a10)();
    };
    const handleFinishLater = ()=>{
        handleModalCloseByUser(false);
        store.AppConfig.setFinishLaterVisible(true);
        resetStartTime();
    };
    (0, $hJwnw.useEffect)(()=>{
        sessionStartTime && handleSavedSessionTime();
    }, [
        sessionStartTime
    ]);
    (0, $hJwnw.useEffect)(()=>{
        if (counter < $03e149312dc257ed$var$showCounterTime && counter !== 0 && !modalVisible && page !== "error" && activePage !== "onfido-complete" && page !== "session-expired" && page !== "error-auth" && page !== "continue" && subpage !== 4) setModalVisible(true);
        if (counter >= $03e149312dc257ed$var$showCounterTime) setModalVisible(false);
        if (counter <= $03e149312dc257ed$var$timeBase && countdownStart) handleRedirect();
    }, [
        counter
    ]);
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $ce888247d742db17$export$2b77a92f1a5ad772), {
        modalVisible: modalVisible,
        setModalVisible: (modalVisibility)=>handleModalCloseByUser(modalVisibility),
        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
            className: "session-timer-modal",
            children: [
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                    children: modalSessionTimer.text
                }),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("span", {
                    children: handleVisibleCounter()
                }),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("button", {
                    className: "btn btn-primary",
                    onClick: ()=>handleContinue(),
                    children: modalSessionTimer.buttonComplete
                }),
                flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) ? /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("button", {
                    className: "btn btn--bordered",
                    onClick: ()=>handleFinishLater(),
                    children: modalSessionTimer.buttonLeave
                }) : ""
            ]
        })
    });
});




var $hJwnw = parcelRequire("hJwnw");







const $a943b03d65c747e4$export$73d15d382d31d66d = (0, $b9e73c0b2a621f3b$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $hJwnw.useContext)((0, $7683e80cab633ed9$export$554ccc96b126a426));
    const { translations: translations, finishLaterVisible: finishLaterVisible } = store.AppConfig;
    const { changePage: changePage, setActivePage: setActivePage } = store.AppState;
    const { pageUploadIdStart: pageUploadIdStart } = translations;
    const { modalFinishLater: modalFinishLater } = pageUploadIdStart;
    const resetStartTime = ()=>{
        const currentTime = (0, $e39024ee80b1599c$export$a86190deb5c4a8d0)();
        (0, $b7e9ce5848acd9e0$exports.LocalStorage).set("amex_session_counter", currentTime);
        store.AppConfig.setSessionStartTime(currentTime);
    };
    const handleFinishLater = async ()=>{
        try {
            await (0, $cd771979e180c558$export$2e2bcd8739ae039).request({
                method: "POST",
                url: `${(0, $aad9051021d3a449$export$116a2a95e81fe3c3)()}/interactions/finishLater`,
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json"
                },
                data: {}
            });
            store.AppConfig.setFinishLaterVisible(false);
            resetStartTime();
            setActivePage("continue");
            changePage("continue", 1);
        } catch (e) {
            if (e.response?.status === 409) changePage("error", 1);
            else console.log(e);
        }
    };
    const handleContinue = ()=>{
        resetStartTime();
        store.AppConfig.setFinishLaterVisible(false);
    };
    const handleModalVisibility = ()=>{
        store.AppConfig.setFinishLaterVisible(false);
    };
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $ce888247d742db17$export$2b77a92f1a5ad772), {
        modalVisible: finishLaterVisible,
        setModalVisible: handleModalVisibility,
        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("div", {
            className: "modal--finish-later-onfido",
            children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
                className: "line centered",
                children: [
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("h2", {
                        children: modalFinishLater.heading
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                        children: modalFinishLater.paragraphFirst
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("p", {
                        children: modalFinishLater.paragraphSecond
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("button", {
                        className: "btn btn-primary",
                        onClick: ()=>handleContinue(),
                        children: modalFinishLater.buttonComplete
                    }),
                    /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)("button", {
                        className: "btn btn--bordered",
                        onClick: ()=>handleFinishLater(),
                        children: modalFinishLater.buttonLeave
                    })
                ]
            })
        })
    });
});





const $8f816dd8d363a9df$export$cf0053e3244335c0 = async (selector)=>{
    while(document.querySelector(selector) === null)await new Promise((resolve)=>requestAnimationFrame(resolve));
    return document.querySelector(selector);
};



const $040ccda67f995cf0$export$b96c566893dd29af = `<li><button type="button" class="onfido-sdk-ui-DocumentSelector-option onfido-sdk-ui-DocumentSelector-optionHoverDesktop onfido-mocked-button" data-onfido-qa="driving_licence" disabled=""><div class="onfido-sdk-ui-DocumentSelector-icon onfido-sdk-ui-DocumentSelector-icon-driving-licence"></div><div class="onfido-sdk-ui-DocumentSelector-content"><div class="onfido-sdk-ui-DocumentSelector-optionMain"><p class="onfido-sdk-ui-DocumentSelector-label">Rijbewijs</p><div class="onfido-sdk-ui-DocumentSelector-hint">Rijbewijs accepteren wij niet als een geldig identiteitsbewijs</div></div></div></button></li>`;


const $45f747034f1e527b$export$8e06ae43636e24cb = `<p class="onfido-full-legal">Voor de tenaamstelling van uw account, gebruiken wij de gegevens zoals op uw identiteitsbewijs</p>`;



const $7683e80cab633ed9$export$554ccc96b126a426 = /*#__PURE__*/ (0, $hJwnw.createContext)((0, $6a0b0eac07d647c3$export$8ee67b622d91e484));
const $7683e80cab633ed9$export$86fbec116b87613f = ()=>{
    const obs = new MutationObserver(()=>{
        const mainContainer = document.getElementsByClassName("onfido-sdk-ui-Theme-content")[0];
        obs.disconnect();
        const selectionList = document.getElementsByClassName("onfido-sdk-ui-DocumentSelector-list");
        if (selectionList && selectionList[0]) {
            if ((0, $6a0b0eac07d647c3$export$8ee67b622d91e484).ClientState.selectedCountry.toUpperCase() === "NL") selectionList[0].insertAdjacentHTML("beforeend", (0, $040ccda67f995cf0$export$b96c566893dd29af));
            document.getElementsByClassName("onfido-sdk-ui-Theme-footer")[0].insertAdjacentHTML("beforeend", (0, $45f747034f1e527b$export$8e06ae43636e24cb));
        }
        const uploaderContainer = document.getElementsByClassName("onfido-sdk-ui-Uploader-container");
        if (uploaderContainer && uploaderContainer[0]) {
            const legalInfoElement = document.getElementsByClassName("onfido-full-legal");
            if (legalInfoElement && legalInfoElement[0]) legalInfoElement[0].remove();
        }
        const mobileFlowContainer = document.getElementsByClassName("onfido-sdk-ui-crossDevice-Intro-container");
        if (mobileFlowContainer && mobileFlowContainer[0]) {
            const element = document.getElementsByClassName("onfido-full-legal")[0];
            if (element) element.remove();
        }
        const completeWrapper = document.getElementsByClassName("onfido-sdk-ui-Complete-wrapper");
        if (completeWrapper && completeWrapper[0]) {
            const element = document.getElementsByClassName("onfido-sdk-ui-Theme-footer")[0];
            if (element) element.insertAdjacentHTML("beforeend", (0, $45f747034f1e527b$export$8e06ae43636e24cb));
        }
        obs.observe(mainContainer, {
            subtree: true,
            childList: true
        });
    });
    const populateOnfidoElements = ()=>{
        const onfidoNew = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("onfido_new");
        const flow = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("flow");
        if (flow && flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) && onfidoNew === "1") (0, $8f816dd8d363a9df$export$cf0053e3244335c0)(".onfido-sdk-ui-Theme-content").then((selector)=>{
            const selectionList = document.getElementsByClassName("onfido-sdk-ui-DocumentSelector-list");
            if (selectionList && selectionList[0]) {
                if ((0, $6a0b0eac07d647c3$export$8ee67b622d91e484).ClientState.selectedCountry.toUpperCase() === "NL") selectionList[0].insertAdjacentHTML("beforeend", (0, $040ccda67f995cf0$export$b96c566893dd29af));
                document.getElementsByClassName("onfido-sdk-ui-Theme-footer")[0].insertAdjacentHTML("beforeend", (0, $45f747034f1e527b$export$8e06ae43636e24cb));
            }
            obs.observe(selector, {
                subtree: true,
                childList: true
            });
        });
    };
    (0, $hJwnw.useEffect)(()=>{
        // Get current step and page
        const flow = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("flow");
        flow && flow.length > 0 && (0, $6a0b0eac07d647c3$export$8ee67b622d91e484).ClientState.setFlow(flow);
        const activePage = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("step");
        activePage && (0, $6a0b0eac07d647c3$export$8ee67b622d91e484).AppState.setActivePage(activePage);
        const webhookUrl = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("webhook_url");
        webhookUrl && (0, $6a0b0eac07d647c3$export$8ee67b622d91e484).ClientState.setWebHook(webhookUrl);
        const queryPcn = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("pcn");
        queryPcn && (0, $6a0b0eac07d647c3$export$8ee67b622d91e484).ClientState.setPcn(decodeURIComponent(queryPcn));
        const queryClic = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("clic");
        queryClic && (0, $6a0b0eac07d647c3$export$8ee67b622d91e484).ClientState.setClic(decodeURIComponent(queryClic));
        const forceMobile = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("force_mobile");
        forceMobile && forceMobile.length > 0 && (0, $6a0b0eac07d647c3$export$8ee67b622d91e484).ClientState.setForceMobile(true);
        const onfidoNew = (0, $fcbc31c3a20ef8e6$export$34c5a9262f934fa5)("onfido_new");
        onfidoNew && onfidoNew === "1" && (0, $6a0b0eac07d647c3$export$8ee67b622d91e484).ClientState.setOnfidoNew(onfidoNew);
        // handle localStorage session counter
        const currentTime = (0, $e39024ee80b1599c$export$a86190deb5c4a8d0)();
        (0, $b7e9ce5848acd9e0$exports.LocalStorage).set("amex_session_counter", currentTime);
        (0, $6a0b0eac07d647c3$export$8ee67b622d91e484).AppConfig.setSessionStartTime(currentTime);
        flow && flow === (0, $45843b22ada4386e$export$2707f038bb5e8d05) && (0, $016b5408f4f39711$export$66a2189a71063a10)();
    }, []);
    (0, $hJwnw.useEffect)(()=>{
        populateOnfidoElements();
    }, [
        (0, $6a0b0eac07d647c3$export$8ee67b622d91e484).AppState.activePage
    ]);
    return /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)($7683e80cab633ed9$export$554ccc96b126a426.Provider, {
        value: (0, $6a0b0eac07d647c3$export$8ee67b622d91e484),
        children: /*#__PURE__*/ (0, $40ac97942f716825$exports.jsxs)("div", {
            className: "app",
            children: [
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $3a90b4fb2a20515c$export$1ca1e38143dcc152), {}),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $7b4509ffc6ef60a7$export$fb587a27d5a722e7), {}),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $e44d7f65cce98464$export$7c6e2c02157bb7d2), {}),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $bedc61021e1834cd$export$1be7516c0280bee8), {}),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $b3eb5b99e3987ef2$export$a06f1c675e846f6f), {}),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $03e149312dc257ed$export$eaff3ecf1ac85d93), {}),
                /*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $a943b03d65c747e4$export$73d15d382d31d66d), {})
            ]
        })
    });
};


(0, (/*@__PURE__*/$parcel$interopDefault($a7721eb599d74a7a$exports))).render(/*#__PURE__*/ (0, $40ac97942f716825$exports.jsx)((0, $7683e80cab633ed9$export$86fbec116b87613f), {}), document.getElementById("root"));

})();
//# sourceMappingURL=index.fa047f7c.js.map
